var map = {
	"./GuestContactPreferences/GuestContactPreferencesPage": 1709,
	"./GuestContactPreferences/GuestContactPreferencesPage.module": 890,
	"./GuestContactPreferences/GuestContactPreferencesPage.module.sass": 890,
	"./GuestContactPreferences/GuestContactPreferencesPage.module.sass.d": 2965,
	"./GuestContactPreferences/GuestContactPreferencesPage.module.sass.d.ts": 2965,
	"./GuestContactPreferences/GuestContactPreferencesPage.tsx": 1709,
	"./admin/single_customer_view": 1431,
	"./admin/single_customer_view/": 1431,
	"./admin/single_customer_view/actions": 53,
	"./admin/single_customer_view/actions/": 53,
	"./admin/single_customer_view/actions/index": 53,
	"./admin/single_customer_view/actions/index.js": 53,
	"./admin/single_customer_view/actions/messages": 43,
	"./admin/single_customer_view/actions/messages.js": 43,
	"./admin/single_customer_view/actions/types": 1972,
	"./admin/single_customer_view/actions/types.js": 1972,
	"./admin/single_customer_view/asset-imports/icons": 152,
	"./admin/single_customer_view/asset-imports/icons.js": 152,
	"./admin/single_customer_view/components/SearchBar": 1454,
	"./admin/single_customer_view/components/SearchBar.js": 1454,
	"./admin/single_customer_view/components/SearchResultsTable": 1455,
	"./admin/single_customer_view/components/SearchResultsTable.js": 1455,
	"./admin/single_customer_view/components/SingleCustomerViewIndex": 1451,
	"./admin/single_customer_view/components/SingleCustomerViewIndex.js": 1451,
	"./admin/single_customer_view/components/UserDetails": 1458,
	"./admin/single_customer_view/components/UserDetails.js": 1458,
	"./admin/single_customer_view/components/modals/AddCreditCardToSubscriptionModal": 1478,
	"./admin/single_customer_view/components/modals/AddCreditCardToSubscriptionModal.js": 1478,
	"./admin/single_customer_view/components/modals/ChangePlanModal": 1475,
	"./admin/single_customer_view/components/modals/ChangePlanModal.js": 1475,
	"./admin/single_customer_view/components/modals/SwitchToStripeModal": 1477,
	"./admin/single_customer_view/components/modals/SwitchToStripeModal.js": 1477,
	"./admin/single_customer_view/components/modals/restart_subscription_modal": 1476,
	"./admin/single_customer_view/components/modals/restart_subscription_modal.js": 1476,
	"./admin/single_customer_view/components/user_details/AccountDetailsComponent": 1615,
	"./admin/single_customer_view/components/user_details/AccountDetailsComponent.js": 1615,
	"./admin/single_customer_view/components/user_details/ApplicableDiscountsComponent": 1470,
	"./admin/single_customer_view/components/user_details/ApplicableDiscountsComponent.js": 1470,
	"./admin/single_customer_view/components/user_details/CustomerHistory": 1472,
	"./admin/single_customer_view/components/user_details/CustomerHistory.js": 1472,
	"./admin/single_customer_view/components/user_details/DeliveriesDetails": 1467,
	"./admin/single_customer_view/components/user_details/DeliveriesDetails.js": 1467,
	"./admin/single_customer_view/components/user_details/DeliveriesHistory": 1468,
	"./admin/single_customer_view/components/user_details/DeliveriesHistory.js": 1468,
	"./admin/single_customer_view/components/user_details/DogsDetailsComponent": 1463,
	"./admin/single_customer_view/components/user_details/DogsDetailsComponent.js": 1463,
	"./admin/single_customer_view/components/user_details/ExpandedDogDetails": 1464,
	"./admin/single_customer_view/components/user_details/ExpandedDogDetails.js": 1464,
	"./admin/single_customer_view/components/user_details/MarketingPreferences/MarketingPreferences": 1465,
	"./admin/single_customer_view/components/user_details/MarketingPreferences/MarketingPreferences.js": 1465,
	"./admin/single_customer_view/components/user_details/MarketingPreferences/MarketingPreferencesModal": 1466,
	"./admin/single_customer_view/components/user_details/MarketingPreferences/MarketingPreferencesModal.js": 1466,
	"./admin/single_customer_view/components/user_details/MessageBannerComponent": 1453,
	"./admin/single_customer_view/components/user_details/MessageBannerComponent.js": 1453,
	"./admin/single_customer_view/components/user_details/ShippingDetails": 1460,
	"./admin/single_customer_view/components/user_details/ShippingDetails.js": 1460,
	"./admin/single_customer_view/components/user_details/SubscriptionDetails": 1461,
	"./admin/single_customer_view/components/user_details/SubscriptionDetails.js": 1461,
	"./admin/single_customer_view/components/user_details/contact_preferences/ContactPreferencesModal": 2966,
	"./admin/single_customer_view/components/user_details/contact_preferences/ContactPreferencesModal.js": 2966,
	"./admin/single_customer_view/components/user_details/delivery_date_calendar/DeliveryDateCalendarModalComponent": 1473,
	"./admin/single_customer_view/components/user_details/delivery_date_calendar/DeliveryDateCalendarModalComponent.js": 1473,
	"./admin/single_customer_view/containers/SingleCustomerViewIndexContainer": 1442,
	"./admin/single_customer_view/containers/SingleCustomerViewIndexContainer.js": 1442,
	"./admin/single_customer_view/containers/UserDetailsContainer": 1457,
	"./admin/single_customer_view/containers/UserDetailsContainer.js": 1457,
	"./admin/single_customer_view/containers/user_details/AccountDetailsContainer": 1459,
	"./admin/single_customer_view/containers/user_details/AccountDetailsContainer.js": 1459,
	"./admin/single_customer_view/containers/user_details/ApplicableDiscountsContainer": 1469,
	"./admin/single_customer_view/containers/user_details/ApplicableDiscountsContainer.js": 1469,
	"./admin/single_customer_view/containers/user_details/CustomerHistoryContainer": 1471,
	"./admin/single_customer_view/containers/user_details/CustomerHistoryContainer.js": 1471,
	"./admin/single_customer_view/containers/user_details/DogsDetailsContainer": 1462,
	"./admin/single_customer_view/containers/user_details/DogsDetailsContainer.js": 1462,
	"./admin/single_customer_view/containers/user_details/MessageBannerContainer": 1452,
	"./admin/single_customer_view/containers/user_details/MessageBannerContainer.js": 1452,
	"./admin/single_customer_view/graphql_queries/sendRafDetailsSms": 1448,
	"./admin/single_customer_view/graphql_queries/sendRafDetailsSms.js": 1448,
	"./admin/single_customer_view/index": 1431,
	"./admin/single_customer_view/index.js": 1431,
	"./admin/single_customer_view/message_types": 964,
	"./admin/single_customer_view/message_types/": 964,
	"./admin/single_customer_view/message_types/index": 964,
	"./admin/single_customer_view/message_types/index.js": 964,
	"./admin/single_customer_view/middlewares": 1183,
	"./admin/single_customer_view/middlewares/": 1183,
	"./admin/single_customer_view/middlewares/index": 1183,
	"./admin/single_customer_view/middlewares/index.js": 1183,
	"./admin/single_customer_view/middlewares/stepPersistance": 1401,
	"./admin/single_customer_view/middlewares/stepPersistance.js": 1401,
	"./admin/single_customer_view/rails_queries/addCreditCardToSubscription": 1446,
	"./admin/single_customer_view/rails_queries/addCreditCardToSubscription.js": 1446,
	"./admin/single_customer_view/rails_queries/changePlan": 1443,
	"./admin/single_customer_view/rails_queries/changePlan.js": 1443,
	"./admin/single_customer_view/rails_queries/getShippingDetails": 1449,
	"./admin/single_customer_view/rails_queries/getShippingDetails.js": 1449,
	"./admin/single_customer_view/rails_queries/sendRafDetailsEmail": 1447,
	"./admin/single_customer_view/rails_queries/sendRafDetailsEmail.js": 1447,
	"./admin/single_customer_view/rails_queries/switchSubscriptionToStripe": 1445,
	"./admin/single_customer_view/rails_queries/switchSubscriptionToStripe.js": 1445,
	"./admin/single_customer_view/rails_queries/toggleWantsToReceiveIceQuery": 1450,
	"./admin/single_customer_view/rails_queries/toggleWantsToReceiveIceQuery.js": 1450,
	"./admin/single_customer_view/rails_queries/updateProposedPlan": 1444,
	"./admin/single_customer_view/rails_queries/updateProposedPlan.js": 1444,
	"./admin/single_customer_view/reducers": 734,
	"./admin/single_customer_view/reducers/": 734,
	"./admin/single_customer_view/reducers/index": 734,
	"./admin/single_customer_view/reducers/index.js": 734,
	"./admin/single_customer_view/thunks": 133,
	"./admin/single_customer_view/thunks/": 133,
	"./admin/single_customer_view/thunks/addCreditCardToSubscription": 1405,
	"./admin/single_customer_view/thunks/addCreditCardToSubscription.js": 1405,
	"./admin/single_customer_view/thunks/availablePlansThunks": 1411,
	"./admin/single_customer_view/thunks/availablePlansThunks.js": 1411,
	"./admin/single_customer_view/thunks/changePlan": 1402,
	"./admin/single_customer_view/thunks/changePlan.js": 1402,
	"./admin/single_customer_view/thunks/contact_preferences_thunks": 1179,
	"./admin/single_customer_view/thunks/contact_preferences_thunks.js": 1179,
	"./admin/single_customer_view/thunks/getShippingDetails": 1408,
	"./admin/single_customer_view/thunks/getShippingDetails.js": 1408,
	"./admin/single_customer_view/thunks/index": 133,
	"./admin/single_customer_view/thunks/index.js": 133,
	"./admin/single_customer_view/thunks/marketingPreferencesThunks": 965,
	"./admin/single_customer_view/thunks/marketingPreferencesThunks.js": 965,
	"./admin/single_customer_view/thunks/restart_subscription_on_date_thunk": 1410,
	"./admin/single_customer_view/thunks/restart_subscription_on_date_thunk.js": 1410,
	"./admin/single_customer_view/thunks/sendRafDetailsEmail": 1406,
	"./admin/single_customer_view/thunks/sendRafDetailsEmail.js": 1406,
	"./admin/single_customer_view/thunks/sendRafDetailsSms": 1407,
	"./admin/single_customer_view/thunks/sendRafDetailsSms.js": 1407,
	"./admin/single_customer_view/thunks/switchSubscriptionToStripe": 1404,
	"./admin/single_customer_view/thunks/switchSubscriptionToStripe.js": 1404,
	"./admin/single_customer_view/thunks/toggleWantsToReceiveIce": 1409,
	"./admin/single_customer_view/thunks/toggleWantsToReceiveIce.js": 1409,
	"./admin/single_customer_view/thunks/updateProposedPlan": 1403,
	"./admin/single_customer_view/thunks/updateProposedPlan.js": 1403,
	"./affiliates/partials/box_summary_component": 922,
	"./affiliates/partials/box_summary_component.js": 922,
	"./affiliates/partials/referral_component": 728,
	"./affiliates/partials/referral_component.js": 728,
	"./affiliates/partials/referral_link_and_share_component": 632,
	"./affiliates/partials/referral_link_and_share_component.js": 632,
	"./affiliates/tabs/ambassador_referral_tab": 1496,
	"./affiliates/tabs/ambassador_referral_tab.js": 1496,
	"./affiliates/tabs/influencer_referral_tab": 1549,
	"./affiliates/tabs/influencer_referral_tab.js": 1549,
	"./ambassador_dashboard/AmbassadorPopup/AmbassadorPopup": 2875,
	"./ambassador_dashboard/AmbassadorPopup/AmbassadorPopup.module": 1641,
	"./ambassador_dashboard/AmbassadorPopup/AmbassadorPopup.module.sass": 1641,
	"./ambassador_dashboard/AmbassadorPopup/AmbassadorPopup.module.sass.d": 2967,
	"./ambassador_dashboard/AmbassadorPopup/AmbassadorPopup.module.sass.d.ts": 2967,
	"./ambassador_dashboard/AmbassadorPopup/AmbassadorPopup.tsx": 2875,
	"./ambassador_dashboard/balance": 2086,
	"./ambassador_dashboard/balance.jsx": 2086,
	"./ambassador_dashboard/contact": 2087,
	"./ambassador_dashboard/contact.js": 2087,
	"./ambassador_dashboard/merch": 2088,
	"./ambassador_dashboard/merch.jsx": 2088,
	"./ambassador_dashboard/message_types": 2968,
	"./ambassador_dashboard/message_types.js": 2968,
	"./ambassador_dashboard/partials/ContactFAQs": 1494,
	"./ambassador_dashboard/partials/ContactFAQs.js": 1494,
	"./ambassador_dashboard/partials/SelectBar": 513,
	"./ambassador_dashboard/partials/SelectBar.jsx": 513,
	"./ambassador_dashboard/partials/ShopifyCard": 1498,
	"./ambassador_dashboard/partials/ShopifyCard.jsx": 1498,
	"./ambassador_dashboard/partials/balance_tab/BankAccountForm": 1480,
	"./ambassador_dashboard/partials/balance_tab/BankAccountForm.jsx": 1480,
	"./ambassador_dashboard/partials/balance_tab/CharityDonation": 1206,
	"./ambassador_dashboard/partials/balance_tab/CharityDonation.jsx": 1206,
	"./ambassador_dashboard/partials/balance_tab/CompleteTrialAccount": 1488,
	"./ambassador_dashboard/partials/balance_tab/CompleteTrialAccount.jsx": 1488,
	"./ambassador_dashboard/partials/balance_tab/InactiveAccount": 1489,
	"./ambassador_dashboard/partials/balance_tab/InactiveAccount.jsx": 1489,
	"./ambassador_dashboard/partials/balance_tab/NoSubscriptionAccount": 1208,
	"./ambassador_dashboard/partials/balance_tab/NoSubscriptionAccount.jsx": 1208,
	"./ambassador_dashboard/partials/balance_tab/PaidAccount": 1490,
	"./ambassador_dashboard/partials/balance_tab/PaidAccount.jsx": 1490,
	"./ambassador_dashboard/partials/balance_tab/PayoutHistory": 1493,
	"./ambassador_dashboard/partials/balance_tab/PayoutHistory.js": 1493,
	"./ambassador_dashboard/partials/balance_tab/bank_account_form/Alert": 1483,
	"./ambassador_dashboard/partials/balance_tab/bank_account_form/Alert.jsx": 1483,
	"./ambassador_dashboard/partials/balance_tab/bank_account_form/CompleteBankAccount": 1481,
	"./ambassador_dashboard/partials/balance_tab/bank_account_form/CompleteBankAccount.jsx": 1481,
	"./ambassador_dashboard/partials/balance_tab/bank_account_form/EditingBankAccount": 1484,
	"./ambassador_dashboard/partials/balance_tab/bank_account_form/EditingBankAccount.jsx": 1484,
	"./ambassador_dashboard/partials/balance_tab/bank_account_form/EmptyBankAccount": 1482,
	"./ambassador_dashboard/partials/balance_tab/bank_account_form/EmptyBankAccount.jsx": 1482,
	"./ambassador_dashboard/partials/balance_tab/charity_donation/AwaitingDonation": 1486,
	"./ambassador_dashboard/partials/balance_tab/charity_donation/AwaitingDonation.jsx": 1486,
	"./ambassador_dashboard/partials/balance_tab/charity_donation/DonationComplete": 1487,
	"./ambassador_dashboard/partials/balance_tab/charity_donation/DonationComplete.jsx": 1487,
	"./ambassador_dashboard/partials/balance_tab/paid_account/AwaitingCreditRedemption": 1491,
	"./ambassador_dashboard/partials/balance_tab/paid_account/AwaitingCreditRedemption.jsx": 1491,
	"./ambassador_dashboard/partials/balance_tab/paid_account/CreditRedemptionComplete": 1492,
	"./ambassador_dashboard/partials/balance_tab/paid_account/CreditRedemptionComplete.jsx": 1492,
	"./ambassador_dashboard/partials/give_get_referral_component": 1209,
	"./ambassador_dashboard/partials/give_get_referral_component.js": 1209,
	"./ambassador_dashboard/referrals": 2089,
	"./ambassador_dashboard/referrals.jsx": 2089,
	"./ambassador_dashboard/summary": 2090,
	"./ambassador_dashboard/summary.tsx": 2090,
	"./ambassador_dashboard/tabs": 352,
	"./ambassador_dashboard/tabs.ts": 352,
	"./ambassador_dashboard/tabs/BalanceTab": 1479,
	"./ambassador_dashboard/tabs/BalanceTab.jsx": 1479,
	"./ambassador_dashboard/tabs/MerchTab": 1495,
	"./ambassador_dashboard/tabs/MerchTab.jsx": 1495,
	"./ambassador_dashboard/tabs/SummaryTab": 1497,
	"./ambassador_dashboard/tabs/SummaryTab.jsx": 1497,
	"./analytics/Analytics": 37,
	"./analytics/Analytics.d": 2969,
	"./analytics/Analytics.d.ts": 2969,
	"./analytics/Analytics.js": 37,
	"./analytics/admin/single_customer_view/SingleCustomerViewAnalytics": 1456,
	"./analytics/admin/single_customer_view/SingleCustomerViewAnalytics.js": 1456,
	"./apollo/client": 174,
	"./apollo/client.ts": 174,
	"./apollo/types-with-ids": 511,
	"./apollo/types-with-ids.ts": 511,
	"./apollo/withApollo": 112,
	"./apollo/withApollo.tsx": 112,
	"./carousel/CharityCarousel": 2097,
	"./carousel/CharityCarousel.tsx": 2097,
	"./carousel/ExpertsCarousel": 2098,
	"./carousel/ExpertsCarousel.tsx": 2098,
	"./carousel/ugc_reviews_carousel": 1289,
	"./carousel/ugc_reviews_carousel.tsx": 1289,
	"./contact_us": 1432,
	"./contact_us/": 1432,
	"./contact_us/actions": 150,
	"./contact_us/actions/": 150,
	"./contact_us/actions/index": 150,
	"./contact_us/actions/index.ts": 150,
	"./contact_us/actions/messages": 225,
	"./contact_us/actions/messages.ts": 225,
	"./contact_us/actions/types": 2970,
	"./contact_us/actions/types.ts": 2970,
	"./contact_us/analytics": 1055,
	"./contact_us/analytics/": 1055,
	"./contact_us/analytics/index": 1055,
	"./contact_us/analytics/index.ts": 1055,
	"./contact_us/components/ContactForm": 1504,
	"./contact_us/components/ContactForm.tsx": 1504,
	"./contact_us/components/FrequentlyAskedQuestions": 1210,
	"./contact_us/components/FrequentlyAskedQuestions.tsx": 1210,
	"./contact_us/components/LastBox": 2091,
	"./contact_us/components/LastBox.tsx": 2091,
	"./contact_us/components/contact_form/DogNamesInput": 1506,
	"./contact_us/components/contact_form/DogNamesInput.tsx": 1506,
	"./contact_us/components/contact_form/EmailInput": 1507,
	"./contact_us/components/contact_form/EmailInput.tsx": 1507,
	"./contact_us/components/contact_form/FillOutForm": 1505,
	"./contact_us/components/contact_form/FillOutForm.tsx": 1505,
	"./contact_us/components/contact_form/Form": 1185,
	"./contact_us/components/contact_form/Form/": 1185,
	"./contact_us/components/contact_form/Form/Form": 1416,
	"./contact_us/components/contact_form/Form/Form.tsx": 1416,
	"./contact_us/components/contact_form/Form/index": 1185,
	"./contact_us/components/contact_form/Form/index.ts": 1185,
	"./contact_us/components/contact_form/FormRequestMessage": 1515,
	"./contact_us/components/contact_form/FormRequestMessage.tsx": 1515,
	"./contact_us/components/contact_form/FormRequestMessageScrollable": 1514,
	"./contact_us/components/contact_form/FormRequestMessageScrollable.tsx": 1514,
	"./contact_us/components/contact_form/GenericForm": 1049,
	"./contact_us/components/contact_form/GenericForm/": 1049,
	"./contact_us/components/contact_form/GenericForm/GenericForm": 1417,
	"./contact_us/components/contact_form/GenericForm/GenericForm.tsx": 1417,
	"./contact_us/components/contact_form/GenericForm/index": 1049,
	"./contact_us/components/contact_form/GenericForm/index.ts": 1049,
	"./contact_us/components/contact_form/GetInTouch": 1519,
	"./contact_us/components/contact_form/GetInTouch.tsx": 1519,
	"./contact_us/components/contact_form/MessageTextArea": 1508,
	"./contact_us/components/contact_form/MessageTextArea.tsx": 1508,
	"./contact_us/components/contact_form/NameInput": 1510,
	"./contact_us/components/contact_form/NameInput.tsx": 1510,
	"./contact_us/components/contact_form/QueryType": 1517,
	"./contact_us/components/contact_form/QueryType.tsx": 1517,
	"./contact_us/components/contact_form/SubmitButton": 1511,
	"./contact_us/components/contact_form/SubmitButton.tsx": 1511,
	"./contact_us/components/contact_form/query_type/queries": 668,
	"./contact_us/components/contact_form/query_type/queries.tsx": 668,
	"./contact_us/fetch_requests/submitContactForm": 1513,
	"./contact_us/fetch_requests/submitContactForm.ts": 1513,
	"./contact_us/graphql_queries/__generated__/ContactFormInitialData": 2971,
	"./contact_us/graphql_queries/__generated__/ContactFormInitialData.ts": 2971,
	"./contact_us/graphql_queries/__generated__/ContactFormInitialDataPreWizardGuest": 2972,
	"./contact_us/graphql_queries/__generated__/ContactFormInitialDataPreWizardGuest.ts": 2972,
	"./contact_us/graphql_queries/fetchInitialData": 1512,
	"./contact_us/graphql_queries/fetchInitialData.ts": 1512,
	"./contact_us/graphql_queries/queries": 1212,
	"./contact_us/graphql_queries/queries.ts": 1212,
	"./contact_us/index": 1432,
	"./contact_us/index.tsx": 1432,
	"./contact_us/reducers": 2385,
	"./contact_us/reducers/": 2385,
	"./contact_us/reducers/formDataReducer": 360,
	"./contact_us/reducers/formDataReducer.ts": 360,
	"./contact_us/reducers/globalAttributesReducer": 1192,
	"./contact_us/reducers/globalAttributesReducer.ts": 1192,
	"./contact_us/reducers/index": 2385,
	"./contact_us/reducers/index.ts": 2385,
	"./contact_us/reducers/requestsReducer": 1193,
	"./contact_us/reducers/requestsReducer.ts": 1193,
	"./contact_us/tests/__image_snapshots__/contact-us-screenshot-spec-js-rendering-the-contact-us-page-should-render-and-capture-a-screenshot-1-snap": 2973,
	"./contact_us/tests/__image_snapshots__/contact-us-screenshot-spec-js-rendering-the-contact-us-page-should-render-and-capture-a-screenshot-1-snap.png": 2973,
	"./contact_us/thunks": 870,
	"./contact_us/thunks/": 870,
	"./contact_us/thunks/fetchInitialData": 1418,
	"./contact_us/thunks/fetchInitialData.ts": 1418,
	"./contact_us/thunks/index": 870,
	"./contact_us/thunks/index.ts": 870,
	"./contact_us/thunks/submitContactForm": 1419,
	"./contact_us/thunks/submitContactForm.ts": 1419,
	"./cookie_consent": 262,
	"./cookie_consent/": 262,
	"./cookie_consent/gtm": 2974,
	"./cookie_consent/gtm.ts": 2974,
	"./cookie_consent/index": 262,
	"./cookie_consent/index.js.flow": 4226,
	"./cookie_consent/index.tsx": 262,
	"./cookie_consent/scroll": 299,
	"./cookie_consent/scroll.ts": 299,
	"./elements/atoms/Accordion": 1578,
	"./elements/atoms/Accordion/": 1578,
	"./elements/atoms/Accordion/Accordion": 1987,
	"./elements/atoms/Accordion/Accordion.module": 1642,
	"./elements/atoms/Accordion/Accordion.module.sass": 1642,
	"./elements/atoms/Accordion/Accordion.module.sass.d": 2975,
	"./elements/atoms/Accordion/Accordion.module.sass.d.ts": 2975,
	"./elements/atoms/Accordion/Accordion.tsx": 1987,
	"./elements/atoms/Accordion/__snapshots__/Accordion.spec.tsx.snap": 4227,
	"./elements/atoms/Accordion/index": 1578,
	"./elements/atoms/Accordion/index.tsx": 1578,
	"./elements/atoms/AddDogAction": 1290,
	"./elements/atoms/AddDogAction/": 1290,
	"./elements/atoms/AddDogAction/AddDogAction": 1988,
	"./elements/atoms/AddDogAction/AddDogAction.module": 2306,
	"./elements/atoms/AddDogAction/AddDogAction.module.sass": 2306,
	"./elements/atoms/AddDogAction/AddDogAction.module.sass.d": 2976,
	"./elements/atoms/AddDogAction/AddDogAction.module.sass.d.ts": 2976,
	"./elements/atoms/AddDogAction/AddDogAction.stories": 2977,
	"./elements/atoms/AddDogAction/AddDogAction.stories.tsx": 2977,
	"./elements/atoms/AddDogAction/AddDogAction.tsx": 1988,
	"./elements/atoms/AddDogAction/index": 1290,
	"./elements/atoms/AddDogAction/index.ts": 1290,
	"./elements/atoms/Alert": 2386,
	"./elements/atoms/Alert/": 2386,
	"./elements/atoms/Alert/AlertCard": 131,
	"./elements/atoms/Alert/AlertCard.module": 773,
	"./elements/atoms/Alert/AlertCard.module.sass": 773,
	"./elements/atoms/Alert/AlertCard.module.sass.d": 2978,
	"./elements/atoms/Alert/AlertCard.module.sass.d.ts": 2978,
	"./elements/atoms/Alert/AlertCard.stories": 2979,
	"./elements/atoms/Alert/AlertCard.stories.tsx": 2979,
	"./elements/atoms/Alert/AlertCard.tsx": 131,
	"./elements/atoms/Alert/index": 2386,
	"./elements/atoms/Alert/index.js": 2386,
	"./elements/atoms/Animated/Animated": 165,
	"./elements/atoms/Animated/Animated.module": 412,
	"./elements/atoms/Animated/Animated.module.sass": 412,
	"./elements/atoms/Animated/Animated.module.sass.d": 2980,
	"./elements/atoms/Animated/Animated.module.sass.d.ts": 2980,
	"./elements/atoms/Animated/Animated.tsx": 165,
	"./elements/atoms/Animated/Expand.stories": 2981,
	"./elements/atoms/Animated/Expand.stories.tsx": 2981,
	"./elements/atoms/Animated/Fade.stories": 2982,
	"./elements/atoms/Animated/Fade.stories.tsx": 2982,
	"./elements/atoms/Animated/Wiggle.stories": 2983,
	"./elements/atoms/Animated/Wiggle.stories.tsx": 2983,
	"./elements/atoms/BCorpLogo/BCorpLogo": 1195,
	"./elements/atoms/BCorpLogo/BCorpLogo.module": 1643,
	"./elements/atoms/BCorpLogo/BCorpLogo.module.sass": 1643,
	"./elements/atoms/BCorpLogo/BCorpLogo.module.sass.d": 2985,
	"./elements/atoms/BCorpLogo/BCorpLogo.module.sass.d.ts": 2985,
	"./elements/atoms/BCorpLogo/BCorpLogo.stories": 2986,
	"./elements/atoms/BCorpLogo/BCorpLogo.stories.tsx": 2986,
	"./elements/atoms/BCorpLogo/BCorpLogo.tsx": 1195,
	"./elements/atoms/BoxDeliveryStatusText/BoxDeliveryStatusText": 1326,
	"./elements/atoms/BoxDeliveryStatusText/BoxDeliveryStatusText.tsx": 1326,
	"./elements/atoms/Button": 38,
	"./elements/atoms/Button/": 38,
	"./elements/atoms/Button/Button": 452,
	"./elements/atoms/Button/Button.module": 180,
	"./elements/atoms/Button/Button.module.sass": 180,
	"./elements/atoms/Button/Button.module.sass.d": 2987,
	"./elements/atoms/Button/Button.module.sass.d.ts": 2987,
	"./elements/atoms/Button/Button.stories": 2988,
	"./elements/atoms/Button/Button.stories.tsx": 2988,
	"./elements/atoms/Button/Button.tsx": 452,
	"./elements/atoms/Button/ButtonSkeleton": 591,
	"./elements/atoms/Button/ButtonSkeleton.tsx": 591,
	"./elements/atoms/Button/index": 38,
	"./elements/atoms/Button/index.ts": 38,
	"./elements/atoms/CameraAction": 1579,
	"./elements/atoms/CameraAction/": 1579,
	"./elements/atoms/CameraAction/CameraAction": 1989,
	"./elements/atoms/CameraAction/CameraAction.module": 1644,
	"./elements/atoms/CameraAction/CameraAction.module.sass": 1644,
	"./elements/atoms/CameraAction/CameraAction.module.sass.d": 2989,
	"./elements/atoms/CameraAction/CameraAction.module.sass.d.ts": 2989,
	"./elements/atoms/CameraAction/CameraAction.stories": 2990,
	"./elements/atoms/CameraAction/CameraAction.stories.tsx": 2990,
	"./elements/atoms/CameraAction/CameraAction.tsx": 1989,
	"./elements/atoms/CameraAction/CameraActionSkeleton": 2469,
	"./elements/atoms/CameraAction/CameraActionSkeleton.tsx": 2469,
	"./elements/atoms/CameraAction/index": 1579,
	"./elements/atoms/CameraAction/index.ts": 1579,
	"./elements/atoms/Card/Card": 52,
	"./elements/atoms/Card/Card.module": 97,
	"./elements/atoms/Card/Card.module.sass": 97,
	"./elements/atoms/Card/Card.module.sass.d": 2991,
	"./elements/atoms/Card/Card.module.sass.d.ts": 2991,
	"./elements/atoms/Card/Card.stories": 2992,
	"./elements/atoms/Card/Card.stories.tsx": 2992,
	"./elements/atoms/Card/Card.tsx": 52,
	"./elements/atoms/Card/CardSkeleton": 139,
	"./elements/atoms/Card/CardSkeleton.tsx": 139,
	"./elements/atoms/CheckBox/CheckBox": 515,
	"./elements/atoms/CheckBox/CheckBox.module": 669,
	"./elements/atoms/CheckBox/CheckBox.module.sass": 669,
	"./elements/atoms/CheckBox/CheckBox.module.sass.d": 2993,
	"./elements/atoms/CheckBox/CheckBox.module.sass.d.ts": 2993,
	"./elements/atoms/CheckBox/CheckBox.stories": 2994,
	"./elements/atoms/CheckBox/CheckBox.stories.tsx": 2994,
	"./elements/atoms/CheckBox/CheckBox.tsx": 515,
	"./elements/atoms/CheckBox/__snapshots__/CheckBox.spec.tsx.snap": 4233,
	"./elements/atoms/CheckBox/icon-checkmark": 1121,
	"./elements/atoms/CheckBox/icon-checkmark.svg": 1121,
	"./elements/atoms/CloudinaryImage": 838,
	"./elements/atoms/CloudinaryImage/": 838,
	"./elements/atoms/CloudinaryImage/CloudinaryImage": 204,
	"./elements/atoms/CloudinaryImage/CloudinaryImage.module": 872,
	"./elements/atoms/CloudinaryImage/CloudinaryImage.module.sass": 872,
	"./elements/atoms/CloudinaryImage/CloudinaryImage.module.sass.d": 2995,
	"./elements/atoms/CloudinaryImage/CloudinaryImage.module.sass.d.ts": 2995,
	"./elements/atoms/CloudinaryImage/CloudinaryImage.tsx": 204,
	"./elements/atoms/CloudinaryImage/index": 838,
	"./elements/atoms/CloudinaryImage/index.ts": 838,
	"./elements/atoms/CloudinaryVideo/CloudinaryVideo": 2996,
	"./elements/atoms/CloudinaryVideo/CloudinaryVideo.tsx": 2996,
	"./elements/atoms/ConditionalWrapper": 2387,
	"./elements/atoms/ConditionalWrapper/": 2387,
	"./elements/atoms/ConditionalWrapper/ConditionalWrapper": 2388,
	"./elements/atoms/ConditionalWrapper/ConditionalWrapper.tsx": 2388,
	"./elements/atoms/ConditionalWrapper/index": 2387,
	"./elements/atoms/ConditionalWrapper/index.ts": 2387,
	"./elements/atoms/DiscountBadge/DiscountBadge": 874,
	"./elements/atoms/DiscountBadge/DiscountBadge.module": 670,
	"./elements/atoms/DiscountBadge/DiscountBadge.module.sass": 670,
	"./elements/atoms/DiscountBadge/DiscountBadge.module.sass.d": 2997,
	"./elements/atoms/DiscountBadge/DiscountBadge.module.sass.d.ts": 2997,
	"./elements/atoms/DiscountBadge/DiscountBadge.stories": 2998,
	"./elements/atoms/DiscountBadge/DiscountBadge.stories.tsx": 2998,
	"./elements/atoms/DiscountBadge/DiscountBadge.tsx": 874,
	"./elements/atoms/ErrorCard": 1186,
	"./elements/atoms/ErrorCard/": 1186,
	"./elements/atoms/ErrorCard/ErrorCard": 1274,
	"./elements/atoms/ErrorCard/ErrorCard.module": 812,
	"./elements/atoms/ErrorCard/ErrorCard.module.sass": 812,
	"./elements/atoms/ErrorCard/ErrorCard.module.sass.d": 2999,
	"./elements/atoms/ErrorCard/ErrorCard.module.sass.d.ts": 2999,
	"./elements/atoms/ErrorCard/ErrorCard.stories": 3000,
	"./elements/atoms/ErrorCard/ErrorCard.stories.tsx": 3000,
	"./elements/atoms/ErrorCard/ErrorCard.tsx": 1274,
	"./elements/atoms/ErrorCard/index": 1186,
	"./elements/atoms/ErrorCard/index.ts": 1186,
	"./elements/atoms/FeedbackTab/FeedbackTab": 1704,
	"./elements/atoms/FeedbackTab/FeedbackTab.module": 1080,
	"./elements/atoms/FeedbackTab/FeedbackTab.module.sass": 1080,
	"./elements/atoms/FeedbackTab/FeedbackTab.module.sass.d": 3001,
	"./elements/atoms/FeedbackTab/FeedbackTab.module.sass.d.ts": 3001,
	"./elements/atoms/FeedbackTab/FeedbackTab.tsx": 1704,
	"./elements/atoms/FileDecoder/FileDecoder": 2878,
	"./elements/atoms/FileDecoder/FileDecoder.module": 1645,
	"./elements/atoms/FileDecoder/FileDecoder.module.sass": 1645,
	"./elements/atoms/FileDecoder/FileDecoder.module.sass.d": 3002,
	"./elements/atoms/FileDecoder/FileDecoder.module.sass.d.ts": 3002,
	"./elements/atoms/FileDecoder/FileDecoder.stories": 3003,
	"./elements/atoms/FileDecoder/FileDecoder.stories.tsx": 3003,
	"./elements/atoms/FileDecoder/FileDecoder.tsx": 2878,
	"./elements/atoms/FixedBase": 281,
	"./elements/atoms/FixedBase/": 281,
	"./elements/atoms/FixedBase/FixedBase": 1990,
	"./elements/atoms/FixedBase/FixedBase.module": 1095,
	"./elements/atoms/FixedBase/FixedBase.module.sass": 1095,
	"./elements/atoms/FixedBase/FixedBase.module.sass.d": 3004,
	"./elements/atoms/FixedBase/FixedBase.module.sass.d.ts": 3004,
	"./elements/atoms/FixedBase/FixedBase.stories": 3005,
	"./elements/atoms/FixedBase/FixedBase.stories.tsx": 3005,
	"./elements/atoms/FixedBase/FixedBase.tsx": 1990,
	"./elements/atoms/FixedBase/index": 281,
	"./elements/atoms/FixedBase/index.ts": 281,
	"./elements/atoms/FlatButton/FlatButton": 215,
	"./elements/atoms/FlatButton/FlatButton.module": 2307,
	"./elements/atoms/FlatButton/FlatButton.module.sass": 2307,
	"./elements/atoms/FlatButton/FlatButton.module.sass.d": 3006,
	"./elements/atoms/FlatButton/FlatButton.module.sass.d.ts": 3006,
	"./elements/atoms/FlatButton/FlatButton.stories": 3007,
	"./elements/atoms/FlatButton/FlatButton.stories.tsx": 3007,
	"./elements/atoms/FlatButton/FlatButton.tsx": 215,
	"./elements/atoms/HybridSelect/HybridSelect": 2241,
	"./elements/atoms/HybridSelect/HybridSelect.module": 677,
	"./elements/atoms/HybridSelect/HybridSelect.module.sass": 677,
	"./elements/atoms/HybridSelect/HybridSelect.module.sass.d": 3008,
	"./elements/atoms/HybridSelect/HybridSelect.module.sass.d.ts": 3008,
	"./elements/atoms/HybridSelect/HybridSelect.stories": 3009,
	"./elements/atoms/HybridSelect/HybridSelect.stories.tsx": 3009,
	"./elements/atoms/HybridSelect/HybridSelect.tsx": 2241,
	"./elements/atoms/Icon/Icon": 11,
	"./elements/atoms/Icon/Icon.stories": 3010,
	"./elements/atoms/Icon/Icon.stories.tsx": 3010,
	"./elements/atoms/Icon/Icon.tsx": 11,
	"./elements/atoms/Icon/Icons": 267,
	"./elements/atoms/Icon/Icons/": 267,
	"./elements/atoms/Icon/Icons/Alert": 455,
	"./elements/atoms/Icon/Icons/Alert.tsx": 455,
	"./elements/atoms/Icon/Icons/Arrow": 456,
	"./elements/atoms/Icon/Icons/Arrow.tsx": 456,
	"./elements/atoms/Icon/Icons/Badge": 457,
	"./elements/atoms/Icon/Icons/Badge.tsx": 457,
	"./elements/atoms/Icon/Icons/Bin": 458,
	"./elements/atoms/Icon/Icons/Bin.tsx": 458,
	"./elements/atoms/Icon/Icons/BoxClosed": 459,
	"./elements/atoms/Icon/Icons/BoxClosed.tsx": 459,
	"./elements/atoms/Icon/Icons/BoxOpen": 429,
	"./elements/atoms/Icon/Icons/BoxOpen.tsx": 429,
	"./elements/atoms/Icon/Icons/BoxOpen/": 2879,
	"./elements/atoms/Icon/Icons/BoxOpen/BoxOpen": 1291,
	"./elements/atoms/Icon/Icons/BoxOpen/BoxOpen.tsx": 1291,
	"./elements/atoms/Icon/Icons/BoxOpen/index": 2879,
	"./elements/atoms/Icon/Icons/BoxOpen/index.ts": 2879,
	"./elements/atoms/Icon/Icons/Bubble": 460,
	"./elements/atoms/Icon/Icons/Bubble.tsx": 460,
	"./elements/atoms/Icon/Icons/ButternutLogo": 366,
	"./elements/atoms/Icon/Icons/ButternutLogo.tsx": 366,
	"./elements/atoms/Icon/Icons/Calendar": 454,
	"./elements/atoms/Icon/Icons/Calendar.tsx": 454,
	"./elements/atoms/Icon/Icons/CandyCane": 1690,
	"./elements/atoms/Icon/Icons/CandyCane/": 1690,
	"./elements/atoms/Icon/Icons/CandyCane/CandyCane": 2389,
	"./elements/atoms/Icon/Icons/CandyCane/CandyCane.tsx": 2389,
	"./elements/atoms/Icon/Icons/CandyCane/index": 1690,
	"./elements/atoms/Icon/Icons/CandyCane/index.ts": 1690,
	"./elements/atoms/Icon/Icons/Checkmark": 461,
	"./elements/atoms/Icon/Icons/Checkmark.tsx": 461,
	"./elements/atoms/Icon/Icons/Chevron": 409,
	"./elements/atoms/Icon/Icons/Chevron.module": 269,
	"./elements/atoms/Icon/Icons/Chevron.module.sass": 269,
	"./elements/atoms/Icon/Icons/Chevron.module.sass.d": 3011,
	"./elements/atoms/Icon/Icons/Chevron.module.sass.d.ts": 3011,
	"./elements/atoms/Icon/Icons/Chevron.tsx": 409,
	"./elements/atoms/Icon/Icons/ChevronFilled": 462,
	"./elements/atoms/Icon/Icons/ChevronFilled.tsx": 462,
	"./elements/atoms/Icon/Icons/Close": 463,
	"./elements/atoms/Icon/Icons/Close.tsx": 463,
	"./elements/atoms/Icon/Icons/CloseBold": 464,
	"./elements/atoms/Icon/Icons/CloseBold.tsx": 464,
	"./elements/atoms/Icon/Icons/Cog": 2390,
	"./elements/atoms/Icon/Icons/Cog/": 2390,
	"./elements/atoms/Icon/Icons/Cog/Cog": 2391,
	"./elements/atoms/Icon/Icons/Cog/Cog.tsx": 2391,
	"./elements/atoms/Icon/Icons/Cog/index": 2390,
	"./elements/atoms/Icon/Icons/Cog/index.ts": 2390,
	"./elements/atoms/Icon/Icons/CurvedArrow": 465,
	"./elements/atoms/Icon/Icons/CurvedArrow.tsx": 465,
	"./elements/atoms/Icon/Icons/CurvedDashedArrow": 466,
	"./elements/atoms/Icon/Icons/CurvedDashedArrow.tsx": 466,
	"./elements/atoms/Icon/Icons/Customer": 467,
	"./elements/atoms/Icon/Icons/Customer.tsx": 467,
	"./elements/atoms/Icon/Icons/DecorativeCheckbox": 468,
	"./elements/atoms/Icon/Icons/DecorativeCheckbox.tsx": 468,
	"./elements/atoms/Icon/Icons/DogBowl": 469,
	"./elements/atoms/Icon/Icons/DogBowl.tsx": 469,
	"./elements/atoms/Icon/Icons/DogProfileCollar": 1688,
	"./elements/atoms/Icon/Icons/DogProfileCollar/": 1688,
	"./elements/atoms/Icon/Icons/DogProfileCollar/DogProfileCollar": 1992,
	"./elements/atoms/Icon/Icons/DogProfileCollar/DogProfileCollar.module": 1879,
	"./elements/atoms/Icon/Icons/DogProfileCollar/DogProfileCollar.module.sass": 1879,
	"./elements/atoms/Icon/Icons/DogProfileCollar/DogProfileCollar.module.sass.d": 3012,
	"./elements/atoms/Icon/Icons/DogProfileCollar/DogProfileCollar.module.sass.d.ts": 3012,
	"./elements/atoms/Icon/Icons/DogProfileCollar/DogProfileCollar.tsx": 1992,
	"./elements/atoms/Icon/Icons/DogProfileCollar/index": 1688,
	"./elements/atoms/Icon/Icons/DogProfileCollar/index.ts": 1688,
	"./elements/atoms/Icon/Icons/Email": 470,
	"./elements/atoms/Icon/Icons/Email.tsx": 470,
	"./elements/atoms/Icon/Icons/ErrorCircle": 471,
	"./elements/atoms/Icon/Icons/ErrorCircle.tsx": 471,
	"./elements/atoms/Icon/Icons/ExtrasShop": 1689,
	"./elements/atoms/Icon/Icons/ExtrasShop/": 1689,
	"./elements/atoms/Icon/Icons/ExtrasShop/ExtrasShop": 1993,
	"./elements/atoms/Icon/Icons/ExtrasShop/ExtrasShop.module": 1880,
	"./elements/atoms/Icon/Icons/ExtrasShop/ExtrasShop.module.sass": 1880,
	"./elements/atoms/Icon/Icons/ExtrasShop/ExtrasShop.module.sass.d": 3013,
	"./elements/atoms/Icon/Icons/ExtrasShop/ExtrasShop.module.sass.d.ts": 3013,
	"./elements/atoms/Icon/Icons/ExtrasShop/ExtrasShop.tsx": 1993,
	"./elements/atoms/Icon/Icons/ExtrasShop/index": 1689,
	"./elements/atoms/Icon/Icons/ExtrasShop/index.ts": 1689,
	"./elements/atoms/Icon/Icons/Eye": 472,
	"./elements/atoms/Icon/Icons/Eye.tsx": 472,
	"./elements/atoms/Icon/Icons/Facebook": 473,
	"./elements/atoms/Icon/Icons/Facebook.tsx": 473,
	"./elements/atoms/Icon/Icons/FacebookLetter": 474,
	"./elements/atoms/Icon/Icons/FacebookLetter.tsx": 474,
	"./elements/atoms/Icon/Icons/Food": 475,
	"./elements/atoms/Icon/Icons/Food.tsx": 475,
	"./elements/atoms/Icon/Icons/HeartWithPlus": 476,
	"./elements/atoms/Icon/Icons/HeartWithPlus.tsx": 476,
	"./elements/atoms/Icon/Icons/Home": 1687,
	"./elements/atoms/Icon/Icons/Home/": 1687,
	"./elements/atoms/Icon/Icons/Home/Home": 1991,
	"./elements/atoms/Icon/Icons/Home/Home.module": 1878,
	"./elements/atoms/Icon/Icons/Home/Home.module.sass": 1878,
	"./elements/atoms/Icon/Icons/Home/Home.module.sass.d": 3014,
	"./elements/atoms/Icon/Icons/Home/Home.module.sass.d.ts": 3014,
	"./elements/atoms/Icon/Icons/Home/Home.tsx": 1991,
	"./elements/atoms/Icon/Icons/Home/index": 1687,
	"./elements/atoms/Icon/Icons/Home/index.ts": 1687,
	"./elements/atoms/Icon/Icons/House": 432,
	"./elements/atoms/Icon/Icons/House.tsx": 432,
	"./elements/atoms/Icon/Icons/House/": 2880,
	"./elements/atoms/Icon/Icons/House/House": 2392,
	"./elements/atoms/Icon/Icons/House/House.tsx": 2392,
	"./elements/atoms/Icon/Icons/House/index": 2880,
	"./elements/atoms/Icon/Icons/House/index.ts": 2880,
	"./elements/atoms/Icon/Icons/Letter": 1292,
	"./elements/atoms/Icon/Icons/Letter/": 1292,
	"./elements/atoms/Icon/Icons/Letter/Letter": 2393,
	"./elements/atoms/Icon/Icons/Letter/Letter.tsx": 2393,
	"./elements/atoms/Icon/Icons/Letter/index": 1292,
	"./elements/atoms/Icon/Icons/Letter/index.ts": 1292,
	"./elements/atoms/Icon/Icons/Lock": 477,
	"./elements/atoms/Icon/Icons/Lock.tsx": 477,
	"./elements/atoms/Icon/Icons/Logout": 1293,
	"./elements/atoms/Icon/Icons/Logout/": 1293,
	"./elements/atoms/Icon/Icons/Logout/Logout": 2394,
	"./elements/atoms/Icon/Icons/Logout/Logout.tsx": 2394,
	"./elements/atoms/Icon/Icons/Logout/index": 1293,
	"./elements/atoms/Icon/Icons/Logout/index.ts": 1293,
	"./elements/atoms/Icon/Icons/Minus": 478,
	"./elements/atoms/Icon/Icons/Minus.tsx": 478,
	"./elements/atoms/Icon/Icons/Padlock": 479,
	"./elements/atoms/Icon/Icons/Padlock.tsx": 479,
	"./elements/atoms/Icon/Icons/Pause": 480,
	"./elements/atoms/Icon/Icons/Pause.tsx": 480,
	"./elements/atoms/Icon/Icons/Paw": 481,
	"./elements/atoms/Icon/Icons/Paw.tsx": 481,
	"./elements/atoms/Icon/Icons/PaymentMethod": 482,
	"./elements/atoms/Icon/Icons/PaymentMethod.tsx": 482,
	"./elements/atoms/Icon/Icons/PaymentMethods": 1294,
	"./elements/atoms/Icon/Icons/PaymentMethods/": 1294,
	"./elements/atoms/Icon/Icons/PaymentMethods/PaymentMethods": 2395,
	"./elements/atoms/Icon/Icons/PaymentMethods/PaymentMethods.tsx": 2395,
	"./elements/atoms/Icon/Icons/PaymentMethods/index": 1294,
	"./elements/atoms/Icon/Icons/PaymentMethods/index.ts": 1294,
	"./elements/atoms/Icon/Icons/Person": 2396,
	"./elements/atoms/Icon/Icons/Person/": 2396,
	"./elements/atoms/Icon/Icons/Person/Person": 1191,
	"./elements/atoms/Icon/Icons/Person/Person.module": 3015,
	"./elements/atoms/Icon/Icons/Person/Person.module.sass": 3015,
	"./elements/atoms/Icon/Icons/Person/Person.module.sass.d": 3016,
	"./elements/atoms/Icon/Icons/Person/Person.module.sass.d.ts": 3016,
	"./elements/atoms/Icon/Icons/Person/Person.tsx": 1191,
	"./elements/atoms/Icon/Icons/Person/index": 2396,
	"./elements/atoms/Icon/Icons/Person/index.ts": 2396,
	"./elements/atoms/Icon/Icons/Phone": 434,
	"./elements/atoms/Icon/Icons/Phone.tsx": 434,
	"./elements/atoms/Icon/Icons/Phone/": 2881,
	"./elements/atoms/Icon/Icons/Phone/Phone": 1295,
	"./elements/atoms/Icon/Icons/Phone/Phone.tsx": 1295,
	"./elements/atoms/Icon/Icons/Phone/index": 2881,
	"./elements/atoms/Icon/Icons/Phone/index.ts": 2881,
	"./elements/atoms/Icon/Icons/Play": 483,
	"./elements/atoms/Icon/Icons/Play.tsx": 483,
	"./elements/atoms/Icon/Icons/Plus": 383,
	"./elements/atoms/Icon/Icons/Plus.tsx": 383,
	"./elements/atoms/Icon/Icons/Pouch": 484,
	"./elements/atoms/Icon/Icons/Pouch.tsx": 484,
	"./elements/atoms/Icon/Icons/Question": 485,
	"./elements/atoms/Icon/Icons/Question.tsx": 485,
	"./elements/atoms/Icon/Icons/RadioSelected": 486,
	"./elements/atoms/Icon/Icons/RadioSelected.tsx": 486,
	"./elements/atoms/Icon/Icons/RadioUnselected": 487,
	"./elements/atoms/Icon/Icons/RadioUnselected.tsx": 487,
	"./elements/atoms/Icon/Icons/Receipt": 488,
	"./elements/atoms/Icon/Icons/Receipt.tsx": 488,
	"./elements/atoms/Icon/Icons/Rewards": 1691,
	"./elements/atoms/Icon/Icons/Rewards/": 1691,
	"./elements/atoms/Icon/Icons/Rewards/Rewards": 1994,
	"./elements/atoms/Icon/Icons/Rewards/Rewards.module": 1881,
	"./elements/atoms/Icon/Icons/Rewards/Rewards.module.sass": 1881,
	"./elements/atoms/Icon/Icons/Rewards/Rewards.module.sass.d": 3017,
	"./elements/atoms/Icon/Icons/Rewards/Rewards.module.sass.d.ts": 3017,
	"./elements/atoms/Icon/Icons/Rewards/Rewards.tsx": 1994,
	"./elements/atoms/Icon/Icons/Rewards/index": 1691,
	"./elements/atoms/Icon/Icons/Rewards/index.ts": 1691,
	"./elements/atoms/Icon/Icons/ShoppingDog": 489,
	"./elements/atoms/Icon/Icons/ShoppingDog.tsx": 489,
	"./elements/atoms/Icon/Icons/Sprinkles": 490,
	"./elements/atoms/Icon/Icons/Sprinkles.tsx": 490,
	"./elements/atoms/Icon/Icons/SquiggleDashedArrow": 491,
	"./elements/atoms/Icon/Icons/SquiggleDashedArrow.tsx": 491,
	"./elements/atoms/Icon/Icons/Star": 492,
	"./elements/atoms/Icon/Icons/Star.tsx": 492,
	"./elements/atoms/Icon/Icons/Stethoscope": 493,
	"./elements/atoms/Icon/Icons/Stethoscope.tsx": 493,
	"./elements/atoms/Icon/Icons/StopVan": 494,
	"./elements/atoms/Icon/Icons/StopVan.tsx": 494,
	"./elements/atoms/Icon/Icons/SurveyClose": 495,
	"./elements/atoms/Icon/Icons/SurveyClose.tsx": 495,
	"./elements/atoms/Icon/Icons/Van": 496,
	"./elements/atoms/Icon/Icons/Van.tsx": 496,
	"./elements/atoms/Icon/Icons/VanFilled": 497,
	"./elements/atoms/Icon/Icons/VanFilled.tsx": 497,
	"./elements/atoms/Icon/Icons/WhatsApp": 498,
	"./elements/atoms/Icon/Icons/WhatsApp.tsx": 498,
	"./elements/atoms/Icon/Icons/curvedarrow": 430,
	"./elements/atoms/Icon/Icons/curvedarrow.module": 430,
	"./elements/atoms/Icon/Icons/curvedarrow.module.sass": 430,
	"./elements/atoms/Icon/Icons/curvedarrow.module.sass.d": 3018,
	"./elements/atoms/Icon/Icons/curvedarrow.module.sass.d.ts": 3018,
	"./elements/atoms/Icon/Icons/curveddashedarrow": 431,
	"./elements/atoms/Icon/Icons/curveddashedarrow.module": 431,
	"./elements/atoms/Icon/Icons/curveddashedarrow.module.sass": 431,
	"./elements/atoms/Icon/Icons/curveddashedarrow.module.sass.d": 3019,
	"./elements/atoms/Icon/Icons/curveddashedarrow.module.sass.d.ts": 3019,
	"./elements/atoms/Icon/Icons/index": 267,
	"./elements/atoms/Icon/Icons/index.ts": 267,
	"./elements/atoms/Icon/Icons/paw": 433,
	"./elements/atoms/Icon/Icons/paw.module": 433,
	"./elements/atoms/Icon/Icons/paw.module.sass": 433,
	"./elements/atoms/Icon/Icons/paw.module.sass.d": 3020,
	"./elements/atoms/Icon/Icons/paw.module.sass.d.ts": 3020,
	"./elements/atoms/Icon/Icons/sprinkles": 435,
	"./elements/atoms/Icon/Icons/sprinkles.module": 435,
	"./elements/atoms/Icon/Icons/sprinkles.module.sass": 435,
	"./elements/atoms/Icon/Icons/sprinkles.module.sass.d": 3021,
	"./elements/atoms/Icon/Icons/sprinkles.module.sass.d.ts": 3021,
	"./elements/atoms/Icon/Icons/star": 341,
	"./elements/atoms/Icon/Icons/star.module": 341,
	"./elements/atoms/Icon/Icons/star.module.sass": 341,
	"./elements/atoms/Icon/Icons/star.module.sass.d": 3022,
	"./elements/atoms/Icon/Icons/star.module.sass.d.ts": 3022,
	"./elements/atoms/Icon/brandAssets": 453,
	"./elements/atoms/Icon/brandAssets.ts": 453,
	"./elements/atoms/Image": 227,
	"./elements/atoms/Image/": 227,
	"./elements/atoms/Image/Image": 82,
	"./elements/atoms/Image/Image.module": 871,
	"./elements/atoms/Image/Image.module.sass": 871,
	"./elements/atoms/Image/Image.module.sass.d": 3023,
	"./elements/atoms/Image/Image.module.sass.d.ts": 3023,
	"./elements/atoms/Image/Image.stories": 3024,
	"./elements/atoms/Image/Image.stories.tsx": 3024,
	"./elements/atoms/Image/Image.tsx": 82,
	"./elements/atoms/Image/index": 227,
	"./elements/atoms/Image/index.ts": 227,
	"./elements/atoms/InPageNotification": 1125,
	"./elements/atoms/InPageNotification/": 1125,
	"./elements/atoms/InPageNotification/InPageNotification": 536,
	"./elements/atoms/InPageNotification/InPageNotification.module": 1882,
	"./elements/atoms/InPageNotification/InPageNotification.module.sass": 1882,
	"./elements/atoms/InPageNotification/InPageNotification.module.sass.d": 3025,
	"./elements/atoms/InPageNotification/InPageNotification.module.sass.d.ts": 3025,
	"./elements/atoms/InPageNotification/InPageNotification.tsx": 536,
	"./elements/atoms/InPageNotification/index": 1125,
	"./elements/atoms/InPageNotification/index.ts": 1125,
	"./elements/atoms/InPageNotification/toastify": 845,
	"./elements/atoms/InPageNotification/toastify/": 845,
	"./elements/atoms/InPageNotification/toastify/error": 2397,
	"./elements/atoms/InPageNotification/toastify/error.tsx": 2397,
	"./elements/atoms/InPageNotification/toastify/index": 845,
	"./elements/atoms/InPageNotification/toastify/index.ts": 845,
	"./elements/atoms/InPageNotification/toastify/info": 2399,
	"./elements/atoms/InPageNotification/toastify/info.tsx": 2399,
	"./elements/atoms/InPageNotification/toastify/success": 2398,
	"./elements/atoms/InPageNotification/toastify/success.tsx": 2398,
	"./elements/atoms/InPageNotification/toastify/warn": 2400,
	"./elements/atoms/InPageNotification/toastify/warn.tsx": 2400,
	"./elements/atoms/Interactive/Interactive": 221,
	"./elements/atoms/Interactive/Interactive.module": 316,
	"./elements/atoms/Interactive/Interactive.module.sass": 316,
	"./elements/atoms/Interactive/Interactive.module.sass.d": 3026,
	"./elements/atoms/Interactive/Interactive.module.sass.d.ts": 3026,
	"./elements/atoms/Interactive/Interactive.tsx": 221,
	"./elements/atoms/Label/Label": 209,
	"./elements/atoms/Label/Label.module": 1646,
	"./elements/atoms/Label/Label.module.sass": 1646,
	"./elements/atoms/Label/Label.module.sass.d": 3027,
	"./elements/atoms/Label/Label.module.sass.d.ts": 3027,
	"./elements/atoms/Label/Label.stories": 3028,
	"./elements/atoms/Label/Label.stories.tsx": 3028,
	"./elements/atoms/Label/Label.tsx": 209,
	"./elements/atoms/Link/Link": 329,
	"./elements/atoms/Link/Link.module": 450,
	"./elements/atoms/Link/Link.module.sass": 450,
	"./elements/atoms/Link/Link.module.sass.d": 3029,
	"./elements/atoms/Link/Link.module.sass.d.ts": 3029,
	"./elements/atoms/Link/Link.stories": 3030,
	"./elements/atoms/Link/Link.stories.tsx": 3030,
	"./elements/atoms/Link/Link.tsx": 329,
	"./elements/atoms/ListItem/ListItem": 2099,
	"./elements/atoms/ListItem/ListItem.module": 2308,
	"./elements/atoms/ListItem/ListItem.module.sass": 2308,
	"./elements/atoms/ListItem/ListItem.module.sass.d": 3031,
	"./elements/atoms/ListItem/ListItem.module.sass.d.ts": 3031,
	"./elements/atoms/ListItem/ListItem.stories": 3032,
	"./elements/atoms/ListItem/ListItem.stories.tsx": 3032,
	"./elements/atoms/ListItem/ListItem.tsx": 2099,
	"./elements/atoms/LoadingOverlay/LoadingOverlay": 924,
	"./elements/atoms/LoadingOverlay/LoadingOverlay.module": 1219,
	"./elements/atoms/LoadingOverlay/LoadingOverlay.module.sass": 1219,
	"./elements/atoms/LoadingOverlay/LoadingOverlay.module.sass.d": 3033,
	"./elements/atoms/LoadingOverlay/LoadingOverlay.module.sass.d.ts": 3033,
	"./elements/atoms/LoadingOverlay/LoadingOverlay.tsx": 924,
	"./elements/atoms/MerchandisingCard/MerchandisingCard": 1360,
	"./elements/atoms/MerchandisingCard/MerchandisingCard.module": 1390,
	"./elements/atoms/MerchandisingCard/MerchandisingCard.module.sass": 1390,
	"./elements/atoms/MerchandisingCard/MerchandisingCard.module.sass.d": 3044,
	"./elements/atoms/MerchandisingCard/MerchandisingCard.module.sass.d.ts": 3044,
	"./elements/atoms/MerchandisingCard/MerchandisingCard.stories": 3045,
	"./elements/atoms/MerchandisingCard/MerchandisingCard.stories.tsx": 3045,
	"./elements/atoms/MerchandisingCard/MerchandisingCard.tsx": 1360,
	"./elements/atoms/Modal/Modal": 121,
	"./elements/atoms/Modal/Modal.module": 319,
	"./elements/atoms/Modal/Modal.module.sass": 319,
	"./elements/atoms/Modal/Modal.module.sass.d": 3046,
	"./elements/atoms/Modal/Modal.module.sass.d.ts": 3046,
	"./elements/atoms/Modal/Modal.stories": 3047,
	"./elements/atoms/Modal/Modal.stories.tsx": 3047,
	"./elements/atoms/Modal/Modal.tsx": 121,
	"./elements/atoms/Modal/hooks/useCloseOnSwipe": 1538,
	"./elements/atoms/Modal/hooks/useCloseOnSwipe.ts": 1538,
	"./elements/atoms/ModalSkeletonTermplate/ModalSkeletonTemplate": 2597,
	"./elements/atoms/ModalSkeletonTermplate/ModalSkeletonTemplate.stories": 3048,
	"./elements/atoms/ModalSkeletonTermplate/ModalSkeletonTemplate.stories.tsx": 3048,
	"./elements/atoms/ModalSkeletonTermplate/ModalSkeletonTemplate.tsx": 2597,
	"./elements/atoms/MultiLineTextField/MultiLineTextField": 549,
	"./elements/atoms/MultiLineTextField/MultiLineTextField.module": 376,
	"./elements/atoms/MultiLineTextField/MultiLineTextField.module.sass": 376,
	"./elements/atoms/MultiLineTextField/MultiLineTextField.module.sass.d": 3049,
	"./elements/atoms/MultiLineTextField/MultiLineTextField.module.sass.d.ts": 3049,
	"./elements/atoms/MultiLineTextField/MultiLineTextField.stories": 3050,
	"./elements/atoms/MultiLineTextField/MultiLineTextField.stories.tsx": 3050,
	"./elements/atoms/MultiLineTextField/MultiLineTextField.tsx": 549,
	"./elements/atoms/NavLink/NavLink": 232,
	"./elements/atoms/NavLink/NavLink.module": 855,
	"./elements/atoms/NavLink/NavLink.module.sass": 855,
	"./elements/atoms/NavLink/NavLink.module.sass.d": 3051,
	"./elements/atoms/NavLink/NavLink.module.sass.d.ts": 3051,
	"./elements/atoms/NavLink/NavLink.stories": 3052,
	"./elements/atoms/NavLink/NavLink.stories.tsx": 3052,
	"./elements/atoms/NavLink/NavLink.tsx": 232,
	"./elements/atoms/NavLogo/NavLogo": 771,
	"./elements/atoms/NavLogo/NavLogo.module": 2569,
	"./elements/atoms/NavLogo/NavLogo.module.sass": 2569,
	"./elements/atoms/NavLogo/NavLogo.module.sass.d": 3053,
	"./elements/atoms/NavLogo/NavLogo.module.sass.d.ts": 3053,
	"./elements/atoms/NavLogo/NavLogo.stories": 3054,
	"./elements/atoms/NavLogo/NavLogo.stories.tsx": 3054,
	"./elements/atoms/NavLogo/NavLogo.tsx": 771,
	"./elements/atoms/NavMenuIcon/NavMenuIcon": 2209,
	"./elements/atoms/NavMenuIcon/NavMenuIcon.module": 2753,
	"./elements/atoms/NavMenuIcon/NavMenuIcon.module.sass": 2753,
	"./elements/atoms/NavMenuIcon/NavMenuIcon.module.sass.d": 3055,
	"./elements/atoms/NavMenuIcon/NavMenuIcon.module.sass.d.ts": 3055,
	"./elements/atoms/NavMenuIcon/NavMenuIcon.stories": 3056,
	"./elements/atoms/NavMenuIcon/NavMenuIcon.stories.tsx": 3056,
	"./elements/atoms/NavMenuIcon/NavMenuIcon.tsx": 2209,
	"./elements/atoms/Pill": 2442,
	"./elements/atoms/Pill/": 2442,
	"./elements/atoms/Pill/Pill": 659,
	"./elements/atoms/Pill/Pill.module": 675,
	"./elements/atoms/Pill/Pill.module.sass": 675,
	"./elements/atoms/Pill/Pill.module.sass.d": 3057,
	"./elements/atoms/Pill/Pill.module.sass.d.ts": 3057,
	"./elements/atoms/Pill/Pill.stories": 3058,
	"./elements/atoms/Pill/Pill.stories.tsx": 3058,
	"./elements/atoms/Pill/Pill.tsx": 659,
	"./elements/atoms/Pill/PillSkeleton": 2542,
	"./elements/atoms/Pill/PillSkeleton.tsx": 2542,
	"./elements/atoms/Pill/index": 2442,
	"./elements/atoms/Pill/index.js": 2442,
	"./elements/atoms/PillToggle/PillToggle": 2110,
	"./elements/atoms/PillToggle/PillToggle.module": 1891,
	"./elements/atoms/PillToggle/PillToggle.module.sass": 1891,
	"./elements/atoms/PillToggle/PillToggle.module.sass.d": 3059,
	"./elements/atoms/PillToggle/PillToggle.module.sass.d.ts": 3059,
	"./elements/atoms/PillToggle/PillToggle.stories": 3060,
	"./elements/atoms/PillToggle/PillToggle.stories.tsx": 3060,
	"./elements/atoms/PillToggle/PillToggle.tsx": 2110,
	"./elements/atoms/Portal": 929,
	"./elements/atoms/Portal/": 929,
	"./elements/atoms/Portal/Portal": 2409,
	"./elements/atoms/Portal/Portal.tsx": 2409,
	"./elements/atoms/Portal/index": 929,
	"./elements/atoms/Portal/index.ts": 929,
	"./elements/atoms/Pouch/Pouch": 2888,
	"./elements/atoms/Pouch/Pouch.module": 1268,
	"./elements/atoms/Pouch/Pouch.module.sass": 1268,
	"./elements/atoms/Pouch/Pouch.module.sass.d": 3061,
	"./elements/atoms/Pouch/Pouch.module.sass.d.ts": 3061,
	"./elements/atoms/Pouch/Pouch.tsx": 2888,
	"./elements/atoms/ProductThumb/ProductThumb": 1349,
	"./elements/atoms/ProductThumb/ProductThumb.module.sass.d": 3062,
	"./elements/atoms/ProductThumb/ProductThumb.module.sass.d.ts": 3062,
	"./elements/atoms/ProductThumb/ProductThumb.stories": 3063,
	"./elements/atoms/ProductThumb/ProductThumb.stories.tsx": 3063,
	"./elements/atoms/ProductThumb/ProductThumb.tsx": 1349,
	"./elements/atoms/ProgressBar/ProgressBar": 933,
	"./elements/atoms/ProgressBar/ProgressBar.module": 1259,
	"./elements/atoms/ProgressBar/ProgressBar.module.sass": 1259,
	"./elements/atoms/ProgressBar/ProgressBar.module.sass.d": 3064,
	"./elements/atoms/ProgressBar/ProgressBar.module.sass.d.ts": 3064,
	"./elements/atoms/ProgressBar/ProgressBar.stories": 3065,
	"./elements/atoms/ProgressBar/ProgressBar.stories.tsx": 3065,
	"./elements/atoms/ProgressBar/ProgressBar.tsx": 933,
	"./elements/atoms/QuantitySelector/QuantitySelector": 593,
	"./elements/atoms/QuantitySelector/QuantitySelector.module": 543,
	"./elements/atoms/QuantitySelector/QuantitySelector.module.sass": 543,
	"./elements/atoms/QuantitySelector/QuantitySelector.module.sass.d": 3066,
	"./elements/atoms/QuantitySelector/QuantitySelector.module.sass.d.ts": 3066,
	"./elements/atoms/QuantitySelector/QuantitySelector.stories": 3067,
	"./elements/atoms/QuantitySelector/QuantitySelector.stories.tsx": 3067,
	"./elements/atoms/QuantitySelector/QuantitySelector.tsx": 593,
	"./elements/atoms/RadioButton/RadioButton": 2104,
	"./elements/atoms/RadioButton/RadioButton.module": 781,
	"./elements/atoms/RadioButton/RadioButton.module.sass": 781,
	"./elements/atoms/RadioButton/RadioButton.module.sass.d": 3068,
	"./elements/atoms/RadioButton/RadioButton.module.sass.d.ts": 3068,
	"./elements/atoms/RadioButton/RadioButton.stories": 3069,
	"./elements/atoms/RadioButton/RadioButton.stories.tsx": 3069,
	"./elements/atoms/RadioButton/RadioButton.tsx": 2104,
	"./elements/atoms/Ribbon/Ribbon": 2210,
	"./elements/atoms/Ribbon/Ribbon.module": 1113,
	"./elements/atoms/Ribbon/Ribbon.module.sass": 1113,
	"./elements/atoms/Ribbon/Ribbon.module.sass.d": 3070,
	"./elements/atoms/Ribbon/Ribbon.module.sass.d.ts": 3070,
	"./elements/atoms/Ribbon/Ribbon.stories": 3071,
	"./elements/atoms/Ribbon/Ribbon.stories.tsx": 3071,
	"./elements/atoms/Ribbon/Ribbon.tsx": 2210,
	"./elements/atoms/RuffActually/RuffActually": 2100,
	"./elements/atoms/RuffActually/RuffActually.module": 2309,
	"./elements/atoms/RuffActually/RuffActually.module.sass": 2309,
	"./elements/atoms/RuffActually/RuffActually.module.sass.d": 3072,
	"./elements/atoms/RuffActually/RuffActually.module.sass.d.ts": 3072,
	"./elements/atoms/RuffActually/RuffActually.tsx": 2100,
	"./elements/atoms/SectionWrapper": 77,
	"./elements/atoms/SectionWrapper/": 77,
	"./elements/atoms/SectionWrapper/SectionWrapper": 1995,
	"./elements/atoms/SectionWrapper/SectionWrapper.module": 895,
	"./elements/atoms/SectionWrapper/SectionWrapper.module.sass": 895,
	"./elements/atoms/SectionWrapper/SectionWrapper.module.sass.d": 3073,
	"./elements/atoms/SectionWrapper/SectionWrapper.module.sass.d.ts": 3073,
	"./elements/atoms/SectionWrapper/SectionWrapper.stories": 3074,
	"./elements/atoms/SectionWrapper/SectionWrapper.stories.tsx": 3074,
	"./elements/atoms/SectionWrapper/SectionWrapper.tsx": 1995,
	"./elements/atoms/SectionWrapper/components/HeaderRightAdornment": 1580,
	"./elements/atoms/SectionWrapper/components/HeaderRightAdornment/": 1580,
	"./elements/atoms/SectionWrapper/components/HeaderRightAdornment/HeaderRightAdornment": 2401,
	"./elements/atoms/SectionWrapper/components/HeaderRightAdornment/HeaderRightAdornment.tsx": 2401,
	"./elements/atoms/SectionWrapper/components/HeaderRightAdornment/index": 1580,
	"./elements/atoms/SectionWrapper/components/HeaderRightAdornment/index.ts": 1580,
	"./elements/atoms/SectionWrapper/index": 77,
	"./elements/atoms/SectionWrapper/index.ts": 77,
	"./elements/atoms/Select/Select": 2137,
	"./elements/atoms/Select/Select.module": 957,
	"./elements/atoms/Select/Select.module.sass": 957,
	"./elements/atoms/Select/Select.module.sass.d": 3075,
	"./elements/atoms/Select/Select.module.sass.d.ts": 3075,
	"./elements/atoms/Select/Select.stories": 3076,
	"./elements/atoms/Select/Select.stories.tsx": 3076,
	"./elements/atoms/Select/Select.tsx": 2137,
	"./elements/atoms/Separator/Separator": 192,
	"./elements/atoms/Separator/Separator.module": 810,
	"./elements/atoms/Separator/Separator.module.sass": 810,
	"./elements/atoms/Separator/Separator.module.sass.d": 3077,
	"./elements/atoms/Separator/Separator.module.sass.d.ts": 3077,
	"./elements/atoms/Separator/Separator.stories": 3078,
	"./elements/atoms/Separator/Separator.stories.tsx": 3078,
	"./elements/atoms/Separator/Separator.tsx": 192,
	"./elements/atoms/SimpleNav/SimpleNav": 2754,
	"./elements/atoms/SimpleNav/SimpleNav.stories": 3079,
	"./elements/atoms/SimpleNav/SimpleNav.stories.tsx": 3079,
	"./elements/atoms/SimpleNav/SimpleNav.tsx": 2754,
	"./elements/atoms/SimpleNav/simplenav": 849,
	"./elements/atoms/SimpleNav/simplenav.module": 849,
	"./elements/atoms/SimpleNav/simplenav.module.sass": 849,
	"./elements/atoms/SimpleNav/simplenav.module.sass.d": 3080,
	"./elements/atoms/SimpleNav/simplenav.module.sass.d.ts": 3080,
	"./elements/atoms/SkeletonButton/SkeletonButton": 229,
	"./elements/atoms/SkeletonButton/SkeletonButton.module": 1885,
	"./elements/atoms/SkeletonButton/SkeletonButton.module.sass": 1885,
	"./elements/atoms/SkeletonButton/SkeletonButton.module.sass.d": 3081,
	"./elements/atoms/SkeletonButton/SkeletonButton.module.sass.d.ts": 3081,
	"./elements/atoms/SkeletonButton/SkeletonButton.stories": 3082,
	"./elements/atoms/SkeletonButton/SkeletonButton.stories.tsx": 3082,
	"./elements/atoms/SkeletonButton/SkeletonButton.tsx": 229,
	"./elements/atoms/SkeletonImage/SkeletonImage": 516,
	"./elements/atoms/SkeletonImage/SkeletonImage.module": 1892,
	"./elements/atoms/SkeletonImage/SkeletonImage.module.sass": 1892,
	"./elements/atoms/SkeletonImage/SkeletonImage.module.sass.d": 3083,
	"./elements/atoms/SkeletonImage/SkeletonImage.module.sass.d.ts": 3083,
	"./elements/atoms/SkeletonImage/SkeletonImage.stories": 3084,
	"./elements/atoms/SkeletonImage/SkeletonImage.stories.tsx": 3084,
	"./elements/atoms/SkeletonImage/SkeletonImage.tsx": 516,
	"./elements/atoms/SkeletonLoading/SkeletonLoading": 765,
	"./elements/atoms/SkeletonLoading/SkeletonLoading.module": 1520,
	"./elements/atoms/SkeletonLoading/SkeletonLoading.module.sass": 1520,
	"./elements/atoms/SkeletonLoading/SkeletonLoading.module.sass.d": 3085,
	"./elements/atoms/SkeletonLoading/SkeletonLoading.module.sass.d.ts": 3085,
	"./elements/atoms/SkeletonLoading/SkeletonLoading.stories": 3086,
	"./elements/atoms/SkeletonLoading/SkeletonLoading.stories.tsx": 3086,
	"./elements/atoms/SkeletonLoading/SkeletonLoading.tsx": 765,
	"./elements/atoms/SkeletonParagraph/SkeletonParagraph": 191,
	"./elements/atoms/SkeletonParagraph/SkeletonParagraph.module": 1213,
	"./elements/atoms/SkeletonParagraph/SkeletonParagraph.module.sass": 1213,
	"./elements/atoms/SkeletonParagraph/SkeletonParagraph.module.sass.d": 3087,
	"./elements/atoms/SkeletonParagraph/SkeletonParagraph.module.sass.d.ts": 3087,
	"./elements/atoms/SkeletonParagraph/SkeletonParagraph.stories": 3088,
	"./elements/atoms/SkeletonParagraph/SkeletonParagraph.stories.tsx": 3088,
	"./elements/atoms/SkeletonParagraph/SkeletonParagraph.tsx": 191,
	"./elements/atoms/SkeletonTitle/SkeletonTitle": 183,
	"./elements/atoms/SkeletonTitle/SkeletonTitle.module": 1214,
	"./elements/atoms/SkeletonTitle/SkeletonTitle.module.sass": 1214,
	"./elements/atoms/SkeletonTitle/SkeletonTitle.module.sass.d": 3089,
	"./elements/atoms/SkeletonTitle/SkeletonTitle.module.sass.d.ts": 3089,
	"./elements/atoms/SkeletonTitle/SkeletonTitle.stories": 3090,
	"./elements/atoms/SkeletonTitle/SkeletonTitle.stories.tsx": 3090,
	"./elements/atoms/SkeletonTitle/SkeletonTitle.tsx": 183,
	"./elements/atoms/SocialLink/SocialLink": 1242,
	"./elements/atoms/SocialLink/SocialLink.stories": 3091,
	"./elements/atoms/SocialLink/SocialLink.stories.tsx": 3091,
	"./elements/atoms/SocialLink/SocialLink.tsx": 1242,
	"./elements/atoms/SpeechBubble/SpeechBubble": 505,
	"./elements/atoms/SpeechBubble/SpeechBubble.module": 1161,
	"./elements/atoms/SpeechBubble/SpeechBubble.module.sass": 1161,
	"./elements/atoms/SpeechBubble/SpeechBubble.module.sass.d": 3092,
	"./elements/atoms/SpeechBubble/SpeechBubble.module.sass.d.ts": 3092,
	"./elements/atoms/SpeechBubble/SpeechBubble.stories": 3093,
	"./elements/atoms/SpeechBubble/SpeechBubble.stories.tsx": 3093,
	"./elements/atoms/SpeechBubble/SpeechBubble.tsx": 505,
	"./elements/atoms/Spinner/Spinner": 688,
	"./elements/atoms/Spinner/Spinner.module": 1218,
	"./elements/atoms/Spinner/Spinner.module.sass": 1218,
	"./elements/atoms/Spinner/Spinner.module.sass.d": 3094,
	"./elements/atoms/Spinner/Spinner.module.sass.d.ts": 3094,
	"./elements/atoms/Spinner/Spinner.stories": 3095,
	"./elements/atoms/Spinner/Spinner.stories.tsx": 3095,
	"./elements/atoms/Spinner/Spinner.tsx": 688,
	"./elements/atoms/Switch/Switch": 2803,
	"./elements/atoms/Switch/Switch.tsx": 2803,
	"./elements/atoms/Switch/__snapshots__/Switch.spec.tsx.snap": 4308,
	"./elements/atoms/Tabs/Tabs": 673,
	"./elements/atoms/Tabs/Tabs.module": 783,
	"./elements/atoms/Tabs/Tabs.module.sass": 783,
	"./elements/atoms/Tabs/Tabs.module.sass.d": 3096,
	"./elements/atoms/Tabs/Tabs.module.sass.d.ts": 3096,
	"./elements/atoms/Tabs/Tabs.stories": 3097,
	"./elements/atoms/Tabs/Tabs.stories.tsx": 3097,
	"./elements/atoms/Tabs/Tabs.tsx": 673,
	"./elements/atoms/Text": 57,
	"./elements/atoms/Text/": 57,
	"./elements/atoms/Text/Text": 3,
	"./elements/atoms/Text/Text.module": 87,
	"./elements/atoms/Text/Text.module.sass": 87,
	"./elements/atoms/Text/Text.module.sass.d": 3098,
	"./elements/atoms/Text/Text.module.sass.d.ts": 3098,
	"./elements/atoms/Text/Text.stories": 3099,
	"./elements/atoms/Text/Text.stories.tsx": 3099,
	"./elements/atoms/Text/Text.tsx": 3,
	"./elements/atoms/Text/__snapshots__/Text.spec.tsx.snap": 4309,
	"./elements/atoms/Text/index": 57,
	"./elements/atoms/Text/index.js": 4310,
	"./elements/atoms/Text/index.ts": 57,
	"./elements/atoms/TextField/TextField": 288,
	"./elements/atoms/TextField/TextField.stories": 3100,
	"./elements/atoms/TextField/TextField.stories.tsx": 3100,
	"./elements/atoms/TextField/TextField.tsx": 288,
	"./elements/atoms/TextField/text_field": 370,
	"./elements/atoms/TextField/text_field.module": 370,
	"./elements/atoms/TextField/text_field.module.sass": 370,
	"./elements/atoms/TextField/text_field.module.sass.d": 3101,
	"./elements/atoms/TextField/text_field.module.sass.d.ts": 3101,
	"./elements/atoms/TextInput": 1145,
	"./elements/atoms/TextInput/": 1145,
	"./elements/atoms/TextInput/TextInput": 2062,
	"./elements/atoms/TextInput/TextInput.module": 961,
	"./elements/atoms/TextInput/TextInput.module.sass": 961,
	"./elements/atoms/TextInput/TextInput.module.sass.d": 3102,
	"./elements/atoms/TextInput/TextInput.module.sass.d.ts": 3102,
	"./elements/atoms/TextInput/TextInput.tsx": 2062,
	"./elements/atoms/TextInput/index": 1145,
	"./elements/atoms/TextInput/index.ts": 1145,
	"./elements/atoms/Toggle/Toggle": 2211,
	"./elements/atoms/Toggle/Toggle.module": 2358,
	"./elements/atoms/Toggle/Toggle.module.sass": 2358,
	"./elements/atoms/Toggle/Toggle.module.sass.d": 3103,
	"./elements/atoms/Toggle/Toggle.module.sass.d.ts": 3103,
	"./elements/atoms/Toggle/Toggle.stories": 3104,
	"./elements/atoms/Toggle/Toggle.stories.tsx": 3104,
	"./elements/atoms/Toggle/Toggle.tsx": 2211,
	"./elements/atoms/Tooltip": 2443,
	"./elements/atoms/Tooltip/": 2443,
	"./elements/atoms/Tooltip/Tooltip": 444,
	"./elements/atoms/Tooltip/Tooltip.module": 1162,
	"./elements/atoms/Tooltip/Tooltip.module.sass": 1162,
	"./elements/atoms/Tooltip/Tooltip.module.sass.d": 3105,
	"./elements/atoms/Tooltip/Tooltip.module.sass.d.ts": 3105,
	"./elements/atoms/Tooltip/Tooltip.stories": 3106,
	"./elements/atoms/Tooltip/Tooltip.stories.tsx": 3106,
	"./elements/atoms/Tooltip/Tooltip.tsx": 444,
	"./elements/atoms/Tooltip/index": 2443,
	"./elements/atoms/Tooltip/index.js": 2443,
	"./elements/atoms/TopBanner/TopBanner": 936,
	"./elements/atoms/TopBanner/TopBanner.module": 746,
	"./elements/atoms/TopBanner/TopBanner.module.sass": 746,
	"./elements/atoms/TopBanner/TopBanner.module.sass.d": 3107,
	"./elements/atoms/TopBanner/TopBanner.module.sass.d.ts": 3107,
	"./elements/atoms/TopBanner/TopBanner.stories": 3108,
	"./elements/atoms/TopBanner/TopBanner.stories.tsx": 3108,
	"./elements/atoms/TopBanner/TopBanner.tsx": 936,
	"./elements/atoms/Truncate/Truncate": 2212,
	"./elements/atoms/Truncate/Truncate.module": 2755,
	"./elements/atoms/Truncate/Truncate.module.sass": 2755,
	"./elements/atoms/Truncate/Truncate.module.sass.d": 3109,
	"./elements/atoms/Truncate/Truncate.module.sass.d.ts": 3109,
	"./elements/atoms/Truncate/Truncate.stories": 3110,
	"./elements/atoms/Truncate/Truncate.stories.tsx": 3110,
	"./elements/atoms/Truncate/Truncate.tsx": 2212,
	"./elements/atoms/TrustpilotWidget/TrustpilotWidget": 699,
	"./elements/atoms/TrustpilotWidget/TrustpilotWidget.stories": 3111,
	"./elements/atoms/TrustpilotWidget/TrustpilotWidget.stories.tsx": 3111,
	"./elements/atoms/TrustpilotWidget/TrustpilotWidget.tsx": 699,
	"./elements/atoms/Video": 1188,
	"./elements/atoms/Video/": 1188,
	"./elements/atoms/Video/Video": 1275,
	"./elements/atoms/Video/Video.module": 1551,
	"./elements/atoms/Video/Video.module.sass": 1551,
	"./elements/atoms/Video/Video.module.sass.d": 3112,
	"./elements/atoms/Video/Video.module.sass.d.ts": 3112,
	"./elements/atoms/Video/Video.stories": 3113,
	"./elements/atoms/Video/Video.stories.tsx": 3113,
	"./elements/atoms/Video/Video.tsx": 1275,
	"./elements/atoms/Video/index": 1188,
	"./elements/atoms/Video/index.js.flow": 4311,
	"./elements/atoms/Video/index.ts": 1188,
	"./elements/molecules/AccountNavigation/AccountNavigation": 2101,
	"./elements/molecules/AccountNavigation/AccountNavigation.module": 1097,
	"./elements/molecules/AccountNavigation/AccountNavigation.module.sass": 1097,
	"./elements/molecules/AccountNavigation/AccountNavigation.module.sass.d": 3114,
	"./elements/molecules/AccountNavigation/AccountNavigation.module.sass.d.ts": 3114,
	"./elements/molecules/AccountNavigation/AccountNavigation.stories": 3115,
	"./elements/molecules/AccountNavigation/AccountNavigation.stories.tsx": 3115,
	"./elements/molecules/AccountNavigation/AccountNavigation.tsx": 2101,
	"./elements/molecules/AccountNavigation/XmasHat": 2474,
	"./elements/molecules/AccountNavigation/XmasHat.tsx": 2474,
	"./elements/molecules/ActionCard/ActionCard": 595,
	"./elements/molecules/ActionCard/ActionCard.module": 1374,
	"./elements/molecules/ActionCard/ActionCard.module.sass": 1374,
	"./elements/molecules/ActionCard/ActionCard.module.sass.d": 3116,
	"./elements/molecules/ActionCard/ActionCard.module.sass.d.ts": 3116,
	"./elements/molecules/ActionCard/ActionCard.stories": 3117,
	"./elements/molecules/ActionCard/ActionCard.stories.tsx": 3117,
	"./elements/molecules/ActionCard/ActionCard.tsx": 595,
	"./elements/molecules/AddDiscountedExtrasCountdownCard": 1772,
	"./elements/molecules/AddDiscountedExtrasCountdownCard/": 1772,
	"./elements/molecules/AddDiscountedExtrasCountdownCard/AddDiscountedExtrasCountdownCard": 2059,
	"./elements/molecules/AddDiscountedExtrasCountdownCard/AddDiscountedExtrasCountdownCard.module": 1668,
	"./elements/molecules/AddDiscountedExtrasCountdownCard/AddDiscountedExtrasCountdownCard.module.sass": 1668,
	"./elements/molecules/AddDiscountedExtrasCountdownCard/AddDiscountedExtrasCountdownCard.module.sass.d": 3118,
	"./elements/molecules/AddDiscountedExtrasCountdownCard/AddDiscountedExtrasCountdownCard.module.sass.d.ts": 3118,
	"./elements/molecules/AddDiscountedExtrasCountdownCard/AddDiscountedExtrasCountdownCard.stories": 3119,
	"./elements/molecules/AddDiscountedExtrasCountdownCard/AddDiscountedExtrasCountdownCard.stories.tsx": 3119,
	"./elements/molecules/AddDiscountedExtrasCountdownCard/AddDiscountedExtrasCountdownCard.tsx": 2059,
	"./elements/molecules/AddDiscountedExtrasCountdownCard/index": 1772,
	"./elements/molecules/AddDiscountedExtrasCountdownCard/index.ts": 1772,
	"./elements/molecules/AddDiscountedExtrasCountdownCard/queries/AddDiscountedExtrasCountdownCardQuery": 2705,
	"./elements/molecules/AddDiscountedExtrasCountdownCard/queries/AddDiscountedExtrasCountdownCardQuery.ts": 2705,
	"./elements/molecules/AddDiscountedExtrasCountdownCard/queries/__generated__/addDiscountedExtrasCountdownCardQuery": 3120,
	"./elements/molecules/AddDiscountedExtrasCountdownCard/queries/__generated__/addDiscountedExtrasCountdownCardQuery.ts": 3120,
	"./elements/molecules/AppDisplays/AppDisplays": 1864,
	"./elements/molecules/AppDisplays/AppDisplays.module": 2756,
	"./elements/molecules/AppDisplays/AppDisplays.module.sass": 2756,
	"./elements/molecules/AppDisplays/AppDisplays.module.sass.d": 3121,
	"./elements/molecules/AppDisplays/AppDisplays.module.sass.d.ts": 3121,
	"./elements/molecules/AppDisplays/AppDisplays.stories": 3122,
	"./elements/molecules/AppDisplays/AppDisplays.stories.tsx": 3122,
	"./elements/molecules/AppDisplays/AppDisplays.tsx": 1864,
	"./elements/molecules/AppDownloadButtons/AppDownloadButtons": 1357,
	"./elements/molecules/AppDownloadButtons/AppDownloadButtons.module": 1939,
	"./elements/molecules/AppDownloadButtons/AppDownloadButtons.module.sass": 1939,
	"./elements/molecules/AppDownloadButtons/AppDownloadButtons.module.sass.d": 3123,
	"./elements/molecules/AppDownloadButtons/AppDownloadButtons.module.sass.d.ts": 3123,
	"./elements/molecules/AppDownloadButtons/AppDownloadButtons.stories": 3124,
	"./elements/molecules/AppDownloadButtons/AppDownloadButtons.stories.tsx": 3124,
	"./elements/molecules/AppDownloadButtons/AppDownloadButtons.tsx": 1357,
	"./elements/molecules/BannerManager/BannerManager": 923,
	"./elements/molecules/BannerManager/BannerManager.module": 1500,
	"./elements/molecules/BannerManager/BannerManager.module.sass": 1500,
	"./elements/molecules/BannerManager/BannerManager.module.sass.d": 3125,
	"./elements/molecules/BannerManager/BannerManager.module.sass.d.ts": 3125,
	"./elements/molecules/BannerManager/BannerManager.tsx": 923,
	"./elements/molecules/BannerManager/__generated__/Banners": 3126,
	"./elements/molecules/BannerManager/__generated__/Banners.ts": 3126,
	"./elements/molecules/BannerManager/queries": 1499,
	"./elements/molecules/BannerManager/queries.ts": 1499,
	"./elements/molecules/BoxBreakdown/BoxBreakdown": 551,
	"./elements/molecules/BoxBreakdown/BoxBreakdown.module": 1102,
	"./elements/molecules/BoxBreakdown/BoxBreakdown.module.sass": 1102,
	"./elements/molecules/BoxBreakdown/BoxBreakdown.module.sass.d": 3127,
	"./elements/molecules/BoxBreakdown/BoxBreakdown.module.sass.d.ts": 3127,
	"./elements/molecules/BoxBreakdown/BoxBreakdown.stories": 3128,
	"./elements/molecules/BoxBreakdown/BoxBreakdown.stories.tsx": 3128,
	"./elements/molecules/BoxBreakdown/BoxBreakdown.tsx": 551,
	"./elements/molecules/BoxBreakdownV2/BoxBreakdownV2": 1607,
	"./elements/molecules/BoxBreakdownV2/BoxBreakdownV2.module": 1108,
	"./elements/molecules/BoxBreakdownV2/BoxBreakdownV2.module.sass": 1108,
	"./elements/molecules/BoxBreakdownV2/BoxBreakdownV2.module.sass.d": 3129,
	"./elements/molecules/BoxBreakdownV2/BoxBreakdownV2.module.sass.d.ts": 3129,
	"./elements/molecules/BoxBreakdownV2/BoxBreakdownV2.stories": 3130,
	"./elements/molecules/BoxBreakdownV2/BoxBreakdownV2.stories.tsx": 3130,
	"./elements/molecules/BoxBreakdownV2/BoxBreakdownV2.tsx": 1607,
	"./elements/molecules/BoxItem/AdditionalProductItem/AdditionalProductItem": 2359,
	"./elements/molecules/BoxItem/AdditionalProductItem/AdditionalProductItem.tsx": 2359,
	"./elements/molecules/BoxItem/FreshMealItem/FreshMealItem": 949,
	"./elements/molecules/BoxItem/FreshMealItem/FreshMealItem.stories": 3131,
	"./elements/molecules/BoxItem/FreshMealItem/FreshMealItem.stories.tsx": 3131,
	"./elements/molecules/BoxItem/FreshMealItem/FreshMealItem.tsx": 949,
	"./elements/molecules/BoxItem/ShopItem/ShopItem": 1856,
	"./elements/molecules/BoxItem/ShopItem/ShopItem.stories": 3132,
	"./elements/molecules/BoxItem/ShopItem/ShopItem.stories.tsx": 3132,
	"./elements/molecules/BoxItem/ShopItem/ShopItem.tsx": 1856,
	"./elements/molecules/BoxItem/ShopItem/analytics": 1139,
	"./elements/molecules/BoxItem/ShopItem/analytics/": 1139,
	"./elements/molecules/BoxItem/ShopItem/analytics/editShopItemAnalytics": 2414,
	"./elements/molecules/BoxItem/ShopItem/analytics/editShopItemAnalytics.ts": 2414,
	"./elements/molecules/BoxItem/ShopItem/analytics/index": 1139,
	"./elements/molecules/BoxItem/ShopItem/analytics/index.ts": 1139,
	"./elements/molecules/BoxItem/ShopItem/fragments/__generated__/ShopItemFragment": 3133,
	"./elements/molecules/BoxItem/ShopItem/fragments/__generated__/ShopItemFragment.ts": 3133,
	"./elements/molecules/BoxItem/ShopItem/fragments/shopItemFragment": 2544,
	"./elements/molecules/BoxItem/ShopItem/fragments/shopItemFragment.ts": 2544,
	"./elements/molecules/BoxItem/boxitem": 250,
	"./elements/molecules/BoxItem/boxitem.module": 250,
	"./elements/molecules/BoxItem/boxitem.module.sass": 250,
	"./elements/molecules/BoxItem/boxitem.module.sass.d": 3134,
	"./elements/molecules/BoxItem/boxitem.module.sass.d.ts": 3134,
	"./elements/molecules/BoxSummary/BoxSummary": 2889,
	"./elements/molecules/BoxSummary/BoxSummary.module": 1671,
	"./elements/molecules/BoxSummary/BoxSummary.module.sass": 1671,
	"./elements/molecules/BoxSummary/BoxSummary.module.sass.d": 3135,
	"./elements/molecules/BoxSummary/BoxSummary.module.sass.d.ts": 3135,
	"./elements/molecules/BoxSummary/BoxSummary.stories": 3136,
	"./elements/molecules/BoxSummary/BoxSummary.stories.tsx": 3136,
	"./elements/molecules/BoxSummary/BoxSummary.tsx": 2889,
	"./elements/molecules/BoxSummary/__generated__/BoxSummary": 3137,
	"./elements/molecules/BoxSummary/__generated__/BoxSummary.ts": 3137,
	"./elements/molecules/BoxSummary/queries": 1863,
	"./elements/molecules/BoxSummary/queries.ts": 1863,
	"./elements/molecules/BreedAutocomplete/BreedAutocomplete": 2150,
	"./elements/molecules/BreedAutocomplete/BreedAutocomplete.module": 899,
	"./elements/molecules/BreedAutocomplete/BreedAutocomplete.module.sass": 899,
	"./elements/molecules/BreedAutocomplete/BreedAutocomplete.module.sass.d": 3138,
	"./elements/molecules/BreedAutocomplete/BreedAutocomplete.module.sass.d.ts": 3138,
	"./elements/molecules/BreedAutocomplete/BreedAutocomplete.stories": 3139,
	"./elements/molecules/BreedAutocomplete/BreedAutocomplete.stories.tsx": 3139,
	"./elements/molecules/BreedAutocomplete/BreedAutocomplete.tsx": 2150,
	"./elements/molecules/BreedAutocomplete/queries/__generated__/BreedSelectorQuery": 3140,
	"./elements/molecules/BreedAutocomplete/queries/__generated__/BreedSelectorQuery.ts": 3140,
	"./elements/molecules/BreedAutocomplete/queries/breedSelectorQuery": 2603,
	"./elements/molecules/BreedAutocomplete/queries/breedSelectorQuery.ts": 2603,
	"./elements/molecules/Calendar": 873,
	"./elements/molecules/Calendar/": 873,
	"./elements/molecules/Calendar/Calendar": 830,
	"./elements/molecules/Calendar/Calendar.module": 362,
	"./elements/molecules/Calendar/Calendar.module.sass": 362,
	"./elements/molecules/Calendar/Calendar.module.sass.d": 3141,
	"./elements/molecules/Calendar/Calendar.module.sass.d.ts": 3141,
	"./elements/molecules/Calendar/Calendar.stories": 3142,
	"./elements/molecules/Calendar/Calendar.stories.tsx": 3142,
	"./elements/molecules/Calendar/Calendar.tsx": 830,
	"./elements/molecules/Calendar/components/CalendarDates": 1539,
	"./elements/molecules/Calendar/components/CalendarDates.tsx": 1539,
	"./elements/molecules/Calendar/components/DaysOfTheWeek": 1540,
	"./elements/molecules/Calendar/components/DaysOfTheWeek.tsx": 1540,
	"./elements/molecules/Calendar/components/HeaderMonth": 1541,
	"./elements/molecules/Calendar/components/HeaderMonth.tsx": 1541,
	"./elements/molecules/Calendar/index": 873,
	"./elements/molecules/Calendar/index.ts": 873,
	"./elements/molecules/Calendar/queries/__generated__/CalendarDatesData": 3143,
	"./elements/molecules/Calendar/queries/__generated__/CalendarDatesData.ts": 3143,
	"./elements/molecules/Calendar/queries/__generated__/PausedCalendarDatesData": 3144,
	"./elements/molecules/Calendar/queries/__generated__/PausedCalendarDatesData.ts": 3144,
	"./elements/molecules/Calendar/queries/calendarDatesQuery": 1542,
	"./elements/molecules/Calendar/queries/calendarDatesQuery.ts": 1542,
	"./elements/molecules/CalendarV2": 1127,
	"./elements/molecules/CalendarV2/": 1127,
	"./elements/molecules/CalendarV2/CalendarV2": 1996,
	"./elements/molecules/CalendarV2/CalendarV2.module": 558,
	"./elements/molecules/CalendarV2/CalendarV2.module.sass": 558,
	"./elements/molecules/CalendarV2/CalendarV2.module.sass.d": 3145,
	"./elements/molecules/CalendarV2/CalendarV2.module.sass.d.ts": 3145,
	"./elements/molecules/CalendarV2/CalendarV2.tsx": 1996,
	"./elements/molecules/CalendarV2/components/CalendarDatesV2": 2479,
	"./elements/molecules/CalendarV2/components/CalendarDatesV2.tsx": 2479,
	"./elements/molecules/CalendarV2/components/CalendarSkeleton": 2804,
	"./elements/molecules/CalendarV2/components/CalendarSkeleton.tsx": 2804,
	"./elements/molecules/CalendarV2/components/DaysOfTheWeekV2": 1802,
	"./elements/molecules/CalendarV2/components/DaysOfTheWeekV2.tsx": 1802,
	"./elements/molecules/CalendarV2/components/HeaderMonthV2": 1803,
	"./elements/molecules/CalendarV2/components/HeaderMonthV2.tsx": 1803,
	"./elements/molecules/CalendarV2/fragments/__generated__/calendarDatesV2Fragment": 3146,
	"./elements/molecules/CalendarV2/fragments/__generated__/calendarDatesV2Fragment.ts": 3146,
	"./elements/molecules/CalendarV2/fragments/calendarDatesV2Fragment": 1137,
	"./elements/molecules/CalendarV2/fragments/calendarDatesV2Fragment.ts": 1137,
	"./elements/molecules/CalendarV2/index": 1127,
	"./elements/molecules/CalendarV2/index.ts": 1127,
	"./elements/molecules/CalorieBar/CalorieBar": 2530,
	"./elements/molecules/CalorieBar/CalorieBar.tsx": 2530,
	"./elements/molecules/CalorieBar/caloriebar": 1089,
	"./elements/molecules/CalorieBar/caloriebar.module": 1089,
	"./elements/molecules/CalorieBar/caloriebar.module.sass": 1089,
	"./elements/molecules/CalorieBar/caloriebar.module.sass.d": 3147,
	"./elements/molecules/CalorieBar/caloriebar.module.sass.d.ts": 3147,
	"./elements/molecules/CardCallout": 1737,
	"./elements/molecules/CardCallout/": 1737,
	"./elements/molecules/CardCallout/CardCallout": 2029,
	"./elements/molecules/CardCallout/CardCallout.module": 2532,
	"./elements/molecules/CardCallout/CardCallout.module.sass": 2532,
	"./elements/molecules/CardCallout/CardCallout.module.sass.d": 3148,
	"./elements/molecules/CardCallout/CardCallout.module.sass.d.ts": 3148,
	"./elements/molecules/CardCallout/CardCallout.tsx": 2029,
	"./elements/molecules/CardCallout/index": 1737,
	"./elements/molecules/CardCallout/index.ts": 1737,
	"./elements/molecules/CategoryBar/CategoryBar": 2134,
	"./elements/molecules/CategoryBar/CategoryBar.module": 1261,
	"./elements/molecules/CategoryBar/CategoryBar.module.sass": 1261,
	"./elements/molecules/CategoryBar/CategoryBar.module.sass.d": 3149,
	"./elements/molecules/CategoryBar/CategoryBar.module.sass.d.ts": 3149,
	"./elements/molecules/CategoryBar/CategoryBar.stories": 3150,
	"./elements/molecules/CategoryBar/CategoryBar.stories.tsx": 3150,
	"./elements/molecules/CategoryBar/CategoryBar.tsx": 2134,
	"./elements/molecules/ChangeAddress/ChangeAddress": 766,
	"./elements/molecules/ChangeAddress/ChangeAddress.module": 1079,
	"./elements/molecules/ChangeAddress/ChangeAddress.module.sass": 1079,
	"./elements/molecules/ChangeAddress/ChangeAddress.module.sass.d": 3151,
	"./elements/molecules/ChangeAddress/ChangeAddress.module.sass.d.ts": 3151,
	"./elements/molecules/ChangeAddress/ChangeAddress.stories": 3152,
	"./elements/molecules/ChangeAddress/ChangeAddress.stories.tsx": 3152,
	"./elements/molecules/ChangeAddress/ChangeAddress.tsx": 766,
	"./elements/molecules/CopyInputButton/CopyInputButton": 840,
	"./elements/molecules/CopyInputButton/CopyInputButton.module": 1888,
	"./elements/molecules/CopyInputButton/CopyInputButton.module.sass": 1888,
	"./elements/molecules/CopyInputButton/CopyInputButton.module.sass.d": 3153,
	"./elements/molecules/CopyInputButton/CopyInputButton.module.sass.d.ts": 3153,
	"./elements/molecules/CopyInputButton/CopyInputButton.stories": 3154,
	"./elements/molecules/CopyInputButton/CopyInputButton.stories.tsx": 3154,
	"./elements/molecules/CopyInputButton/CopyInputButton.tsx": 840,
	"./elements/molecules/Countdown/Countdown": 932,
	"./elements/molecules/Countdown/Countdown.module": 896,
	"./elements/molecules/Countdown/Countdown.module.sass": 896,
	"./elements/molecules/Countdown/Countdown.module.sass.d": 3155,
	"./elements/molecules/Countdown/Countdown.module.sass.d.ts": 3155,
	"./elements/molecules/Countdown/Countdown.stories": 3156,
	"./elements/molecules/Countdown/Countdown.stories.tsx": 3156,
	"./elements/molecules/Countdown/Countdown.tsx": 932,
	"./elements/molecules/Countdown/CountdownOneLine/CountdownOneLine": 2107,
	"./elements/molecules/Countdown/CountdownOneLine/CountdownOneLine.module": 1099,
	"./elements/molecules/Countdown/CountdownOneLine/CountdownOneLine.module.sass": 1099,
	"./elements/molecules/Countdown/CountdownOneLine/CountdownOneLine.module.sass.d": 3157,
	"./elements/molecules/Countdown/CountdownOneLine/CountdownOneLine.module.sass.d.ts": 3157,
	"./elements/molecules/Countdown/CountdownOneLine/CountdownOneLine.tsx": 2107,
	"./elements/molecules/CountdownBanner/CountdownBanner": 2199,
	"./elements/molecules/CountdownBanner/CountdownBanner.module": 1936,
	"./elements/molecules/CountdownBanner/CountdownBanner.module.sass": 1936,
	"./elements/molecules/CountdownBanner/CountdownBanner.module.sass.d": 3158,
	"./elements/molecules/CountdownBanner/CountdownBanner.module.sass.d.ts": 3158,
	"./elements/molecules/CountdownBanner/CountdownBanner.stories": 3159,
	"./elements/molecules/CountdownBanner/CountdownBanner.stories.tsx": 3159,
	"./elements/molecules/CountdownBanner/CountdownBanner.tsx": 2199,
	"./elements/molecules/CountdownModal/CountdownModal": 1583,
	"./elements/molecules/CountdownModal/CountdownModal.module": 1247,
	"./elements/molecules/CountdownModal/CountdownModal.module.sass": 1247,
	"./elements/molecules/CountdownModal/CountdownModal.module.sass.d": 3160,
	"./elements/molecules/CountdownModal/CountdownModal.module.sass.d.ts": 3160,
	"./elements/molecules/CountdownModal/CountdownModal.tsx": 1583,
	"./elements/molecules/CourierSelector/CourierSelector": 1136,
	"./elements/molecules/CourierSelector/CourierSelector.module": 2310,
	"./elements/molecules/CourierSelector/CourierSelector.module.sass": 2310,
	"./elements/molecules/CourierSelector/CourierSelector.module.sass.d": 3161,
	"./elements/molecules/CourierSelector/CourierSelector.module.sass.d.ts": 3161,
	"./elements/molecules/CourierSelector/CourierSelector.tsx": 1136,
	"./elements/molecules/CourierSelector/fragments/CourierFragment": 1804,
	"./elements/molecules/CourierSelector/fragments/CourierFragment.ts": 1804,
	"./elements/molecules/CourierSelector/fragments/__generated__/CourierFragment": 3162,
	"./elements/molecules/CourierSelector/fragments/__generated__/CourierFragment.ts": 3162,
	"./elements/molecules/DailyFeedingGuideline/DailyFeedingGuideline": 1197,
	"./elements/molecules/DailyFeedingGuideline/DailyFeedingGuideline.module": 1165,
	"./elements/molecules/DailyFeedingGuideline/DailyFeedingGuideline.module.sass": 1165,
	"./elements/molecules/DailyFeedingGuideline/DailyFeedingGuideline.module.sass.d": 3163,
	"./elements/molecules/DailyFeedingGuideline/DailyFeedingGuideline.module.sass.d.ts": 3163,
	"./elements/molecules/DailyFeedingGuideline/DailyFeedingGuideline.stories": 3164,
	"./elements/molecules/DailyFeedingGuideline/DailyFeedingGuideline.stories.tsx": 3164,
	"./elements/molecules/DailyFeedingGuideline/DailyFeedingGuideline.tsx": 1197,
	"./elements/molecules/DeliveryFrequencyOverview": 1581,
	"./elements/molecules/DeliveryFrequencyOverview/": 1581,
	"./elements/molecules/DeliveryFrequencyOverview/DeliveryFrequencyOverview": 2402,
	"./elements/molecules/DeliveryFrequencyOverview/DeliveryFrequencyOverview.tsx": 2402,
	"./elements/molecules/DeliveryFrequencyOverview/__snapshots__/DeliveryFrequencyOverview.spec.tsx.snap": 4312,
	"./elements/molecules/DeliveryFrequencyOverview/fragments/__generated__/DeliveryFrequencyOverviewFragment": 3165,
	"./elements/molecules/DeliveryFrequencyOverview/fragments/__generated__/DeliveryFrequencyOverviewFragment.ts": 3165,
	"./elements/molecules/DeliveryFrequencyOverview/index": 1581,
	"./elements/molecules/DeliveryFrequencyOverview/index.ts": 1581,
	"./elements/molecules/DetailsCard/DetailsCard": 556,
	"./elements/molecules/DetailsCard/DetailsCard.module": 956,
	"./elements/molecules/DetailsCard/DetailsCard.module.sass": 956,
	"./elements/molecules/DetailsCard/DetailsCard.module.sass.d": 3166,
	"./elements/molecules/DetailsCard/DetailsCard.module.sass.d.ts": 3166,
	"./elements/molecules/DetailsCard/DetailsCard.stories": 3167,
	"./elements/molecules/DetailsCard/DetailsCard.stories.tsx": 3167,
	"./elements/molecules/DetailsCard/DetailsCard.tsx": 556,
	"./elements/molecules/DogAvatar": 1300,
	"./elements/molecules/DogAvatar/": 1300,
	"./elements/molecules/DogAvatar/DogAvatar": 928,
	"./elements/molecules/DogAvatar/DogAvatar.module": 3168,
	"./elements/molecules/DogAvatar/DogAvatar.module.sass": 3168,
	"./elements/molecules/DogAvatar/DogAvatar.module.sass.d": 3169,
	"./elements/molecules/DogAvatar/DogAvatar.module.sass.d.ts": 3169,
	"./elements/molecules/DogAvatar/DogAvatar.stories": 3170,
	"./elements/molecules/DogAvatar/DogAvatar.stories.tsx": 3170,
	"./elements/molecules/DogAvatar/DogAvatar.tsx": 928,
	"./elements/molecules/DogAvatar/components/DynamicImage": 1714,
	"./elements/molecules/DogAvatar/components/DynamicImage/": 1714,
	"./elements/molecules/DogAvatar/components/DynamicImage/DynamicImage": 2002,
	"./elements/molecules/DogAvatar/components/DynamicImage/DynamicImage.module": 2317,
	"./elements/molecules/DogAvatar/components/DynamicImage/DynamicImage.module.sass": 2317,
	"./elements/molecules/DogAvatar/components/DynamicImage/DynamicImage.module.sass.d": 3171,
	"./elements/molecules/DogAvatar/components/DynamicImage/DynamicImage.module.sass.d.ts": 3171,
	"./elements/molecules/DogAvatar/components/DynamicImage/DynamicImage.tsx": 2002,
	"./elements/molecules/DogAvatar/components/DynamicImage/index": 1714,
	"./elements/molecules/DogAvatar/components/DynamicImage/index.ts": 1714,
	"./elements/molecules/DogAvatar/components/Sprinkles": 1716,
	"./elements/molecules/DogAvatar/components/Sprinkles/": 1716,
	"./elements/molecules/DogAvatar/components/Sprinkles/Sprinkles": 2004,
	"./elements/molecules/DogAvatar/components/Sprinkles/Sprinkles.module": 2318,
	"./elements/molecules/DogAvatar/components/Sprinkles/Sprinkles.module.sass": 2318,
	"./elements/molecules/DogAvatar/components/Sprinkles/Sprinkles.module.sass.d": 3172,
	"./elements/molecules/DogAvatar/components/Sprinkles/Sprinkles.module.sass.d.ts": 3172,
	"./elements/molecules/DogAvatar/components/Sprinkles/Sprinkles.tsx": 2004,
	"./elements/molecules/DogAvatar/components/Sprinkles/index": 1716,
	"./elements/molecules/DogAvatar/components/Sprinkles/index.ts": 1716,
	"./elements/molecules/DogAvatar/components/StaticImage": 1715,
	"./elements/molecules/DogAvatar/components/StaticImage/": 1715,
	"./elements/molecules/DogAvatar/components/StaticImage/StaticImage": 2003,
	"./elements/molecules/DogAvatar/components/StaticImage/StaticImage.module": 1906,
	"./elements/molecules/DogAvatar/components/StaticImage/StaticImage.module.sass": 1906,
	"./elements/molecules/DogAvatar/components/StaticImage/StaticImage.module.sass.d": 3173,
	"./elements/molecules/DogAvatar/components/StaticImage/StaticImage.module.sass.d.ts": 3173,
	"./elements/molecules/DogAvatar/components/StaticImage/StaticImage.tsx": 2003,
	"./elements/molecules/DogAvatar/components/StaticImage/index": 1715,
	"./elements/molecules/DogAvatar/components/StaticImage/index.ts": 1715,
	"./elements/molecules/DogAvatar/hooks/useBreedImage": 2503,
	"./elements/molecules/DogAvatar/hooks/useBreedImage.ts": 2503,
	"./elements/molecules/DogAvatar/index": 1300,
	"./elements/molecules/DogAvatar/index.ts": 1300,
	"./elements/molecules/DogAvatarGroup/DogAvatarGroup": 1611,
	"./elements/molecules/DogAvatarGroup/DogAvatarGroup.module": 2360,
	"./elements/molecules/DogAvatarGroup/DogAvatarGroup.module.sass": 2360,
	"./elements/molecules/DogAvatarGroup/DogAvatarGroup.module.sass.d": 3174,
	"./elements/molecules/DogAvatarGroup/DogAvatarGroup.module.sass.d.ts": 3174,
	"./elements/molecules/DogAvatarGroup/DogAvatarGroup.stories": 3175,
	"./elements/molecules/DogAvatarGroup/DogAvatarGroup.stories.tsx": 3175,
	"./elements/molecules/DogAvatarGroup/DogAvatarGroup.tsx": 1611,
	"./elements/molecules/DownloadInvoiceButton/DownloadInvoiceButton": 1586,
	"./elements/molecules/DownloadInvoiceButton/DownloadInvoiceButton.module": 2493,
	"./elements/molecules/DownloadInvoiceButton/DownloadInvoiceButton.module.sass": 2493,
	"./elements/molecules/DownloadInvoiceButton/DownloadInvoiceButton.module.sass.d": 3176,
	"./elements/molecules/DownloadInvoiceButton/DownloadInvoiceButton.module.sass.d.ts": 3176,
	"./elements/molecules/DownloadInvoiceButton/DownloadInvoiceButton.stories": 3177,
	"./elements/molecules/DownloadInvoiceButton/DownloadInvoiceButton.stories.tsx": 3177,
	"./elements/molecules/DownloadInvoiceButton/DownloadInvoiceButton.tsx": 1586,
	"./elements/molecules/ExpandCard/ExpandCard": 925,
	"./elements/molecules/ExpandCard/ExpandCard.module": 622,
	"./elements/molecules/ExpandCard/ExpandCard.module.sass": 622,
	"./elements/molecules/ExpandCard/ExpandCard.module.sass.d": 3178,
	"./elements/molecules/ExpandCard/ExpandCard.module.sass.d.ts": 3178,
	"./elements/molecules/ExpandCard/ExpandCard.stories": 3179,
	"./elements/molecules/ExpandCard/ExpandCard.stories.tsx": 3179,
	"./elements/molecules/ExpandCard/ExpandCard.tsx": 925,
	"./elements/molecules/ExpandableIconButton/ExpandableIconButton": 2151,
	"./elements/molecules/ExpandableIconButton/ExpandableIconButton.module": 1263,
	"./elements/molecules/ExpandableIconButton/ExpandableIconButton.module.sass": 1263,
	"./elements/molecules/ExpandableIconButton/ExpandableIconButton.module.sass.d": 3180,
	"./elements/molecules/ExpandableIconButton/ExpandableIconButton.module.sass.d.ts": 3180,
	"./elements/molecules/ExpandableIconButton/ExpandableIconButton.stories": 3181,
	"./elements/molecules/ExpandableIconButton/ExpandableIconButton.stories.tsx": 3181,
	"./elements/molecules/ExpandableIconButton/ExpandableIconButton.tsx": 2151,
	"./elements/molecules/ExpertCard": 2444,
	"./elements/molecules/ExpertCard/": 2444,
	"./elements/molecules/ExpertCard/ExpertCard": 539,
	"./elements/molecules/ExpertCard/ExpertCard.module": 1908,
	"./elements/molecules/ExpertCard/ExpertCard.module.sass": 1908,
	"./elements/molecules/ExpertCard/ExpertCard.module.sass.d": 3182,
	"./elements/molecules/ExpertCard/ExpertCard.module.sass.d.ts": 3182,
	"./elements/molecules/ExpertCard/ExpertCard.stories": 3183,
	"./elements/molecules/ExpertCard/ExpertCard.stories.tsx": 3183,
	"./elements/molecules/ExpertCard/ExpertCard.tsx": 539,
	"./elements/molecules/ExpertCard/index": 2444,
	"./elements/molecules/ExpertCard/index.js": 2444,
	"./elements/molecules/ExtrasModal/ExtrasContent": 1818,
	"./elements/molecules/ExtrasModal/ExtrasContent.tsx": 1818,
	"./elements/molecules/ExtrasModal/ExtrasModal": 2186,
	"./elements/molecules/ExtrasModal/ExtrasModal.module": 777,
	"./elements/molecules/ExtrasModal/ExtrasModal.module.sass": 777,
	"./elements/molecules/ExtrasModal/ExtrasModal.module.sass.d": 3184,
	"./elements/molecules/ExtrasModal/ExtrasModal.module.sass.d.ts": 3184,
	"./elements/molecules/ExtrasModal/ExtrasModal.stories": 3185,
	"./elements/molecules/ExtrasModal/ExtrasModal.stories.tsx": 3185,
	"./elements/molecules/ExtrasModal/ExtrasModal.tsx": 2186,
	"./elements/molecules/ExtrasModal/components/LineItem": 2127,
	"./elements/molecules/ExtrasModal/components/LineItem.module": 1156,
	"./elements/molecules/ExtrasModal/components/LineItem.module.sass": 1156,
	"./elements/molecules/ExtrasModal/components/LineItem.module.sass.d": 3186,
	"./elements/molecules/ExtrasModal/components/LineItem.module.sass.d.ts": 3186,
	"./elements/molecules/ExtrasModal/components/LineItem.tsx": 2127,
	"./elements/molecules/ExtrasModal/components/ProductPrice": 2543,
	"./elements/molecules/ExtrasModal/components/ProductPrice.tsx": 2543,
	"./elements/molecules/ExtrasModal/fragments/__generated__/BoxPhysicalOrderProducts": 3187,
	"./elements/molecules/ExtrasModal/fragments/__generated__/BoxPhysicalOrderProducts.ts": 3187,
	"./elements/molecules/ExtrasModal/fragments/__generated__/EditExtrasBoxFragment": 3188,
	"./elements/molecules/ExtrasModal/fragments/__generated__/EditExtrasBoxFragment.ts": 3188,
	"./elements/molecules/ExtrasModal/fragments/__generated__/EditExtrasUserFragment": 3189,
	"./elements/molecules/ExtrasModal/fragments/__generated__/EditExtrasUserFragment.ts": 3189,
	"./elements/molecules/ExtrasModal/fragments/__generated__/OrderViewerFragment": 3190,
	"./elements/molecules/ExtrasModal/fragments/__generated__/OrderViewerFragment.ts": 3190,
	"./elements/molecules/ExtrasModal/fragments/__generated__/fragments": 3191,
	"./elements/molecules/ExtrasModal/fragments/__generated__/fragments.ts": 3191,
	"./elements/molecules/ExtrasModal/fragments/fragments": 948,
	"./elements/molecules/ExtrasModal/fragments/fragments.ts": 948,
	"./elements/molecules/ExtrasModal/helpers": 2545,
	"./elements/molecules/ExtrasModal/helpers.ts": 2545,
	"./elements/molecules/ExtrasModal/mutations/recommendedOrderProductCreate": 3192,
	"./elements/molecules/ExtrasModal/mutations/recommendedOrderProductCreate.ts": 3192,
	"./elements/molecules/ExtrasModal/mutations/updateOrderProducts": 2329,
	"./elements/molecules/ExtrasModal/mutations/updateOrderProducts.ts": 2329,
	"./elements/molecules/ExtrasModal/queries/queries": 2331,
	"./elements/molecules/ExtrasModal/queries/queries.ts": 2331,
	"./elements/molecules/ExtrasModal/utils/transformExtras": 1336,
	"./elements/molecules/ExtrasModal/utils/transformExtras.ts": 1336,
	"./elements/molecules/Faq/Faq": 597,
	"./elements/molecules/Faq/Faq.module": 747,
	"./elements/molecules/Faq/Faq.module.sass": 747,
	"./elements/molecules/Faq/Faq.module.sass.d": 3193,
	"./elements/molecules/Faq/Faq.module.sass.d.ts": 3193,
	"./elements/molecules/Faq/Faq.stories": 3194,
	"./elements/molecules/Faq/Faq.stories.tsx": 3194,
	"./elements/molecules/Faq/Faq.tsx": 597,
	"./elements/molecules/FeedCard/FeedCard": 2213,
	"./elements/molecules/FeedCard/FeedCard.module": 1940,
	"./elements/molecules/FeedCard/FeedCard.module.sass": 1940,
	"./elements/molecules/FeedCard/FeedCard.module.sass.d": 3195,
	"./elements/molecules/FeedCard/FeedCard.module.sass.d.ts": 3195,
	"./elements/molecules/FeedCard/FeedCard.stories": 3196,
	"./elements/molecules/FeedCard/FeedCard.stories.tsx": 3196,
	"./elements/molecules/FeedCard/FeedCard.tsx": 2213,
	"./elements/molecules/FlavoursInformationAccordian/FlavoursInformationAccordian": 1633,
	"./elements/molecules/FlavoursInformationAccordian/FlavoursInformationAccordian.module": 1169,
	"./elements/molecules/FlavoursInformationAccordian/FlavoursInformationAccordian.module.sass": 1169,
	"./elements/molecules/FlavoursInformationAccordian/FlavoursInformationAccordian.module.sass.d": 3197,
	"./elements/molecules/FlavoursInformationAccordian/FlavoursInformationAccordian.module.sass.d.ts": 3197,
	"./elements/molecules/FlavoursInformationAccordian/FlavoursInformationAccordian.tsx": 1633,
	"./elements/molecules/Footer": 1764,
	"./elements/molecules/Footer/": 1764,
	"./elements/molecules/Footer/Footer": 2055,
	"./elements/molecules/Footer/Footer.module": 623,
	"./elements/molecules/Footer/Footer.module.sass": 623,
	"./elements/molecules/Footer/Footer.module.sass.d": 3198,
	"./elements/molecules/Footer/Footer.module.sass.d.ts": 3198,
	"./elements/molecules/Footer/Footer.stories": 3199,
	"./elements/molecules/Footer/Footer.stories.tsx": 3199,
	"./elements/molecules/Footer/Footer.tsx": 2055,
	"./elements/molecules/Footer/FooterSkeleton": 2692,
	"./elements/molecules/Footer/FooterSkeleton.tsx": 2692,
	"./elements/molecules/Footer/XmasDogs": 2690,
	"./elements/molecules/Footer/XmasDogs.tsx": 2690,
	"./elements/molecules/Footer/index": 1764,
	"./elements/molecules/Footer/index.ts": 1764,
	"./elements/molecules/Footer/queries/footerQuery": 2691,
	"./elements/molecules/Footer/queries/footerQuery.ts": 2691,
	"./elements/molecules/Form/Form": 689,
	"./elements/molecules/Form/Form.module": 1220,
	"./elements/molecules/Form/Form.module.sass": 1220,
	"./elements/molecules/Form/Form.module.sass.d": 3200,
	"./elements/molecules/Form/Form.module.sass.d.ts": 3200,
	"./elements/molecules/Form/Form.stories": 3201,
	"./elements/molecules/Form/Form.stories.tsx": 3201,
	"./elements/molecules/Form/Form.tsx": 689,
	"./elements/molecules/Header": 1309,
	"./elements/molecules/Header/": 1309,
	"./elements/molecules/Header/Header": 2037,
	"./elements/molecules/Header/Header.module": 676,
	"./elements/molecules/Header/Header.module.sass": 676,
	"./elements/molecules/Header/Header.module.sass.d": 3202,
	"./elements/molecules/Header/Header.module.sass.d.ts": 3202,
	"./elements/molecules/Header/Header.stories": 3203,
	"./elements/molecules/Header/Header.stories.tsx": 3203,
	"./elements/molecules/Header/Header.tsx": 2037,
	"./elements/molecules/Header/LeftAdornment": 1745,
	"./elements/molecules/Header/LeftAdornment/": 1745,
	"./elements/molecules/Header/LeftAdornment/LeftAdornment": 2415,
	"./elements/molecules/Header/LeftAdornment/LeftAdornment.tsx": 2415,
	"./elements/molecules/Header/LeftAdornment/index": 1745,
	"./elements/molecules/Header/LeftAdornment/index.ts": 1745,
	"./elements/molecules/Header/index": 1309,
	"./elements/molecules/Header/index.ts": 1309,
	"./elements/molecules/HowToFeedModalTrigger": 1732,
	"./elements/molecules/HowToFeedModalTrigger/": 1732,
	"./elements/molecules/HowToFeedModalTrigger/HowToFeedModalTrigger": 2022,
	"./elements/molecules/HowToFeedModalTrigger/HowToFeedModalTrigger.module": 2523,
	"./elements/molecules/HowToFeedModalTrigger/HowToFeedModalTrigger.module.sass": 2523,
	"./elements/molecules/HowToFeedModalTrigger/HowToFeedModalTrigger.module.sass.d": 3204,
	"./elements/molecules/HowToFeedModalTrigger/HowToFeedModalTrigger.module.sass.d.ts": 3204,
	"./elements/molecules/HowToFeedModalTrigger/HowToFeedModalTrigger.tsx": 2022,
	"./elements/molecules/HowToFeedModalTrigger/fragments/__generated__/HowToFeedModalTriggerDogFragment": 3205,
	"./elements/molecules/HowToFeedModalTrigger/fragments/__generated__/HowToFeedModalTriggerDogFragment.ts": 3205,
	"./elements/molecules/HowToFeedModalTrigger/fragments/__generated__/HowToFeedModalTriggerPlanFragment": 3206,
	"./elements/molecules/HowToFeedModalTrigger/fragments/__generated__/HowToFeedModalTriggerPlanFragment.ts": 3206,
	"./elements/molecules/HowToFeedModalTrigger/fragments/howToFeedModalFragment": 1365,
	"./elements/molecules/HowToFeedModalTrigger/fragments/howToFeedModalFragment.ts": 1365,
	"./elements/molecules/HowToFeedModalTrigger/index": 1732,
	"./elements/molecules/HowToFeedModalTrigger/index.ts": 1732,
	"./elements/molecules/IconButton/IconButton": 368,
	"./elements/molecules/IconButton/IconButton.module": 306,
	"./elements/molecules/IconButton/IconButton.module.sass": 306,
	"./elements/molecules/IconButton/IconButton.module.sass.d": 3207,
	"./elements/molecules/IconButton/IconButton.module.sass.d.ts": 3207,
	"./elements/molecules/IconButton/IconButton.stories": 3208,
	"./elements/molecules/IconButton/IconButton.stories.tsx": 3208,
	"./elements/molecules/IconButton/IconButton.tsx": 368,
	"./elements/molecules/IconCard/IconCard": 665,
	"./elements/molecules/IconCard/IconCard.module": 678,
	"./elements/molecules/IconCard/IconCard.module.sass": 678,
	"./elements/molecules/IconCard/IconCard.module.sass.d": 3209,
	"./elements/molecules/IconCard/IconCard.module.sass.d.ts": 3209,
	"./elements/molecules/IconCard/IconCard.stories": 3210,
	"./elements/molecules/IconCard/IconCard.stories.tsx": 3210,
	"./elements/molecules/IconCard/IconCard.tsx": 665,
	"./elements/molecules/LabelList/LabelList": 691,
	"./elements/molecules/LabelList/LabelList.module": 2311,
	"./elements/molecules/LabelList/LabelList.module.sass": 2311,
	"./elements/molecules/LabelList/LabelList.module.sass.d": 3211,
	"./elements/molecules/LabelList/LabelList.module.sass.d.ts": 3211,
	"./elements/molecules/LabelList/LabelList.stories": 3212,
	"./elements/molecules/LabelList/LabelList.stories.tsx": 3212,
	"./elements/molecules/LabelList/LabelList.tsx": 691,
	"./elements/molecules/ListGroup/ListGroup": 1599,
	"./elements/molecules/ListGroup/ListGroup.module": 2342,
	"./elements/molecules/ListGroup/ListGroup.module.sass": 2342,
	"./elements/molecules/ListGroup/ListGroup.module.sass.d": 3213,
	"./elements/molecules/ListGroup/ListGroup.module.sass.d.ts": 3213,
	"./elements/molecules/ListGroup/ListGroup.stories": 3214,
	"./elements/molecules/ListGroup/ListGroup.stories.tsx": 3214,
	"./elements/molecules/ListGroup/ListGroup.tsx": 1599,
	"./elements/molecules/MissingPaymentAlert": 1130,
	"./elements/molecules/MissingPaymentAlert/": 1130,
	"./elements/molecules/MissingPaymentAlert/MissingPaymentAlert": 2435,
	"./elements/molecules/MissingPaymentAlert/MissingPaymentAlert.tsx": 2435,
	"./elements/molecules/MissingPaymentAlert/index": 1130,
	"./elements/molecules/MissingPaymentAlert/index.ts": 1130,
	"./elements/molecules/ModalWithHeaderFooter/ModalWithHeaderFooter": 2187,
	"./elements/molecules/ModalWithHeaderFooter/ModalWithHeaderFooter.module": 1267,
	"./elements/molecules/ModalWithHeaderFooter/ModalWithHeaderFooter.module.sass": 1267,
	"./elements/molecules/ModalWithHeaderFooter/ModalWithHeaderFooter.module.sass.d": 3215,
	"./elements/molecules/ModalWithHeaderFooter/ModalWithHeaderFooter.module.sass.d.ts": 3215,
	"./elements/molecules/ModalWithHeaderFooter/ModalWithHeaderFooter.stories": 3216,
	"./elements/molecules/ModalWithHeaderFooter/ModalWithHeaderFooter.stories.tsx": 3216,
	"./elements/molecules/ModalWithHeaderFooter/ModalWithHeaderFooter.tsx": 2187,
	"./elements/molecules/MultipleComboBox": 1129,
	"./elements/molecules/MultipleComboBox/": 1129,
	"./elements/molecules/MultipleComboBox/MultipleComboBox": 2035,
	"./elements/molecules/MultipleComboBox/MultipleComboBox.module": 785,
	"./elements/molecules/MultipleComboBox/MultipleComboBox.module.sass": 785,
	"./elements/molecules/MultipleComboBox/MultipleComboBox.module.sass.d": 3217,
	"./elements/molecules/MultipleComboBox/MultipleComboBox.module.sass.d.ts": 3217,
	"./elements/molecules/MultipleComboBox/MultipleComboBox.stories": 3218,
	"./elements/molecules/MultipleComboBox/MultipleComboBox.stories.tsx": 3218,
	"./elements/molecules/MultipleComboBox/MultipleComboBox.tsx": 2035,
	"./elements/molecules/MultipleComboBox/index": 1129,
	"./elements/molecules/MultipleComboBox/index.ts": 1129,
	"./elements/molecules/NavigateAwayModal/NavigateAwayModal": 2144,
	"./elements/molecules/NavigateAwayModal/NavigateAwayModal.module": 2341,
	"./elements/molecules/NavigateAwayModal/NavigateAwayModal.module.sass": 2341,
	"./elements/molecules/NavigateAwayModal/NavigateAwayModal.module.sass.d": 3219,
	"./elements/molecules/NavigateAwayModal/NavigateAwayModal.module.sass.d.ts": 3219,
	"./elements/molecules/NavigateAwayModal/NavigateAwayModal.tsx": 2144,
	"./elements/molecules/NavigationTabBar": 1765,
	"./elements/molecules/NavigationTabBar/": 1765,
	"./elements/molecules/NavigationTabBar/NavigationTabBar": 2056,
	"./elements/molecules/NavigationTabBar/NavigationTabBar.module": 2351,
	"./elements/molecules/NavigationTabBar/NavigationTabBar.module.sass": 2351,
	"./elements/molecules/NavigationTabBar/NavigationTabBar.module.sass.d": 3220,
	"./elements/molecules/NavigationTabBar/NavigationTabBar.module.sass.d.ts": 3220,
	"./elements/molecules/NavigationTabBar/NavigationTabBar.stories": 3221,
	"./elements/molecules/NavigationTabBar/NavigationTabBar.stories.tsx": 3221,
	"./elements/molecules/NavigationTabBar/NavigationTabBar.tsx": 2056,
	"./elements/molecules/NavigationTabBar/Tab": 1296,
	"./elements/molecules/NavigationTabBar/Tab/": 1296,
	"./elements/molecules/NavigationTabBar/Tab/Tab": 2081,
	"./elements/molecules/NavigationTabBar/Tab/Tab.module": 1647,
	"./elements/molecules/NavigationTabBar/Tab/Tab.module.sass": 1647,
	"./elements/molecules/NavigationTabBar/Tab/Tab.module.sass.d": 3222,
	"./elements/molecules/NavigationTabBar/Tab/Tab.module.sass.d.ts": 3222,
	"./elements/molecules/NavigationTabBar/Tab/Tab.tsx": 2081,
	"./elements/molecules/NavigationTabBar/Tab/index": 1296,
	"./elements/molecules/NavigationTabBar/Tab/index.ts": 1296,
	"./elements/molecules/NavigationTabBar/index": 1765,
	"./elements/molecules/NavigationTabBar/index.ts": 1765,
	"./elements/molecules/NotificationContainer/NotificationContainer": 373,
	"./elements/molecules/NotificationContainer/NotificationContainer.module": 1883,
	"./elements/molecules/NotificationContainer/NotificationContainer.module.sass": 1883,
	"./elements/molecules/NotificationContainer/NotificationContainer.module.sass.d": 3223,
	"./elements/molecules/NotificationContainer/NotificationContainer.module.sass.d.ts": 3223,
	"./elements/molecules/NotificationContainer/NotificationContainer.stories": 3224,
	"./elements/molecules/NotificationContainer/NotificationContainer.stories.tsx": 3224,
	"./elements/molecules/NotificationContainer/NotificationContainer.tsx": 373,
	"./elements/molecules/NotificationContent/NotificationContent": 166,
	"./elements/molecules/NotificationContent/NotificationContent.module": 1884,
	"./elements/molecules/NotificationContent/NotificationContent.module.sass": 1884,
	"./elements/molecules/NotificationContent/NotificationContent.module.sass.d": 3225,
	"./elements/molecules/NotificationContent/NotificationContent.module.sass.d.ts": 3225,
	"./elements/molecules/NotificationContent/NotificationContent.tsx": 166,
	"./elements/molecules/OOBCard": 2445,
	"./elements/molecules/OOBCard/": 2445,
	"./elements/molecules/OOBCard/OOBCard": 1313,
	"./elements/molecules/OOBCard/OOBCard.tsx": 1313,
	"./elements/molecules/OOBCard/index": 2445,
	"./elements/molecules/OOBCard/index.ts": 2445,
	"./elements/molecules/OneTimePurchaseFooter/OneTimePurchaseFooter": 1590,
	"./elements/molecules/OneTimePurchaseFooter/OneTimePurchaseFooter.module": 587,
	"./elements/molecules/OneTimePurchaseFooter/OneTimePurchaseFooter.module.sass": 587,
	"./elements/molecules/OneTimePurchaseFooter/OneTimePurchaseFooter.module.sass.d": 3226,
	"./elements/molecules/OneTimePurchaseFooter/OneTimePurchaseFooter.module.sass.d.ts": 3226,
	"./elements/molecules/OneTimePurchaseFooter/OneTimePurchaseFooter.stories": 3227,
	"./elements/molecules/OneTimePurchaseFooter/OneTimePurchaseFooter.stories.tsx": 3227,
	"./elements/molecules/OneTimePurchaseFooter/OneTimePurchaseFooter.tsx": 1590,
	"./elements/molecules/OptionSelector": 1307,
	"./elements/molecules/OptionSelector/": 1307,
	"./elements/molecules/OptionSelector/OptionSelector": 2026,
	"./elements/molecules/OptionSelector/OptionSelector.module": 1090,
	"./elements/molecules/OptionSelector/OptionSelector.module.sass": 1090,
	"./elements/molecules/OptionSelector/OptionSelector.module.sass.d": 3228,
	"./elements/molecules/OptionSelector/OptionSelector.module.sass.d.ts": 3228,
	"./elements/molecules/OptionSelector/OptionSelector.tsx": 2026,
	"./elements/molecules/OptionSelector/OptionSelectorSkeleton": 2531,
	"./elements/molecules/OptionSelector/OptionSelectorSkeleton.tsx": 2531,
	"./elements/molecules/OptionSelector/index": 1307,
	"./elements/molecules/OptionSelector/index.ts": 1307,
	"./elements/molecules/OrderCard/OrderCard": 1857,
	"./elements/molecules/OrderCard/OrderCard.module": 706,
	"./elements/molecules/OrderCard/OrderCard.module.sass": 706,
	"./elements/molecules/OrderCard/OrderCard.module.sass.d": 3229,
	"./elements/molecules/OrderCard/OrderCard.module.sass.d.ts": 3229,
	"./elements/molecules/OrderCard/OrderCard.stories": 3230,
	"./elements/molecules/OrderCard/OrderCard.stories.tsx": 3230,
	"./elements/molecules/OrderCard/OrderCard.tsx": 1857,
	"./elements/molecules/OrderSummary/OrderSummary": 1592,
	"./elements/molecules/OrderSummary/OrderSummary.module": 754,
	"./elements/molecules/OrderSummary/OrderSummary.module.sass": 754,
	"./elements/molecules/OrderSummary/OrderSummary.module.sass.d": 3231,
	"./elements/molecules/OrderSummary/OrderSummary.module.sass.d.ts": 3231,
	"./elements/molecules/OrderSummary/OrderSummary.stories": 3232,
	"./elements/molecules/OrderSummary/OrderSummary.stories.tsx": 3232,
	"./elements/molecules/OrderSummary/OrderSummary.tsx": 1592,
	"./elements/molecules/PasswordField/PasswordField": 1061,
	"./elements/molecules/PasswordField/PasswordField.module": 885,
	"./elements/molecules/PasswordField/PasswordField.module.sass": 885,
	"./elements/molecules/PasswordField/PasswordField.module.sass.d": 3233,
	"./elements/molecules/PasswordField/PasswordField.module.sass.d.ts": 3233,
	"./elements/molecules/PasswordField/PasswordField.stories": 3234,
	"./elements/molecules/PasswordField/PasswordField.stories.tsx": 3234,
	"./elements/molecules/PasswordField/PasswordField.tsx": 1061,
	"./elements/molecules/PasswordFields/PasswordFields": 1859,
	"./elements/molecules/PasswordFields/PasswordFields.tsx": 1859,
	"./elements/molecules/PillGroup/PillGroup": 554,
	"./elements/molecules/PillGroup/PillGroup.module": 2328,
	"./elements/molecules/PillGroup/PillGroup.module.sass": 2328,
	"./elements/molecules/PillGroup/PillGroup.module.sass.d": 3235,
	"./elements/molecules/PillGroup/PillGroup.module.sass.d.ts": 3235,
	"./elements/molecules/PillGroup/PillGroup.stories": 3236,
	"./elements/molecules/PillGroup/PillGroup.stories.tsx": 3236,
	"./elements/molecules/PillGroup/PillGroup.tsx": 554,
	"./elements/molecules/PlanDetails/PlanDetails": 2475,
	"./elements/molecules/PlanDetails/PlanDetails.tsx": 2475,
	"./elements/molecules/PlanDetails/queries/__generated__/PlanDetailsQuery": 3237,
	"./elements/molecules/PlanDetails/queries/__generated__/PlanDetailsQuery.ts": 3237,
	"./elements/molecules/PlanDetails/queries/queries": 2476,
	"./elements/molecules/PlanDetails/queries/queries.ts": 2476,
	"./elements/molecules/PriceBreakdown/PriceBreakdown": 1585,
	"./elements/molecules/PriceBreakdown/PriceBreakdown.module": 1100,
	"./elements/molecules/PriceBreakdown/PriceBreakdown.module.sass": 1100,
	"./elements/molecules/PriceBreakdown/PriceBreakdown.module.sass.d": 3238,
	"./elements/molecules/PriceBreakdown/PriceBreakdown.module.sass.d.ts": 3238,
	"./elements/molecules/PriceBreakdown/PriceBreakdown.stories": 3239,
	"./elements/molecules/PriceBreakdown/PriceBreakdown.stories.tsx": 3239,
	"./elements/molecules/PriceBreakdown/PriceBreakdown.tsx": 1585,
	"./elements/molecules/ProductBenefit/ProductBenefit": 1140,
	"./elements/molecules/ProductBenefit/ProductBenefit.module": 1921,
	"./elements/molecules/ProductBenefit/ProductBenefit.module.sass": 1921,
	"./elements/molecules/ProductBenefit/ProductBenefit.module.sass.d": 3240,
	"./elements/molecules/ProductBenefit/ProductBenefit.module.sass.d.ts": 3240,
	"./elements/molecules/ProductBenefit/ProductBenefit.stories": 3241,
	"./elements/molecules/ProductBenefit/ProductBenefit.stories.tsx": 3241,
	"./elements/molecules/ProductBenefit/ProductBenefit.tsx": 1140,
	"./elements/molecules/ProductCard/ProductCard": 1596,
	"./elements/molecules/ProductCard/ProductCard.module": 703,
	"./elements/molecules/ProductCard/ProductCard.module.sass": 703,
	"./elements/molecules/ProductCard/ProductCard.module.sass.d": 3242,
	"./elements/molecules/ProductCard/ProductCard.module.sass.d.ts": 3242,
	"./elements/molecules/ProductCard/ProductCard.stories": 3243,
	"./elements/molecules/ProductCard/ProductCard.stories.tsx": 3243,
	"./elements/molecules/ProductCard/ProductCard.tsx": 1596,
	"./elements/molecules/ProductCard/ProductCardSkeleton": 1825,
	"./elements/molecules/ProductCard/ProductCardSkeleton.tsx": 1825,
	"./elements/molecules/ProductQuantityLarge/ProductQuantityLarge": 1591,
	"./elements/molecules/ProductQuantityLarge/ProductQuantityLarge.module": 955,
	"./elements/molecules/ProductQuantityLarge/ProductQuantityLarge.module.sass": 955,
	"./elements/molecules/ProductQuantityLarge/ProductQuantityLarge.module.sass.d": 3244,
	"./elements/molecules/ProductQuantityLarge/ProductQuantityLarge.module.sass.d.ts": 3244,
	"./elements/molecules/ProductQuantityLarge/ProductQuantityLarge.stories": 3245,
	"./elements/molecules/ProductQuantityLarge/ProductQuantityLarge.stories.tsx": 3245,
	"./elements/molecules/ProductQuantityLarge/ProductQuantityLarge.tsx": 1591,
	"./elements/molecules/ProductThumb/ProductThumb": 695,
	"./elements/molecules/ProductThumb/ProductThumb.module": 952,
	"./elements/molecules/ProductThumb/ProductThumb.module.sass": 952,
	"./elements/molecules/ProductThumb/ProductThumb.module.sass.d": 3246,
	"./elements/molecules/ProductThumb/ProductThumb.module.sass.d.ts": 3246,
	"./elements/molecules/ProductThumb/ProductThumb.stories": 3247,
	"./elements/molecules/ProductThumb/ProductThumb.stories.tsx": 3247,
	"./elements/molecules/ProductThumb/ProductThumb.tsx": 695,
	"./elements/molecules/ProductThumb/__snapshots__/ProductThumb.spec.tsx.snap": 4313,
	"./elements/molecules/ProductUpsellableCard": 1126,
	"./elements/molecules/ProductUpsellableCard/": 1126,
	"./elements/molecules/ProductUpsellableCard/ProductUpsellableCard": 1435,
	"./elements/molecules/ProductUpsellableCard/ProductUpsellableCard.module": 559,
	"./elements/molecules/ProductUpsellableCard/ProductUpsellableCard.module.sass": 559,
	"./elements/molecules/ProductUpsellableCard/ProductUpsellableCard.module.sass.d": 3248,
	"./elements/molecules/ProductUpsellableCard/ProductUpsellableCard.module.sass.d.ts": 3248,
	"./elements/molecules/ProductUpsellableCard/ProductUpsellableCard.stories": 3249,
	"./elements/molecules/ProductUpsellableCard/ProductUpsellableCard.stories.tsx": 3249,
	"./elements/molecules/ProductUpsellableCard/ProductUpsellableCard.tsx": 1435,
	"./elements/molecules/ProductUpsellableCard/ProductUpsellableCardSkeleton": 1624,
	"./elements/molecules/ProductUpsellableCard/ProductUpsellableCardSkeleton.tsx": 1624,
	"./elements/molecules/ProductUpsellableCard/index": 1126,
	"./elements/molecules/ProductUpsellableCard/index.ts": 1126,
	"./elements/molecules/PuppyDiscountModal/PuppyDiscountModal": 2614,
	"./elements/molecules/PuppyDiscountModal/PuppyDiscountModal.tsx": 2614,
	"./elements/molecules/PuppyDiscountModal/queries/PuppyDiscountModal": 2617,
	"./elements/molecules/PuppyDiscountModal/queries/PuppyDiscountModal.ts": 2617,
	"./elements/molecules/RadioGroup/RadioGroup": 618,
	"./elements/molecules/RadioGroup/RadioGroup.module": 1649,
	"./elements/molecules/RadioGroup/RadioGroup.module.sass": 1649,
	"./elements/molecules/RadioGroup/RadioGroup.module.sass.d": 3250,
	"./elements/molecules/RadioGroup/RadioGroup.module.sass.d.ts": 3250,
	"./elements/molecules/RadioGroup/RadioGroup.stories": 3251,
	"./elements/molecules/RadioGroup/RadioGroup.stories.tsx": 3251,
	"./elements/molecules/RadioGroup/RadioGroup.tsx": 618,
	"./elements/molecules/RafCampaignModal/RafCampaignModal": 1808,
	"./elements/molecules/RafCampaignModal/RafCampaignModal.tsx": 1808,
	"./elements/molecules/RecipeCard/RecipeCard": 1225,
	"./elements/molecules/RecipeCard/RecipeCard.module": 756,
	"./elements/molecules/RecipeCard/RecipeCard.module.sass": 756,
	"./elements/molecules/RecipeCard/RecipeCard.module.sass.d": 3252,
	"./elements/molecules/RecipeCard/RecipeCard.module.sass.d.ts": 3252,
	"./elements/molecules/RecipeCard/RecipeCard.stories": 3253,
	"./elements/molecules/RecipeCard/RecipeCard.stories.tsx": 3253,
	"./elements/molecules/RecipeCard/RecipeCard.tsx": 1225,
	"./elements/molecules/RecipeCard/fragment/__generated__/recipeCardFlavourFragment": 3254,
	"./elements/molecules/RecipeCard/fragment/__generated__/recipeCardFlavourFragment.ts": 3254,
	"./elements/molecules/RecipeCard/fragment/__generated__/recipeCardFragment": 3255,
	"./elements/molecules/RecipeCard/fragment/__generated__/recipeCardFragment.ts": 3255,
	"./elements/molecules/RecipeCard/fragment/__generated__/recipeCardPlanFields": 3256,
	"./elements/molecules/RecipeCard/fragment/__generated__/recipeCardPlanFields.ts": 3256,
	"./elements/molecules/RecipeCard/fragment/__generated__/recipeCardPlanFragment": 3257,
	"./elements/molecules/RecipeCard/fragment/__generated__/recipeCardPlanFragment.ts": 3257,
	"./elements/molecules/RecipeCard/fragment/recipeCardFragment": 1841,
	"./elements/molecules/RecipeCard/fragment/recipeCardFragment.ts": 1841,
	"./elements/molecules/SelectableCard/SelectableCard": 1073,
	"./elements/molecules/SelectableCard/SelectableCard.module": 682,
	"./elements/molecules/SelectableCard/SelectableCard.module.sass": 682,
	"./elements/molecules/SelectableCard/SelectableCard.module.sass.d": 3258,
	"./elements/molecules/SelectableCard/SelectableCard.module.sass.d.ts": 3258,
	"./elements/molecules/SelectableCard/SelectableCard.stories": 3259,
	"./elements/molecules/SelectableCard/SelectableCard.stories.tsx": 3259,
	"./elements/molecules/SelectableCard/SelectableCard.tsx": 1073,
	"./elements/molecules/SelectableCardGroup": 552,
	"./elements/molecules/SelectableCardGroup/": 552,
	"./elements/molecules/SelectableCardGroup/SelectableCardGroup": 2034,
	"./elements/molecules/SelectableCardGroup/SelectableCardGroup.module": 774,
	"./elements/molecules/SelectableCardGroup/SelectableCardGroup.module.sass": 774,
	"./elements/molecules/SelectableCardGroup/SelectableCardGroup.module.sass.d": 3260,
	"./elements/molecules/SelectableCardGroup/SelectableCardGroup.module.sass.d.ts": 3260,
	"./elements/molecules/SelectableCardGroup/SelectableCardGroup.tsx": 2034,
	"./elements/molecules/SelectableCardGroup/SelectableCardGtoupV2": 2413,
	"./elements/molecules/SelectableCardGroup/SelectableCardGtoupV2.tsx": 2413,
	"./elements/molecules/SelectableCardGroup/components/CardItem": 2540,
	"./elements/molecules/SelectableCardGroup/components/CardItem.tsx": 2540,
	"./elements/molecules/SelectableCardGroup/index": 552,
	"./elements/molecules/SelectableCardGroup/index.ts": 552,
	"./elements/molecules/SelectableCardTemplate": 2446,
	"./elements/molecules/SelectableCardTemplate/": 2446,
	"./elements/molecules/SelectableCardTemplate/SelectableCardTemplate": 2074,
	"./elements/molecules/SelectableCardTemplate/SelectableCardTemplate.module": 1672,
	"./elements/molecules/SelectableCardTemplate/SelectableCardTemplate.module.sass": 1672,
	"./elements/molecules/SelectableCardTemplate/SelectableCardTemplate.module.sass.d": 3261,
	"./elements/molecules/SelectableCardTemplate/SelectableCardTemplate.module.sass.d.ts": 3261,
	"./elements/molecules/SelectableCardTemplate/SelectableCardTemplate.tsx": 2074,
	"./elements/molecules/SelectableCardTemplate/index": 2446,
	"./elements/molecules/SelectableCardTemplate/index.ts": 2446,
	"./elements/molecules/ShareModalButton/ShareModalButton": 1143,
	"./elements/molecules/ShareModalButton/ShareModalButton.stories": 3262,
	"./elements/molecules/ShareModalButton/ShareModalButton.stories.tsx": 3262,
	"./elements/molecules/ShareModalButton/ShareModalButton.tsx": 1143,
	"./elements/molecules/ShareModalButton/queries/ShareModalQuery": 2718,
	"./elements/molecules/ShareModalButton/queries/ShareModalQuery.ts": 2718,
	"./elements/molecules/ShareModalButton/queries/__generated__/ShareModalQuery": 3263,
	"./elements/molecules/ShareModalButton/queries/__generated__/ShareModalQuery.ts": 3263,
	"./elements/molecules/StarRating/StarRating": 1199,
	"./elements/molecules/StarRating/StarRating.module": 2333,
	"./elements/molecules/StarRating/StarRating.module.sass": 2333,
	"./elements/molecules/StarRating/StarRating.module.sass.d": 3264,
	"./elements/molecules/StarRating/StarRating.module.sass.d.ts": 3264,
	"./elements/molecules/StarRating/StarRating.stories": 3265,
	"./elements/molecules/StarRating/StarRating.stories.tsx": 3265,
	"./elements/molecules/StarRating/StarRating.tsx": 1199,
	"./elements/molecules/SteppedProgressBar/SteppedProgressBar": 2890,
	"./elements/molecules/SteppedProgressBar/SteppedProgressBar.module": 1673,
	"./elements/molecules/SteppedProgressBar/SteppedProgressBar.module.sass": 1673,
	"./elements/molecules/SteppedProgressBar/SteppedProgressBar.module.sass.d": 3266,
	"./elements/molecules/SteppedProgressBar/SteppedProgressBar.module.sass.d.ts": 3266,
	"./elements/molecules/SteppedProgressBar/SteppedProgressBar.tsx": 2890,
	"./elements/molecules/StopDeliveriesButton/queries/__generated__/BrightbackInitialiserQuery": 3267,
	"./elements/molecules/StopDeliveriesButton/queries/__generated__/BrightbackInitialiserQuery.ts": 3267,
	"./elements/molecules/StopDeliveriesButton/queries/brightInitialiserQuery": 3268,
	"./elements/molecules/StopDeliveriesButton/queries/brightInitialiserQuery.ts": 3268,
	"./elements/molecules/SubHeader": 1766,
	"./elements/molecules/SubHeader/": 1766,
	"./elements/molecules/SubHeader/SubHeader": 2057,
	"./elements/molecules/SubHeader/SubHeader.module": 2352,
	"./elements/molecules/SubHeader/SubHeader.module.sass": 2352,
	"./elements/molecules/SubHeader/SubHeader.module.sass.d": 3269,
	"./elements/molecules/SubHeader/SubHeader.module.sass.d.ts": 3269,
	"./elements/molecules/SubHeader/SubHeader.stories": 3270,
	"./elements/molecules/SubHeader/SubHeader.stories.tsx": 3270,
	"./elements/molecules/SubHeader/SubHeader.tsx": 2057,
	"./elements/molecules/SubHeader/index": 1766,
	"./elements/molecules/SubHeader/index.ts": 1766,
	"./elements/molecules/SubscriptionDetailsCard/SubscriptionDetailsCard": 2891,
	"./elements/molecules/SubscriptionDetailsCard/SubscriptionDetailsCard.module": 708,
	"./elements/molecules/SubscriptionDetailsCard/SubscriptionDetailsCard.module.sass": 708,
	"./elements/molecules/SubscriptionDetailsCard/SubscriptionDetailsCard.module.sass.d": 3271,
	"./elements/molecules/SubscriptionDetailsCard/SubscriptionDetailsCard.module.sass.d.ts": 3271,
	"./elements/molecules/SubscriptionDetailsCard/SubscriptionDetailsCard.tsx": 2891,
	"./elements/molecules/SubscriptionDetailsCard/components/DeliveryDetails/DeliveryDetails": 1865,
	"./elements/molecules/SubscriptionDetailsCard/components/DeliveryDetails/DeliveryDetails.module": 1173,
	"./elements/molecules/SubscriptionDetailsCard/components/DeliveryDetails/DeliveryDetails.module.sass": 1173,
	"./elements/molecules/SubscriptionDetailsCard/components/DeliveryDetails/DeliveryDetails.module.sass.d": 3272,
	"./elements/molecules/SubscriptionDetailsCard/components/DeliveryDetails/DeliveryDetails.module.sass.d.ts": 3272,
	"./elements/molecules/SubscriptionDetailsCard/components/DeliveryDetails/DeliveryDetails.tsx": 1865,
	"./elements/molecules/SubscriptionDetailsCard/components/DogGramsPerDay/DogGramsPerDay": 1866,
	"./elements/molecules/SubscriptionDetailsCard/components/DogGramsPerDay/DogGramsPerDay.module": 758,
	"./elements/molecules/SubscriptionDetailsCard/components/DogGramsPerDay/DogGramsPerDay.module.sass": 758,
	"./elements/molecules/SubscriptionDetailsCard/components/DogGramsPerDay/DogGramsPerDay.module.sass.d": 3273,
	"./elements/molecules/SubscriptionDetailsCard/components/DogGramsPerDay/DogGramsPerDay.module.sass.d.ts": 3273,
	"./elements/molecules/SubscriptionDetailsCard/components/DogGramsPerDay/DogGramsPerDay.tsx": 1866,
	"./elements/molecules/SubscriptionDetailsCard/queries/__generated__/SubscriptionDetailsCardQuery": 3274,
	"./elements/molecules/SubscriptionDetailsCard/queries/__generated__/SubscriptionDetailsCardQuery.ts": 3274,
	"./elements/molecules/SubscriptionDetailsCard/queries/queries": 2757,
	"./elements/molecules/SubscriptionDetailsCard/queries/queries.ts": 2757,
	"./elements/molecules/SubscriptionOverview": 1712,
	"./elements/molecules/SubscriptionOverview/": 1712,
	"./elements/molecules/SubscriptionOverview/SubscriptionOverview": 2000,
	"./elements/molecules/SubscriptionOverview/SubscriptionOverview.module": 1377,
	"./elements/molecules/SubscriptionOverview/SubscriptionOverview.module.sass": 1377,
	"./elements/molecules/SubscriptionOverview/SubscriptionOverview.module.sass.d": 3275,
	"./elements/molecules/SubscriptionOverview/SubscriptionOverview.module.sass.d.ts": 3275,
	"./elements/molecules/SubscriptionOverview/SubscriptionOverview.tsx": 2000,
	"./elements/molecules/SubscriptionOverview/components/HowToFeedModalTrigger": 1713,
	"./elements/molecules/SubscriptionOverview/components/HowToFeedModalTrigger/": 1713,
	"./elements/molecules/SubscriptionOverview/components/HowToFeedModalTrigger/HowToFeedModalTrigger": 2001,
	"./elements/molecules/SubscriptionOverview/components/HowToFeedModalTrigger/HowToFeedModalTrigger.module": 2502,
	"./elements/molecules/SubscriptionOverview/components/HowToFeedModalTrigger/HowToFeedModalTrigger.module.sass": 2502,
	"./elements/molecules/SubscriptionOverview/components/HowToFeedModalTrigger/HowToFeedModalTrigger.module.sass.d": 3276,
	"./elements/molecules/SubscriptionOverview/components/HowToFeedModalTrigger/HowToFeedModalTrigger.module.sass.d.ts": 3276,
	"./elements/molecules/SubscriptionOverview/components/HowToFeedModalTrigger/HowToFeedModalTrigger.tsx": 2001,
	"./elements/molecules/SubscriptionOverview/components/HowToFeedModalTrigger/index": 1713,
	"./elements/molecules/SubscriptionOverview/components/HowToFeedModalTrigger/index.ts": 1713,
	"./elements/molecules/SubscriptionOverview/fragments/__generated__/SubscriptionOverviewFragment": 3277,
	"./elements/molecules/SubscriptionOverview/fragments/__generated__/SubscriptionOverviewFragment.ts": 3277,
	"./elements/molecules/SubscriptionOverview/fragments/subscriptionOverviewFragment": 2507,
	"./elements/molecules/SubscriptionOverview/fragments/subscriptionOverviewFragment.ts": 2507,
	"./elements/molecules/SubscriptionOverview/index": 1712,
	"./elements/molecules/SubscriptionOverview/index.ts": 1712,
	"./elements/molecules/SurchargeTooltip": 1763,
	"./elements/molecules/SurchargeTooltip/": 1763,
	"./elements/molecules/SurchargeTooltip/SurchargeTooltip": 2433,
	"./elements/molecules/SurchargeTooltip/SurchargeTooltip.tsx": 2433,
	"./elements/molecules/SurchargeTooltip/index": 1763,
	"./elements/molecules/SurchargeTooltip/index.ts": 1763,
	"./elements/molecules/SurveyCard/SurveyCard": 1204,
	"./elements/molecules/SurveyCard/SurveyCard.module": 526,
	"./elements/molecules/SurveyCard/SurveyCard.module.sass": 526,
	"./elements/molecules/SurveyCard/SurveyCard.module.sass.d": 3278,
	"./elements/molecules/SurveyCard/SurveyCard.module.sass.d.ts": 3278,
	"./elements/molecules/SurveyCard/SurveyCard.stories": 3279,
	"./elements/molecules/SurveyCard/SurveyCard.stories.tsx": 3279,
	"./elements/molecules/SurveyCard/SurveyCard.tsx": 1204,
	"./elements/molecules/SurveyCard/SurveyCardCards/ExternalLinkCard": 2759,
	"./elements/molecules/SurveyCard/SurveyCardCards/ExternalLinkCard.tsx": 2759,
	"./elements/molecules/SurveyCard/SurveyCardCards/FreeTextQuestion": 2760,
	"./elements/molecules/SurveyCard/SurveyCardCards/FreeTextQuestion.tsx": 2760,
	"./elements/molecules/SurveyCard/SurveyCardCards/IntroCard": 2761,
	"./elements/molecules/SurveyCard/SurveyCardCards/IntroCard.tsx": 2761,
	"./elements/molecules/SurveyCard/SurveyCardCards/MultipleChoiceQuestion": 2762,
	"./elements/molecules/SurveyCard/SurveyCardCards/MultipleChoiceQuestion.tsx": 2762,
	"./elements/molecules/SurveyCard/SurveyCardCards/RatingQuestion": 2763,
	"./elements/molecules/SurveyCard/SurveyCardCards/RatingQuestion.tsx": 2763,
	"./elements/molecules/SurveyCard/mutations/__generated__/SubmitSurveyAnswers": 3280,
	"./elements/molecules/SurveyCard/mutations/__generated__/SubmitSurveyAnswers.ts": 3280,
	"./elements/molecules/SurveyCard/mutations/submitAnswersMutation": 2758,
	"./elements/molecules/SurveyCard/mutations/submitAnswersMutation.ts": 2758,
	"./elements/molecules/SurveyCard/queries/__generated__/SurveyCardQuery": 3281,
	"./elements/molecules/SurveyCard/queries/__generated__/SurveyCardQuery.ts": 3281,
	"./elements/molecules/SurveyCard/queries/surveyCardQuery": 2214,
	"./elements/molecules/SurveyCard/queries/surveyCardQuery.ts": 2214,
	"./elements/molecules/SwiperSlider/SwiperSlider": 179,
	"./elements/molecules/SwiperSlider/SwiperSlider.module": 143,
	"./elements/molecules/SwiperSlider/SwiperSlider.module.sass": 143,
	"./elements/molecules/SwiperSlider/SwiperSlider.module.sass.d": 3282,
	"./elements/molecules/SwiperSlider/SwiperSlider.module.sass.d.ts": 3282,
	"./elements/molecules/SwiperSlider/SwiperSlider.stories": 3283,
	"./elements/molecules/SwiperSlider/SwiperSlider.stories.tsx": 3283,
	"./elements/molecules/SwiperSlider/SwiperSlider.tsx": 179,
	"./elements/molecules/SwiperSlider/v2": 1721,
	"./elements/molecules/SwiperSlider/v2/": 1721,
	"./elements/molecules/SwiperSlider/v2/SwiperSlider": 1694,
	"./elements/molecules/SwiperSlider/v2/SwiperSlider.module": 850,
	"./elements/molecules/SwiperSlider/v2/SwiperSlider.module.sass": 850,
	"./elements/molecules/SwiperSlider/v2/SwiperSlider.module.sass.d": 3284,
	"./elements/molecules/SwiperSlider/v2/SwiperSlider.module.sass.d.ts": 3284,
	"./elements/molecules/SwiperSlider/v2/SwiperSlider.tsx": 1694,
	"./elements/molecules/SwiperSlider/v2/components/SkeletonSlide": 2319,
	"./elements/molecules/SwiperSlider/v2/components/SkeletonSlide.tsx": 2319,
	"./elements/molecules/SwiperSlider/v2/index": 1721,
	"./elements/molecules/SwiperSlider/v2/index.ts": 1721,
	"./elements/molecules/TalkingHead/TalkingHead": 1582,
	"./elements/molecules/TalkingHead/TalkingHead.module": 1650,
	"./elements/molecules/TalkingHead/TalkingHead.module.sass": 1650,
	"./elements/molecules/TalkingHead/TalkingHead.module.sass.d": 3285,
	"./elements/molecules/TalkingHead/TalkingHead.module.sass.d.ts": 3285,
	"./elements/molecules/TalkingHead/TalkingHead.stories": 3286,
	"./elements/molecules/TalkingHead/TalkingHead.stories.tsx": 3286,
	"./elements/molecules/TalkingHead/TalkingHead.tsx": 1582,
	"./elements/molecules/TextSeparator/TextSeparator": 804,
	"./elements/molecules/TextSeparator/TextSeparator.module": 1910,
	"./elements/molecules/TextSeparator/TextSeparator.module.sass": 1910,
	"./elements/molecules/TextSeparator/TextSeparator.module.sass.d": 3287,
	"./elements/molecules/TextSeparator/TextSeparator.module.sass.d.ts": 3287,
	"./elements/molecules/TextSeparator/TextSeparator.stories": 3288,
	"./elements/molecules/TextSeparator/TextSeparator.stories.tsx": 3288,
	"./elements/molecules/TextSeparator/TextSeparator.tsx": 804,
	"./elements/molecules/TitleAndMore/TitleAndMore": 1354,
	"./elements/molecules/TitleAndMore/TitleAndMore.module": 2702,
	"./elements/molecules/TitleAndMore/TitleAndMore.module.sass": 2702,
	"./elements/molecules/TitleAndMore/TitleAndMore.module.sass.d": 3289,
	"./elements/molecules/TitleAndMore/TitleAndMore.module.sass.d.ts": 3289,
	"./elements/molecules/TitleAndMore/TitleAndMore.stories": 3290,
	"./elements/molecules/TitleAndMore/TitleAndMore.stories.tsx": 3290,
	"./elements/molecules/TitleAndMore/TitleAndMore.tsx": 1354,
	"./elements/molecules/TopNavBanner/TopNavBanner": 633,
	"./elements/molecules/TopNavBanner/TopNavBanner.module": 2338,
	"./elements/molecules/TopNavBanner/TopNavBanner.module.sass": 2338,
	"./elements/molecules/TopNavBanner/TopNavBanner.module.sass.d": 3291,
	"./elements/molecules/TopNavBanner/TopNavBanner.module.sass.d.ts": 3291,
	"./elements/molecules/TopNavBanner/TopNavBanner.stories": 3292,
	"./elements/molecules/TopNavBanner/TopNavBanner.stories.tsx": 3292,
	"./elements/molecules/TopNavBanner/TopNavBanner.tsx": 633,
	"./elements/molecules/TopNavDiscount/TopNavDiscount": 2142,
	"./elements/molecules/TopNavDiscount/TopNavDiscount.module": 2571,
	"./elements/molecules/TopNavDiscount/TopNavDiscount.module.sass": 2571,
	"./elements/molecules/TopNavDiscount/TopNavDiscount.module.sass.d": 3293,
	"./elements/molecules/TopNavDiscount/TopNavDiscount.module.sass.d.ts": 3293,
	"./elements/molecules/TopNavDiscount/TopNavDiscount.stories": 3294,
	"./elements/molecules/TopNavDiscount/TopNavDiscount.stories.tsx": 3294,
	"./elements/molecules/TopNavDiscount/TopNavDiscount.tsx": 2142,
	"./elements/molecules/TopNavDiscount/queries/__generated__/TopNavDiscountQuery": 3295,
	"./elements/molecules/TopNavDiscount/queries/__generated__/TopNavDiscountQuery.ts": 3295,
	"./elements/molecules/TopNavDiscount/queries/topNavDiscountQuery": 2570,
	"./elements/molecules/TopNavDiscount/queries/topNavDiscountQuery.ts": 2570,
	"./elements/molecules/Tour/Tour": 1873,
	"./elements/molecules/Tour/Tour.module": 601,
	"./elements/molecules/Tour/Tour.module.sass": 601,
	"./elements/molecules/Tour/Tour.module.sass.d": 3296,
	"./elements/molecules/Tour/Tour.module.sass.d.ts": 3296,
	"./elements/molecules/Tour/Tour.stories": 3297,
	"./elements/molecules/Tour/Tour.stories.tsx": 3297,
	"./elements/molecules/Tour/Tour.tsx": 1873,
	"./elements/molecules/TourV2/TourV2": 1243,
	"./elements/molecules/TourV2/TourV2.module": 902,
	"./elements/molecules/TourV2/TourV2.module.sass": 902,
	"./elements/molecules/TourV2/TourV2.module.sass.d": 3298,
	"./elements/molecules/TourV2/TourV2.module.sass.d.ts": 3298,
	"./elements/molecules/TourV2/TourV2.tsx": 1243,
	"./elements/molecules/UndeliverableDateAdjustment": 1297,
	"./elements/molecules/UndeliverableDateAdjustment/": 1297,
	"./elements/molecules/UndeliverableDateAdjustment/UndeliverableDateAdjustment": 1998,
	"./elements/molecules/UndeliverableDateAdjustment/UndeliverableDateAdjustment.module": 1652,
	"./elements/molecules/UndeliverableDateAdjustment/UndeliverableDateAdjustment.module.sass": 1652,
	"./elements/molecules/UndeliverableDateAdjustment/UndeliverableDateAdjustment.module.sass.d": 3299,
	"./elements/molecules/UndeliverableDateAdjustment/UndeliverableDateAdjustment.module.sass.d.ts": 3299,
	"./elements/molecules/UndeliverableDateAdjustment/UndeliverableDateAdjustment.tsx": 1998,
	"./elements/molecules/UndeliverableDateAdjustment/index": 1297,
	"./elements/molecules/UndeliverableDateAdjustment/index.ts": 1297,
	"./elements/organisms/AdditionalProductModal/AdditionalProductModal": 1224,
	"./elements/organisms/AdditionalProductModal/AdditionalProductModal.module": 959,
	"./elements/organisms/AdditionalProductModal/AdditionalProductModal.module.sass": 959,
	"./elements/organisms/AdditionalProductModal/AdditionalProductModal.module.sass.d": 3300,
	"./elements/organisms/AdditionalProductModal/AdditionalProductModal.module.sass.d.ts": 3300,
	"./elements/organisms/AdditionalProductModal/AdditionalProductModal.stories": 3301,
	"./elements/organisms/AdditionalProductModal/AdditionalProductModal.stories.tsx": 3301,
	"./elements/organisms/AdditionalProductModal/AdditionalProductModal.tsx": 1224,
	"./elements/organisms/AdditionalProductModal/queries/__generated__/AdditionalProductQuery": 3302,
	"./elements/organisms/AdditionalProductModal/queries/__generated__/AdditionalProductQuery.ts": 3302,
	"./elements/organisms/AdditionalProductModal/queries/additionalProductQuery": 2143,
	"./elements/organisms/AdditionalProductModal/queries/additionalProductQuery.ts": 2143,
	"./elements/organisms/BottomStickyMobileNav/BottomStickyMobileNav": 2892,
	"./elements/organisms/BottomStickyMobileNav/BottomStickyMobileNav.module": 1391,
	"./elements/organisms/BottomStickyMobileNav/BottomStickyMobileNav.module.sass": 1391,
	"./elements/organisms/BottomStickyMobileNav/BottomStickyMobileNav.module.sass.d": 3303,
	"./elements/organisms/BottomStickyMobileNav/BottomStickyMobileNav.module.sass.d.ts": 3303,
	"./elements/organisms/BottomStickyMobileNav/BottomStickyMobileNav.stories": 3304,
	"./elements/organisms/BottomStickyMobileNav/BottomStickyMobileNav.stories.tsx": 3304,
	"./elements/organisms/BottomStickyMobileNav/BottomStickyMobileNav.tsx": 2892,
	"./elements/organisms/BottomStickyMobileNav/queries/__generated__/BottomNavQuery": 3305,
	"./elements/organisms/BottomStickyMobileNav/queries/__generated__/BottomNavQuery.ts": 3305,
	"./elements/organisms/BottomStickyMobileNav/queries/bottomNavQuery": 2215,
	"./elements/organisms/BottomStickyMobileNav/queries/bottomNavQuery.ts": 2215,
	"./elements/organisms/BoxPriceBreakdown/BoxPriceBreakdown": 620,
	"./elements/organisms/BoxPriceBreakdown/BoxPriceBreakdown.stories": 3306,
	"./elements/organisms/BoxPriceBreakdown/BoxPriceBreakdown.stories.tsx": 3306,
	"./elements/organisms/BoxPriceBreakdown/BoxPriceBreakdown.tsx": 620,
	"./elements/organisms/BoxPriceBreakdown/helpers": 782,
	"./elements/organisms/BoxPriceBreakdown/helpers.tsx": 782,
	"./elements/organisms/ConfirmationModal/ConfirmationModal": 310,
	"./elements/organisms/ConfirmationModal/ConfirmationModal.module": 1083,
	"./elements/organisms/ConfirmationModal/ConfirmationModal.module.sass": 1083,
	"./elements/organisms/ConfirmationModal/ConfirmationModal.module.sass.d": 3307,
	"./elements/organisms/ConfirmationModal/ConfirmationModal.module.sass.d.ts": 3307,
	"./elements/organisms/ConfirmationModal/ConfirmationModal.stories": 3308,
	"./elements/organisms/ConfirmationModal/ConfirmationModal.stories.tsx": 3308,
	"./elements/organisms/ConfirmationModal/ConfirmationModal.tsx": 310,
	"./elements/organisms/DashboardFooter/DashboardFooter": 1605,
	"./elements/organisms/DashboardFooter/DashboardFooter.module": 1385,
	"./elements/organisms/DashboardFooter/DashboardFooter.module.sass": 1385,
	"./elements/organisms/DashboardFooter/DashboardFooter.module.sass.d": 3309,
	"./elements/organisms/DashboardFooter/DashboardFooter.module.sass.d.ts": 3309,
	"./elements/organisms/DashboardFooter/DashboardFooter.stories": 3310,
	"./elements/organisms/DashboardFooter/DashboardFooter.stories.tsx": 3310,
	"./elements/organisms/DashboardFooter/DashboardFooter.tsx": 1605,
	"./elements/organisms/DashboardFooter/queries/__generated__/DashboardFooterQuery": 3311,
	"./elements/organisms/DashboardFooter/queries/__generated__/DashboardFooterQuery.ts": 3311,
	"./elements/organisms/DashboardFooter/queries/dashboardFooterQuery": 2701,
	"./elements/organisms/DashboardFooter/queries/dashboardFooterQuery.ts": 2701,
	"./elements/organisms/DashboardMobileNavMenu/DashboardMobileNavMenu": 2242,
	"./elements/organisms/DashboardMobileNavMenu/DashboardMobileNavMenu.module": 600,
	"./elements/organisms/DashboardMobileNavMenu/DashboardMobileNavMenu.module.sass": 600,
	"./elements/organisms/DashboardMobileNavMenu/DashboardMobileNavMenu.module.sass.d": 3312,
	"./elements/organisms/DashboardMobileNavMenu/DashboardMobileNavMenu.module.sass.d.ts": 3312,
	"./elements/organisms/DashboardMobileNavMenu/DashboardMobileNavMenu.stories": 3313,
	"./elements/organisms/DashboardMobileNavMenu/DashboardMobileNavMenu.stories.tsx": 3313,
	"./elements/organisms/DashboardMobileNavMenu/DashboardMobileNavMenu.tsx": 2242,
	"./elements/organisms/DashboardNavigation/DashboardNavigation": 1606,
	"./elements/organisms/DashboardNavigation/DashboardNavigation.module": 588,
	"./elements/organisms/DashboardNavigation/DashboardNavigation.module.sass": 588,
	"./elements/organisms/DashboardNavigation/DashboardNavigation.module.sass.d": 3314,
	"./elements/organisms/DashboardNavigation/DashboardNavigation.module.sass.d.ts": 3314,
	"./elements/organisms/DashboardNavigation/DashboardNavigation.stories": 3315,
	"./elements/organisms/DashboardNavigation/DashboardNavigation.stories.tsx": 3315,
	"./elements/organisms/DashboardNavigation/DashboardNavigation.tsx": 1606,
	"./elements/organisms/DashboardNavigation/queries/__generated__/TopNavQuery": 3316,
	"./elements/organisms/DashboardNavigation/queries/__generated__/TopNavQuery.ts": 3316,
	"./elements/organisms/DashboardNavigation/queries/topNavQuery": 2183,
	"./elements/organisms/DashboardNavigation/queries/topNavQuery.ts": 2183,
	"./elements/organisms/DeliveryDetails/DeliveryDetails": 1593,
	"./elements/organisms/DeliveryDetails/DeliveryDetails.module": 2556,
	"./elements/organisms/DeliveryDetails/DeliveryDetails.module.sass": 2556,
	"./elements/organisms/DeliveryDetails/DeliveryDetails.module.sass.d": 3317,
	"./elements/organisms/DeliveryDetails/DeliveryDetails.module.sass.d.ts": 3317,
	"./elements/organisms/DeliveryDetails/DeliveryDetails.stories": 3318,
	"./elements/organisms/DeliveryDetails/DeliveryDetails.stories.tsx": 3318,
	"./elements/organisms/DeliveryDetails/DeliveryDetails.tsx": 1593,
	"./elements/organisms/DeliveryDetails/queries/__generated__/DeliverableDatesData": 3319,
	"./elements/organisms/DeliveryDetails/queries/__generated__/DeliverableDatesData.ts": 3319,
	"./elements/organisms/DeliveryDetails/queries/deliverableDatesQuery": 2555,
	"./elements/organisms/DeliveryDetails/queries/deliverableDatesQuery.ts": 2555,
	"./elements/organisms/DeliveryTracking": 1298,
	"./elements/organisms/DeliveryTracking/": 1298,
	"./elements/organisms/DeliveryTracking/DeliveryTracking": 2082,
	"./elements/organisms/DeliveryTracking/DeliveryTracking.module": 776,
	"./elements/organisms/DeliveryTracking/DeliveryTracking.module.sass": 776,
	"./elements/organisms/DeliveryTracking/DeliveryTracking.module.sass.d": 3320,
	"./elements/organisms/DeliveryTracking/DeliveryTracking.module.sass.d.ts": 3320,
	"./elements/organisms/DeliveryTracking/DeliveryTracking.stories": 3321,
	"./elements/organisms/DeliveryTracking/DeliveryTracking.stories.tsx": 3321,
	"./elements/organisms/DeliveryTracking/DeliveryTracking.tsx": 2082,
	"./elements/organisms/DeliveryTracking/components/Actions": 2447,
	"./elements/organisms/DeliveryTracking/components/Actions/": 2447,
	"./elements/organisms/DeliveryTracking/components/Actions/Actions": 1436,
	"./elements/organisms/DeliveryTracking/components/Actions/Actions.module": 2312,
	"./elements/organisms/DeliveryTracking/components/Actions/Actions.module.sass": 2312,
	"./elements/organisms/DeliveryTracking/components/Actions/Actions.module.sass.d": 3322,
	"./elements/organisms/DeliveryTracking/components/Actions/Actions.module.sass.d.ts": 3322,
	"./elements/organisms/DeliveryTracking/components/Actions/Actions.tsx": 1436,
	"./elements/organisms/DeliveryTracking/components/Actions/index": 2447,
	"./elements/organisms/DeliveryTracking/components/Actions/index.ts": 2447,
	"./elements/organisms/DeliveryTracking/components/ProgressBar": 2489,
	"./elements/organisms/DeliveryTracking/components/ProgressBar.tsx": 2489,
	"./elements/organisms/DeliveryTracking/hooks": 1299,
	"./elements/organisms/DeliveryTracking/hooks/": 1299,
	"./elements/organisms/DeliveryTracking/hooks/index": 1299,
	"./elements/organisms/DeliveryTracking/hooks/index.ts": 1299,
	"./elements/organisms/DeliveryTracking/hooks/useTransformedDeliveryStatus": 1128,
	"./elements/organisms/DeliveryTracking/hooks/useTransformedDeliveryStatus.tsx": 1128,
	"./elements/organisms/DeliveryTracking/index": 1298,
	"./elements/organisms/DeliveryTracking/index.ts": 1298,
	"./elements/organisms/DeliveryTracking/queries/__generated__/BoxTrackingQuery": 3323,
	"./elements/organisms/DeliveryTracking/queries/__generated__/BoxTrackingQuery.ts": 3323,
	"./elements/organisms/DeliveryTracking/queries/__generated__/NcoTrackingQuery": 3324,
	"./elements/organisms/DeliveryTracking/queries/__generated__/NcoTrackingQuery.ts": 3324,
	"./elements/organisms/DeliveryTracking/queries/boxDeliveryTrackingQuery": 2490,
	"./elements/organisms/DeliveryTracking/queries/boxDeliveryTrackingQuery.ts": 2490,
	"./elements/organisms/DeliveryTracking/queries/ncoDeliveryTrackingQuery": 2491,
	"./elements/organisms/DeliveryTracking/queries/ncoDeliveryTrackingQuery.ts": 2491,
	"./elements/organisms/DownloadAppSection/DownloadAppSection": 1612,
	"./elements/organisms/DownloadAppSection/DownloadAppSection.module": 1114,
	"./elements/organisms/DownloadAppSection/DownloadAppSection.module.sass": 1114,
	"./elements/organisms/DownloadAppSection/DownloadAppSection.module.sass.d": 3325,
	"./elements/organisms/DownloadAppSection/DownloadAppSection.module.sass.d.ts": 3325,
	"./elements/organisms/DownloadAppSection/DownloadAppSection.stories": 3326,
	"./elements/organisms/DownloadAppSection/DownloadAppSection.stories.tsx": 3326,
	"./elements/organisms/DownloadAppSection/DownloadAppSection.tsx": 1612,
	"./elements/organisms/EmailShare/EmailShare": 927,
	"./elements/organisms/EmailShare/EmailShare.module": 333,
	"./elements/organisms/EmailShare/EmailShare.module.sass": 333,
	"./elements/organisms/EmailShare/EmailShare.module.sass.d": 3327,
	"./elements/organisms/EmailShare/EmailShare.module.sass.d.ts": 3327,
	"./elements/organisms/EmailShare/EmailShare.stories": 3328,
	"./elements/organisms/EmailShare/EmailShare.stories.tsx": 3328,
	"./elements/organisms/EmailShare/EmailShare.tsx": 927,
	"./elements/organisms/EmailShare/queries/__generated__/ReferAFriendUpsert": 3329,
	"./elements/organisms/EmailShare/queries/__generated__/ReferAFriendUpsert.ts": 3329,
	"./elements/organisms/EmailShare/queries/sendEmailMutation": 1575,
	"./elements/organisms/EmailShare/queries/sendEmailMutation.ts": 1575,
	"./elements/organisms/ErrorState": 211,
	"./elements/organisms/ErrorState/": 211,
	"./elements/organisms/ErrorState/ErrorState": 2007,
	"./elements/organisms/ErrorState/ErrorState.module": 1253,
	"./elements/organisms/ErrorState/ErrorState.module.sass": 1253,
	"./elements/organisms/ErrorState/ErrorState.module.sass.d": 3330,
	"./elements/organisms/ErrorState/ErrorState.module.sass.d.ts": 3330,
	"./elements/organisms/ErrorState/ErrorState.stories": 3331,
	"./elements/organisms/ErrorState/ErrorState.stories.tsx": 3331,
	"./elements/organisms/ErrorState/ErrorState.tsx": 2007,
	"./elements/organisms/ErrorState/index": 211,
	"./elements/organisms/ErrorState/index.ts": 211,
	"./elements/organisms/FlavourInformationModal/FlavourInformationModal": 1226,
	"./elements/organisms/FlavourInformationModal/FlavourInformationModal.module": 1265,
	"./elements/organisms/FlavourInformationModal/FlavourInformationModal.module.sass": 1265,
	"./elements/organisms/FlavourInformationModal/FlavourInformationModal.module.sass.d": 3332,
	"./elements/organisms/FlavourInformationModal/FlavourInformationModal.module.sass.d.ts": 3332,
	"./elements/organisms/FlavourInformationModal/FlavourInformationModal.stories": 3333,
	"./elements/organisms/FlavourInformationModal/FlavourInformationModal.stories.tsx": 3333,
	"./elements/organisms/FlavourInformationModal/FlavourInformationModal.tsx": 1226,
	"./elements/organisms/FlavourInformationModal/queries/__generated__/FlavourQuery": 3334,
	"./elements/organisms/FlavourInformationModal/queries/__generated__/FlavourQuery.ts": 3334,
	"./elements/organisms/FlavourInformationModal/queries/flavourQuery": 2166,
	"./elements/organisms/FlavourInformationModal/queries/flavourQuery.ts": 2166,
	"./elements/organisms/FreshMealList/FreshMealList": 1141,
	"./elements/organisms/FreshMealList/FreshMealList.stories": 3335,
	"./elements/organisms/FreshMealList/FreshMealList.stories.tsx": 3335,
	"./elements/organisms/FreshMealList/FreshMealList.tsx": 1141,
	"./elements/organisms/HeroText/HeroText": 540,
	"./elements/organisms/HeroText/HeroText.module": 1256,
	"./elements/organisms/HeroText/HeroText.module.sass": 1256,
	"./elements/organisms/HeroText/HeroText.module.sass.d": 3336,
	"./elements/organisms/HeroText/HeroText.module.sass.d.ts": 3336,
	"./elements/organisms/HeroText/HeroText.stories": 3337,
	"./elements/organisms/HeroText/HeroText.stories.tsx": 3337,
	"./elements/organisms/HeroText/HeroText.tsx": 540,
	"./elements/organisms/HowToFeedCard/HowToFeedCard": 2744,
	"./elements/organisms/HowToFeedCard/HowToFeedCard.stories": 3338,
	"./elements/organisms/HowToFeedCard/HowToFeedCard.stories.tsx": 3338,
	"./elements/organisms/HowToFeedCard/HowToFeedCard.tsx": 2744,
	"./elements/organisms/ImageCard/ImageCard": 1138,
	"./elements/organisms/ImageCard/ImageCard.module": 821,
	"./elements/organisms/ImageCard/ImageCard.module.sass": 821,
	"./elements/organisms/ImageCard/ImageCard.module.sass.d": 3339,
	"./elements/organisms/ImageCard/ImageCard.module.sass.d.ts": 3339,
	"./elements/organisms/ImageCard/ImageCard.stories": 3340,
	"./elements/organisms/ImageCard/ImageCard.stories.tsx": 3340,
	"./elements/organisms/ImageCard/ImageCard.tsx": 1138,
	"./elements/organisms/LoadingScreen/LoadingScreen": 190,
	"./elements/organisms/LoadingScreen/LoadingScreen.module": 811,
	"./elements/organisms/LoadingScreen/LoadingScreen.module.sass": 811,
	"./elements/organisms/LoadingScreen/LoadingScreen.module.sass.d": 3341,
	"./elements/organisms/LoadingScreen/LoadingScreen.module.sass.d.ts": 3341,
	"./elements/organisms/LoadingScreen/LoadingScreen.stories": 3342,
	"./elements/organisms/LoadingScreen/LoadingScreen.stories.tsx": 3342,
	"./elements/organisms/LoadingScreen/LoadingScreen.tsx": 190,
	"./elements/organisms/MarketingPreferences/MarketingPreferences": 1123,
	"./elements/organisms/MarketingPreferences/MarketingPreferences.module": 378,
	"./elements/organisms/MarketingPreferences/MarketingPreferences.module.sass": 378,
	"./elements/organisms/MarketingPreferences/MarketingPreferences.module.sass.d": 3343,
	"./elements/organisms/MarketingPreferences/MarketingPreferences.module.sass.d.ts": 3343,
	"./elements/organisms/MarketingPreferences/MarketingPreferences.tsx": 1123,
	"./elements/organisms/MarketingPreferences/fragments/__generated__/marketingPreferenceFragment": 3344,
	"./elements/organisms/MarketingPreferences/fragments/__generated__/marketingPreferenceFragment.ts": 3344,
	"./elements/organisms/MarketingPreferences/fragments/marketingPreferenceFragment": 1807,
	"./elements/organisms/MarketingPreferences/fragments/marketingPreferenceFragment.ts": 1807,
	"./elements/organisms/MarketingPreferences/mutations/__generated__/MarketingMethodPurposeUpdate": 3345,
	"./elements/organisms/MarketingPreferences/mutations/__generated__/MarketingMethodPurposeUpdate.ts": 3345,
	"./elements/organisms/MarketingPreferences/mutations/updateMarketingPreferences": 2487,
	"./elements/organisms/MarketingPreferences/mutations/updateMarketingPreferences.ts": 2487,
	"./elements/organisms/MarketingPreferences/queries/__generated__/MarketingPreferenceQuery": 3346,
	"./elements/organisms/MarketingPreferences/queries/__generated__/MarketingPreferenceQuery.ts": 3346,
	"./elements/organisms/MarketingPreferences/queries/__generated__/SMSDeliveryReminderQuery": 3347,
	"./elements/organisms/MarketingPreferences/queries/__generated__/SMSDeliveryReminderQuery.ts": 3347,
	"./elements/organisms/MarketingPreferences/queries/marketingPreferenceQuery": 2488,
	"./elements/organisms/MarketingPreferences/queries/marketingPreferenceQuery.ts": 2488,
	"./elements/organisms/MerchandisingCarousel/MerchandisingCarousel": 2497,
	"./elements/organisms/MerchandisingCarousel/MerchandisingCarousel.stories": 3348,
	"./elements/organisms/MerchandisingCarousel/MerchandisingCarousel.stories.tsx": 3348,
	"./elements/organisms/MerchandisingCarousel/MerchandisingCarousel.tsx": 2497,
	"./elements/organisms/MerchandisingCarousel/__generated__/NotificationsQuery": 3349,
	"./elements/organisms/MerchandisingCarousel/__generated__/NotificationsQuery.ts": 3349,
	"./elements/organisms/MerchandisingCarousel/queries": 2111,
	"./elements/organisms/MerchandisingCarousel/queries.ts": 2111,
	"./elements/organisms/MerchandisingRAFCard/MerchandisingRAFCard": 2112,
	"./elements/organisms/MerchandisingRAFCard/MerchandisingRAFCard.module": 2316,
	"./elements/organisms/MerchandisingRAFCard/MerchandisingRAFCard.module.sass": 2316,
	"./elements/organisms/MerchandisingRAFCard/MerchandisingRAFCard.module.sass.d": 3350,
	"./elements/organisms/MerchandisingRAFCard/MerchandisingRAFCard.module.sass.d.ts": 3350,
	"./elements/organisms/MerchandisingRAFCard/MerchandisingRAFCard.tsx": 2112,
	"./elements/organisms/MerchandisingRAFCard/__generated__/MerchRafCardQuery": 3351,
	"./elements/organisms/MerchandisingRAFCard/__generated__/MerchRafCardQuery.ts": 3351,
	"./elements/organisms/MerchandisingRAFCard/queries": 2498,
	"./elements/organisms/MerchandisingRAFCard/queries.ts": 2498,
	"./elements/organisms/MobileNavMenu/MobileNavMenu": 2216,
	"./elements/organisms/MobileNavMenu/MobileNavMenu.module": 643,
	"./elements/organisms/MobileNavMenu/MobileNavMenu.module.sass": 643,
	"./elements/organisms/MobileNavMenu/MobileNavMenu.module.sass.d": 3352,
	"./elements/organisms/MobileNavMenu/MobileNavMenu.module.sass.d.ts": 3352,
	"./elements/organisms/MobileNavMenu/MobileNavMenu.stories": 3353,
	"./elements/organisms/MobileNavMenu/MobileNavMenu.stories.tsx": 3353,
	"./elements/organisms/MobileNavMenu/MobileNavMenu.tsx": 2216,
	"./elements/organisms/Navigation/Navigation": 2893,
	"./elements/organisms/Navigation/Navigation.module": 903,
	"./elements/organisms/Navigation/Navigation.module.sass": 903,
	"./elements/organisms/Navigation/Navigation.module.sass.d": 3354,
	"./elements/organisms/Navigation/Navigation.module.sass.d.ts": 3354,
	"./elements/organisms/Navigation/Navigation.stories": 3355,
	"./elements/organisms/Navigation/Navigation.stories.tsx": 3355,
	"./elements/organisms/Navigation/Navigation.tsx": 2893,
	"./elements/organisms/OrderCarousel": 1717,
	"./elements/organisms/OrderCarousel/": 1717,
	"./elements/organisms/OrderCarousel/OrderCarousel": 1437,
	"./elements/organisms/OrderCarousel/OrderCarousel.module": 1248,
	"./elements/organisms/OrderCarousel/OrderCarousel.module.sass": 1248,
	"./elements/organisms/OrderCarousel/OrderCarousel.module.sass.d": 3356,
	"./elements/organisms/OrderCarousel/OrderCarousel.module.sass.d.ts": 3356,
	"./elements/organisms/OrderCarousel/OrderCarousel.stories": 3357,
	"./elements/organisms/OrderCarousel/OrderCarousel.stories.tsx": 3357,
	"./elements/organisms/OrderCarousel/OrderCarousel.tsx": 1437,
	"./elements/organisms/OrderCarousel/index": 1717,
	"./elements/organisms/OrderCarousel/index.ts": 1717,
	"./elements/organisms/OrderCarousel/v3": 1693,
	"./elements/organisms/OrderCarousel/v3/": 1693,
	"./elements/organisms/OrderCarousel/v3/OrderCarousel": 2406,
	"./elements/organisms/OrderCarousel/v3/OrderCarousel.tsx": 2406,
	"./elements/organisms/OrderCarousel/v3/components/Badge": 1719,
	"./elements/organisms/OrderCarousel/v3/components/Badge/": 1719,
	"./elements/organisms/OrderCarousel/v3/components/Badge/Badge": 2006,
	"./elements/organisms/OrderCarousel/v3/components/Badge/Badge.module": 1654,
	"./elements/organisms/OrderCarousel/v3/components/Badge/Badge.module.sass": 1654,
	"./elements/organisms/OrderCarousel/v3/components/Badge/Badge.module.sass.d": 3358,
	"./elements/organisms/OrderCarousel/v3/components/Badge/Badge.module.sass.d.ts": 3358,
	"./elements/organisms/OrderCarousel/v3/components/Badge/Badge.tsx": 2006,
	"./elements/organisms/OrderCarousel/v3/components/Badge/index": 1719,
	"./elements/organisms/OrderCarousel/v3/components/Badge/index.ts": 1719,
	"./elements/organisms/OrderCarousel/v3/components/OrderDate": 1718,
	"./elements/organisms/OrderCarousel/v3/components/OrderDate/": 1718,
	"./elements/organisms/OrderCarousel/v3/components/OrderDate/OrderDate": 2005,
	"./elements/organisms/OrderCarousel/v3/components/OrderDate/OrderDate.module": 1378,
	"./elements/organisms/OrderCarousel/v3/components/OrderDate/OrderDate.module.sass": 1378,
	"./elements/organisms/OrderCarousel/v3/components/OrderDate/OrderDate.module.sass.d": 3359,
	"./elements/organisms/OrderCarousel/v3/components/OrderDate/OrderDate.module.sass.d.ts": 3359,
	"./elements/organisms/OrderCarousel/v3/components/OrderDate/OrderDate.tsx": 2005,
	"./elements/organisms/OrderCarousel/v3/components/OrderDate/index": 1718,
	"./elements/organisms/OrderCarousel/v3/components/OrderDate/index.ts": 1718,
	"./elements/organisms/OrderCarousel/v3/components/OrderLabel": 1720,
	"./elements/organisms/OrderCarousel/v3/components/OrderLabel/": 1720,
	"./elements/organisms/OrderCarousel/v3/components/OrderLabel/OrderLabel": 2407,
	"./elements/organisms/OrderCarousel/v3/components/OrderLabel/OrderLabel.tsx": 2407,
	"./elements/organisms/OrderCarousel/v3/components/OrderLabel/index": 1720,
	"./elements/organisms/OrderCarousel/v3/components/OrderLabel/index.ts": 1720,
	"./elements/organisms/OrderCarousel/v3/index": 1693,
	"./elements/organisms/OrderCarousel/v3/index.ts": 1693,
	"./elements/organisms/PasswordForm/PasswordForm": 2191,
	"./elements/organisms/PasswordForm/PasswordForm.module": 2713,
	"./elements/organisms/PasswordForm/PasswordForm.module.sass": 2713,
	"./elements/organisms/PasswordForm/PasswordForm.module.sass.d": 3360,
	"./elements/organisms/PasswordForm/PasswordForm.module.sass.d.ts": 3360,
	"./elements/organisms/PasswordForm/PasswordForm.stories": 3361,
	"./elements/organisms/PasswordForm/PasswordForm.stories.tsx": 3361,
	"./elements/organisms/PasswordForm/PasswordForm.tsx": 2191,
	"./elements/organisms/ProductsUpsellModal/ProductsUpsellModal": 1065,
	"./elements/organisms/ProductsUpsellModal/ProductsUpsellModal.module": 1096,
	"./elements/organisms/ProductsUpsellModal/ProductsUpsellModal.module.sass": 1096,
	"./elements/organisms/ProductsUpsellModal/ProductsUpsellModal.module.sass.d": 3362,
	"./elements/organisms/ProductsUpsellModal/ProductsUpsellModal.module.sass.d.ts": 3362,
	"./elements/organisms/ProductsUpsellModal/ProductsUpsellModal.stories": 3363,
	"./elements/organisms/ProductsUpsellModal/ProductsUpsellModal.stories.tsx": 3363,
	"./elements/organisms/ProductsUpsellModal/ProductsUpsellModal.tsx": 1065,
	"./elements/organisms/ProductsUpsellModal/queries/__generated__/GetUpsellableProducts": 3364,
	"./elements/organisms/ProductsUpsellModal/queries/__generated__/GetUpsellableProducts.ts": 3364,
	"./elements/organisms/ProductsUpsellModal/queries/__generated__/OrderProductsUpdate": 3365,
	"./elements/organisms/ProductsUpsellModal/queries/__generated__/OrderProductsUpdate.ts": 3365,
	"./elements/organisms/ProductsUpsellModal/queries/__generated__/RecurringOrderProductsUpdate": 3366,
	"./elements/organisms/ProductsUpsellModal/queries/__generated__/RecurringOrderProductsUpdate.ts": 3366,
	"./elements/organisms/ProductsUpsellModal/queries/getUpSellableProducts": 2471,
	"./elements/organisms/ProductsUpsellModal/queries/getUpSellableProducts.ts": 2471,
	"./elements/organisms/ProductsUpsellModal/queries/orderProductsUpdate": 2472,
	"./elements/organisms/ProductsUpsellModal/queries/orderProductsUpdate.ts": 2472,
	"./elements/organisms/ProductsUpsellModal/queries/recurringOrderProductsUpdate": 2473,
	"./elements/organisms/ProductsUpsellModal/queries/recurringOrderProductsUpdate.ts": 2473,
	"./elements/organisms/RafLinkAndShare/RafLinkAndShare": 1122,
	"./elements/organisms/RafLinkAndShare/RafLinkAndShare.module": 889,
	"./elements/organisms/RafLinkAndShare/RafLinkAndShare.module.sass": 889,
	"./elements/organisms/RafLinkAndShare/RafLinkAndShare.module.sass.d": 3367,
	"./elements/organisms/RafLinkAndShare/RafLinkAndShare.module.sass.d.ts": 3367,
	"./elements/organisms/RafLinkAndShare/RafLinkAndShare.stories": 3368,
	"./elements/organisms/RafLinkAndShare/RafLinkAndShare.stories.tsx": 3368,
	"./elements/organisms/RafLinkAndShare/RafLinkAndShare.tsx": 1122,
	"./elements/organisms/RecipeSelectionToggle/RecipeSelectionToggle": 1146,
	"./elements/organisms/RecipeSelectionToggle/RecipeSelectionToggle.module": 1674,
	"./elements/organisms/RecipeSelectionToggle/RecipeSelectionToggle.module.sass": 1674,
	"./elements/organisms/RecipeSelectionToggle/RecipeSelectionToggle.module.sass.d": 3369,
	"./elements/organisms/RecipeSelectionToggle/RecipeSelectionToggle.module.sass.d.ts": 3369,
	"./elements/organisms/RecipeSelectionToggle/RecipeSelectionToggle.stories": 3370,
	"./elements/organisms/RecipeSelectionToggle/RecipeSelectionToggle.stories.tsx": 3370,
	"./elements/organisms/RecipeSelectionToggle/RecipeSelectionToggle.tsx": 1146,
	"./elements/organisms/ShareModal/ShareModal": 1860,
	"./elements/organisms/ShareModal/ShareModal.module": 1109,
	"./elements/organisms/ShareModal/ShareModal.module.sass": 1109,
	"./elements/organisms/ShareModal/ShareModal.module.sass.d": 3371,
	"./elements/organisms/ShareModal/ShareModal.module.sass.d.ts": 3371,
	"./elements/organisms/ShareModal/ShareModal.tsx": 1860,
	"./elements/organisms/SizeGuide/SizeGuide": 2136,
	"./elements/organisms/SizeGuide/SizeGuide.module": 823,
	"./elements/organisms/SizeGuide/SizeGuide.module.sass": 823,
	"./elements/organisms/SizeGuide/SizeGuide.module.sass.d": 3372,
	"./elements/organisms/SizeGuide/SizeGuide.module.sass.d.ts": 3372,
	"./elements/organisms/SizeGuide/SizeGuide.stories": 3373,
	"./elements/organisms/SizeGuide/SizeGuide.stories.tsx": 3373,
	"./elements/organisms/SizeGuide/SizeGuide.tsx": 2136,
	"./elements/organisms/StickyNavigation/StickyNavigation": 205,
	"./elements/organisms/StickyNavigation/StickyNavigation.module": 953,
	"./elements/organisms/StickyNavigation/StickyNavigation.module.sass": 953,
	"./elements/organisms/StickyNavigation/StickyNavigation.module.sass.d": 3374,
	"./elements/organisms/StickyNavigation/StickyNavigation.module.sass.d.ts": 3374,
	"./elements/organisms/StickyNavigation/StickyNavigation.stories": 3375,
	"./elements/organisms/StickyNavigation/StickyNavigation.stories.tsx": 3375,
	"./elements/organisms/StickyNavigation/StickyNavigation.tsx": 205,
	"./elements/organisms/Stories": 1794,
	"./elements/organisms/Stories/": 1794,
	"./elements/organisms/Stories/Stories": 2084,
	"./elements/organisms/Stories/Stories.module": 1115,
	"./elements/organisms/Stories/Stories.module.sass": 1115,
	"./elements/organisms/Stories/Stories.module.sass.d": 3376,
	"./elements/organisms/Stories/Stories.module.sass.d.ts": 3376,
	"./elements/organisms/Stories/Stories.stories": 3377,
	"./elements/organisms/Stories/Stories.stories.tsx": 3377,
	"./elements/organisms/Stories/Stories.tsx": 2084,
	"./elements/organisms/Stories/components/atoms/ProgressBar": 1797,
	"./elements/organisms/Stories/components/atoms/ProgressBar/": 1797,
	"./elements/organisms/Stories/components/atoms/ProgressBar/ProgressBar": 2077,
	"./elements/organisms/Stories/components/atoms/ProgressBar/ProgressBar.module": 1269,
	"./elements/organisms/Stories/components/atoms/ProgressBar/ProgressBar.module.sass": 1269,
	"./elements/organisms/Stories/components/atoms/ProgressBar/ProgressBar.module.sass.d": 3378,
	"./elements/organisms/Stories/components/atoms/ProgressBar/ProgressBar.module.sass.d.ts": 3378,
	"./elements/organisms/Stories/components/atoms/ProgressBar/ProgressBar.tsx": 2077,
	"./elements/organisms/Stories/components/atoms/ProgressBar/index": 1797,
	"./elements/organisms/Stories/components/atoms/ProgressBar/index.ts": 1797,
	"./elements/organisms/Stories/components/molecules/StoryContent": 1795,
	"./elements/organisms/Stories/components/molecules/StoryContent/": 1795,
	"./elements/organisms/Stories/components/molecules/StoryContent/StoryContent": 2075,
	"./elements/organisms/Stories/components/molecules/StoryContent/StoryContent.module": 1392,
	"./elements/organisms/Stories/components/molecules/StoryContent/StoryContent.module.sass": 1392,
	"./elements/organisms/Stories/components/molecules/StoryContent/StoryContent.module.sass.d": 3379,
	"./elements/organisms/Stories/components/molecules/StoryContent/StoryContent.module.sass.d.ts": 3379,
	"./elements/organisms/Stories/components/molecules/StoryContent/StoryContent.tsx": 2075,
	"./elements/organisms/Stories/components/molecules/StoryContent/index": 1795,
	"./elements/organisms/Stories/components/molecules/StoryContent/index.ts": 1795,
	"./elements/organisms/Stories/components/molecules/StoryProgress": 1796,
	"./elements/organisms/Stories/components/molecules/StoryProgress/": 1796,
	"./elements/organisms/Stories/components/molecules/StoryProgress/StoryProgress": 2076,
	"./elements/organisms/Stories/components/molecules/StoryProgress/StoryProgress.module": 2764,
	"./elements/organisms/Stories/components/molecules/StoryProgress/StoryProgress.module.sass": 2764,
	"./elements/organisms/Stories/components/molecules/StoryProgress/StoryProgress.module.sass.d": 3380,
	"./elements/organisms/Stories/components/molecules/StoryProgress/StoryProgress.module.sass.d.ts": 3380,
	"./elements/organisms/Stories/components/molecules/StoryProgress/StoryProgress.tsx": 2076,
	"./elements/organisms/Stories/components/molecules/StoryProgress/index": 1796,
	"./elements/organisms/Stories/components/molecules/StoryProgress/index.ts": 1796,
	"./elements/organisms/Stories/index": 1794,
	"./elements/organisms/Stories/index.ts": 1794,
	"./elements/organisms/SuccessOverlay/SuccessOverlay": 737,
	"./elements/organisms/SuccessOverlay/SuccessOverlay.stories": 3381,
	"./elements/organisms/SuccessOverlay/SuccessOverlay.stories.tsx": 3381,
	"./elements/organisms/SuccessOverlay/SuccessOverlay.tsx": 737,
	"./elements/organisms/SuccessOverlay/successoverlay": 1369,
	"./elements/organisms/SuccessOverlay/successoverlay.module": 1369,
	"./elements/organisms/SuccessOverlay/successoverlay.module.sass": 1369,
	"./elements/organisms/SuccessOverlay/successoverlay.module.sass.d": 3382,
	"./elements/organisms/SuccessOverlay/successoverlay.module.sass.d.ts": 3382,
	"./elements/organisms/WelcomeBackCard/WelcomeBackCard": 2113,
	"./elements/organisms/WelcomeBackCard/WelcomeBackCard.module": 1250,
	"./elements/organisms/WelcomeBackCard/WelcomeBackCard.module.sass": 1250,
	"./elements/organisms/WelcomeBackCard/WelcomeBackCard.module.sass.d": 3383,
	"./elements/organisms/WelcomeBackCard/WelcomeBackCard.module.sass.d.ts": 3383,
	"./elements/organisms/WelcomeBackCard/WelcomeBackCard.tsx": 2113,
	"./elements/organisms/WelcomeBackCard/__generated__/WelcomeBackCardQuery": 3384,
	"./elements/organisms/WelcomeBackCard/__generated__/WelcomeBackCardQuery.ts": 3384,
	"./elements/organisms/WelcomeBackCard/queries": 2499,
	"./elements/organisms/WelcomeBackCard/queries.ts": 2499,
	"./elements/organisms/WizardFooter/WizardFooter": 797,
	"./elements/organisms/WizardFooter/WizardFooter.module": 585,
	"./elements/organisms/WizardFooter/WizardFooter.module.sass": 585,
	"./elements/organisms/WizardFooter/WizardFooter.module.sass.d": 3385,
	"./elements/organisms/WizardFooter/WizardFooter.module.sass.d.ts": 3385,
	"./elements/organisms/WizardFooter/WizardFooter.stories": 3386,
	"./elements/organisms/WizardFooter/WizardFooter.stories.tsx": 3386,
	"./elements/organisms/WizardFooter/WizardFooter.tsx": 797,
	"./elements/organisms/WizardNavigation/WizardNavigation": 732,
	"./elements/organisms/WizardNavigation/WizardNavigation.module": 958,
	"./elements/organisms/WizardNavigation/WizardNavigation.module.sass": 958,
	"./elements/organisms/WizardNavigation/WizardNavigation.module.sass.d": 3387,
	"./elements/organisms/WizardNavigation/WizardNavigation.module.sass.d.ts": 3387,
	"./elements/organisms/WizardNavigation/WizardNavigation.stories": 3388,
	"./elements/organisms/WizardNavigation/WizardNavigation.stories.tsx": 3388,
	"./elements/organisms/WizardNavigation/WizardNavigation.tsx": 732,
	"./elements/organisms/modals/StoriesModal": 2448,
	"./elements/organisms/modals/StoriesModal/": 2448,
	"./elements/organisms/modals/StoriesModal/StoriesModal": 2449,
	"./elements/organisms/modals/StoriesModal/StoriesModal.tsx": 2449,
	"./elements/organisms/modals/StoriesModal/index": 2448,
	"./elements/organisms/modals/StoriesModal/index.ts": 2448,
	"./factories": 698,
	"./factories/": 698,
	"./factories/AllergenFactory": 2419,
	"./factories/AllergenFactory.ts": 2419,
	"./factories/BannerFactory": 2054,
	"./factories/BannerFactory.ts": 2054,
	"./factories/BoxFactory": 2420,
	"./factories/BoxFactory.ts": 2420,
	"./factories/DogFactory": 2421,
	"./factories/DogFactory.ts": 2421,
	"./factories/DogProfileFactory": 2624,
	"./factories/DogProfileFactory.ts": 2624,
	"./factories/FetchifyAddressFactory": 2422,
	"./factories/FetchifyAddressFactory.ts": 2422,
	"./factories/FoodCategoryFactory": 2423,
	"./factories/FoodCategoryFactory.ts": 2423,
	"./factories/HealthIssueFactory": 2424,
	"./factories/HealthIssueFactory.ts": 2424,
	"./factories/NotificationFactory": 2425,
	"./factories/NotificationFactory.ts": 2425,
	"./factories/PlanFactory": 2426,
	"./factories/PlanFactory.ts": 2426,
	"./factories/ProductCollectionFactory": 2427,
	"./factories/ProductCollectionFactory.ts": 2427,
	"./factories/ShopItemFactory": 2428,
	"./factories/ShopItemFactory.ts": 2428,
	"./factories/SubscriptionFactory": 2429,
	"./factories/SubscriptionFactory.ts": 2429,
	"./factories/SurveyFactory": 2430,
	"./factories/SurveyFactory.ts": 2430,
	"./factories/UserFactory": 2431,
	"./factories/UserFactory.ts": 2431,
	"./factories/WizardFactory": 2432,
	"./factories/WizardFactory.ts": 2432,
	"./factories/index": 698,
	"./factories/index.ts": 698,
	"./influencer_dashboard/SummaryTab": 1550,
	"./influencer_dashboard/SummaryTab.jsx": 1550,
	"./influencer_dashboard/message_types": 3389,
	"./influencer_dashboard/message_types.js": 3389,
	"./influencer_dashboard/refer": 2094,
	"./influencer_dashboard/refer.jsx": 2094,
	"./influencer_dashboard/summary": 2095,
	"./influencer_dashboard/summary.jsx": 2095,
	"./influencer_dashboard/tabs": 557,
	"./influencer_dashboard/tabs.js": 557,
	"./modals/OrderSummaryModal": 1793,
	"./modals/OrderSummaryModal/": 1793,
	"./modals/OrderSummaryModal/OrderSummaryModal": 2073,
	"./modals/OrderSummaryModal/OrderSummaryModal.module": 820,
	"./modals/OrderSummaryModal/OrderSummaryModal.module.sass": 820,
	"./modals/OrderSummaryModal/OrderSummaryModal.module.sass.d": 3390,
	"./modals/OrderSummaryModal/OrderSummaryModal.module.sass.d.ts": 3390,
	"./modals/OrderSummaryModal/OrderSummaryModal.tsx": 2073,
	"./modals/OrderSummaryModal/components/BoxPriceBreakdown": 2749,
	"./modals/OrderSummaryModal/components/BoxPriceBreakdown.tsx": 2749,
	"./modals/OrderSummaryModal/components/NonCoreOrderPriceBreakdown": 2750,
	"./modals/OrderSummaryModal/components/NonCoreOrderPriceBreakdown.tsx": 2750,
	"./modals/OrderSummaryModal/fragments": 1066,
	"./modals/OrderSummaryModal/fragments/": 1066,
	"./modals/OrderSummaryModal/fragments/__generated__/BoxOrderSummaryModalFragment": 3391,
	"./modals/OrderSummaryModal/fragments/__generated__/BoxOrderSummaryModalFragment.ts": 3391,
	"./modals/OrderSummaryModal/fragments/__generated__/NonCoreOrderOrderSummaryModalFragment": 3392,
	"./modals/OrderSummaryModal/fragments/__generated__/NonCoreOrderOrderSummaryModalFragment.ts": 3392,
	"./modals/OrderSummaryModal/fragments/__generated__/OrderSummaryModalFragment": 3393,
	"./modals/OrderSummaryModal/fragments/__generated__/OrderSummaryModalFragment.ts": 3393,
	"./modals/OrderSummaryModal/fragments/index": 1066,
	"./modals/OrderSummaryModal/fragments/index.ts": 1066,
	"./modals/OrderSummaryModal/index": 1793,
	"./modals/OrderSummaryModal/index.tsx": 1793,
	"./modals/components/EditDeliveryFrequencyBenefit": 1788,
	"./modals/components/EditDeliveryFrequencyBenefit/": 1788,
	"./modals/components/EditDeliveryFrequencyBenefit/EditDeliveryFrequencyBenefit": 2070,
	"./modals/components/EditDeliveryFrequencyBenefit/EditDeliveryFrequencyBenefit.module": 2746,
	"./modals/components/EditDeliveryFrequencyBenefit/EditDeliveryFrequencyBenefit.module.sass": 2746,
	"./modals/components/EditDeliveryFrequencyBenefit/EditDeliveryFrequencyBenefit.module.sass.d": 3394,
	"./modals/components/EditDeliveryFrequencyBenefit/EditDeliveryFrequencyBenefit.module.sass.d.ts": 3394,
	"./modals/components/EditDeliveryFrequencyBenefit/EditDeliveryFrequencyBenefit.tsx": 2070,
	"./modals/components/EditDeliveryFrequencyBenefit/index": 1788,
	"./modals/components/EditDeliveryFrequencyBenefit/index.ts": 1788,
	"./modals/components/EditRecipesNotSaved": 2450,
	"./modals/components/EditRecipesNotSaved/": 2450,
	"./modals/components/EditRecipesNotSaved/EditRecipesNotSaved": 1439,
	"./modals/components/EditRecipesNotSaved/EditRecipesNotSaved.module": 2747,
	"./modals/components/EditRecipesNotSaved/EditRecipesNotSaved.module.sass": 2747,
	"./modals/components/EditRecipesNotSaved/EditRecipesNotSaved.module.sass.d": 3395,
	"./modals/components/EditRecipesNotSaved/EditRecipesNotSaved.module.sass.d.ts": 3395,
	"./modals/components/EditRecipesNotSaved/EditRecipesNotSaved.tsx": 1439,
	"./modals/components/EditRecipesNotSaved/index": 2450,
	"./modals/components/EditRecipesNotSaved/index.ts": 2450,
	"./modals/components/HowToFeed": 1789,
	"./modals/components/HowToFeed/": 1789,
	"./modals/components/HowToFeed/HowToFeed": 2071,
	"./modals/components/HowToFeed/HowToFeed.module": 2748,
	"./modals/components/HowToFeed/HowToFeed.module.sass": 2748,
	"./modals/components/HowToFeed/HowToFeed.module.sass.d": 3396,
	"./modals/components/HowToFeed/HowToFeed.module.sass.d.ts": 3396,
	"./modals/components/HowToFeed/HowToFeed.tsx": 2071,
	"./modals/components/HowToFeed/index": 1789,
	"./modals/components/HowToFeed/index.ts": 1789,
	"./modals/components/RecipeDetail": 1787,
	"./modals/components/RecipeDetail/": 1787,
	"./modals/components/RecipeDetail/RecipeDetail": 2069,
	"./modals/components/RecipeDetail/RecipeDetail.module": 1389,
	"./modals/components/RecipeDetail/RecipeDetail.module.sass": 1389,
	"./modals/components/RecipeDetail/RecipeDetail.module.sass.d": 3397,
	"./modals/components/RecipeDetail/RecipeDetail.module.sass.d.ts": 3397,
	"./modals/components/RecipeDetail/RecipeDetail.tsx": 2069,
	"./modals/components/RecipeDetail/index": 1787,
	"./modals/components/RecipeDetail/index.ts": 1787,
	"./modals/components/RecipesMakeRoomForMore": 1790,
	"./modals/components/RecipesMakeRoomForMore/": 1790,
	"./modals/components/RecipesMakeRoomForMore/RecipesMakeRoomForMore": 2072,
	"./modals/components/RecipesMakeRoomForMore/RecipesMakeRoomForMore.module": 1112,
	"./modals/components/RecipesMakeRoomForMore/RecipesMakeRoomForMore.module.sass": 1112,
	"./modals/components/RecipesMakeRoomForMore/RecipesMakeRoomForMore.module.sass.d": 3398,
	"./modals/components/RecipesMakeRoomForMore/RecipesMakeRoomForMore.module.sass.d.ts": 3398,
	"./modals/components/RecipesMakeRoomForMore/RecipesMakeRoomForMore.tsx": 2072,
	"./modals/components/RecipesMakeRoomForMore/index": 1790,
	"./modals/components/RecipesMakeRoomForMore/index.ts": 1790,
	"./modals/components/RedeemDiscountModal": 2451,
	"./modals/components/RedeemDiscountModal/": 2451,
	"./modals/components/RedeemDiscountModal/RedeemDiscountModal": 1791,
	"./modals/components/RedeemDiscountModal/RedeemDiscountModal.tsx": 1791,
	"./modals/components/RedeemDiscountModal/index": 2451,
	"./modals/components/RedeemDiscountModal/index.ts": 2451,
	"./modals/components/WhereToStart": 1792,
	"./modals/components/WhereToStart/": 1792,
	"./modals/components/WhereToStart/WhereToStart": 2441,
	"./modals/components/WhereToStart/WhereToStart.tsx": 2441,
	"./modals/components/WhereToStart/fragments/WhereToStartFragment": 2527,
	"./modals/components/WhereToStart/fragments/WhereToStartFragment.ts": 2527,
	"./modals/components/WhereToStart/fragments/__generated__/WhereToStartFragment": 3399,
	"./modals/components/WhereToStart/fragments/__generated__/WhereToStartFragment.ts": 3399,
	"./modals/components/WhereToStart/index": 1792,
	"./modals/components/WhereToStart/index.ts": 1792,
	"./modals/hooks/useDragBehavior": 2745,
	"./modals/hooks/useDragBehavior.ts": 2745,
	"./modals/layout": 572,
	"./modals/layout/": 572,
	"./modals/layout/index": 572,
	"./modals/layout/index.module": 602,
	"./modals/layout/index.module.sass": 602,
	"./modals/layout/index.module.sass.d": 3400,
	"./modals/layout/index.module.sass.d.ts": 3400,
	"./modals/layout/index.tsx": 572,
	"./modals/registerModals": 2887,
	"./modals/registerModals.ts": 2887,
	"./modals/trigger": 839,
	"./modals/trigger/": 839,
	"./modals/trigger/index": 839,
	"./modals/trigger/index.tsx": 839,
	"./modals/trigger/trigger": 1088,
	"./modals/trigger/trigger.module": 1088,
	"./modals/trigger/trigger.module.sass": 1088,
	"./modals/trigger/trigger.module.sass.d": 3401,
	"./modals/trigger/trigger.module.sass.d.ts": 3401,
	"./pages/AddressBookPage/AddressBookPage": 1823,
	"./pages/AddressBookPage/AddressBookPage.module": 1823,
	"./pages/AddressBookPage/AddressBookPage.module.sass": 1823,
	"./pages/AddressBookPage/AddressBookPage.module.sass.d": 3402,
	"./pages/AddressBookPage/AddressBookPage.module.sass.d.ts": 3402,
	"./pages/AddressBookPage/components/DefaultAddress": 2806,
	"./pages/AddressBookPage/components/DefaultAddress.tsx": 2806,
	"./pages/AddressBookPage/components/DeliveryNotes": 1822,
	"./pages/AddressBookPage/components/DeliveryNotes.tsx": 1822,
	"./pages/AddressBookPage/fragments/__generated__/addressFragment": 3403,
	"./pages/AddressBookPage/fragments/__generated__/addressFragment.ts": 3403,
	"./pages/AddressBookPage/fragments/__generated__/userAddressFragment": 3404,
	"./pages/AddressBookPage/fragments/__generated__/userAddressFragment.ts": 3404,
	"./pages/AddressBookPage/fragments/addressFragment": 1229,
	"./pages/AddressBookPage/fragments/addressFragment.ts": 1229,
	"./pages/AddressBookPage/mutations/__generated__/UpdateDefaultAddress": 3405,
	"./pages/AddressBookPage/mutations/__generated__/UpdateDefaultAddress.ts": 3405,
	"./pages/AddressBookPage/mutations/updateAddress": 2714,
	"./pages/AddressBookPage/mutations/updateAddress.ts": 2714,
	"./pages/AddressBookPage/queries/__generated__/AddressBookQuery": 3406,
	"./pages/AddressBookPage/queries/__generated__/AddressBookQuery.ts": 3406,
	"./pages/AdminMessagePage/AdminMessagePage": 2894,
	"./pages/AdminMessagePage/AdminMessagePage.module": 2765,
	"./pages/AdminMessagePage/AdminMessagePage.module.sass": 2765,
	"./pages/AdminMessagePage/AdminMessagePage.module.sass.d": 3407,
	"./pages/AdminMessagePage/AdminMessagePage.module.sass.d.ts": 3407,
	"./pages/AdminMessagePage/AdminMessagePage.tsx": 2894,
	"./pages/App": 301,
	"./pages/App/": 301,
	"./pages/App/App": 369,
	"./pages/App/App.tsx": 369,
	"./pages/App/fragments/__generated__/reactivationCampaignFragment": 3408,
	"./pages/App/fragments/__generated__/reactivationCampaignFragment.ts": 3408,
	"./pages/App/fragments/limitedOfferFragment": 3409,
	"./pages/App/fragments/limitedOfferFragment.ts": 3409,
	"./pages/App/index": 301,
	"./pages/App/index.ts": 301,
	"./pages/App/queries/clientInitQuery": 2752,
	"./pages/App/queries/clientInitQuery.ts": 2752,
	"./pages/App/serverCookieNotificationHandler/serverCookieNotificationHandler": 2751,
	"./pages/App/serverCookieNotificationHandler/serverCookieNotificationHandler.tsx": 2751,
	"./pages/ChangeDatePage/ChangeDatePage": 2102,
	"./pages/ChangeDatePage/ChangeDatePage.module": 584,
	"./pages/ChangeDatePage/ChangeDatePage.module.sass": 584,
	"./pages/ChangeDatePage/ChangeDatePage.module.sass.d": 3410,
	"./pages/ChangeDatePage/ChangeDatePage.module.sass.d.ts": 3410,
	"./pages/ChangeDatePage/ChangeDatePage.tsx": 2102,
	"./pages/ChangeDatePage/components/AddDeliveryNoteModal": 2477,
	"./pages/ChangeDatePage/components/AddDeliveryNoteModal.tsx": 2477,
	"./pages/ChangeDatePage/components/ChangeCourierFooter": 2103,
	"./pages/ChangeDatePage/components/ChangeCourierFooter.module": 1648,
	"./pages/ChangeDatePage/components/ChangeCourierFooter.module.sass": 1648,
	"./pages/ChangeDatePage/components/ChangeCourierFooter.module.sass.d": 3411,
	"./pages/ChangeDatePage/components/ChangeCourierFooter.module.sass.d.ts": 3411,
	"./pages/ChangeDatePage/components/ChangeCourierFooter.tsx": 2103,
	"./pages/ChangeDatePage/components/DateConfirmationFooter": 1801,
	"./pages/ChangeDatePage/components/DateConfirmationFooter.tsx": 1801,
	"./pages/ChangeDatePage/components/DefaultFooter": 2478,
	"./pages/ChangeDatePage/components/DefaultFooter.tsx": 2478,
	"./pages/ChangeDatePage/fragments/DeliveryDateUserFragment": 1805,
	"./pages/ChangeDatePage/fragments/DeliveryDateUserFragment.ts": 1805,
	"./pages/ChangeDatePage/fragments/UpsellModalFragment": 3412,
	"./pages/ChangeDatePage/fragments/UpsellModalFragment.ts": 3412,
	"./pages/ChangeDatePage/fragments/__generated__/DeliveryDateUserFragment": 3413,
	"./pages/ChangeDatePage/fragments/__generated__/DeliveryDateUserFragment.ts": 3413,
	"./pages/ChangeDatePage/fragments/__generated__/UpsellModalFragment": 3414,
	"./pages/ChangeDatePage/fragments/__generated__/UpsellModalFragment.ts": 3414,
	"./pages/ChangeDatePage/mutations/DeliveryDateUpdate": 2480,
	"./pages/ChangeDatePage/mutations/DeliveryDateUpdate.ts": 2480,
	"./pages/ChangeDatePage/mutations/__generated__/DeliveryDateUpdate": 3415,
	"./pages/ChangeDatePage/mutations/__generated__/DeliveryDateUpdate.ts": 3415,
	"./pages/ChangeDatePage/queries/CourierDeliveryDatesQuery": 2481,
	"./pages/ChangeDatePage/queries/CourierDeliveryDatesQuery.ts": 2481,
	"./pages/ChangeDatePage/queries/DeliveryDateQuery": 2482,
	"./pages/ChangeDatePage/queries/DeliveryDateQuery.ts": 2482,
	"./pages/ChangeDatePage/queries/__generated__/CourierDeliveryDatesQuery": 3416,
	"./pages/ChangeDatePage/queries/__generated__/CourierDeliveryDatesQuery.ts": 3416,
	"./pages/ChangeDatePage/queries/__generated__/DeliveryDateQuery": 3417,
	"./pages/ChangeDatePage/queries/__generated__/DeliveryDateQuery.ts": 3417,
	"./pages/CheckoutPage/Analytics/CheckoutAnalytics": 198,
	"./pages/CheckoutPage/Analytics/CheckoutAnalytics.ts": 198,
	"./pages/CheckoutPage/CheckoutPage": 91,
	"./pages/CheckoutPage/CheckoutPage.stories": 3418,
	"./pages/CheckoutPage/CheckoutPage.stories.tsx": 3418,
	"./pages/CheckoutPage/CheckoutPage.tsx": 91,
	"./pages/CheckoutPage/components/AccountSection/AccountSection": 2572,
	"./pages/CheckoutPage/components/AccountSection/AccountSection.tsx": 2572,
	"./pages/CheckoutPage/components/AccountSection/ExpressCheckout": 2591,
	"./pages/CheckoutPage/components/AccountSection/ExpressCheckout.tsx": 2591,
	"./pages/CheckoutPage/components/AccountSection/ExpressCheckoutElements": 2590,
	"./pages/CheckoutPage/components/AccountSection/ExpressCheckoutElements.tsx": 2590,
	"./pages/CheckoutPage/components/DeliveryAddressSection/DeliveryAddressFinder": 2623,
	"./pages/CheckoutPage/components/DeliveryAddressSection/DeliveryAddressFinder.tsx": 2623,
	"./pages/CheckoutPage/components/DeliveryAddressSection/DeliveryAddressSection": 2592,
	"./pages/CheckoutPage/components/DeliveryAddressSection/DeliveryAddressSection.tsx": 2592,
	"./pages/CheckoutPage/components/DeliveryAddressSection/FetchifyParams": 2625,
	"./pages/CheckoutPage/components/DeliveryAddressSection/FetchifyParams.ts": 2625,
	"./pages/CheckoutPage/components/DeliveryDateSection/DeliveryDateModal": 1843,
	"./pages/CheckoutPage/components/DeliveryDateSection/DeliveryDateModal.tsx": 1843,
	"./pages/CheckoutPage/components/DeliveryDateSection/DeliveryDateModalWithCourier/DeliveryDateModalWithCourier": 1600,
	"./pages/CheckoutPage/components/DeliveryDateSection/DeliveryDateModalWithCourier/DeliveryDateModalWithCourier.module": 1383,
	"./pages/CheckoutPage/components/DeliveryDateSection/DeliveryDateModalWithCourier/DeliveryDateModalWithCourier.module.sass": 1383,
	"./pages/CheckoutPage/components/DeliveryDateSection/DeliveryDateModalWithCourier/DeliveryDateModalWithCourier.module.sass.d": 3419,
	"./pages/CheckoutPage/components/DeliveryDateSection/DeliveryDateModalWithCourier/DeliveryDateModalWithCourier.module.sass.d.ts": 3419,
	"./pages/CheckoutPage/components/DeliveryDateSection/DeliveryDateModalWithCourier/DeliveryDateModalWithCourier.tsx": 1600,
	"./pages/CheckoutPage/components/DeliveryDateSection/DeliveryDateOptimisedCourier": 2628,
	"./pages/CheckoutPage/components/DeliveryDateSection/DeliveryDateOptimisedCourier.tsx": 2628,
	"./pages/CheckoutPage/components/DeliveryDateSection/DeliveryDateSection": 2168,
	"./pages/CheckoutPage/components/DeliveryDateSection/DeliveryDateSection.module": 2344,
	"./pages/CheckoutPage/components/DeliveryDateSection/DeliveryDateSection.module.sass": 2344,
	"./pages/CheckoutPage/components/DeliveryDateSection/DeliveryDateSection.module.sass.d": 3420,
	"./pages/CheckoutPage/components/DeliveryDateSection/DeliveryDateSection.module.sass.d.ts": 3420,
	"./pages/CheckoutPage/components/DeliveryDateSection/DeliveryDateSection.tsx": 2168,
	"./pages/CheckoutPage/components/DeliveryDateSection/DeliveryFeeInfo": 1844,
	"./pages/CheckoutPage/components/DeliveryDateSection/DeliveryFeeInfo.tsx": 1844,
	"./pages/CheckoutPage/components/DeliveryDateSection/queries/__generated__/DeliveryDateModalQuery": 3421,
	"./pages/CheckoutPage/components/DeliveryDateSection/queries/__generated__/DeliveryDateModalQuery.ts": 3421,
	"./pages/CheckoutPage/components/DeliveryDateSection/queries/__generated__/DeliveryDateModalWithCourierQuery": 3422,
	"./pages/CheckoutPage/components/DeliveryDateSection/queries/__generated__/DeliveryDateModalWithCourierQuery.ts": 3422,
	"./pages/CheckoutPage/components/DeliveryDateSection/queries/deliveryDateModalQuery": 2626,
	"./pages/CheckoutPage/components/DeliveryDateSection/queries/deliveryDateModalQuery.ts": 2626,
	"./pages/CheckoutPage/components/DeliveryDateSection/queries/deliveryDateModalWithCourierQuery": 2627,
	"./pages/CheckoutPage/components/DeliveryDateSection/queries/deliveryDateModalWithCourierQuery.ts": 2627,
	"./pages/CheckoutPage/components/InputField/InputField": 541,
	"./pages/CheckoutPage/components/InputField/InputField.tsx": 541,
	"./pages/CheckoutPage/components/InputField/MobileNumberInputField": 844,
	"./pages/CheckoutPage/components/InputField/MobileNumberInputField.tsx": 844,
	"./pages/CheckoutPage/components/InputField/PasswordInputField": 697,
	"./pages/CheckoutPage/components/InputField/PasswordInputField.tsx": 697,
	"./pages/CheckoutPage/components/InputField/PostcodeInputField": 2622,
	"./pages/CheckoutPage/components/InputField/PostcodeInputField.tsx": 2622,
	"./pages/CheckoutPage/components/InputField/__snapshots__/PasswordInputField.spec.tsx.snap": 4314,
	"./pages/CheckoutPage/components/InputField/queries/PostcodeIsDeliveryableQuery": 2621,
	"./pages/CheckoutPage/components/InputField/queries/PostcodeIsDeliveryableQuery.ts": 2621,
	"./pages/CheckoutPage/components/InputField/queries/__generated__/PostcodeIsDeliverableQuery": 3423,
	"./pages/CheckoutPage/components/InputField/queries/__generated__/PostcodeIsDeliverableQuery.ts": 3423,
	"./pages/CheckoutPage/components/LoadingCheckoutPage/LoadingCheckoutPage": 2567,
	"./pages/CheckoutPage/components/LoadingCheckoutPage/LoadingCheckoutPage.tsx": 2567,
	"./pages/CheckoutPage/components/NextDayDeliveryCountdown/NextDayDeliveryCountdown": 2337,
	"./pages/CheckoutPage/components/NextDayDeliveryCountdown/NextDayDeliveryCountdown.tsx": 2337,
	"./pages/CheckoutPage/components/OrderSummary/OrderSummary": 2169,
	"./pages/CheckoutPage/components/OrderSummary/OrderSummary.module": 1106,
	"./pages/CheckoutPage/components/OrderSummary/OrderSummary.module.sass": 1106,
	"./pages/CheckoutPage/components/OrderSummary/OrderSummary.module.sass.d": 3424,
	"./pages/CheckoutPage/components/OrderSummary/OrderSummary.module.sass.d.ts": 3424,
	"./pages/CheckoutPage/components/OrderSummary/OrderSummary.tsx": 2169,
	"./pages/CheckoutPage/components/OrderSummary/components/BoxBreakdownSummary/BoxBreakdownSummary": 2170,
	"./pages/CheckoutPage/components/OrderSummary/components/BoxBreakdownSummary/BoxBreakdownSummary.module": 1105,
	"./pages/CheckoutPage/components/OrderSummary/components/BoxBreakdownSummary/BoxBreakdownSummary.module.sass": 1105,
	"./pages/CheckoutPage/components/OrderSummary/components/BoxBreakdownSummary/BoxBreakdownSummary.module.sass.d": 3425,
	"./pages/CheckoutPage/components/OrderSummary/components/BoxBreakdownSummary/BoxBreakdownSummary.module.sass.d.ts": 3425,
	"./pages/CheckoutPage/components/OrderSummary/components/BoxBreakdownSummary/BoxBreakdownSummary.tsx": 2170,
	"./pages/CheckoutPage/components/OrderSummary/components/OngoingBoxTab/OngoingBoxTab": 2895,
	"./pages/CheckoutPage/components/OrderSummary/components/OngoingBoxTab/OngoingBoxTab.module": 1270,
	"./pages/CheckoutPage/components/OrderSummary/components/OngoingBoxTab/OngoingBoxTab.module.sass": 1270,
	"./pages/CheckoutPage/components/OrderSummary/components/OngoingBoxTab/OngoingBoxTab.module.sass.d": 3426,
	"./pages/CheckoutPage/components/OrderSummary/components/OngoingBoxTab/OngoingBoxTab.module.sass.d.ts": 3426,
	"./pages/CheckoutPage/components/OrderSummary/components/OngoingBoxTab/OngoingBoxTab.tsx": 2895,
	"./pages/CheckoutPage/components/OrderSummary/components/OrderSummaryRowItem/OrderSummaryRowItem": 891,
	"./pages/CheckoutPage/components/OrderSummary/components/OrderSummaryRowItem/OrderSummaryRowItem.module": 1664,
	"./pages/CheckoutPage/components/OrderSummary/components/OrderSummaryRowItem/OrderSummaryRowItem.module.sass": 1664,
	"./pages/CheckoutPage/components/OrderSummary/components/OrderSummaryRowItem/OrderSummaryRowItem.module.sass.d": 3427,
	"./pages/CheckoutPage/components/OrderSummary/components/OrderSummaryRowItem/OrderSummaryRowItem.module.sass.d.ts": 3427,
	"./pages/CheckoutPage/components/OrderSummary/components/OrderSummaryRowItem/OrderSummaryRowItem.tsx": 891,
	"./pages/CheckoutPage/components/OrderSummary/components/OrderSummaryTab/OrderSummaryTab": 2896,
	"./pages/CheckoutPage/components/OrderSummary/components/OrderSummaryTab/OrderSummaryTab.module": 1675,
	"./pages/CheckoutPage/components/OrderSummary/components/OrderSummaryTab/OrderSummaryTab.module.sass": 1675,
	"./pages/CheckoutPage/components/OrderSummary/components/OrderSummaryTab/OrderSummaryTab.module.sass.d": 3428,
	"./pages/CheckoutPage/components/OrderSummary/components/OrderSummaryTab/OrderSummaryTab.module.sass.d.ts": 3428,
	"./pages/CheckoutPage/components/OrderSummary/components/OrderSummaryTab/OrderSummaryTab.tsx": 2896,
	"./pages/CheckoutPage/components/OrderSummary/components/RedeemDiscount/RedeemDiscount": 1601,
	"./pages/CheckoutPage/components/OrderSummary/components/RedeemDiscount/RedeemDiscount.module": 1384,
	"./pages/CheckoutPage/components/OrderSummary/components/RedeemDiscount/RedeemDiscount.module.sass": 1384,
	"./pages/CheckoutPage/components/OrderSummary/components/RedeemDiscount/RedeemDiscount.module.sass.d": 3429,
	"./pages/CheckoutPage/components/OrderSummary/components/RedeemDiscount/RedeemDiscount.module.sass.d.ts": 3429,
	"./pages/CheckoutPage/components/OrderSummary/components/RedeemDiscount/RedeemDiscount.stories": 3430,
	"./pages/CheckoutPage/components/OrderSummary/components/RedeemDiscount/RedeemDiscount.stories.tsx": 3430,
	"./pages/CheckoutPage/components/OrderSummary/components/RedeemDiscount/RedeemDiscount.tsx": 1601,
	"./pages/CheckoutPage/components/OrderSummary/components/RedeemDiscount/queries/__generated__/CheckoutAddDiscountToGuest": 3431,
	"./pages/CheckoutPage/components/OrderSummary/components/RedeemDiscount/queries/__generated__/CheckoutAddDiscountToGuest.ts": 3431,
	"./pages/CheckoutPage/components/OrderSummary/components/RedeemDiscount/queries/__generated__/CheckoutCurrentDiscountCode": 3432,
	"./pages/CheckoutPage/components/OrderSummary/components/RedeemDiscount/queries/__generated__/CheckoutCurrentDiscountCode.ts": 3432,
	"./pages/CheckoutPage/components/OrderSummary/components/RedeemDiscount/queries/currentDiscountCode": 2629,
	"./pages/CheckoutPage/components/OrderSummary/components/RedeemDiscount/queries/currentDiscountCode.ts": 2629,
	"./pages/CheckoutPage/components/OrderSummary/components/RedeemDiscount/queries/redeemDiscount": 2630,
	"./pages/CheckoutPage/components/OrderSummary/components/RedeemDiscount/queries/redeemDiscount.ts": 2630,
	"./pages/CheckoutPage/components/OrderSummary/components/RedeemDiscount/queries/redeemReactivationDiscount": 2631,
	"./pages/CheckoutPage/components/OrderSummary/components/RedeemDiscount/queries/redeemReactivationDiscount.ts": 2631,
	"./pages/CheckoutPage/components/OrderSummary/components/RedeemDiscount/queries/redeemedDiscount": 2632,
	"./pages/CheckoutPage/components/OrderSummary/components/RedeemDiscount/queries/redeemedDiscount.ts": 2632,
	"./pages/CheckoutPage/components/OrderSummary/components/SelectedRecipesModal/SelectedRecipesModal": 2171,
	"./pages/CheckoutPage/components/OrderSummary/components/SelectedRecipesModal/SelectedRecipesModal.module": 1665,
	"./pages/CheckoutPage/components/OrderSummary/components/SelectedRecipesModal/SelectedRecipesModal.module.sass": 1665,
	"./pages/CheckoutPage/components/OrderSummary/components/SelectedRecipesModal/SelectedRecipesModal.module.sass.d": 3433,
	"./pages/CheckoutPage/components/OrderSummary/components/SelectedRecipesModal/SelectedRecipesModal.module.sass.d.ts": 3433,
	"./pages/CheckoutPage/components/OrderSummary/components/SelectedRecipesModal/SelectedRecipesModal.tsx": 2171,
	"./pages/CheckoutPage/components/OrderSummary/fragments/OrderSummaryFragment": 2637,
	"./pages/CheckoutPage/components/OrderSummary/fragments/OrderSummaryFragment.ts": 2637,
	"./pages/CheckoutPage/components/OrderSummary/fragments/__generated__/orderSummaryFlavourFragment": 3434,
	"./pages/CheckoutPage/components/OrderSummary/fragments/__generated__/orderSummaryFlavourFragment.ts": 3434,
	"./pages/CheckoutPage/components/OrderSummary/fragments/__generated__/orderSummaryPendingSubscriptionFragment": 3435,
	"./pages/CheckoutPage/components/OrderSummary/fragments/__generated__/orderSummaryPendingSubscriptionFragment.ts": 3435,
	"./pages/CheckoutPage/components/PaymentSection/Banner": 188,
	"./pages/CheckoutPage/components/PaymentSection/Banner.tsx": 188,
	"./pages/CheckoutPage/components/PaymentSection/CreditCardView": 2578,
	"./pages/CheckoutPage/components/PaymentSection/CreditCardView.tsx": 2578,
	"./pages/CheckoutPage/components/PaymentSection/PayPalButton": 1829,
	"./pages/CheckoutPage/components/PaymentSection/PayPalButton.tsx": 1829,
	"./pages/CheckoutPage/components/PaymentSection/PaymentOptions/BancontactOption": 2576,
	"./pages/CheckoutPage/components/PaymentSection/PaymentOptions/BancontactOption.tsx": 2576,
	"./pages/CheckoutPage/components/PaymentSection/PaymentOptions/CreditCardOption": 2577,
	"./pages/CheckoutPage/components/PaymentSection/PaymentOptions/CreditCardOption.tsx": 2577,
	"./pages/CheckoutPage/components/PaymentSection/PaymentOptions/IdealOption": 2579,
	"./pages/CheckoutPage/components/PaymentSection/PaymentOptions/IdealOption.tsx": 2579,
	"./pages/CheckoutPage/components/PaymentSection/PaymentOptions/PayPalOption": 2580,
	"./pages/CheckoutPage/components/PaymentSection/PaymentOptions/PayPalOption.tsx": 2580,
	"./pages/CheckoutPage/components/PaymentSection/PaymentOptions/PaymentOption": 2575,
	"./pages/CheckoutPage/components/PaymentSection/PaymentOptions/PaymentOption.tsx": 2575,
	"./pages/CheckoutPage/components/PaymentSection/PaymentOptions/PaymentRequestOption": 2581,
	"./pages/CheckoutPage/components/PaymentSection/PaymentOptions/PaymentRequestOption.tsx": 2581,
	"./pages/CheckoutPage/components/PaymentSection/PaymentSection": 420,
	"./pages/CheckoutPage/components/PaymentSection/PaymentSection.tsx": 420,
	"./pages/CheckoutPage/components/PaymentSection/PaymentSectionWithStripe": 2573,
	"./pages/CheckoutPage/components/PaymentSection/PaymentSectionWithStripe.tsx": 2573,
	"./pages/CheckoutPage/components/PaymentSection/PlaceMyOrderDisclaimer": 2568,
	"./pages/CheckoutPage/components/PaymentSection/PlaceMyOrderDisclaimer.tsx": 2568,
	"./pages/CheckoutPage/components/PaymentSection/PurchaseButton": 2589,
	"./pages/CheckoutPage/components/PaymentSection/PurchaseButton.tsx": 2589,
	"./pages/CheckoutPage/components/PaymentSection/StripePaymentElement": 805,
	"./pages/CheckoutPage/components/PaymentSection/StripePaymentElement.tsx": 805,
	"./pages/CheckoutPage/components/PaymentSection/helpers/buySubscriptionWithCard": 578,
	"./pages/CheckoutPage/components/PaymentSection/helpers/buySubscriptionWithCard.ts": 578,
	"./pages/CheckoutPage/components/PaymentSection/helpers/buySubscriptionWithPayPal": 2340,
	"./pages/CheckoutPage/components/PaymentSection/helpers/buySubscriptionWithPayPal.ts": 2340,
	"./pages/CheckoutPage/components/PaymentSection/helpers/buySubscriptionWithPaymentRequest": 2586,
	"./pages/CheckoutPage/components/PaymentSection/helpers/buySubscriptionWithPaymentRequest.ts": 2586,
	"./pages/CheckoutPage/components/PaymentSection/helpers/buySubscriptionWithSepaDirectDebit": 1833,
	"./pages/CheckoutPage/components/PaymentSection/helpers/buySubscriptionWithSepaDirectDebit.ts": 1833,
	"./pages/CheckoutPage/components/PaymentSection/helpers/buySubscriptionWithStripe": 1341,
	"./pages/CheckoutPage/components/PaymentSection/helpers/buySubscriptionWithStripe.ts": 1341,
	"./pages/CheckoutPage/components/PaymentSection/helpers/chargeBoxOne": 1831,
	"./pages/CheckoutPage/components/PaymentSection/helpers/chargeBoxOne.ts": 1831,
	"./pages/CheckoutPage/components/PaymentSection/helpers/chargeStripeBoxOne": 2588,
	"./pages/CheckoutPage/components/PaymentSection/helpers/chargeStripeBoxOne.ts": 2588,
	"./pages/CheckoutPage/components/PaymentSection/helpers/formatPaymentMethod": 882,
	"./pages/CheckoutPage/components/PaymentSection/helpers/formatPaymentMethod.ts": 882,
	"./pages/CheckoutPage/components/PaymentSection/helpers/formatSubscriptionDataAddressForGraphql": 1071,
	"./pages/CheckoutPage/components/PaymentSection/helpers/formatSubscriptionDataAddressForGraphql.ts": 1071,
	"./pages/CheckoutPage/components/PaymentSection/helpers/getBancontactPaymentAuthorisation": 2584,
	"./pages/CheckoutPage/components/PaymentSection/helpers/getBancontactPaymentAuthorisation.ts": 2584,
	"./pages/CheckoutPage/components/PaymentSection/helpers/getIdealPaymentAuthorisation": 2585,
	"./pages/CheckoutPage/components/PaymentSection/helpers/getIdealPaymentAuthorisation.ts": 2585,
	"./pages/CheckoutPage/components/PaymentSection/helpers/getPaypalPaymentAuthorisation": 2587,
	"./pages/CheckoutPage/components/PaymentSection/helpers/getPaypalPaymentAuthorisation.ts": 2587,
	"./pages/CheckoutPage/components/PaymentSection/helpers/paymentMethodFromWalletName": 1836,
	"./pages/CheckoutPage/components/PaymentSection/helpers/paymentMethodFromWalletName.ts": 1836,
	"./pages/CheckoutPage/components/PaymentSection/helpers/paymentMethodIcons": 2582,
	"./pages/CheckoutPage/components/PaymentSection/helpers/paymentMethodIcons.tsx": 2582,
	"./pages/CheckoutPage/components/PaymentSection/helpers/paymentMethodsAvaliable": 944,
	"./pages/CheckoutPage/components/PaymentSection/helpers/paymentMethodsAvaliable.ts": 944,
	"./pages/CheckoutPage/components/PaymentSection/helpers/paymentRequestDisplayItems": 2339,
	"./pages/CheckoutPage/components/PaymentSection/helpers/paymentRequestDisplayItems.ts": 2339,
	"./pages/CheckoutPage/components/PaymentSection/helpers/requestFromSCAController": 1339,
	"./pages/CheckoutPage/components/PaymentSection/helpers/requestFromSCAController.ts": 1339,
	"./pages/CheckoutPage/components/PaymentSection/helpers/submitSubscription": 542,
	"./pages/CheckoutPage/components/PaymentSection/helpers/submitSubscription.ts": 542,
	"./pages/CheckoutPage/components/PaymentSection/hooks/useBuySubscriptionWithBancontact": 1832,
	"./pages/CheckoutPage/components/PaymentSection/hooks/useBuySubscriptionWithBancontact.ts": 1832,
	"./pages/CheckoutPage/components/PaymentSection/hooks/useBuySubscriptionWithIdeal": 1834,
	"./pages/CheckoutPage/components/PaymentSection/hooks/useBuySubscriptionWithIdeal.ts": 1834,
	"./pages/CheckoutPage/components/PaymentSection/hooks/useBuySubscriptionWithPayPal": 1152,
	"./pages/CheckoutPage/components/PaymentSection/hooks/useBuySubscriptionWithPayPal.ts": 1152,
	"./pages/CheckoutPage/components/PaymentSection/hooks/useBuySubscriptionWithPaymentRequest": 1835,
	"./pages/CheckoutPage/components/PaymentSection/hooks/useBuySubscriptionWithPaymentRequest.ts": 1835,
	"./pages/CheckoutPage/components/PaymentSection/hooks/usePaymentView": 1340,
	"./pages/CheckoutPage/components/PaymentSection/hooks/usePaymentView.ts": 1340,
	"./pages/CheckoutPage/components/PaymentSection/mutations/__generated__/StripeChargeBoxOneAndSetupPaymentMethod": 3436,
	"./pages/CheckoutPage/components/PaymentSection/mutations/__generated__/StripeChargeBoxOneAndSetupPaymentMethod.ts": 3436,
	"./pages/CheckoutPage/components/PaymentSection/mutations/__generated__/StripeUserParamsSetupIntentCreate": 3437,
	"./pages/CheckoutPage/components/PaymentSection/mutations/__generated__/StripeUserParamsSetupIntentCreate.ts": 3437,
	"./pages/CheckoutPage/components/PaymentSection/mutations/stripeChargeBoxOneAndSetupPaymentMethod": 1069,
	"./pages/CheckoutPage/components/PaymentSection/mutations/stripeChargeBoxOneAndSetupPaymentMethod.ts": 1069,
	"./pages/CheckoutPage/components/PaymentSection/mutations/stripeUserParamsSetupIntentCreate": 1070,
	"./pages/CheckoutPage/components/PaymentSection/mutations/stripeUserParamsSetupIntentCreate.ts": 1070,
	"./pages/CheckoutPage/components/PaymentSection/queries/__generated__/ChargeIdFromPaymentIntentId": 3438,
	"./pages/CheckoutPage/components/PaymentSection/queries/__generated__/ChargeIdFromPaymentIntentId.ts": 3438,
	"./pages/CheckoutPage/components/PaymentSection/queries/__generated__/SepaPaymentMethodIdFromIntentSecret": 3439,
	"./pages/CheckoutPage/components/PaymentSection/queries/__generated__/SepaPaymentMethodIdFromIntentSecret.ts": 3439,
	"./pages/CheckoutPage/components/PaymentSection/queries/chargeIdFromPaymentIntentId": 1223,
	"./pages/CheckoutPage/components/PaymentSection/queries/chargeIdFromPaymentIntentId.ts": 1223,
	"./pages/CheckoutPage/components/PaymentSection/queries/sepaPaymentMethodIdFromIntentSecret": 2583,
	"./pages/CheckoutPage/components/PaymentSection/queries/sepaPaymentMethodIdFromIntentSecret.ts": 2583,
	"./pages/CheckoutPage/components/Trustpilot/Trustpilot": 2635,
	"./pages/CheckoutPage/components/Trustpilot/Trustpilot.tsx": 2635,
	"./pages/CheckoutPage/components/Validation/Validation": 418,
	"./pages/CheckoutPage/components/Validation/Validation.tsx": 418,
	"./pages/CheckoutPage/helpers/errors": 1830,
	"./pages/CheckoutPage/helpers/errors.ts": 1830,
	"./pages/CheckoutPage/helpers/generateEndOfLeadTime": 1348,
	"./pages/CheckoutPage/helpers/generateEndOfLeadTime.ts": 1348,
	"./pages/CheckoutPage/helpers/graphql": 1632,
	"./pages/CheckoutPage/helpers/graphql.ts": 1632,
	"./pages/CheckoutPage/helpers/inputs": 216,
	"./pages/CheckoutPage/helpers/inputs.ts": 216,
	"./pages/CheckoutPage/helpers/sections": 1631,
	"./pages/CheckoutPage/helpers/sections.ts": 1631,
	"./pages/CheckoutPage/helpers/submission.js.flow": 4315,
	"./pages/CheckoutPage/hooks/useCheckoutPricing": 445,
	"./pages/CheckoutPage/hooks/useCheckoutPricing.ts": 445,
	"./pages/CheckoutPage/hooks/useCountdownBanner": 2643,
	"./pages/CheckoutPage/hooks/useCountdownBanner.ts": 2643,
	"./pages/CheckoutPage/hooks/useDeliveryDatesQuery": 1842,
	"./pages/CheckoutPage/hooks/useDeliveryDatesQuery.ts": 1842,
	"./pages/CheckoutPage/hooks/useDiscountCopy": 2633,
	"./pages/CheckoutPage/hooks/useDiscountCopy.ts": 2633,
	"./pages/CheckoutPage/hooks/useValidatePostcode": 2620,
	"./pages/CheckoutPage/hooks/useValidatePostcode.ts": 2620,
	"./pages/CheckoutPage/queries/__generated__/CheckoutPage": 3440,
	"./pages/CheckoutPage/queries/__generated__/CheckoutPage.ts": 3440,
	"./pages/CheckoutPage/queries/__generated__/CheckoutPendingSubscriptionOrderPricingQuery": 3441,
	"./pages/CheckoutPage/queries/__generated__/CheckoutPendingSubscriptionOrderPricingQuery.ts": 3441,
	"./pages/CheckoutPage/queries/__generated__/DeliveryDates": 3442,
	"./pages/CheckoutPage/queries/__generated__/DeliveryDates.ts": 3442,
	"./pages/CheckoutPage/queries/__generated__/DiscountCopyQuery": 3443,
	"./pages/CheckoutPage/queries/__generated__/DiscountCopyQuery.ts": 3443,
	"./pages/CheckoutPage/queries/__generated__/LoginUser": 3444,
	"./pages/CheckoutPage/queries/__generated__/LoginUser.ts": 3444,
	"./pages/CheckoutPage/queries/__generated__/PendingSubscriptionFlavoursQuery": 3445,
	"./pages/CheckoutPage/queries/__generated__/PendingSubscriptionFlavoursQuery.ts": 3445,
	"./pages/CheckoutPage/queries/__generated__/UserTypeQuery": 3446,
	"./pages/CheckoutPage/queries/__generated__/UserTypeQuery.ts": 3446,
	"./pages/CheckoutPage/queries/__generated__/billingRequestFlowCreate": 3447,
	"./pages/CheckoutPage/queries/__generated__/billingRequestFlowCreate.ts": 3447,
	"./pages/CheckoutPage/queries/__generated__/gocardlessUserParamCreate": 3448,
	"./pages/CheckoutPage/queries/__generated__/gocardlessUserParamCreate.ts": 3448,
	"./pages/CheckoutPage/queries/__generated__/pendingSubscriptionOrderPricing": 3449,
	"./pages/CheckoutPage/queries/__generated__/pendingSubscriptionOrderPricing.ts": 3449,
	"./pages/CheckoutPage/queries/__generated__/pendingSubscriptionOrderPricingFragment": 3450,
	"./pages/CheckoutPage/queries/__generated__/pendingSubscriptionOrderPricingFragment.ts": 3450,
	"./pages/CheckoutPage/queries/billingRequestFlowCreateMutation": 2644,
	"./pages/CheckoutPage/queries/billingRequestFlowCreateMutation.ts": 2644,
	"./pages/CheckoutPage/queries/checkoutPageQuery": 2636,
	"./pages/CheckoutPage/queries/checkoutPageQuery.ts": 2636,
	"./pages/CheckoutPage/queries/checkoutPendingSubscriptionPricingQuery": 2574,
	"./pages/CheckoutPage/queries/checkoutPendingSubscriptionPricingQuery.ts": 2574,
	"./pages/CheckoutPage/queries/deliveryDatesQuery": 2619,
	"./pages/CheckoutPage/queries/deliveryDatesQuery.ts": 2619,
	"./pages/CheckoutPage/queries/discountCopyQuery": 2634,
	"./pages/CheckoutPage/queries/discountCopyQuery.ts": 2634,
	"./pages/CheckoutPage/queries/fragments/DiscountCodeFragment": 1350,
	"./pages/CheckoutPage/queries/fragments/DiscountCodeFragment.ts": 1350,
	"./pages/CheckoutPage/queries/fragments/FeatureFlagFragment": 2638,
	"./pages/CheckoutPage/queries/fragments/FeatureFlagFragment.ts": 2638,
	"./pages/CheckoutPage/queries/fragments/PendingSubscriptionOrderPricingFragment": 1827,
	"./pages/CheckoutPage/queries/fragments/PendingSubscriptionOrderPricingFragment.ts": 1827,
	"./pages/CheckoutPage/queries/fragments/ProductVariantFragment": 2639,
	"./pages/CheckoutPage/queries/fragments/ProductVariantFragment.ts": 2639,
	"./pages/CheckoutPage/queries/fragments/ShippingCountryFragment": 2640,
	"./pages/CheckoutPage/queries/fragments/ShippingCountryFragment.ts": 2640,
	"./pages/CheckoutPage/queries/fragments/__generated__/discountCodeFragment": 3451,
	"./pages/CheckoutPage/queries/fragments/__generated__/discountCodeFragment.ts": 3451,
	"./pages/CheckoutPage/queries/fragments/__generated__/featureFlagFragment": 3452,
	"./pages/CheckoutPage/queries/fragments/__generated__/featureFlagFragment.ts": 3452,
	"./pages/CheckoutPage/queries/fragments/__generated__/pendingSubscriptionOrderPricingFragment": 3453,
	"./pages/CheckoutPage/queries/fragments/__generated__/pendingSubscriptionOrderPricingFragment.ts": 3453,
	"./pages/CheckoutPage/queries/fragments/__generated__/productVariantFragment": 3454,
	"./pages/CheckoutPage/queries/fragments/__generated__/productVariantFragment.ts": 3454,
	"./pages/CheckoutPage/queries/fragments/__generated__/shippingCountryFragment": 3455,
	"./pages/CheckoutPage/queries/fragments/__generated__/shippingCountryFragment.ts": 3455,
	"./pages/CheckoutPage/queries/gocardlessUserParamCreateMutation": 2645,
	"./pages/CheckoutPage/queries/gocardlessUserParamCreateMutation.ts": 2645,
	"./pages/CheckoutPage/queries/loginUser": 2641,
	"./pages/CheckoutPage/queries/loginUser.ts": 2641,
	"./pages/CheckoutPage/queries/userTypeQuery": 2642,
	"./pages/CheckoutPage/queries/userTypeQuery.ts": 2642,
	"./pages/CheckoutPage/types": 1828,
	"./pages/CheckoutPage/types.ts": 1828,
	"./pages/ConfirmPlanPage/ConfirmPlanPage": 2105,
	"./pages/ConfirmPlanPage/ConfirmPlanPage.module": 752,
	"./pages/ConfirmPlanPage/ConfirmPlanPage.module.sass": 752,
	"./pages/ConfirmPlanPage/ConfirmPlanPage.module.sass.d": 3456,
	"./pages/ConfirmPlanPage/ConfirmPlanPage.module.sass.d.ts": 3456,
	"./pages/ConfirmPlanPage/ConfirmPlanPage.tsx": 2105,
	"./pages/ConfirmPlanPage/__generated__/PlanConfirmationQuery": 3457,
	"./pages/ConfirmPlanPage/__generated__/PlanConfirmationQuery.ts": 3457,
	"./pages/ConfirmPlanPage/queries": 2483,
	"./pages/ConfirmPlanPage/queries.ts": 2483,
	"./pages/ConfirmedPaused/ConfirmedPaused": 2897,
	"./pages/ConfirmedPaused/ConfirmedPaused.module": 2361,
	"./pages/ConfirmedPaused/ConfirmedPaused.module.sass": 2361,
	"./pages/ConfirmedPaused/ConfirmedPaused.module.sass.d": 3458,
	"./pages/ConfirmedPaused/ConfirmedPaused.module.sass.d.ts": 3458,
	"./pages/ConfirmedPaused/ConfirmedPaused.tsx": 2897,
	"./pages/ContactPreferencesPage/ContactPreferencesPage": 2106,
	"./pages/ContactPreferencesPage/ContactPreferencesPage.module": 1651,
	"./pages/ContactPreferencesPage/ContactPreferencesPage.module.sass": 1651,
	"./pages/ContactPreferencesPage/ContactPreferencesPage.module.sass.d": 3459,
	"./pages/ContactPreferencesPage/ContactPreferencesPage.module.sass.d.ts": 3459,
	"./pages/ContactPreferencesPage/ContactPreferencesPage.tsx": 2106,
	"./pages/ContactPreferencesPage/components/SMSDeliveryReminder": 2484,
	"./pages/ContactPreferencesPage/components/SMSDeliveryReminder.tsx": 2484,
	"./pages/ContactPreferencesPage/mutations/__generated__/SmsDeliveryReminderMutation": 3460,
	"./pages/ContactPreferencesPage/mutations/__generated__/SmsDeliveryReminderMutation.ts": 3460,
	"./pages/ContactPreferencesPage/mutations/smsDeliveryReminderMutation": 2485,
	"./pages/ContactPreferencesPage/mutations/smsDeliveryReminderMutation.ts": 2485,
	"./pages/ContactPreferencesPage/queries/__generated__/SmsDeliveryReminderQuery": 3461,
	"./pages/ContactPreferencesPage/queries/__generated__/SmsDeliveryReminderQuery.ts": 3461,
	"./pages/ContactPreferencesPage/queries/smsDeliveryReminderQuery": 2486,
	"./pages/ContactPreferencesPage/queries/smsDeliveryReminderQuery.ts": 2486,
	"./pages/CustomerIssueManagementPage/CustomerIssueManagement": 2650,
	"./pages/CustomerIssueManagementPage/CustomerIssueManagement.tsx": 2650,
	"./pages/CustomerIssueManagementPage/CustomerIssueManagementPage": 92,
	"./pages/CustomerIssueManagementPage/CustomerIssueManagementPage.module": 816,
	"./pages/CustomerIssueManagementPage/CustomerIssueManagementPage.module.sass": 816,
	"./pages/CustomerIssueManagementPage/CustomerIssueManagementPage.module.sass.d": 3462,
	"./pages/CustomerIssueManagementPage/CustomerIssueManagementPage.module.sass.d.ts": 3462,
	"./pages/CustomerIssueManagementPage/CustomerIssueManagementPage.tsx": 92,
	"./pages/CustomerIssueManagementPage/analytics": 340,
	"./pages/CustomerIssueManagementPage/analytics/": 340,
	"./pages/CustomerIssueManagementPage/analytics/index": 340,
	"./pages/CustomerIssueManagementPage/analytics/index.ts": 340,
	"./pages/CustomerIssueManagementPage/components/Accordion/Accordion": 2176,
	"./pages/CustomerIssueManagementPage/components/Accordion/Accordion.module": 2349,
	"./pages/CustomerIssueManagementPage/components/Accordion/Accordion.module.sass": 2349,
	"./pages/CustomerIssueManagementPage/components/Accordion/Accordion.module.sass.d": 3463,
	"./pages/CustomerIssueManagementPage/components/Accordion/Accordion.module.sass.d.ts": 3463,
	"./pages/CustomerIssueManagementPage/components/Accordion/Accordion.tsx": 2176,
	"./pages/CustomerIssueManagementPage/components/ActionButtons/ActionButtons": 772,
	"./pages/CustomerIssueManagementPage/components/ActionButtons/ActionButtons.module": 2347,
	"./pages/CustomerIssueManagementPage/components/ActionButtons/ActionButtons.module.sass": 2347,
	"./pages/CustomerIssueManagementPage/components/ActionButtons/ActionButtons.module.sass.d": 3464,
	"./pages/CustomerIssueManagementPage/components/ActionButtons/ActionButtons.module.sass.d.ts": 3464,
	"./pages/CustomerIssueManagementPage/components/ActionButtons/ActionButtons.tsx": 772,
	"./pages/CustomerIssueManagementPage/components/ContactCustomerLove/ContactCustomerLoveButton": 2654,
	"./pages/CustomerIssueManagementPage/components/ContactCustomerLove/ContactCustomerLoveButton.tsx": 2654,
	"./pages/CustomerIssueManagementPage/components/CustomerIssueManagementHeader/CustomerIssueManagementHeader": 2172,
	"./pages/CustomerIssueManagementPage/components/CustomerIssueManagementHeader/CustomerIssueManagementHeader.module": 1266,
	"./pages/CustomerIssueManagementPage/components/CustomerIssueManagementHeader/CustomerIssueManagementHeader.module.sass": 1266,
	"./pages/CustomerIssueManagementPage/components/CustomerIssueManagementHeader/CustomerIssueManagementHeader.module.sass.d": 3465,
	"./pages/CustomerIssueManagementPage/components/CustomerIssueManagementHeader/CustomerIssueManagementHeader.module.sass.d.ts": 3465,
	"./pages/CustomerIssueManagementPage/components/CustomerIssueManagementHeader/CustomerIssueManagementHeader.tsx": 2172,
	"./pages/CustomerIssueManagementPage/components/CustomerIssueManagementLoading/CustomerIssueManagementLoading": 2647,
	"./pages/CustomerIssueManagementPage/components/CustomerIssueManagementLoading/CustomerIssueManagementLoading.tsx": 2647,
	"./pages/CustomerIssueManagementPage/components/CustomerIssuesFAQ/CustomerIssuesFAQ": 2173,
	"./pages/CustomerIssueManagementPage/components/CustomerIssuesFAQ/CustomerIssuesFAQ.module": 2345,
	"./pages/CustomerIssueManagementPage/components/CustomerIssuesFAQ/CustomerIssuesFAQ.module.sass": 2345,
	"./pages/CustomerIssueManagementPage/components/CustomerIssuesFAQ/CustomerIssuesFAQ.module.sass.d": 3466,
	"./pages/CustomerIssueManagementPage/components/CustomerIssuesFAQ/CustomerIssuesFAQ.module.sass.d.ts": 3466,
	"./pages/CustomerIssueManagementPage/components/CustomerIssuesFAQ/CustomerIssuesFAQ.tsx": 2173,
	"./pages/CustomerIssueManagementPage/components/CustomerIssuesFAQ/CustomerIssuesFAQSwitch": 2648,
	"./pages/CustomerIssueManagementPage/components/CustomerIssuesFAQ/CustomerIssuesFAQSwitch.tsx": 2648,
	"./pages/CustomerIssueManagementPage/components/CustomerIssuesFAQ/ReplaceBoxFaq": 2649,
	"./pages/CustomerIssueManagementPage/components/CustomerIssuesFAQ/ReplaceBoxFaq.tsx": 2649,
	"./pages/CustomerIssueManagementPage/hooks/useCustomerIssueEntryInputsCreateMutation": 2678,
	"./pages/CustomerIssueManagementPage/hooks/useCustomerIssueEntryInputsCreateMutation.ts": 2678,
	"./pages/CustomerIssueManagementPage/hooks/useCustomerIssueInitialQuery": 2680,
	"./pages/CustomerIssueManagementPage/hooks/useCustomerIssueInitialQuery.ts": 2680,
	"./pages/CustomerIssueManagementPage/hooks/useCustomerIssueReportCreateMutation": 2682,
	"./pages/CustomerIssueManagementPage/hooks/useCustomerIssueReportCreateMutation.ts": 2682,
	"./pages/CustomerIssueManagementPage/hooks/useCustomerIssueResolutionOfferingMutations": 2684,
	"./pages/CustomerIssueManagementPage/hooks/useCustomerIssueResolutionOfferingMutations.ts": 2684,
	"./pages/CustomerIssueManagementPage/hooks/useQueryParam": 1848,
	"./pages/CustomerIssueManagementPage/hooks/useQueryParam.ts": 1848,
	"./pages/CustomerIssueManagementPage/mutations/CustomerIssueEntryInputsCreate": 2679,
	"./pages/CustomerIssueManagementPage/mutations/CustomerIssueEntryInputsCreate.ts": 2679,
	"./pages/CustomerIssueManagementPage/mutations/CustomerIssueReportCreate": 2683,
	"./pages/CustomerIssueManagementPage/mutations/CustomerIssueReportCreate.ts": 2683,
	"./pages/CustomerIssueManagementPage/mutations/CustomerIssueResolutionOfferingAccept": 2350,
	"./pages/CustomerIssueManagementPage/mutations/CustomerIssueResolutionOfferingAccept.ts": 2350,
	"./pages/CustomerIssueManagementPage/mutations/CustomerIssueResolutionOfferingReject": 2685,
	"./pages/CustomerIssueManagementPage/mutations/CustomerIssueResolutionOfferingReject.ts": 2685,
	"./pages/CustomerIssueManagementPage/mutations/__generated__/CustomerIssueEntryInputsCreate": 3467,
	"./pages/CustomerIssueManagementPage/mutations/__generated__/CustomerIssueEntryInputsCreate.ts": 3467,
	"./pages/CustomerIssueManagementPage/mutations/__generated__/CustomerIssueReportCreate": 3468,
	"./pages/CustomerIssueManagementPage/mutations/__generated__/CustomerIssueReportCreate.ts": 3468,
	"./pages/CustomerIssueManagementPage/mutations/__generated__/CustomerIssueResolutionOfferingAccept": 3469,
	"./pages/CustomerIssueManagementPage/mutations/__generated__/CustomerIssueResolutionOfferingAccept.ts": 3469,
	"./pages/CustomerIssueManagementPage/mutations/__generated__/CustomerIssueResolutionOfferingReject": 3470,
	"./pages/CustomerIssueManagementPage/mutations/__generated__/CustomerIssueResolutionOfferingReject.ts": 3470,
	"./pages/CustomerIssueManagementPage/mutations/__generated__/applyDiscount": 3471,
	"./pages/CustomerIssueManagementPage/mutations/__generated__/applyDiscount.ts": 3471,
	"./pages/CustomerIssueManagementPage/mutations/__generated__/helpCentreArticleResolutionDetailsFields": 3472,
	"./pages/CustomerIssueManagementPage/mutations/__generated__/helpCentreArticleResolutionDetailsFields.ts": 3472,
	"./pages/CustomerIssueManagementPage/mutations/__generated__/replaceBox": 3473,
	"./pages/CustomerIssueManagementPage/mutations/__generated__/replaceBox.ts": 3473,
	"./pages/CustomerIssueManagementPage/mutations/__generated__/trackOrderResolutionDetailsFields": 3474,
	"./pages/CustomerIssueManagementPage/mutations/__generated__/trackOrderResolutionDetailsFields.ts": 3474,
	"./pages/CustomerIssueManagementPage/queries/__generated__/CustomerIssueManagementInitialDataQuery": 3475,
	"./pages/CustomerIssueManagementPage/queries/__generated__/CustomerIssueManagementInitialDataQuery.ts": 3475,
	"./pages/CustomerIssueManagementPage/queries/initialDataQuery": 2681,
	"./pages/CustomerIssueManagementPage/queries/initialDataQuery.ts": 2681,
	"./pages/CustomerIssueManagementPage/screens/Categories/CategoriesScreen": 2651,
	"./pages/CustomerIssueManagementPage/screens/Categories/CategoriesScreen.stories": 3476,
	"./pages/CustomerIssueManagementPage/screens/Categories/CategoriesScreen.stories.tsx": 3476,
	"./pages/CustomerIssueManagementPage/screens/Categories/CategoriesScreen.tsx": 2651,
	"./pages/CustomerIssueManagementPage/screens/Categories/categories": 1227,
	"./pages/CustomerIssueManagementPage/screens/Categories/categories.module": 1227,
	"./pages/CustomerIssueManagementPage/screens/Categories/categories.module.sass": 1227,
	"./pages/CustomerIssueManagementPage/screens/Categories/categories.module.sass.d": 3477,
	"./pages/CustomerIssueManagementPage/screens/Categories/categories.module.sass.d.ts": 3477,
	"./pages/CustomerIssueManagementPage/screens/Categories/components/Categories": 2652,
	"./pages/CustomerIssueManagementPage/screens/Categories/components/Categories.tsx": 2652,
	"./pages/CustomerIssueManagementPage/screens/Categories/components/Category": 2653,
	"./pages/CustomerIssueManagementPage/screens/Categories/components/Category.tsx": 2653,
	"./pages/CustomerIssueManagementPage/screens/ContactCustomerLove/ContactCustomerLove": 1602,
	"./pages/CustomerIssueManagementPage/screens/ContactCustomerLove/ContactCustomerLove.module": 642,
	"./pages/CustomerIssueManagementPage/screens/ContactCustomerLove/ContactCustomerLove.module.sass": 642,
	"./pages/CustomerIssueManagementPage/screens/ContactCustomerLove/ContactCustomerLove.module.sass.d": 3478,
	"./pages/CustomerIssueManagementPage/screens/ContactCustomerLove/ContactCustomerLove.module.sass.d.ts": 3478,
	"./pages/CustomerIssueManagementPage/screens/ContactCustomerLove/ContactCustomerLove.stories": 3479,
	"./pages/CustomerIssueManagementPage/screens/ContactCustomerLove/ContactCustomerLove.stories.tsx": 3479,
	"./pages/CustomerIssueManagementPage/screens/ContactCustomerLove/ContactCustomerLove.tsx": 1602,
	"./pages/CustomerIssueManagementPage/screens/ContactCustomerLove/ContactCustomerLoveDetails": 769,
	"./pages/CustomerIssueManagementPage/screens/ContactCustomerLove/ContactCustomerLoveDetails.tsx": 769,
	"./pages/CustomerIssueManagementPage/screens/Error/Error": 2174,
	"./pages/CustomerIssueManagementPage/screens/Error/Error.module": 2346,
	"./pages/CustomerIssueManagementPage/screens/Error/Error.module.sass": 2346,
	"./pages/CustomerIssueManagementPage/screens/Error/Error.module.sass.d": 3480,
	"./pages/CustomerIssueManagementPage/screens/Error/Error.module.sass.d.ts": 3480,
	"./pages/CustomerIssueManagementPage/screens/Error/Error.stories": 3481,
	"./pages/CustomerIssueManagementPage/screens/Error/Error.stories.tsx": 3481,
	"./pages/CustomerIssueManagementPage/screens/Error/Error.tsx": 2174,
	"./pages/CustomerIssueManagementPage/screens/Inputs/InputsScreen": 2175,
	"./pages/CustomerIssueManagementPage/screens/Inputs/InputsScreen.module": 666,
	"./pages/CustomerIssueManagementPage/screens/Inputs/InputsScreen.module.sass": 666,
	"./pages/CustomerIssueManagementPage/screens/Inputs/InputsScreen.module.sass.d": 3482,
	"./pages/CustomerIssueManagementPage/screens/Inputs/InputsScreen.module.sass.d.ts": 3482,
	"./pages/CustomerIssueManagementPage/screens/Inputs/InputsScreen.stories": 3483,
	"./pages/CustomerIssueManagementPage/screens/Inputs/InputsScreen.stories.tsx": 3483,
	"./pages/CustomerIssueManagementPage/screens/Inputs/InputsScreen.tsx": 2175,
	"./pages/CustomerIssueManagementPage/screens/Inputs/components/Input": 2348,
	"./pages/CustomerIssueManagementPage/screens/Inputs/components/Input.tsx": 2348,
	"./pages/CustomerIssueManagementPage/screens/Inputs/components/InputSection": 2656,
	"./pages/CustomerIssueManagementPage/screens/Inputs/components/InputSection.tsx": 2656,
	"./pages/CustomerIssueManagementPage/screens/Inputs/components/InputSwitch": 2655,
	"./pages/CustomerIssueManagementPage/screens/Inputs/components/InputSwitch.tsx": 2655,
	"./pages/CustomerIssueManagementPage/screens/Inputs/components/display_types/ConfirmationBox": 1850,
	"./pages/CustomerIssueManagementPage/screens/Inputs/components/display_types/ConfirmationBox.tsx": 1850,
	"./pages/CustomerIssueManagementPage/screens/Inputs/components/display_types/Dropdown": 1849,
	"./pages/CustomerIssueManagementPage/screens/Inputs/components/display_types/Dropdown.tsx": 1849,
	"./pages/CustomerIssueManagementPage/screens/Inputs/components/display_types/FreeForm": 2662,
	"./pages/CustomerIssueManagementPage/screens/Inputs/components/display_types/FreeForm.tsx": 2662,
	"./pages/CustomerIssueManagementPage/screens/Inputs/components/display_types/Multiselect": 2665,
	"./pages/CustomerIssueManagementPage/screens/Inputs/components/display_types/Multiselect.tsx": 2665,
	"./pages/CustomerIssueManagementPage/screens/Inputs/components/display_types/MultiselectAndEnumerate": 2664,
	"./pages/CustomerIssueManagementPage/screens/Inputs/components/display_types/MultiselectAndEnumerate.tsx": 2664,
	"./pages/CustomerIssueManagementPage/screens/Inputs/components/display_types/ProductStepper": 2666,
	"./pages/CustomerIssueManagementPage/screens/Inputs/components/display_types/ProductStepper.tsx": 2666,
	"./pages/CustomerIssueManagementPage/screens/Inputs/components/display_types/Stepper": 1851,
	"./pages/CustomerIssueManagementPage/screens/Inputs/components/display_types/Stepper.tsx": 1851,
	"./pages/CustomerIssueManagementPage/screens/Inputs/components/input_types/Association": 2657,
	"./pages/CustomerIssueManagementPage/screens/Inputs/components/input_types/Association.tsx": 2657,
	"./pages/CustomerIssueManagementPage/screens/Inputs/components/input_types/Boolean": 2658,
	"./pages/CustomerIssueManagementPage/screens/Inputs/components/input_types/Boolean.tsx": 2658,
	"./pages/CustomerIssueManagementPage/screens/Inputs/components/input_types/Integer": 2659,
	"./pages/CustomerIssueManagementPage/screens/Inputs/components/input_types/Integer.tsx": 2659,
	"./pages/CustomerIssueManagementPage/screens/Inputs/components/input_types/Multifield": 2663,
	"./pages/CustomerIssueManagementPage/screens/Inputs/components/input_types/Multifield.tsx": 2663,
	"./pages/CustomerIssueManagementPage/screens/Inputs/components/input_types/Reason": 2660,
	"./pages/CustomerIssueManagementPage/screens/Inputs/components/input_types/Reason.tsx": 2660,
	"./pages/CustomerIssueManagementPage/screens/Inputs/components/input_types/String": 2661,
	"./pages/CustomerIssueManagementPage/screens/Inputs/components/input_types/String.tsx": 2661,
	"./pages/CustomerIssueManagementPage/screens/QuickHelp/QuickHelp": 2177,
	"./pages/CustomerIssueManagementPage/screens/QuickHelp/QuickHelp.module": 892,
	"./pages/CustomerIssueManagementPage/screens/QuickHelp/QuickHelp.module.sass": 892,
	"./pages/CustomerIssueManagementPage/screens/QuickHelp/QuickHelp.module.sass.d": 3484,
	"./pages/CustomerIssueManagementPage/screens/QuickHelp/QuickHelp.module.sass.d.ts": 3484,
	"./pages/CustomerIssueManagementPage/screens/QuickHelp/QuickHelp.stories": 3485,
	"./pages/CustomerIssueManagementPage/screens/QuickHelp/QuickHelp.stories.tsx": 3485,
	"./pages/CustomerIssueManagementPage/screens/QuickHelp/QuickHelp.tsx": 2177,
	"./pages/CustomerIssueManagementPage/screens/QuickHelp/components/HelpCentreArticle": 2805,
	"./pages/CustomerIssueManagementPage/screens/QuickHelp/components/HelpCentreArticle.tsx": 2805,
	"./pages/CustomerIssueManagementPage/screens/QuickHelp/components/QuickHelpTypeSwitch": 2667,
	"./pages/CustomerIssueManagementPage/screens/QuickHelp/components/QuickHelpTypeSwitch.tsx": 2667,
	"./pages/CustomerIssueManagementPage/screens/QuickHelp/components/TrackOrder": 2668,
	"./pages/CustomerIssueManagementPage/screens/QuickHelp/components/TrackOrder.tsx": 2668,
	"./pages/CustomerIssueManagementPage/screens/Resolution/Resolution": 2178,
	"./pages/CustomerIssueManagementPage/screens/Resolution/Resolution.module": 1228,
	"./pages/CustomerIssueManagementPage/screens/Resolution/Resolution.module.sass": 1228,
	"./pages/CustomerIssueManagementPage/screens/Resolution/Resolution.module.sass.d": 3486,
	"./pages/CustomerIssueManagementPage/screens/Resolution/Resolution.module.sass.d.ts": 3486,
	"./pages/CustomerIssueManagementPage/screens/Resolution/Resolution.stories": 3487,
	"./pages/CustomerIssueManagementPage/screens/Resolution/Resolution.stories.tsx": 3487,
	"./pages/CustomerIssueManagementPage/screens/Resolution/Resolution.tsx": 2178,
	"./pages/CustomerIssueManagementPage/screens/Resolution/components/ApplyDiscount": 2670,
	"./pages/CustomerIssueManagementPage/screens/Resolution/components/ApplyDiscount.tsx": 2670,
	"./pages/CustomerIssueManagementPage/screens/Resolution/components/ChangeAddressButton": 2672,
	"./pages/CustomerIssueManagementPage/screens/Resolution/components/ChangeAddressButton.tsx": 2672,
	"./pages/CustomerIssueManagementPage/screens/Resolution/components/ChangeDateButton": 2673,
	"./pages/CustomerIssueManagementPage/screens/Resolution/components/ChangeDateButton.tsx": 2673,
	"./pages/CustomerIssueManagementPage/screens/Resolution/components/Replacement": 2671,
	"./pages/CustomerIssueManagementPage/screens/Resolution/components/Replacement.tsx": 2671,
	"./pages/CustomerIssueManagementPage/screens/Resolution/components/ResolutionSwitch": 2669,
	"./pages/CustomerIssueManagementPage/screens/Resolution/components/ResolutionSwitch.tsx": 2669,
	"./pages/CustomerIssueManagementPage/screens/ResolutionConfirmation/ResolutionConfirmation": 2179,
	"./pages/CustomerIssueManagementPage/screens/ResolutionConfirmation/ResolutionConfirmation.module": 843,
	"./pages/CustomerIssueManagementPage/screens/ResolutionConfirmation/ResolutionConfirmation.module.sass": 843,
	"./pages/CustomerIssueManagementPage/screens/ResolutionConfirmation/ResolutionConfirmation.module.sass.d": 3488,
	"./pages/CustomerIssueManagementPage/screens/ResolutionConfirmation/ResolutionConfirmation.module.sass.d.ts": 3488,
	"./pages/CustomerIssueManagementPage/screens/ResolutionConfirmation/ResolutionConfirmation.stories": 3489,
	"./pages/CustomerIssueManagementPage/screens/ResolutionConfirmation/ResolutionConfirmation.stories.tsx": 3489,
	"./pages/CustomerIssueManagementPage/screens/ResolutionConfirmation/ResolutionConfirmation.tsx": 2179,
	"./pages/CustomerIssueManagementPage/screens/ResolutionConfirmation/components/ApplyDiscount": 2675,
	"./pages/CustomerIssueManagementPage/screens/ResolutionConfirmation/components/ApplyDiscount.tsx": 2675,
	"./pages/CustomerIssueManagementPage/screens/ResolutionConfirmation/components/Default": 2676,
	"./pages/CustomerIssueManagementPage/screens/ResolutionConfirmation/components/Default.tsx": 2676,
	"./pages/CustomerIssueManagementPage/screens/ResolutionConfirmation/components/Replacement": 2677,
	"./pages/CustomerIssueManagementPage/screens/ResolutionConfirmation/components/Replacement.tsx": 2677,
	"./pages/CustomerIssueManagementPage/screens/ResolutionConfirmation/components/ResolutionConfirmationBox": 1852,
	"./pages/CustomerIssueManagementPage/screens/ResolutionConfirmation/components/ResolutionConfirmationBox.tsx": 1852,
	"./pages/CustomerIssueManagementPage/screens/ResolutionConfirmation/components/ResolutionConfirmationSwitch": 2674,
	"./pages/CustomerIssueManagementPage/screens/ResolutionConfirmation/components/ResolutionConfirmationSwitch.tsx": 2674,
	"./pages/CustomerIssueManagementPage/types/routes": 235,
	"./pages/CustomerIssueManagementPage/types/routes.ts": 235,
	"./pages/CustomerIssueManagementPage/types/types": 3490,
	"./pages/CustomerIssueManagementPage/types/types.ts": 3490,
	"./pages/Dashboard/Dashboard": 1330,
	"./pages/Dashboard/Dashboard.tsx": 1330,
	"./pages/Dashboard/components/BoxDetailsPriceBreakdown": 1711,
	"./pages/Dashboard/components/BoxDetailsPriceBreakdown/": 1711,
	"./pages/Dashboard/components/BoxDetailsPriceBreakdown/BoxDetailsPriceBreakdown": 1999,
	"./pages/Dashboard/components/BoxDetailsPriceBreakdown/BoxDetailsPriceBreakdown.module": 2313,
	"./pages/Dashboard/components/BoxDetailsPriceBreakdown/BoxDetailsPriceBreakdown.module.sass": 2313,
	"./pages/Dashboard/components/BoxDetailsPriceBreakdown/BoxDetailsPriceBreakdown.module.sass.d": 3491,
	"./pages/Dashboard/components/BoxDetailsPriceBreakdown/BoxDetailsPriceBreakdown.module.sass.d.ts": 3491,
	"./pages/Dashboard/components/BoxDetailsPriceBreakdown/BoxDetailsPriceBreakdown.tsx": 1999,
	"./pages/Dashboard/components/BoxDetailsPriceBreakdown/index": 1711,
	"./pages/Dashboard/components/BoxDetailsPriceBreakdown/index.ts": 1711,
	"./pages/Dashboard/components/BoxDetailsPriceBreakdown/utils": 1653,
	"./pages/Dashboard/components/BoxDetailsPriceBreakdown/utils.ts": 1653,
	"./pages/Dashboard/components/FeedingTipsCard/FeedingTipsCard": 2114,
	"./pages/Dashboard/components/FeedingTipsCard/FeedingTipsCard.module": 1375,
	"./pages/Dashboard/components/FeedingTipsCard/FeedingTipsCard.module.sass": 1375,
	"./pages/Dashboard/components/FeedingTipsCard/FeedingTipsCard.module.sass.d": 3492,
	"./pages/Dashboard/components/FeedingTipsCard/FeedingTipsCard.module.sass.d.ts": 3492,
	"./pages/Dashboard/components/FeedingTipsCard/FeedingTipsCard.tsx": 2114,
	"./pages/Dashboard/components/FeedingTipsCard/__generated__/FeedingTipsQuery": 3493,
	"./pages/Dashboard/components/FeedingTipsCard/__generated__/FeedingTipsQuery.ts": 3493,
	"./pages/Dashboard/components/FeedingTipsCard/queries": 2500,
	"./pages/Dashboard/components/FeedingTipsCard/queries.ts": 2500,
	"./pages/Dashboard/components/FestiveThemeCard/FestiveThemeCard": 2109,
	"./pages/Dashboard/components/FestiveThemeCard/FestiveThemeCard.module": 2315,
	"./pages/Dashboard/components/FestiveThemeCard/FestiveThemeCard.module.sass": 2315,
	"./pages/Dashboard/components/FestiveThemeCard/FestiveThemeCard.module.sass.d": 3494,
	"./pages/Dashboard/components/FestiveThemeCard/FestiveThemeCard.module.sass.d.ts": 3494,
	"./pages/Dashboard/components/FestiveThemeCard/FestiveThemeCard.tsx": 2109,
	"./pages/Dashboard/components/HeroSection/HeroSection": 2495,
	"./pages/Dashboard/components/HeroSection/HeroSection.tsx": 2495,
	"./pages/Dashboard/components/HeroSection/PrimaryActions": 2496,
	"./pages/Dashboard/components/HeroSection/PrimaryActions.tsx": 2496,
	"./pages/Dashboard/components/HomeTourV2/HomeTourV2": 2898,
	"./pages/Dashboard/components/HomeTourV2/HomeTourV2.module": 1393,
	"./pages/Dashboard/components/HomeTourV2/HomeTourV2.module.sass": 1393,
	"./pages/Dashboard/components/HomeTourV2/HomeTourV2.module.sass.d": 3495,
	"./pages/Dashboard/components/HomeTourV2/HomeTourV2.module.sass.d.ts": 3495,
	"./pages/Dashboard/components/HomeTourV2/HomeTourV2.tsx": 2898,
	"./pages/Dashboard/components/NoPaymentMethodSection/NoPaymentMethodSection": 2115,
	"./pages/Dashboard/components/NoPaymentMethodSection/NoPaymentMethodSection.module": 1893,
	"./pages/Dashboard/components/NoPaymentMethodSection/NoPaymentMethodSection.module.sass": 1893,
	"./pages/Dashboard/components/NoPaymentMethodSection/NoPaymentMethodSection.module.sass.d": 3496,
	"./pages/Dashboard/components/NoPaymentMethodSection/NoPaymentMethodSection.module.sass.d.ts": 3496,
	"./pages/Dashboard/components/NoPaymentMethodSection/NoPaymentMethodSection.tsx": 2115,
	"./pages/Dashboard/components/PriceBreakdownWithQuery/PriceBreakdownWithQuery": 2703,
	"./pages/Dashboard/components/PriceBreakdownWithQuery/PriceBreakdownWithQuery.tsx": 2703,
	"./pages/Dashboard/components/SuspendedSection/SuspendedSection": 2116,
	"./pages/Dashboard/components/SuspendedSection/SuspendedSection.module": 1894,
	"./pages/Dashboard/components/SuspendedSection/SuspendedSection.module.sass": 1894,
	"./pages/Dashboard/components/SuspendedSection/SuspendedSection.module.sass.d": 3497,
	"./pages/Dashboard/components/SuspendedSection/SuspendedSection.module.sass.d.ts": 3497,
	"./pages/Dashboard/components/SuspendedSection/SuspendedSection.tsx": 2116,
	"./pages/Dashboard/components/SuspendedSection/__generated__/SuspendedSectionQuery": 3498,
	"./pages/Dashboard/components/SuspendedSection/__generated__/SuspendedSectionQuery.ts": 3498,
	"./pages/Dashboard/components/SuspendedSection/queries": 2501,
	"./pages/Dashboard/components/SuspendedSection/queries.ts": 2501,
	"./pages/Dashboard/components/boxDetails/BoxDetails": 2108,
	"./pages/Dashboard/components/boxDetails/BoxDetails.module": 1249,
	"./pages/Dashboard/components/boxDetails/BoxDetails.module.sass": 1249,
	"./pages/Dashboard/components/boxDetails/BoxDetails.module.sass.d": 3499,
	"./pages/Dashboard/components/boxDetails/BoxDetails.module.sass.d.ts": 3499,
	"./pages/Dashboard/components/boxDetails/BoxDetails.tsx": 2108,
	"./pages/Dashboard/components/boxDetails/fragments/__generated__/BoxOrderFragment": 3500,
	"./pages/Dashboard/components/boxDetails/fragments/__generated__/BoxOrderFragment.ts": 3500,
	"./pages/Dashboard/components/boxDetails/fragments/boxOrderFragment": 2330,
	"./pages/Dashboard/components/boxDetails/fragments/boxOrderFragment.ts": 2330,
	"./pages/Dashboard/components/dashboardCarousel/dashboardcarousel": 2899,
	"./pages/Dashboard/components/dashboardCarousel/dashboardcarousel.module": 2899,
	"./pages/Dashboard/components/dashboardCarousel/dashboardcarousel.module.sass": 2899,
	"./pages/Dashboard/components/sampleProductModal/SampleProductModalWithQuery": 2900,
	"./pages/Dashboard/components/sampleProductModal/SampleProductModalWithQuery.module": 2362,
	"./pages/Dashboard/components/sampleProductModal/SampleProductModalWithQuery.module.sass": 2362,
	"./pages/Dashboard/components/sampleProductModal/SampleProductModalWithQuery.module.sass.d": 3501,
	"./pages/Dashboard/components/sampleProductModal/SampleProductModalWithQuery.module.sass.d.ts": 3501,
	"./pages/Dashboard/components/sampleProductModal/SampleProductModalWithQuery.tsx": 2900,
	"./pages/Dashboard/components/sampleProductModal/__generated__/sampleProductUpsellableQuery": 3502,
	"./pages/Dashboard/components/sampleProductModal/__generated__/sampleProductUpsellableQuery.ts": 3502,
	"./pages/Dashboard/components/sampleProductModal/queries": 2766,
	"./pages/Dashboard/components/sampleProductModal/queries.ts": 2766,
	"./pages/Dashboard/components/upcomingBoxes/UpcomingBoxes": 731,
	"./pages/Dashboard/components/upcomingBoxes/UpcomingBoxes.module": 1890,
	"./pages/Dashboard/components/upcomingBoxes/UpcomingBoxes.module.sass": 1890,
	"./pages/Dashboard/components/upcomingBoxes/UpcomingBoxes.module.sass.d": 3503,
	"./pages/Dashboard/components/upcomingBoxes/UpcomingBoxes.module.sass.d.ts": 3503,
	"./pages/Dashboard/components/upcomingBoxes/UpcomingBoxes.tsx": 731,
	"./pages/Dashboard/components/upcomingBoxes/queries/__generated__/nonCoreUpcomingOrderFragment": 3504,
	"./pages/Dashboard/components/upcomingBoxes/queries/__generated__/nonCoreUpcomingOrderFragment.ts": 3504,
	"./pages/Dashboard/components/upcomingBoxes/queries/__generated__/upcomingBoxOrderFragment": 3505,
	"./pages/Dashboard/components/upcomingBoxes/queries/__generated__/upcomingBoxOrderFragment.ts": 3505,
	"./pages/Dashboard/components/upcomingBoxes/queries/__generated__/upcomingBoxQuery": 3506,
	"./pages/Dashboard/components/upcomingBoxes/queries/__generated__/upcomingBoxQuery.ts": 3506,
	"./pages/Dashboard/components/upcomingBoxes/queries/fragments": 743,
	"./pages/Dashboard/components/upcomingBoxes/queries/fragments.ts": 743,
	"./pages/Dashboard/components/upcomingBoxes/queries/queries": 2494,
	"./pages/Dashboard/components/upcomingBoxes/queries/queries.ts": 2494,
	"./pages/Dashboard/components/upcomingBoxes/utilities": 2314,
	"./pages/Dashboard/components/upcomingBoxes/utilities.ts": 2314,
	"./pages/Dashboard/petCare/PetCareSection": 2452,
	"./pages/Dashboard/petCare/PetCareSection/": 2452,
	"./pages/Dashboard/petCare/PetCareSection/PetCareSection": 2078,
	"./pages/Dashboard/petCare/PetCareSection/PetCareSection.module": 1174,
	"./pages/Dashboard/petCare/PetCareSection/PetCareSection.module.sass": 1174,
	"./pages/Dashboard/petCare/PetCareSection/PetCareSection.module.sass.d": 3507,
	"./pages/Dashboard/petCare/PetCareSection/PetCareSection.module.sass.d.ts": 3507,
	"./pages/Dashboard/petCare/PetCareSection/PetCareSection.tsx": 2078,
	"./pages/Dashboard/petCare/PetCareSection/components/DogAvatarImage": 2453,
	"./pages/Dashboard/petCare/PetCareSection/components/DogAvatarImage/": 2453,
	"./pages/Dashboard/petCare/PetCareSection/components/DogAvatarImage/DogAvatarImage": 2079,
	"./pages/Dashboard/petCare/PetCareSection/components/DogAvatarImage/DogAvatarImage.module": 2363,
	"./pages/Dashboard/petCare/PetCareSection/components/DogAvatarImage/DogAvatarImage.module.sass": 2363,
	"./pages/Dashboard/petCare/PetCareSection/components/DogAvatarImage/DogAvatarImage.module.sass.d": 3508,
	"./pages/Dashboard/petCare/PetCareSection/components/DogAvatarImage/DogAvatarImage.module.sass.d.ts": 3508,
	"./pages/Dashboard/petCare/PetCareSection/components/DogAvatarImage/DogAvatarImage.tsx": 2079,
	"./pages/Dashboard/petCare/PetCareSection/components/DogAvatarImage/index": 2453,
	"./pages/Dashboard/petCare/PetCareSection/components/DogAvatarImage/index.ts": 2453,
	"./pages/Dashboard/petCare/PetCareSection/fragments/__generated__/PetCareSectionDogsFragment": 3509,
	"./pages/Dashboard/petCare/PetCareSection/fragments/__generated__/PetCareSectionDogsFragment.ts": 3509,
	"./pages/Dashboard/petCare/PetCareSection/fragments/petCareSectionFragment": 3510,
	"./pages/Dashboard/petCare/PetCareSection/fragments/petCareSectionFragment.ts": 3510,
	"./pages/Dashboard/petCare/PetCareSection/index": 2452,
	"./pages/Dashboard/petCare/PetCareSection/index.ts": 2452,
	"./pages/Dashboard/queries/dashboardQuery": 3511,
	"./pages/Dashboard/queries/dashboardQuery.ts": 3511,
	"./pages/DashboardV3/DashboardV3": 1626,
	"./pages/DashboardV3/DashboardV3.tsx": 1626,
	"./pages/DashboardV3/components/BoxDetailsV3/AddMore/AddMore": 2119,
	"./pages/DashboardV3/components/BoxDetailsV3/AddMore/AddMore.module": 2504,
	"./pages/DashboardV3/components/BoxDetailsV3/AddMore/AddMore.module.sass": 2504,
	"./pages/DashboardV3/components/BoxDetailsV3/AddMore/AddMore.module.sass.d": 3512,
	"./pages/DashboardV3/components/BoxDetailsV3/AddMore/AddMore.module.sass.d.ts": 3512,
	"./pages/DashboardV3/components/BoxDetailsV3/AddMore/AddMore.tsx": 2119,
	"./pages/DashboardV3/components/BoxDetailsV3/BoxActionButtons/BoxActionButtons": 2120,
	"./pages/DashboardV3/components/BoxDetailsV3/BoxActionButtons/BoxActionButtons.module": 2505,
	"./pages/DashboardV3/components/BoxDetailsV3/BoxActionButtons/BoxActionButtons.module.sass": 2505,
	"./pages/DashboardV3/components/BoxDetailsV3/BoxActionButtons/BoxActionButtons.module.sass.d": 3513,
	"./pages/DashboardV3/components/BoxDetailsV3/BoxActionButtons/BoxActionButtons.module.sass.d.ts": 3513,
	"./pages/DashboardV3/components/BoxDetailsV3/BoxActionButtons/BoxActionButtons.tsx": 2120,
	"./pages/DashboardV3/components/BoxDetailsV3/BoxActionButtons/InvoiceCard/InvoiceCard": 2121,
	"./pages/DashboardV3/components/BoxDetailsV3/BoxActionButtons/InvoiceCard/InvoiceCard.module": 1379,
	"./pages/DashboardV3/components/BoxDetailsV3/BoxActionButtons/InvoiceCard/InvoiceCard.module.sass": 1379,
	"./pages/DashboardV3/components/BoxDetailsV3/BoxActionButtons/InvoiceCard/InvoiceCard.module.sass.d": 3514,
	"./pages/DashboardV3/components/BoxDetailsV3/BoxActionButtons/InvoiceCard/InvoiceCard.module.sass.d.ts": 3514,
	"./pages/DashboardV3/components/BoxDetailsV3/BoxActionButtons/InvoiceCard/InvoiceCard.tsx": 2121,
	"./pages/DashboardV3/components/BoxDetailsV3/BoxDetailsV3": 2117,
	"./pages/DashboardV3/components/BoxDetailsV3/BoxDetailsV3.module": 1251,
	"./pages/DashboardV3/components/BoxDetailsV3/BoxDetailsV3.module.sass": 1251,
	"./pages/DashboardV3/components/BoxDetailsV3/BoxDetailsV3.module.sass.d": 3515,
	"./pages/DashboardV3/components/BoxDetailsV3/BoxDetailsV3.module.sass.d.ts": 3515,
	"./pages/DashboardV3/components/BoxDetailsV3/BoxDetailsV3.tsx": 2117,
	"./pages/DashboardV3/components/BoxDetailsV3/fragments/__generated__/BoxOrderFragmentV3": 3516,
	"./pages/DashboardV3/components/BoxDetailsV3/fragments/__generated__/BoxOrderFragmentV3.ts": 3516,
	"./pages/DashboardV3/components/BoxDetailsV3/fragments/boxDetailsV3Fragment": 3517,
	"./pages/DashboardV3/components/BoxDetailsV3/fragments/boxDetailsV3Fragment.ts": 3517,
	"./pages/DashboardV3/components/BoxDetailsV3/fragments/boxOrderFragment": 3518,
	"./pages/DashboardV3/components/BoxDetailsV3/fragments/boxOrderFragment.ts": 3518,
	"./pages/DashboardV3/components/DeliveryAddress/DeliveryAddress": 2118,
	"./pages/DashboardV3/components/DeliveryAddress/DeliveryAddress.module": 3519,
	"./pages/DashboardV3/components/DeliveryAddress/DeliveryAddress.module.sass": 3519,
	"./pages/DashboardV3/components/DeliveryAddress/DeliveryAddress.module.sass.d": 3520,
	"./pages/DashboardV3/components/DeliveryAddress/DeliveryAddress.module.sass.d.ts": 3520,
	"./pages/DashboardV3/components/DeliveryAddress/DeliveryAddress.tsx": 2118,
	"./pages/DashboardV3/components/EditDeliveryAddress/EditDeliveryAddress": 2122,
	"./pages/DashboardV3/components/EditDeliveryAddress/EditDeliveryAddress.module": 2322,
	"./pages/DashboardV3/components/EditDeliveryAddress/EditDeliveryAddress.module.sass": 2322,
	"./pages/DashboardV3/components/EditDeliveryAddress/EditDeliveryAddress.module.sass.d": 3521,
	"./pages/DashboardV3/components/EditDeliveryAddress/EditDeliveryAddress.module.sass.d.ts": 3521,
	"./pages/DashboardV3/components/EditDeliveryAddress/EditDeliveryAddress.tsx": 2122,
	"./pages/DashboardV3/components/EditDeliveryAddress/mutations/__generated__/UpdateBoxDeliveryAddressV3": 3522,
	"./pages/DashboardV3/components/EditDeliveryAddress/mutations/__generated__/UpdateBoxDeliveryAddressV3.ts": 3522,
	"./pages/DashboardV3/components/EditDeliveryAddress/mutations/__generated__/UpdateDeliveryAddress": 3523,
	"./pages/DashboardV3/components/EditDeliveryAddress/mutations/__generated__/UpdateDeliveryAddress.ts": 3523,
	"./pages/DashboardV3/components/EditDeliveryAddress/mutations/updateDeliveryAddress": 2508,
	"./pages/DashboardV3/components/EditDeliveryAddress/mutations/updateDeliveryAddress.ts": 2508,
	"./pages/DashboardV3/components/EditDeliveryAddress/queries/__generated__/editBoxDeliveryAddressV3Query": 3524,
	"./pages/DashboardV3/components/EditDeliveryAddress/queries/__generated__/editBoxDeliveryAddressV3Query.ts": 3524,
	"./pages/DashboardV3/components/EditDeliveryAddress/queries/editBoxDeliveryAddressQuery": 2509,
	"./pages/DashboardV3/components/EditDeliveryAddress/queries/editBoxDeliveryAddressQuery.ts": 2509,
	"./pages/DashboardV3/components/UpcomingBoxesV3/UpcomingBoxesV3": 1587,
	"./pages/DashboardV3/components/UpcomingBoxesV3/UpcomingBoxesV3.module": 1907,
	"./pages/DashboardV3/components/UpcomingBoxesV3/UpcomingBoxesV3.module.sass": 1907,
	"./pages/DashboardV3/components/UpcomingBoxesV3/UpcomingBoxesV3.module.sass.d": 3525,
	"./pages/DashboardV3/components/UpcomingBoxesV3/UpcomingBoxesV3.module.sass.d.ts": 3525,
	"./pages/DashboardV3/components/UpcomingBoxesV3/UpcomingBoxesV3.tsx": 1587,
	"./pages/DashboardV3/components/UpcomingBoxesV3/queries/__generated__/fetchMoreOrdersQuery": 3526,
	"./pages/DashboardV3/components/UpcomingBoxesV3/queries/__generated__/fetchMoreOrdersQuery.ts": 3526,
	"./pages/DashboardV3/components/UpcomingBoxesV3/queries/__generated__/nonCoreUpcomingOrderFragmentV3": 3527,
	"./pages/DashboardV3/components/UpcomingBoxesV3/queries/__generated__/nonCoreUpcomingOrderFragmentV3.ts": 3527,
	"./pages/DashboardV3/components/UpcomingBoxesV3/queries/__generated__/upcomingBoxOrderFragmentV3": 3528,
	"./pages/DashboardV3/components/UpcomingBoxesV3/queries/__generated__/upcomingBoxOrderFragmentV3.ts": 3528,
	"./pages/DashboardV3/components/UpcomingBoxesV3/queries/__generated__/upcomingBoxQueryV3": 3529,
	"./pages/DashboardV3/components/UpcomingBoxesV3/queries/__generated__/upcomingBoxQueryV3.ts": 3529,
	"./pages/DashboardV3/components/UpcomingBoxesV3/queries/fragments": 1655,
	"./pages/DashboardV3/components/UpcomingBoxesV3/queries/fragments.ts": 1655,
	"./pages/DashboardV3/components/UpcomingBoxesV3/queries/queries": 2321,
	"./pages/DashboardV3/components/UpcomingBoxesV3/queries/queries.ts": 2321,
	"./pages/DashboardV3/components/UpcomingBoxesV3/utilities": 2320,
	"./pages/DashboardV3/components/UpcomingBoxesV3/utilities.ts": 2320,
	"./pages/DashboardV3/queries/dashboardQuery": 2506,
	"./pages/DashboardV3/queries/dashboardQuery.ts": 2506,
	"./pages/DeliveryFrequencyPage/DeliveryFrequencyPage": 2123,
	"./pages/DeliveryFrequencyPage/DeliveryFrequencyPage.module": 1252,
	"./pages/DeliveryFrequencyPage/DeliveryFrequencyPage.module.sass": 1252,
	"./pages/DeliveryFrequencyPage/DeliveryFrequencyPage.module.sass.d": 3530,
	"./pages/DeliveryFrequencyPage/DeliveryFrequencyPage.module.sass.d.ts": 3530,
	"./pages/DeliveryFrequencyPage/DeliveryFrequencyPage.tsx": 2123,
	"./pages/DirectSalesPayOnOwnDevicePage/Analytics/Analytics": 1231,
	"./pages/DirectSalesPayOnOwnDevicePage/Analytics/Analytics.ts": 1231,
	"./pages/DirectSalesPayOnOwnDevicePage/PayOnOwnDevicePage": 692,
	"./pages/DirectSalesPayOnOwnDevicePage/PayOnOwnDevicePage.module": 2783,
	"./pages/DirectSalesPayOnOwnDevicePage/PayOnOwnDevicePage.module.sass": 2783,
	"./pages/DirectSalesPayOnOwnDevicePage/PayOnOwnDevicePage.module.sass.d": 3531,
	"./pages/DirectSalesPayOnOwnDevicePage/PayOnOwnDevicePage.module.sass.d.ts": 3531,
	"./pages/DirectSalesPayOnOwnDevicePage/PayOnOwnDevicePage.tsx": 692,
	"./pages/DirectSalesPayOnOwnDevicePage/components/Banner/Banner": 524,
	"./pages/DirectSalesPayOnOwnDevicePage/components/Banner/Banner.module": 2767,
	"./pages/DirectSalesPayOnOwnDevicePage/components/Banner/Banner.module.sass": 2767,
	"./pages/DirectSalesPayOnOwnDevicePage/components/Banner/Banner.module.sass.d": 3532,
	"./pages/DirectSalesPayOnOwnDevicePage/components/Banner/Banner.module.sass.d.ts": 3532,
	"./pages/DirectSalesPayOnOwnDevicePage/components/Banner/Banner.tsx": 524,
	"./pages/DirectSalesPayOnOwnDevicePage/components/CompletionComponents/AccountManagement/AccountManagement": 2218,
	"./pages/DirectSalesPayOnOwnDevicePage/components/CompletionComponents/AccountManagement/AccountManagement.module": 2367,
	"./pages/DirectSalesPayOnOwnDevicePage/components/CompletionComponents/AccountManagement/AccountManagement.module.sass": 2367,
	"./pages/DirectSalesPayOnOwnDevicePage/components/CompletionComponents/AccountManagement/AccountManagement.module.sass.d": 3533,
	"./pages/DirectSalesPayOnOwnDevicePage/components/CompletionComponents/AccountManagement/AccountManagement.module.sass.d.ts": 3533,
	"./pages/DirectSalesPayOnOwnDevicePage/components/CompletionComponents/AccountManagement/AccountManagement.tsx": 2218,
	"./pages/DirectSalesPayOnOwnDevicePage/components/CompletionComponents/AppSMSComponent/AppSMSComponent": 2221,
	"./pages/DirectSalesPayOnOwnDevicePage/components/CompletionComponents/AppSMSComponent/AppSMSComponent.module": 1677,
	"./pages/DirectSalesPayOnOwnDevicePage/components/CompletionComponents/AppSMSComponent/AppSMSComponent.module.sass": 1677,
	"./pages/DirectSalesPayOnOwnDevicePage/components/CompletionComponents/AppSMSComponent/AppSMSComponent.module.sass.d": 3534,
	"./pages/DirectSalesPayOnOwnDevicePage/components/CompletionComponents/AppSMSComponent/AppSMSComponent.module.sass.d.ts": 3534,
	"./pages/DirectSalesPayOnOwnDevicePage/components/CompletionComponents/AppSMSComponent/AppSMSComponent.tsx": 2221,
	"./pages/DirectSalesPayOnOwnDevicePage/components/CompletionComponents/RafSMSComponent/RAFSMSComponent": 2222,
	"./pages/DirectSalesPayOnOwnDevicePage/components/CompletionComponents/RafSMSComponent/RAFSMSComponent.module": 1678,
	"./pages/DirectSalesPayOnOwnDevicePage/components/CompletionComponents/RafSMSComponent/RAFSMSComponent.module.sass": 1678,
	"./pages/DirectSalesPayOnOwnDevicePage/components/CompletionComponents/RafSMSComponent/RAFSMSComponent.module.sass.d": 3535,
	"./pages/DirectSalesPayOnOwnDevicePage/components/CompletionComponents/RafSMSComponent/RAFSMSComponent.module.sass.d.ts": 3535,
	"./pages/DirectSalesPayOnOwnDevicePage/components/CompletionComponents/RafSMSComponent/RAFSMSComponent.tsx": 2222,
	"./pages/DirectSalesPayOnOwnDevicePage/components/Disclaimer/PlaceMyOrderDisclaimer": 2220,
	"./pages/DirectSalesPayOnOwnDevicePage/components/Disclaimer/PlaceMyOrderDisclaimer.module": 2364,
	"./pages/DirectSalesPayOnOwnDevicePage/components/Disclaimer/PlaceMyOrderDisclaimer.module.sass": 2364,
	"./pages/DirectSalesPayOnOwnDevicePage/components/Disclaimer/PlaceMyOrderDisclaimer.module.sass.d": 3536,
	"./pages/DirectSalesPayOnOwnDevicePage/components/Disclaimer/PlaceMyOrderDisclaimer.module.sass.d.ts": 3536,
	"./pages/DirectSalesPayOnOwnDevicePage/components/Disclaimer/PlaceMyOrderDisclaimer.tsx": 2220,
	"./pages/DirectSalesPayOnOwnDevicePage/components/DsAppOrderSummary/DsAppOrderSummary": 693,
	"./pages/DirectSalesPayOnOwnDevicePage/components/DsAppOrderSummary/DsAppOrderSummary.module": 307,
	"./pages/DirectSalesPayOnOwnDevicePage/components/DsAppOrderSummary/DsAppOrderSummary.module.sass": 307,
	"./pages/DirectSalesPayOnOwnDevicePage/components/DsAppOrderSummary/DsAppOrderSummary.module.sass.d": 3537,
	"./pages/DirectSalesPayOnOwnDevicePage/components/DsAppOrderSummary/DsAppOrderSummary.module.sass.d.ts": 3537,
	"./pages/DirectSalesPayOnOwnDevicePage/components/DsAppOrderSummary/DsAppOrderSummary.tsx": 693,
	"./pages/DirectSalesPayOnOwnDevicePage/components/PaymentComponents/PayPal": 2768,
	"./pages/DirectSalesPayOnOwnDevicePage/components/PaymentComponents/PayPal.tsx": 2768,
	"./pages/DirectSalesPayOnOwnDevicePage/components/PaymentComponents/PaymentComponents": 2224,
	"./pages/DirectSalesPayOnOwnDevicePage/components/PaymentComponents/PaymentComponents.module": 2224,
	"./pages/DirectSalesPayOnOwnDevicePage/components/PaymentComponents/PaymentComponents.module.sass": 2224,
	"./pages/DirectSalesPayOnOwnDevicePage/components/PaymentComponents/PaymentComponents.module.sass.d": 3538,
	"./pages/DirectSalesPayOnOwnDevicePage/components/PaymentComponents/PaymentComponents.module.sass.d.ts": 3538,
	"./pages/DirectSalesPayOnOwnDevicePage/components/PaymentComponents/PaymentElements": 2770,
	"./pages/DirectSalesPayOnOwnDevicePage/components/PaymentComponents/PaymentElements.tsx": 2770,
	"./pages/DirectSalesPayOnOwnDevicePage/components/PaymentComponents/PaymentRequestOption": 3539,
	"./pages/DirectSalesPayOnOwnDevicePage/components/PaymentComponents/PaymentRequestOption.tsx": 3539,
	"./pages/DirectSalesPayOnOwnDevicePage/components/PaymentOptions/PaymentOptions": 2219,
	"./pages/DirectSalesPayOnOwnDevicePage/components/PaymentOptions/PaymentOptions.module": 1372,
	"./pages/DirectSalesPayOnOwnDevicePage/components/PaymentOptions/PaymentOptions.module.sass": 1372,
	"./pages/DirectSalesPayOnOwnDevicePage/components/PaymentOptions/PaymentOptions.module.sass.d": 3540,
	"./pages/DirectSalesPayOnOwnDevicePage/components/PaymentOptions/PaymentOptions.module.sass.d.ts": 3540,
	"./pages/DirectSalesPayOnOwnDevicePage/components/PaymentOptions/PaymentOptions.tsx": 2219,
	"./pages/DirectSalesPayOnOwnDevicePage/components/PaymentOptions/paymentMethodsAvaliable": 2782,
	"./pages/DirectSalesPayOnOwnDevicePage/components/PaymentOptions/paymentMethodsAvaliable.ts": 2782,
	"./pages/DirectSalesPayOnOwnDevicePage/helpers/buiildSubscriptionData": 694,
	"./pages/DirectSalesPayOnOwnDevicePage/helpers/buiildSubscriptionData.ts": 694,
	"./pages/DirectSalesPayOnOwnDevicePage/helpers/buiildSubscriptionInputDataForStripeSetupIntent": 2771,
	"./pages/DirectSalesPayOnOwnDevicePage/helpers/buiildSubscriptionInputDataForStripeSetupIntent.ts": 2771,
	"./pages/DirectSalesPayOnOwnDevicePage/helpers/buildDogPricing": 3541,
	"./pages/DirectSalesPayOnOwnDevicePage/helpers/buildDogPricing.ts": 3541,
	"./pages/DirectSalesPayOnOwnDevicePage/helpers/errors": 2772,
	"./pages/DirectSalesPayOnOwnDevicePage/helpers/errors.ts": 2772,
	"./pages/DirectSalesPayOnOwnDevicePage/helpers/inputs": 640,
	"./pages/DirectSalesPayOnOwnDevicePage/helpers/inputs.ts": 640,
	"./pages/DirectSalesPayOnOwnDevicePage/hooks/paypal/buySubscriptionWithPayPal": 2365,
	"./pages/DirectSalesPayOnOwnDevicePage/hooks/paypal/buySubscriptionWithPayPal.ts": 2365,
	"./pages/DirectSalesPayOnOwnDevicePage/hooks/paypal/getPaypalPaymentAuthorisation": 2769,
	"./pages/DirectSalesPayOnOwnDevicePage/hooks/paypal/getPaypalPaymentAuthorisation.ts": 2769,
	"./pages/DirectSalesPayOnOwnDevicePage/hooks/paypal/useBuySubscriptionWithPayPal": 1676,
	"./pages/DirectSalesPayOnOwnDevicePage/hooks/paypal/useBuySubscriptionWithPayPal.ts": 1676,
	"./pages/DirectSalesPayOnOwnDevicePage/hooks/stripe/apple_and_google_pay/buySubscriptionWithPaymentRequest": 2773,
	"./pages/DirectSalesPayOnOwnDevicePage/hooks/stripe/apple_and_google_pay/buySubscriptionWithPaymentRequest.ts": 2773,
	"./pages/DirectSalesPayOnOwnDevicePage/hooks/stripe/apple_and_google_pay/chargeBoxOnePaymentRequest": 2774,
	"./pages/DirectSalesPayOnOwnDevicePage/hooks/stripe/apple_and_google_pay/chargeBoxOnePaymentRequest.ts": 2774,
	"./pages/DirectSalesPayOnOwnDevicePage/hooks/stripe/apple_and_google_pay/paymentMethodFromWalletName": 1868,
	"./pages/DirectSalesPayOnOwnDevicePage/hooks/stripe/apple_and_google_pay/paymentMethodFromWalletName.ts": 1868,
	"./pages/DirectSalesPayOnOwnDevicePage/hooks/stripe/apple_and_google_pay/paymentRequestDisplayItems": 2775,
	"./pages/DirectSalesPayOnOwnDevicePage/hooks/stripe/apple_and_google_pay/paymentRequestDisplayItems.ts": 2775,
	"./pages/DirectSalesPayOnOwnDevicePage/hooks/stripe/apple_and_google_pay/useBuySubscriptionWithPaymentRequest": 1867,
	"./pages/DirectSalesPayOnOwnDevicePage/hooks/stripe/apple_and_google_pay/useBuySubscriptionWithPaymentRequest.ts": 1867,
	"./pages/DirectSalesPayOnOwnDevicePage/hooks/stripe/payment_elements/buySubscriptionWithPaymentElements": 2776,
	"./pages/DirectSalesPayOnOwnDevicePage/hooks/stripe/payment_elements/buySubscriptionWithPaymentElements.ts": 2776,
	"./pages/DirectSalesPayOnOwnDevicePage/hooks/stripe/payment_elements/chargeStripeBoxOne": 2777,
	"./pages/DirectSalesPayOnOwnDevicePage/hooks/stripe/payment_elements/chargeStripeBoxOne.ts": 2777,
	"./pages/DirectSalesPayOnOwnDevicePage/hooks/stripe/sepa_direct_debit/buySubscriptionWithSepaDirectDebit": 1869,
	"./pages/DirectSalesPayOnOwnDevicePage/hooks/stripe/sepa_direct_debit/buySubscriptionWithSepaDirectDebit.ts": 1869,
	"./pages/DirectSalesPayOnOwnDevicePage/hooks/stripe/sepa_direct_debit/chargeBoxOneBancontact": 2779,
	"./pages/DirectSalesPayOnOwnDevicePage/hooks/stripe/sepa_direct_debit/chargeBoxOneBancontact.ts": 2779,
	"./pages/DirectSalesPayOnOwnDevicePage/hooks/stripe/sepa_direct_debit/chargeBoxOneIdeal": 2781,
	"./pages/DirectSalesPayOnOwnDevicePage/hooks/stripe/sepa_direct_debit/chargeBoxOneIdeal.ts": 2781,
	"./pages/DirectSalesPayOnOwnDevicePage/hooks/stripe/sepa_direct_debit/useBuySubscriptionWithBancontact": 2778,
	"./pages/DirectSalesPayOnOwnDevicePage/hooks/stripe/sepa_direct_debit/useBuySubscriptionWithBancontact.ts": 2778,
	"./pages/DirectSalesPayOnOwnDevicePage/hooks/stripe/sepa_direct_debit/useBuySubscriptionWithIdeal": 2780,
	"./pages/DirectSalesPayOnOwnDevicePage/hooks/stripe/sepa_direct_debit/useBuySubscriptionWithIdeal.ts": 2780,
	"./pages/DirectSalesPayOnOwnDevicePage/hooks/stripe/sharedStripeMutationMethods": 662,
	"./pages/DirectSalesPayOnOwnDevicePage/hooks/stripe/sharedStripeMutationMethods.ts": 662,
	"./pages/DirectSalesPayOnOwnDevicePage/hooks/submitSubscription": 935,
	"./pages/DirectSalesPayOnOwnDevicePage/hooks/submitSubscription.ts": 935,
	"./pages/DirectSalesPayOnOwnDevicePage/mutations/__generated__/DirectSalesAppSubscriptionCreate": 3542,
	"./pages/DirectSalesPayOnOwnDevicePage/mutations/__generated__/DirectSalesAppSubscriptionCreate.ts": 3542,
	"./pages/DirectSalesPayOnOwnDevicePage/mutations/__generated__/DirectSalesChargeIdFromPaymentIntentId": 3543,
	"./pages/DirectSalesPayOnOwnDevicePage/mutations/__generated__/DirectSalesChargeIdFromPaymentIntentId.ts": 3543,
	"./pages/DirectSalesPayOnOwnDevicePage/mutations/__generated__/DirectSalesStripeCustomerCreate": 3544,
	"./pages/DirectSalesPayOnOwnDevicePage/mutations/__generated__/DirectSalesStripeCustomerCreate.ts": 3544,
	"./pages/DirectSalesPayOnOwnDevicePage/mutations/__generated__/SendAppSMS": 3545,
	"./pages/DirectSalesPayOnOwnDevicePage/mutations/__generated__/SendAppSMS.ts": 3545,
	"./pages/DirectSalesPayOnOwnDevicePage/mutations/__generated__/SendRafSMS": 3546,
	"./pages/DirectSalesPayOnOwnDevicePage/mutations/__generated__/SendRafSMS.ts": 3546,
	"./pages/DirectSalesPayOnOwnDevicePage/mutations/__generated__/directSalesStripeUserParamsSetupIntentCreate": 3547,
	"./pages/DirectSalesPayOnOwnDevicePage/mutations/__generated__/directSalesStripeUserParamsSetupIntentCreate.ts": 3547,
	"./pages/DirectSalesPayOnOwnDevicePage/mutations/mutations": 1074,
	"./pages/DirectSalesPayOnOwnDevicePage/mutations/mutations.ts": 1074,
	"./pages/DirectSalesPayOnOwnDevicePage/queries/__generated__/DirectSalesChargeIdFromPaymentIntentId": 3548,
	"./pages/DirectSalesPayOnOwnDevicePage/queries/__generated__/DirectSalesChargeIdFromPaymentIntentId.ts": 3548,
	"./pages/DirectSalesPayOnOwnDevicePage/queries/__generated__/DirectSalesPaymentQuery": 3549,
	"./pages/DirectSalesPayOnOwnDevicePage/queries/__generated__/DirectSalesPaymentQuery.ts": 3549,
	"./pages/DirectSalesPayOnOwnDevicePage/queries/__generated__/DirectSalesPendingSubscriptionOrderPrices": 3550,
	"./pages/DirectSalesPayOnOwnDevicePage/queries/__generated__/DirectSalesPendingSubscriptionOrderPrices.ts": 3550,
	"./pages/DirectSalesPayOnOwnDevicePage/queries/__generated__/DirectSalesSepaPaymentMethodIdFromIntentSecret": 3551,
	"./pages/DirectSalesPayOnOwnDevicePage/queries/__generated__/DirectSalesSepaPaymentMethodIdFromIntentSecret.ts": 3551,
	"./pages/DirectSalesPayOnOwnDevicePage/queries/__generated__/RetrieveRafUrl": 3552,
	"./pages/DirectSalesPayOnOwnDevicePage/queries/__generated__/RetrieveRafUrl.ts": 3552,
	"./pages/DirectSalesPayOnOwnDevicePage/queries/directSalesPaymentQuery": 1358,
	"./pages/DirectSalesPayOnOwnDevicePage/queries/directSalesPaymentQuery.ts": 1358,
	"./pages/DirectSalesPayOnOwnDevicePage/routes": 2454,
	"./pages/DirectSalesPayOnOwnDevicePage/routes/": 2454,
	"./pages/DirectSalesPayOnOwnDevicePage/routes/RouterWrapper": 921,
	"./pages/DirectSalesPayOnOwnDevicePage/routes/RouterWrapper.tsx": 921,
	"./pages/DirectSalesPayOnOwnDevicePage/routes/index": 2454,
	"./pages/DirectSalesPayOnOwnDevicePage/routes/index.ts": 2454,
	"./pages/DirectSalesPayOnOwnDevicePage/screens/CompleteScreen/CompleteScreen": 2217,
	"./pages/DirectSalesPayOnOwnDevicePage/screens/CompleteScreen/CompleteScreen.module": 1679,
	"./pages/DirectSalesPayOnOwnDevicePage/screens/CompleteScreen/CompleteScreen.module.sass": 1679,
	"./pages/DirectSalesPayOnOwnDevicePage/screens/CompleteScreen/CompleteScreen.module.sass.d": 3553,
	"./pages/DirectSalesPayOnOwnDevicePage/screens/CompleteScreen/CompleteScreen.module.sass.d.ts": 3553,
	"./pages/DirectSalesPayOnOwnDevicePage/screens/CompleteScreen/CompleteScreen.tsx": 2217,
	"./pages/DirectSalesPayOnOwnDevicePage/screens/PaymentScreen/PaymentScreen": 355,
	"./pages/DirectSalesPayOnOwnDevicePage/screens/PaymentScreen/PaymentScreen.module": 2366,
	"./pages/DirectSalesPayOnOwnDevicePage/screens/PaymentScreen/PaymentScreen.module.sass": 2366,
	"./pages/DirectSalesPayOnOwnDevicePage/screens/PaymentScreen/PaymentScreen.module.sass.d": 3554,
	"./pages/DirectSalesPayOnOwnDevicePage/screens/PaymentScreen/PaymentScreen.module.sass.d.ts": 3554,
	"./pages/DirectSalesPayOnOwnDevicePage/screens/PaymentScreen/PaymentScreen.tsx": 355,
	"./pages/DirectSalesPayOnOwnDevicePage/screens/Summary/SummaryScreen": 2223,
	"./pages/DirectSalesPayOnOwnDevicePage/screens/Summary/SummaryScreen.module": 2368,
	"./pages/DirectSalesPayOnOwnDevicePage/screens/Summary/SummaryScreen.module.sass": 2368,
	"./pages/DirectSalesPayOnOwnDevicePage/screens/Summary/SummaryScreen.module.sass.d": 3555,
	"./pages/DirectSalesPayOnOwnDevicePage/screens/Summary/SummaryScreen.module.sass.d.ts": 3555,
	"./pages/DirectSalesPayOnOwnDevicePage/screens/Summary/SummaryScreen.tsx": 2223,
	"./pages/DirectSalesPayOnOwnDevicePage/types": 3556,
	"./pages/DirectSalesPayOnOwnDevicePage/types.ts": 3556,
	"./pages/DixaMessengerWebviewPage/DixaMessengerWebviewPage": 3557,
	"./pages/DixaMessengerWebviewPage/DixaMessengerWebviewPage.tsx": 3557,
	"./pages/DixaMessengerWebviewPage/dixamessengerwebview": 1870,
	"./pages/DixaMessengerWebviewPage/dixamessengerwebview.module": 1870,
	"./pages/DixaMessengerWebviewPage/dixamessengerwebview.module.sass": 1870,
	"./pages/DixaMessengerWebviewPage/dixamessengerwebview.module.sass.d": 3558,
	"./pages/DixaMessengerWebviewPage/dixamessengerwebview.module.sass.d.ts": 3558,
	"./pages/DogProfile": 1722,
	"./pages/DogProfile/": 1722,
	"./pages/DogProfile/DogProfile": 2408,
	"./pages/DogProfile/DogProfile.tsx": 2408,
	"./pages/DogProfile/DogProfileContent": 2124,
	"./pages/DogProfile/DogProfileContent.module": 1239,
	"./pages/DogProfile/DogProfileContent.module.sass": 1239,
	"./pages/DogProfile/DogProfileContent.module.sass.d": 3559,
	"./pages/DogProfile/DogProfileContent.module.sass.d.ts": 3559,
	"./pages/DogProfile/DogProfileContent.tsx": 2124,
	"./pages/DogProfile/components/ArchiveDogProfileAction": 1301,
	"./pages/DogProfile/components/ArchiveDogProfileAction/": 1301,
	"./pages/DogProfile/components/ArchiveDogProfileAction/ArchiveDogProfileAction": 2008,
	"./pages/DogProfile/components/ArchiveDogProfileAction/ArchiveDogProfileAction.module": 1367,
	"./pages/DogProfile/components/ArchiveDogProfileAction/ArchiveDogProfileAction.module.sass": 1367,
	"./pages/DogProfile/components/ArchiveDogProfileAction/ArchiveDogProfileAction.module.sass.d": 3560,
	"./pages/DogProfile/components/ArchiveDogProfileAction/ArchiveDogProfileAction.module.sass.d.ts": 3560,
	"./pages/DogProfile/components/ArchiveDogProfileAction/ArchiveDogProfileAction.tsx": 2008,
	"./pages/DogProfile/components/ArchiveDogProfileAction/ArchiveDogProfileModal": 2512,
	"./pages/DogProfile/components/ArchiveDogProfileAction/ArchiveDogProfileModal.tsx": 2512,
	"./pages/DogProfile/components/ArchiveDogProfileAction/fragments/__generated__/ArchiveDogProfileActionDogFragment": 3561,
	"./pages/DogProfile/components/ArchiveDogProfileAction/fragments/__generated__/ArchiveDogProfileActionDogFragment.ts": 3561,
	"./pages/DogProfile/components/ArchiveDogProfileAction/fragments/__generated__/ArchiveDogProfileActionFragment": 3562,
	"./pages/DogProfile/components/ArchiveDogProfileAction/fragments/__generated__/ArchiveDogProfileActionFragment.ts": 3562,
	"./pages/DogProfile/components/ArchiveDogProfileAction/fragments/__generated__/ArchiveDogProfileActionQueryFragment": 3563,
	"./pages/DogProfile/components/ArchiveDogProfileAction/fragments/__generated__/ArchiveDogProfileActionQueryFragment.ts": 3563,
	"./pages/DogProfile/components/ArchiveDogProfileAction/fragments/archiveDogProfileActionFragment": 1366,
	"./pages/DogProfile/components/ArchiveDogProfileAction/fragments/archiveDogProfileActionFragment.ts": 1366,
	"./pages/DogProfile/components/ArchiveDogProfileAction/index": 1301,
	"./pages/DogProfile/components/ArchiveDogProfileAction/index.ts": 1301,
	"./pages/DogProfile/components/ArchiveDogProfileAction/mutations/__generated__/ArchiveDogProfileMutation": 3564,
	"./pages/DogProfile/components/ArchiveDogProfileAction/mutations/__generated__/ArchiveDogProfileMutation.ts": 3564,
	"./pages/DogProfile/components/ArchiveDogProfileAction/mutations/archiveDogProfileMutation": 2513,
	"./pages/DogProfile/components/ArchiveDogProfileAction/mutations/archiveDogProfileMutation.ts": 2513,
	"./pages/DogProfile/components/CalorieDetails": 1724,
	"./pages/DogProfile/components/CalorieDetails/": 1724,
	"./pages/DogProfile/components/CalorieDetails/CalorieDetails": 2010,
	"./pages/DogProfile/components/CalorieDetails/CalorieDetails.module": 851,
	"./pages/DogProfile/components/CalorieDetails/CalorieDetails.module.sass": 851,
	"./pages/DogProfile/components/CalorieDetails/CalorieDetails.module.sass.d": 3565,
	"./pages/DogProfile/components/CalorieDetails/CalorieDetails.module.sass.d.ts": 3565,
	"./pages/DogProfile/components/CalorieDetails/CalorieDetails.tsx": 2010,
	"./pages/DogProfile/components/CalorieDetails/fragments/__generated__/CalorieDetailsFragment": 3566,
	"./pages/DogProfile/components/CalorieDetails/fragments/__generated__/CalorieDetailsFragment.ts": 3566,
	"./pages/DogProfile/components/CalorieDetails/fragments/calorieDetailsFragment": 1332,
	"./pages/DogProfile/components/CalorieDetails/fragments/calorieDetailsFragment.ts": 1332,
	"./pages/DogProfile/components/CalorieDetails/index": 1724,
	"./pages/DogProfile/components/CalorieDetails/index.ts": 1724,
	"./pages/DogProfile/components/DailyPortionSize": 1723,
	"./pages/DogProfile/components/DailyPortionSize/": 1723,
	"./pages/DogProfile/components/DailyPortionSize/DailyPortionSize": 2009,
	"./pages/DogProfile/components/DailyPortionSize/DailyPortionSize.module": 852,
	"./pages/DogProfile/components/DailyPortionSize/DailyPortionSize.module.sass": 852,
	"./pages/DogProfile/components/DailyPortionSize/DailyPortionSize.module.sass.d": 3567,
	"./pages/DogProfile/components/DailyPortionSize/DailyPortionSize.module.sass.d.ts": 3567,
	"./pages/DogProfile/components/DailyPortionSize/DailyPortionSize.tsx": 2009,
	"./pages/DogProfile/components/DailyPortionSize/fragments/__generated__/DailyPortionSizeFragment": 3568,
	"./pages/DogProfile/components/DailyPortionSize/fragments/__generated__/DailyPortionSizeFragment.ts": 3568,
	"./pages/DogProfile/components/DailyPortionSize/fragments/dailyPortionSizeFragment": 2510,
	"./pages/DogProfile/components/DailyPortionSize/fragments/dailyPortionSizeFragment.ts": 2510,
	"./pages/DogProfile/components/DailyPortionSize/index": 1723,
	"./pages/DogProfile/components/DailyPortionSize/index.ts": 1723,
	"./pages/DogProfile/components/DetailsCarousel": 1725,
	"./pages/DogProfile/components/DetailsCarousel/": 1725,
	"./pages/DogProfile/components/DetailsCarousel/DetailsCarousel": 2011,
	"./pages/DogProfile/components/DetailsCarousel/DetailsCarousel.module": 1101,
	"./pages/DogProfile/components/DetailsCarousel/DetailsCarousel.module.sass": 1101,
	"./pages/DogProfile/components/DetailsCarousel/DetailsCarousel.module.sass.d": 3569,
	"./pages/DogProfile/components/DetailsCarousel/DetailsCarousel.module.sass.d.ts": 3569,
	"./pages/DogProfile/components/DetailsCarousel/DetailsCarousel.tsx": 2011,
	"./pages/DogProfile/components/DetailsCarousel/index": 1725,
	"./pages/DogProfile/components/DetailsCarousel/index.ts": 1725,
	"./pages/DogProfile/components/DogProfilePicture": 1302,
	"./pages/DogProfile/components/DogProfilePicture/": 1302,
	"./pages/DogProfile/components/DogProfilePicture/DogProfilePicture": 2012,
	"./pages/DogProfile/components/DogProfilePicture/DogProfilePicture.module": 897,
	"./pages/DogProfile/components/DogProfilePicture/DogProfilePicture.module.sass": 897,
	"./pages/DogProfile/components/DogProfilePicture/DogProfilePicture.module.sass.d": 3570,
	"./pages/DogProfile/components/DogProfilePicture/DogProfilePicture.module.sass.d.ts": 3570,
	"./pages/DogProfile/components/DogProfilePicture/DogProfilePicture.tsx": 2012,
	"./pages/DogProfile/components/DogProfilePicture/fragments/dogProfilePictureFragment": 1811,
	"./pages/DogProfile/components/DogProfilePicture/fragments/dogProfilePictureFragment.ts": 1811,
	"./pages/DogProfile/components/DogProfilePicture/index": 1302,
	"./pages/DogProfile/components/DogProfilePicture/index.ts": 1302,
	"./pages/DogProfile/components/DogSelection": 1303,
	"./pages/DogProfile/components/DogSelection/": 1303,
	"./pages/DogProfile/components/DogSelection/DogSelection": 2013,
	"./pages/DogProfile/components/DogSelection/DogSelection.module": 2515,
	"./pages/DogProfile/components/DogSelection/DogSelection.module.sass": 2515,
	"./pages/DogProfile/components/DogSelection/DogSelection.module.sass.d": 3571,
	"./pages/DogProfile/components/DogSelection/DogSelection.module.sass.d.ts": 3571,
	"./pages/DogProfile/components/DogSelection/DogSelection.tsx": 2013,
	"./pages/DogProfile/components/DogSelection/fragments/dogSelectionFragment": 1812,
	"./pages/DogProfile/components/DogSelection/fragments/dogSelectionFragment.ts": 1812,
	"./pages/DogProfile/components/DogSelection/index": 1303,
	"./pages/DogProfile/components/DogSelection/index.ts": 1303,
	"./pages/DogProfile/components/HealthSection": 1726,
	"./pages/DogProfile/components/HealthSection/": 1726,
	"./pages/DogProfile/components/HealthSection/HealthSection": 2015,
	"./pages/DogProfile/components/HealthSection/HealthSection.module": 1164,
	"./pages/DogProfile/components/HealthSection/HealthSection.module.sass": 1164,
	"./pages/DogProfile/components/HealthSection/HealthSection.module.sass.d": 3572,
	"./pages/DogProfile/components/HealthSection/HealthSection.module.sass.d.ts": 3572,
	"./pages/DogProfile/components/HealthSection/HealthSection.tsx": 2015,
	"./pages/DogProfile/components/HealthSection/components/UpsellEntryPoint": 2516,
	"./pages/DogProfile/components/HealthSection/components/UpsellEntryPoint.tsx": 2516,
	"./pages/DogProfile/components/HealthSection/index": 1726,
	"./pages/DogProfile/components/HealthSection/index.ts": 1726,
	"./pages/DogProfile/components/PersonalityDetails": 1727,
	"./pages/DogProfile/components/PersonalityDetails/": 1727,
	"./pages/DogProfile/components/PersonalityDetails/PersonalityDetails": 2016,
	"./pages/DogProfile/components/PersonalityDetails/PersonalityDetails.module": 1254,
	"./pages/DogProfile/components/PersonalityDetails/PersonalityDetails.module.sass": 1254,
	"./pages/DogProfile/components/PersonalityDetails/PersonalityDetails.module.sass.d": 3573,
	"./pages/DogProfile/components/PersonalityDetails/PersonalityDetails.module.sass.d.ts": 3573,
	"./pages/DogProfile/components/PersonalityDetails/PersonalityDetails.tsx": 2016,
	"./pages/DogProfile/components/PersonalityDetails/index": 1727,
	"./pages/DogProfile/components/PersonalityDetails/index.ts": 1727,
	"./pages/DogProfile/components/PersonalityTrait": 1728,
	"./pages/DogProfile/components/PersonalityTrait/": 1728,
	"./pages/DogProfile/components/PersonalityTrait/PersonalityTrait": 2017,
	"./pages/DogProfile/components/PersonalityTrait/PersonalityTrait.module": 2323,
	"./pages/DogProfile/components/PersonalityTrait/PersonalityTrait.module.sass": 2323,
	"./pages/DogProfile/components/PersonalityTrait/PersonalityTrait.module.sass.d": 3574,
	"./pages/DogProfile/components/PersonalityTrait/PersonalityTrait.module.sass.d.ts": 3574,
	"./pages/DogProfile/components/PersonalityTrait/PersonalityTrait.tsx": 2017,
	"./pages/DogProfile/components/PersonalityTrait/index": 1728,
	"./pages/DogProfile/components/PersonalityTrait/index.ts": 1728,
	"./pages/DogProfile/components/SelectableDogAvatar": 1304,
	"./pages/DogProfile/components/SelectableDogAvatar/": 1304,
	"./pages/DogProfile/components/SelectableDogAvatar/DogAvatarImage": 1627,
	"./pages/DogProfile/components/SelectableDogAvatar/DogAvatarImage.tsx": 1627,
	"./pages/DogProfile/components/SelectableDogAvatar/SelectableDogAvatar": 2014,
	"./pages/DogProfile/components/SelectableDogAvatar/SelectableDogAvatar.module": 1238,
	"./pages/DogProfile/components/SelectableDogAvatar/SelectableDogAvatar.module.sass": 1238,
	"./pages/DogProfile/components/SelectableDogAvatar/SelectableDogAvatar.module.sass.d": 3575,
	"./pages/DogProfile/components/SelectableDogAvatar/SelectableDogAvatar.module.sass.d.ts": 3575,
	"./pages/DogProfile/components/SelectableDogAvatar/SelectableDogAvatar.tsx": 2014,
	"./pages/DogProfile/components/SelectableDogAvatar/fragments/selectableDogAvatarFragment": 2511,
	"./pages/DogProfile/components/SelectableDogAvatar/fragments/selectableDogAvatarFragment.ts": 2511,
	"./pages/DogProfile/components/SelectableDogAvatar/index": 1304,
	"./pages/DogProfile/components/SelectableDogAvatar/index.ts": 1304,
	"./pages/DogProfile/components/ShareProfile": 1305,
	"./pages/DogProfile/components/ShareProfile/": 1305,
	"./pages/DogProfile/components/ShareProfile/ShareProfile": 2018,
	"./pages/DogProfile/components/ShareProfile/ShareProfile.module": 2517,
	"./pages/DogProfile/components/ShareProfile/ShareProfile.module.sass": 2517,
	"./pages/DogProfile/components/ShareProfile/ShareProfile.module.sass.d": 3576,
	"./pages/DogProfile/components/ShareProfile/ShareProfile.module.sass.d.ts": 3576,
	"./pages/DogProfile/components/ShareProfile/ShareProfile.tsx": 2018,
	"./pages/DogProfile/components/ShareProfile/fragment/shareProfileFragment": 1813,
	"./pages/DogProfile/components/ShareProfile/fragment/shareProfileFragment.ts": 1813,
	"./pages/DogProfile/components/ShareProfile/index": 1305,
	"./pages/DogProfile/components/ShareProfile/index.ts": 1305,
	"./pages/DogProfile/components/ShareRafPass": 1306,
	"./pages/DogProfile/components/ShareRafPass/": 1306,
	"./pages/DogProfile/components/ShareRafPass/ShareRafPass": 2019,
	"./pages/DogProfile/components/ShareRafPass/ShareRafPass.module": 2324,
	"./pages/DogProfile/components/ShareRafPass/ShareRafPass.module.sass": 2324,
	"./pages/DogProfile/components/ShareRafPass/ShareRafPass.module.sass.d": 3577,
	"./pages/DogProfile/components/ShareRafPass/ShareRafPass.module.sass.d.ts": 3577,
	"./pages/DogProfile/components/ShareRafPass/ShareRafPass.tsx": 2019,
	"./pages/DogProfile/components/ShareRafPass/fragment/shareRafPassFragment": 1814,
	"./pages/DogProfile/components/ShareRafPass/fragment/shareRafPassFragment.ts": 1814,
	"./pages/DogProfile/components/ShareRafPass/index": 1306,
	"./pages/DogProfile/components/ShareRafPass/index.ts": 1306,
	"./pages/DogProfile/helpers/helpers": 1815,
	"./pages/DogProfile/helpers/helpers.ts": 1815,
	"./pages/DogProfile/index": 1722,
	"./pages/DogProfile/index.ts": 1722,
	"./pages/DogProfile/mutations/__generated__/CreateDogProfileMutation": 3578,
	"./pages/DogProfile/mutations/__generated__/CreateDogProfileMutation.ts": 3578,
	"./pages/DogProfile/mutations/__generated__/UpdateDogProfilePictureMutation": 3579,
	"./pages/DogProfile/mutations/__generated__/UpdateDogProfilePictureMutation.ts": 3579,
	"./pages/DogProfile/mutations/createDogProfileMutation": 2514,
	"./pages/DogProfile/mutations/createDogProfileMutation.ts": 2514,
	"./pages/DogProfile/mutations/updateDogProfilePictureMutation": 3580,
	"./pages/DogProfile/mutations/updateDogProfilePictureMutation.ts": 3580,
	"./pages/DogProfile/queries/__generated__/DogProfileQuery": 3581,
	"./pages/DogProfile/queries/__generated__/DogProfileQuery.ts": 3581,
	"./pages/DogProfile/queries/dogProfileQuery": 1810,
	"./pages/DogProfile/queries/dogProfileQuery.ts": 1810,
	"./pages/DogProfile/v2": 1729,
	"./pages/DogProfile/v2/": 1729,
	"./pages/DogProfile/v2/DogProfile": 2410,
	"./pages/DogProfile/v2/DogProfile.tsx": 2410,
	"./pages/DogProfile/v2/DogProfileContent": 2522,
	"./pages/DogProfile/v2/DogProfileContent.tsx": 2522,
	"./pages/DogProfile/v2/components/DetailsRowSection": 1196,
	"./pages/DogProfile/v2/components/DetailsRowSection/": 1196,
	"./pages/DogProfile/v2/components/DetailsRowSection/DetailsRowSection": 2411,
	"./pages/DogProfile/v2/components/DetailsRowSection/DetailsRowSection.tsx": 2411,
	"./pages/DogProfile/v2/components/DetailsRowSection/index": 1196,
	"./pages/DogProfile/v2/components/DetailsRowSection/index.ts": 1196,
	"./pages/DogProfile/v2/components/Medical": 1730,
	"./pages/DogProfile/v2/components/Medical/": 1730,
	"./pages/DogProfile/v2/components/Medical/Medical": 2020,
	"./pages/DogProfile/v2/components/Medical/Medical.module": 1656,
	"./pages/DogProfile/v2/components/Medical/Medical.module.sass": 1656,
	"./pages/DogProfile/v2/components/Medical/Medical.module.sass.d": 3582,
	"./pages/DogProfile/v2/components/Medical/Medical.module.sass.d.ts": 3582,
	"./pages/DogProfile/v2/components/Medical/Medical.tsx": 2020,
	"./pages/DogProfile/v2/components/Medical/index": 1730,
	"./pages/DogProfile/v2/components/Medical/index.ts": 1730,
	"./pages/DogProfile/v2/components/PersonalityDetails": 1731,
	"./pages/DogProfile/v2/components/PersonalityDetails/": 1731,
	"./pages/DogProfile/v2/components/PersonalityDetails/PersonalityDetails": 2021,
	"./pages/DogProfile/v2/components/PersonalityDetails/PersonalityDetails.module": 1909,
	"./pages/DogProfile/v2/components/PersonalityDetails/PersonalityDetails.module.sass": 1909,
	"./pages/DogProfile/v2/components/PersonalityDetails/PersonalityDetails.module.sass.d": 3583,
	"./pages/DogProfile/v2/components/PersonalityDetails/PersonalityDetails.module.sass.d.ts": 3583,
	"./pages/DogProfile/v2/components/PersonalityDetails/PersonalityDetails.tsx": 2021,
	"./pages/DogProfile/v2/components/PersonalityDetails/index": 1731,
	"./pages/DogProfile/v2/components/PersonalityDetails/index.ts": 1731,
	"./pages/DogProfile/v2/components/WeightAndAppetite": 1733,
	"./pages/DogProfile/v2/components/WeightAndAppetite/": 1733,
	"./pages/DogProfile/v2/components/WeightAndAppetite/WeightAndAppetite": 2023,
	"./pages/DogProfile/v2/components/WeightAndAppetite/WeightAndAppetite.module": 1657,
	"./pages/DogProfile/v2/components/WeightAndAppetite/WeightAndAppetite.module.sass": 1657,
	"./pages/DogProfile/v2/components/WeightAndAppetite/WeightAndAppetite.module.sass.d": 3584,
	"./pages/DogProfile/v2/components/WeightAndAppetite/WeightAndAppetite.module.sass.d.ts": 3584,
	"./pages/DogProfile/v2/components/WeightAndAppetite/WeightAndAppetite.tsx": 2023,
	"./pages/DogProfile/v2/components/WeightAndAppetite/index": 1733,
	"./pages/DogProfile/v2/components/WeightAndAppetite/index.ts": 1733,
	"./pages/DogProfile/v2/fragments/__generated__/DogProfileMedicalFragment": 3585,
	"./pages/DogProfile/v2/fragments/__generated__/DogProfileMedicalFragment.ts": 3585,
	"./pages/DogProfile/v2/fragments/__generated__/DogProfilePersonalityDetailsFragment": 3586,
	"./pages/DogProfile/v2/fragments/__generated__/DogProfilePersonalityDetailsFragment.ts": 3586,
	"./pages/DogProfile/v2/fragments/__generated__/DogProfileWeightAndAppetiteFragment": 3587,
	"./pages/DogProfile/v2/fragments/__generated__/DogProfileWeightAndAppetiteFragment.ts": 3587,
	"./pages/DogProfile/v2/fragments/dogProfileMedicalFragment": 2519,
	"./pages/DogProfile/v2/fragments/dogProfileMedicalFragment.ts": 2519,
	"./pages/DogProfile/v2/fragments/dogProfilePersonalityDetailsFragment": 2520,
	"./pages/DogProfile/v2/fragments/dogProfilePersonalityDetailsFragment.ts": 2520,
	"./pages/DogProfile/v2/fragments/dogProfileWeightAndAppetiteFragment": 2521,
	"./pages/DogProfile/v2/fragments/dogProfileWeightAndAppetiteFragment.ts": 2521,
	"./pages/DogProfile/v2/index": 1729,
	"./pages/DogProfile/v2/index.ts": 1729,
	"./pages/DogProfile/v2/queries/__generated__/DogProfileV2Query": 3588,
	"./pages/DogProfile/v2/queries/__generated__/DogProfileV2Query.ts": 3588,
	"./pages/DogProfile/v2/queries/dogProfileQuery": 2518,
	"./pages/DogProfile/v2/queries/dogProfileQuery.ts": 2518,
	"./pages/DownsizeAndSavePage/DownsizeAndSavePage": 2125,
	"./pages/DownsizeAndSavePage/DownsizeAndSavePage.module": 954,
	"./pages/DownsizeAndSavePage/DownsizeAndSavePage.module.sass": 954,
	"./pages/DownsizeAndSavePage/DownsizeAndSavePage.module.sass.d": 3589,
	"./pages/DownsizeAndSavePage/DownsizeAndSavePage.module.sass.d.ts": 3589,
	"./pages/DownsizeAndSavePage/DownsizeAndSavePage.tsx": 2125,
	"./pages/DownsizeAndSavePage/queries/DownsizeAndSavePageQuery": 2524,
	"./pages/DownsizeAndSavePage/queries/DownsizeAndSavePageQuery.ts": 2524,
	"./pages/DownsizeAndSavePage/queries/__generated__/DownsizeAndSavePageQuery": 3590,
	"./pages/DownsizeAndSavePage/queries/__generated__/DownsizeAndSavePageQuery.ts": 3590,
	"./pages/EditDailyAmount": 1734,
	"./pages/EditDailyAmount/": 1734,
	"./pages/EditDailyAmount/EditDailyAmount": 2024,
	"./pages/EditDailyAmount/EditDailyAmount.module": 2325,
	"./pages/EditDailyAmount/EditDailyAmount.module.sass": 2325,
	"./pages/EditDailyAmount/EditDailyAmount.module.sass.d": 3591,
	"./pages/EditDailyAmount/EditDailyAmount.module.sass.d.ts": 3591,
	"./pages/EditDailyAmount/EditDailyAmount.tsx": 2024,
	"./pages/EditDailyAmount/EditDailyAmountContent": 2529,
	"./pages/EditDailyAmount/EditDailyAmountContent.tsx": 2529,
	"./pages/EditDailyAmount/components/DailyCalorieGuidance": 1735,
	"./pages/EditDailyAmount/components/DailyCalorieGuidance/": 1735,
	"./pages/EditDailyAmount/components/DailyCalorieGuidance/DailyCalorieGuidance": 2025,
	"./pages/EditDailyAmount/components/DailyCalorieGuidance/DailyCalorieGuidance.module": 1912,
	"./pages/EditDailyAmount/components/DailyCalorieGuidance/DailyCalorieGuidance.module.sass": 1912,
	"./pages/EditDailyAmount/components/DailyCalorieGuidance/DailyCalorieGuidance.module.sass.d": 3592,
	"./pages/EditDailyAmount/components/DailyCalorieGuidance/DailyCalorieGuidance.module.sass.d.ts": 3592,
	"./pages/EditDailyAmount/components/DailyCalorieGuidance/DailyCalorieGuidance.tsx": 2025,
	"./pages/EditDailyAmount/components/DailyCalorieGuidance/__snapshots__/DailyCalorieGuidance.spec.tsx.snap": 4316,
	"./pages/EditDailyAmount/components/DailyCalorieGuidance/index": 1735,
	"./pages/EditDailyAmount/components/DailyCalorieGuidance/index.ts": 1735,
	"./pages/EditDailyAmount/components/LargestPlanNotification": 1308,
	"./pages/EditDailyAmount/components/LargestPlanNotification/": 1308,
	"./pages/EditDailyAmount/components/LargestPlanNotification/LargestPlanNotification": 2027,
	"./pages/EditDailyAmount/components/LargestPlanNotification/LargestPlanNotification.tsx": 2027,
	"./pages/EditDailyAmount/components/LargestPlanNotification/index": 1308,
	"./pages/EditDailyAmount/components/LargestPlanNotification/index.ts": 1308,
	"./pages/EditDailyAmount/components/MultipleDogsCallout": 1736,
	"./pages/EditDailyAmount/components/MultipleDogsCallout/": 1736,
	"./pages/EditDailyAmount/components/MultipleDogsCallout/MultipleDogsCallout": 2028,
	"./pages/EditDailyAmount/components/MultipleDogsCallout/MultipleDogsCallout.module": 1911,
	"./pages/EditDailyAmount/components/MultipleDogsCallout/MultipleDogsCallout.module.sass": 1911,
	"./pages/EditDailyAmount/components/MultipleDogsCallout/MultipleDogsCallout.module.sass.d": 3593,
	"./pages/EditDailyAmount/components/MultipleDogsCallout/MultipleDogsCallout.module.sass.d.ts": 3593,
	"./pages/EditDailyAmount/components/MultipleDogsCallout/MultipleDogsCallout.tsx": 2028,
	"./pages/EditDailyAmount/components/MultipleDogsCallout/index": 1736,
	"./pages/EditDailyAmount/components/MultipleDogsCallout/index.ts": 1736,
	"./pages/EditDailyAmount/components/WhereToStartModalTrigger": 1738,
	"./pages/EditDailyAmount/components/WhereToStartModalTrigger/": 1738,
	"./pages/EditDailyAmount/components/WhereToStartModalTrigger/WhereToStartModalTrigger": 2030,
	"./pages/EditDailyAmount/components/WhereToStartModalTrigger/WhereToStartModalTrigger.module": 2533,
	"./pages/EditDailyAmount/components/WhereToStartModalTrigger/WhereToStartModalTrigger.module.sass": 2533,
	"./pages/EditDailyAmount/components/WhereToStartModalTrigger/WhereToStartModalTrigger.module.sass.d": 3594,
	"./pages/EditDailyAmount/components/WhereToStartModalTrigger/WhereToStartModalTrigger.module.sass.d.ts": 3594,
	"./pages/EditDailyAmount/components/WhereToStartModalTrigger/WhereToStartModalTrigger.tsx": 2030,
	"./pages/EditDailyAmount/components/WhereToStartModalTrigger/index": 1738,
	"./pages/EditDailyAmount/components/WhereToStartModalTrigger/index.ts": 1738,
	"./pages/EditDailyAmount/fragments/__generated__/EditDailyAmountDogFragment": 3595,
	"./pages/EditDailyAmount/fragments/__generated__/EditDailyAmountDogFragment.ts": 3595,
	"./pages/EditDailyAmount/fragments/__generated__/EditDailyAmountFragment": 3596,
	"./pages/EditDailyAmount/fragments/__generated__/EditDailyAmountFragment.ts": 3596,
	"./pages/EditDailyAmount/fragments/__generated__/EditDailyAmountPlanFragment": 3597,
	"./pages/EditDailyAmount/fragments/__generated__/EditDailyAmountPlanFragment.ts": 3597,
	"./pages/EditDailyAmount/fragments/editDailyAmountFragment": 2526,
	"./pages/EditDailyAmount/fragments/editDailyAmountFragment.ts": 2526,
	"./pages/EditDailyAmount/index": 1734,
	"./pages/EditDailyAmount/index.ts": 1734,
	"./pages/EditDailyAmount/queries/__generated__/EditDailyAmountQuery": 3598,
	"./pages/EditDailyAmount/queries/__generated__/EditDailyAmountQuery.ts": 3598,
	"./pages/EditDailyAmount/queries/editDailyAmountQuery": 2525,
	"./pages/EditDailyAmount/queries/editDailyAmountQuery.ts": 2525,
	"./pages/EditDailyAmount/utils": 1334,
	"./pages/EditDailyAmount/utils/": 1334,
	"./pages/EditDailyAmount/utils/index": 1334,
	"./pages/EditDailyAmount/utils/index.ts": 1334,
	"./pages/EditDeliveryFrequency": 1739,
	"./pages/EditDeliveryFrequency/": 1739,
	"./pages/EditDeliveryFrequency/EditDeliveryFrequency": 2031,
	"./pages/EditDeliveryFrequency/EditDeliveryFrequency.module": 2326,
	"./pages/EditDeliveryFrequency/EditDeliveryFrequency.module.sass": 2326,
	"./pages/EditDeliveryFrequency/EditDeliveryFrequency.module.sass.d": 3599,
	"./pages/EditDeliveryFrequency/EditDeliveryFrequency.module.sass.d.ts": 3599,
	"./pages/EditDeliveryFrequency/EditDeliveryFrequency.tsx": 2031,
	"./pages/EditDeliveryFrequency/EditDeliveryFrequencyContent": 2537,
	"./pages/EditDeliveryFrequency/EditDeliveryFrequencyContent.tsx": 2537,
	"./pages/EditDeliveryFrequency/components/BenefitModalTrigger": 1740,
	"./pages/EditDeliveryFrequency/components/BenefitModalTrigger/": 1740,
	"./pages/EditDeliveryFrequency/components/BenefitModalTrigger/BenefitModalTrigger": 2412,
	"./pages/EditDeliveryFrequency/components/BenefitModalTrigger/BenefitModalTrigger.tsx": 2412,
	"./pages/EditDeliveryFrequency/components/BenefitModalTrigger/index": 1740,
	"./pages/EditDeliveryFrequency/components/BenefitModalTrigger/index.ts": 1740,
	"./pages/EditDeliveryFrequency/components/FrequencySelector": 1741,
	"./pages/EditDeliveryFrequency/components/FrequencySelector/": 1741,
	"./pages/EditDeliveryFrequency/components/FrequencySelector/FrequencySelector": 2032,
	"./pages/EditDeliveryFrequency/components/FrequencySelector/FrequencySelector.module": 2538,
	"./pages/EditDeliveryFrequency/components/FrequencySelector/FrequencySelector.module.sass": 2538,
	"./pages/EditDeliveryFrequency/components/FrequencySelector/FrequencySelector.module.sass.d": 3600,
	"./pages/EditDeliveryFrequency/components/FrequencySelector/FrequencySelector.module.sass.d.ts": 3600,
	"./pages/EditDeliveryFrequency/components/FrequencySelector/FrequencySelector.tsx": 2032,
	"./pages/EditDeliveryFrequency/components/FrequencySelector/index": 1741,
	"./pages/EditDeliveryFrequency/components/FrequencySelector/index.ts": 1741,
	"./pages/EditDeliveryFrequency/components/PlanOverview": 1742,
	"./pages/EditDeliveryFrequency/components/PlanOverview/": 1742,
	"./pages/EditDeliveryFrequency/components/PlanOverview/PlanOverview": 2033,
	"./pages/EditDeliveryFrequency/components/PlanOverview/PlanOverview.module": 1257,
	"./pages/EditDeliveryFrequency/components/PlanOverview/PlanOverview.module.sass": 1257,
	"./pages/EditDeliveryFrequency/components/PlanOverview/PlanOverview.module.sass.d": 3601,
	"./pages/EditDeliveryFrequency/components/PlanOverview/PlanOverview.module.sass.d.ts": 3601,
	"./pages/EditDeliveryFrequency/components/PlanOverview/PlanOverview.tsx": 2033,
	"./pages/EditDeliveryFrequency/components/PlanOverview/index": 1742,
	"./pages/EditDeliveryFrequency/components/PlanOverview/index.ts": 1742,
	"./pages/EditDeliveryFrequency/fragments/__generated__/EditDeliveryFrequencyFragment": 3602,
	"./pages/EditDeliveryFrequency/fragments/__generated__/EditDeliveryFrequencyFragment.ts": 3602,
	"./pages/EditDeliveryFrequency/fragments/__generated__/EditDeliveryFrequencyPlanFragment": 3603,
	"./pages/EditDeliveryFrequency/fragments/__generated__/EditDeliveryFrequencyPlanFragment.ts": 3603,
	"./pages/EditDeliveryFrequency/fragments/editDeliveryFrequencyFragment": 2536,
	"./pages/EditDeliveryFrequency/fragments/editDeliveryFrequencyFragment.ts": 2536,
	"./pages/EditDeliveryFrequency/index": 1739,
	"./pages/EditDeliveryFrequency/index.ts": 1739,
	"./pages/EditDeliveryFrequency/mutations/__generated__/EditDeliveryFrequencyMutation": 3604,
	"./pages/EditDeliveryFrequency/mutations/__generated__/EditDeliveryFrequencyMutation.ts": 3604,
	"./pages/EditDeliveryFrequency/mutations/editDeliveryFrequencyMutation": 2539,
	"./pages/EditDeliveryFrequency/mutations/editDeliveryFrequencyMutation.ts": 2539,
	"./pages/EditDeliveryFrequency/queries/__generated__/EditDeliveryFrequencyQuery": 3605,
	"./pages/EditDeliveryFrequency/queries/__generated__/EditDeliveryFrequencyQuery.ts": 3605,
	"./pages/EditDeliveryFrequency/queries/editDeliveryFrequencyQuery": 2535,
	"./pages/EditDeliveryFrequency/queries/editDeliveryFrequencyQuery.ts": 2535,
	"./pages/EditDeliveryFrequency/utils": 1335,
	"./pages/EditDeliveryFrequency/utils/": 1335,
	"./pages/EditDeliveryFrequency/utils/index": 1335,
	"./pages/EditDeliveryFrequency/utils/index.ts": 1335,
	"./pages/EditDogDetailsPage/EditDogDetailsPage": 2126,
	"./pages/EditDogDetailsPage/EditDogDetailsPage.module": 679,
	"./pages/EditDogDetailsPage/EditDogDetailsPage.module.sass": 679,
	"./pages/EditDogDetailsPage/EditDogDetailsPage.module.sass.d": 3606,
	"./pages/EditDogDetailsPage/EditDogDetailsPage.module.sass.d.ts": 3606,
	"./pages/EditDogDetailsPage/EditDogDetailsPage.tsx": 2126,
	"./pages/EditDogDetailsPage/__generated__/DogDetailsQuery": 3607,
	"./pages/EditDogDetailsPage/__generated__/DogDetailsQuery.ts": 3607,
	"./pages/EditDogDetailsPage/__generated__/DogsUpdate": 3608,
	"./pages/EditDogDetailsPage/__generated__/DogsUpdate.ts": 3608,
	"./pages/EditDogDetailsPage/queries": 2327,
	"./pages/EditDogDetailsPage/queries.ts": 2327,
	"./pages/EditExtrasPage": 1743,
	"./pages/EditExtrasPage/": 1743,
	"./pages/EditExtrasPage/EditExtrasPage": 2036,
	"./pages/EditExtrasPage/EditExtrasPage.module": 3609,
	"./pages/EditExtrasPage/EditExtrasPage.module.sass": 3609,
	"./pages/EditExtrasPage/EditExtrasPage.module.sass.d": 3610,
	"./pages/EditExtrasPage/EditExtrasPage.module.sass.d.ts": 3610,
	"./pages/EditExtrasPage/EditExtrasPage.tsx": 2036,
	"./pages/EditExtrasPage/index": 1743,
	"./pages/EditExtrasPage/index.ts": 1743,
	"./pages/EditPlanPage/EditPlanPage": 2128,
	"./pages/EditPlanPage/EditPlanPage.module": 624,
	"./pages/EditPlanPage/EditPlanPage.module.sass": 624,
	"./pages/EditPlanPage/EditPlanPage.module.sass.d": 3611,
	"./pages/EditPlanPage/EditPlanPage.module.sass.d.ts": 3611,
	"./pages/EditPlanPage/EditPlanPage.tsx": 2128,
	"./pages/EditPlanPage/queries/queries": 1329,
	"./pages/EditPlanPage/queries/queries.ts": 1329,
	"./pages/EditRecipes": 1744,
	"./pages/EditRecipes/": 1744,
	"./pages/EditRecipes/EditRecipes": 1438,
	"./pages/EditRecipes/EditRecipes.module": 324,
	"./pages/EditRecipes/EditRecipes.module.sass": 324,
	"./pages/EditRecipes/EditRecipes.module.sass.d": 3612,
	"./pages/EditRecipes/EditRecipes.module.sass.d.ts": 3612,
	"./pages/EditRecipes/EditRecipes.tsx": 1438,
	"./pages/EditRecipes/components/RecipeCard/RecipeCard": 1915,
	"./pages/EditRecipes/components/RecipeCard/RecipeCard.tsx": 1915,
	"./pages/EditRecipes/components/RecipesProgressBar/RecipesProgressBar": 1820,
	"./pages/EditRecipes/components/RecipesProgressBar/RecipesProgressBar.tsx": 1820,
	"./pages/EditRecipes/icons/plusBadge": 2550,
	"./pages/EditRecipes/icons/plusBadge.tsx": 2550,
	"./pages/EditRecipes/icons/tickBadge": 2551,
	"./pages/EditRecipes/icons/tickBadge.tsx": 2551,
	"./pages/EditRecipes/index": 1744,
	"./pages/EditRecipes/index.ts": 1744,
	"./pages/EditRecipes/mutations/__generated__/SaveFreshMealsMutation": 3613,
	"./pages/EditRecipes/mutations/__generated__/SaveFreshMealsMutation.ts": 3613,
	"./pages/EditRecipes/mutations/saveFreshMealsMutation": 2547,
	"./pages/EditRecipes/mutations/saveFreshMealsMutation.ts": 2547,
	"./pages/EditRecipes/queries/__generated__/MealFlavoursQuery": 3614,
	"./pages/EditRecipes/queries/__generated__/MealFlavoursQuery.ts": 3614,
	"./pages/EditRecipes/queries/__generated__/SaveFreshMealsUpdateQuery": 3615,
	"./pages/EditRecipes/queries/__generated__/SaveFreshMealsUpdateQuery.ts": 3615,
	"./pages/EditRecipes/queries/mealFlavoursQuery": 2548,
	"./pages/EditRecipes/queries/mealFlavoursQuery.ts": 2548,
	"./pages/EditRecipes/queries/saveFreshMealsUpdateQuery": 2549,
	"./pages/EditRecipes/queries/saveFreshMealsUpdateQuery.ts": 2549,
	"./pages/EditRecipes/utils": 1198,
	"./pages/EditRecipes/utils/": 1198,
	"./pages/EditRecipes/utils/index": 1198,
	"./pages/EditRecipes/utils/index.ts": 1198,
	"./pages/ErrorPage/ErrorPage": 1241,
	"./pages/ErrorPage/ErrorPage.tsx": 1241,
	"./pages/ExtrasPage": 2455,
	"./pages/ExtrasPage/": 2455,
	"./pages/ExtrasPage/components/BasketButton/BasketButton": 1821,
	"./pages/ExtrasPage/components/BasketButton/BasketButton.module": 1103,
	"./pages/ExtrasPage/components/BasketButton/BasketButton.module.sass": 1103,
	"./pages/ExtrasPage/components/BasketButton/BasketButton.module.sass.d": 3616,
	"./pages/ExtrasPage/components/BasketButton/BasketButton.module.sass.d.ts": 3616,
	"./pages/ExtrasPage/components/BasketButton/BasketButton.tsx": 1821,
	"./pages/ExtrasPage/components/BasketButton/queries/__generated__/BasketButtonQuery": 3617,
	"./pages/ExtrasPage/components/BasketButton/queries/__generated__/BasketButtonQuery.ts": 3617,
	"./pages/ExtrasPage/components/BasketButton/queries/basketButtonQuery": 2552,
	"./pages/ExtrasPage/components/BasketButton/queries/basketButtonQuery.ts": 2552,
	"./pages/ExtrasPage/components/BasketCard/BasketCard": 2129,
	"./pages/ExtrasPage/components/BasketCard/BasketCard.module": 1260,
	"./pages/ExtrasPage/components/BasketCard/BasketCard.module.sass": 1260,
	"./pages/ExtrasPage/components/BasketCard/BasketCard.module.sass.d": 3618,
	"./pages/ExtrasPage/components/BasketCard/BasketCard.module.sass.d.ts": 3618,
	"./pages/ExtrasPage/components/BasketCard/BasketCard.tsx": 2129,
	"./pages/ExtrasPage/index": 2455,
	"./pages/ExtrasPage/index.js": 2455,
	"./pages/ExtrasPage/routes": 881,
	"./pages/ExtrasPage/routes.ts": 881,
	"./pages/ExtrasPage/screens/BasketPage/BasketPage": 1589,
	"./pages/ExtrasPage/screens/BasketPage/BasketPage.module": 848,
	"./pages/ExtrasPage/screens/BasketPage/BasketPage.module.sass": 848,
	"./pages/ExtrasPage/screens/BasketPage/BasketPage.module.sass.d": 3619,
	"./pages/ExtrasPage/screens/BasketPage/BasketPage.module.sass.d.ts": 3619,
	"./pages/ExtrasPage/screens/BasketPage/BasketPage.stories": 3620,
	"./pages/ExtrasPage/screens/BasketPage/BasketPage.stories.tsx": 3620,
	"./pages/ExtrasPage/screens/BasketPage/BasketPage.tsx": 1589,
	"./pages/ExtrasPage/screens/BasketPage/components/BasketFooter/BasketFooter": 2553,
	"./pages/ExtrasPage/screens/BasketPage/components/BasketFooter/BasketFooter.tsx": 2553,
	"./pages/ExtrasPage/screens/BasketPage/components/BasketProductsList": 1747,
	"./pages/ExtrasPage/screens/BasketPage/components/BasketProductsList/": 1747,
	"./pages/ExtrasPage/screens/BasketPage/components/BasketProductsList/BasketProductCard": 2554,
	"./pages/ExtrasPage/screens/BasketPage/components/BasketProductsList/BasketProductCard.tsx": 2554,
	"./pages/ExtrasPage/screens/BasketPage/components/BasketProductsList/BasketProductsList": 2416,
	"./pages/ExtrasPage/screens/BasketPage/components/BasketProductsList/BasketProductsList.tsx": 2416,
	"./pages/ExtrasPage/screens/BasketPage/components/BasketProductsList/index": 1747,
	"./pages/ExtrasPage/screens/BasketPage/components/BasketProductsList/index.ts": 1747,
	"./pages/ExtrasPage/screens/BasketPage/components/EmptyBasketState/EmptyBasketState": 2130,
	"./pages/ExtrasPage/screens/BasketPage/components/EmptyBasketState/EmptyBasketState.module": 1916,
	"./pages/ExtrasPage/screens/BasketPage/components/EmptyBasketState/EmptyBasketState.module.sass": 1916,
	"./pages/ExtrasPage/screens/BasketPage/components/EmptyBasketState/EmptyBasketState.module.sass.d": 3621,
	"./pages/ExtrasPage/screens/BasketPage/components/EmptyBasketState/EmptyBasketState.module.sass.d.ts": 3621,
	"./pages/ExtrasPage/screens/BasketPage/components/EmptyBasketState/EmptyBasketState.tsx": 2130,
	"./pages/ExtrasPage/screens/BasketPage/mutations": 1748,
	"./pages/ExtrasPage/screens/BasketPage/mutations/": 1748,
	"./pages/ExtrasPage/screens/BasketPage/mutations/__generated__/BasketProductsUpdate": 3622,
	"./pages/ExtrasPage/screens/BasketPage/mutations/__generated__/BasketProductsUpdate.ts": 3622,
	"./pages/ExtrasPage/screens/BasketPage/mutations/__generated__/nonCoreOrderCreate": 3623,
	"./pages/ExtrasPage/screens/BasketPage/mutations/__generated__/nonCoreOrderCreate.ts": 3623,
	"./pages/ExtrasPage/screens/BasketPage/mutations/basketProductsUpdate": 2417,
	"./pages/ExtrasPage/screens/BasketPage/mutations/basketProductsUpdate.ts": 2417,
	"./pages/ExtrasPage/screens/BasketPage/mutations/createOrderMutation": 1746,
	"./pages/ExtrasPage/screens/BasketPage/mutations/createOrderMutation.ts": 1746,
	"./pages/ExtrasPage/screens/BasketPage/mutations/index": 1748,
	"./pages/ExtrasPage/screens/BasketPage/mutations/index.ts": 1748,
	"./pages/ExtrasPage/screens/BasketPage/queries/__generated__/BasketPageQuery": 3624,
	"./pages/ExtrasPage/screens/BasketPage/queries/__generated__/BasketPageQuery.ts": 3624,
	"./pages/ExtrasPage/screens/BasketPage/queries/basketPageQuery": 2131,
	"./pages/ExtrasPage/screens/BasketPage/queries/basketPageQuery.ts": 2131,
	"./pages/ExtrasPage/screens/ConfirmationPage/ConfirmationPage": 1594,
	"./pages/ExtrasPage/screens/ConfirmationPage/ConfirmationPage.module": 898,
	"./pages/ExtrasPage/screens/ConfirmationPage/ConfirmationPage.module.sass": 898,
	"./pages/ExtrasPage/screens/ConfirmationPage/ConfirmationPage.module.sass.d": 3625,
	"./pages/ExtrasPage/screens/ConfirmationPage/ConfirmationPage.module.sass.d.ts": 3625,
	"./pages/ExtrasPage/screens/ConfirmationPage/ConfirmationPage.stories": 3626,
	"./pages/ExtrasPage/screens/ConfirmationPage/ConfirmationPage.stories.tsx": 3626,
	"./pages/ExtrasPage/screens/ConfirmationPage/ConfirmationPage.tsx": 1594,
	"./pages/ExtrasPage/screens/ConfirmationPage/queries/__generated__/ConfirmationPageQuery": 3627,
	"./pages/ExtrasPage/screens/ConfirmationPage/queries/__generated__/ConfirmationPageQuery.ts": 3627,
	"./pages/ExtrasPage/screens/ConfirmationPage/queries/confirmationPageQuery": 2132,
	"./pages/ExtrasPage/screens/ConfirmationPage/queries/confirmationPageQuery.ts": 2132,
	"./pages/ExtrasPage/screens/ExtrasList/ExtrasList": 1595,
	"./pages/ExtrasPage/screens/ExtrasList/ExtrasList.module": 1262,
	"./pages/ExtrasPage/screens/ExtrasList/ExtrasList.module.sass": 1262,
	"./pages/ExtrasPage/screens/ExtrasList/ExtrasList.module.sass.d": 3628,
	"./pages/ExtrasPage/screens/ExtrasList/ExtrasList.module.sass.d.ts": 3628,
	"./pages/ExtrasPage/screens/ExtrasList/ExtrasList.stories": 3629,
	"./pages/ExtrasPage/screens/ExtrasList/ExtrasList.stories.tsx": 3629,
	"./pages/ExtrasPage/screens/ExtrasList/ExtrasList.tsx": 1595,
	"./pages/ExtrasPage/screens/ExtrasList/components/CategoryList/CategoryList": 2133,
	"./pages/ExtrasPage/screens/ExtrasList/components/CategoryList/CategoryList.module": 1917,
	"./pages/ExtrasPage/screens/ExtrasList/components/CategoryList/CategoryList.module.sass": 1917,
	"./pages/ExtrasPage/screens/ExtrasList/components/CategoryList/CategoryList.module.sass.d": 3630,
	"./pages/ExtrasPage/screens/ExtrasList/components/CategoryList/CategoryList.module.sass.d.ts": 3630,
	"./pages/ExtrasPage/screens/ExtrasList/components/CategoryList/CategoryList.tsx": 2133,
	"./pages/ExtrasPage/screens/ExtrasList/components/CategoryNavBar": 2557,
	"./pages/ExtrasPage/screens/ExtrasList/components/CategoryNavBar.tsx": 2557,
	"./pages/ExtrasPage/screens/ExtrasList/queries/__generated__/ExtrasListQuery": 3631,
	"./pages/ExtrasPage/screens/ExtrasList/queries/__generated__/ExtrasListQuery.ts": 3631,
	"./pages/ExtrasPage/screens/ExtrasList/queries/extrasListQuery": 2135,
	"./pages/ExtrasPage/screens/ExtrasList/queries/extrasListQuery.ts": 2135,
	"./pages/ExtrasPage/screens/ProductCollection": 1798,
	"./pages/ExtrasPage/screens/ProductCollection/": 1798,
	"./pages/ExtrasPage/screens/ProductCollection/ProductCollection": 875,
	"./pages/ExtrasPage/screens/ProductCollection/ProductCollection.module": 1380,
	"./pages/ExtrasPage/screens/ProductCollection/ProductCollection.module.sass": 1380,
	"./pages/ExtrasPage/screens/ProductCollection/ProductCollection.module.sass.d": 3632,
	"./pages/ExtrasPage/screens/ProductCollection/ProductCollection.module.sass.d.ts": 3632,
	"./pages/ExtrasPage/screens/ProductCollection/ProductCollection.tsx": 875,
	"./pages/ExtrasPage/screens/ProductCollection/components/SectionWrapper": 767,
	"./pages/ExtrasPage/screens/ProductCollection/components/SectionWrapper/": 767,
	"./pages/ExtrasPage/screens/ProductCollection/components/SectionWrapper/SectionWrapper": 2041,
	"./pages/ExtrasPage/screens/ProductCollection/components/SectionWrapper/SectionWrapper.module": 1658,
	"./pages/ExtrasPage/screens/ProductCollection/components/SectionWrapper/SectionWrapper.module.sass": 1658,
	"./pages/ExtrasPage/screens/ProductCollection/components/SectionWrapper/SectionWrapper.module.sass.d": 3633,
	"./pages/ExtrasPage/screens/ProductCollection/components/SectionWrapper/SectionWrapper.module.sass.d.ts": 3633,
	"./pages/ExtrasPage/screens/ProductCollection/components/SectionWrapper/SectionWrapper.tsx": 2041,
	"./pages/ExtrasPage/screens/ProductCollection/components/SectionWrapper/index": 767,
	"./pages/ExtrasPage/screens/ProductCollection/components/SectionWrapper/index.ts": 767,
	"./pages/ExtrasPage/screens/ProductCollection/components/atoms/FrequencyVariantIcon": 1200,
	"./pages/ExtrasPage/screens/ProductCollection/components/atoms/FrequencyVariantIcon/": 1200,
	"./pages/ExtrasPage/screens/ProductCollection/components/atoms/FrequencyVariantIcon/FrequencyVariantIcon": 2050,
	"./pages/ExtrasPage/screens/ProductCollection/components/atoms/FrequencyVariantIcon/FrequencyVariantIcon.module": 1920,
	"./pages/ExtrasPage/screens/ProductCollection/components/atoms/FrequencyVariantIcon/FrequencyVariantIcon.module.sass": 1920,
	"./pages/ExtrasPage/screens/ProductCollection/components/atoms/FrequencyVariantIcon/FrequencyVariantIcon.module.sass.d": 3634,
	"./pages/ExtrasPage/screens/ProductCollection/components/atoms/FrequencyVariantIcon/FrequencyVariantIcon.module.sass.d.ts": 3634,
	"./pages/ExtrasPage/screens/ProductCollection/components/atoms/FrequencyVariantIcon/FrequencyVariantIcon.tsx": 2050,
	"./pages/ExtrasPage/screens/ProductCollection/components/atoms/FrequencyVariantIcon/index": 1200,
	"./pages/ExtrasPage/screens/ProductCollection/components/atoms/FrequencyVariantIcon/index.ts": 1200,
	"./pages/ExtrasPage/screens/ProductCollection/components/molecules/FixedBase": 1749,
	"./pages/ExtrasPage/screens/ProductCollection/components/molecules/FixedBase/": 1749,
	"./pages/ExtrasPage/screens/ProductCollection/components/molecules/FixedBase/FixedBase": 2038,
	"./pages/ExtrasPage/screens/ProductCollection/components/molecules/FixedBase/FixedBase.module": 2332,
	"./pages/ExtrasPage/screens/ProductCollection/components/molecules/FixedBase/FixedBase.module.sass": 2332,
	"./pages/ExtrasPage/screens/ProductCollection/components/molecules/FixedBase/FixedBase.module.sass.d": 3635,
	"./pages/ExtrasPage/screens/ProductCollection/components/molecules/FixedBase/FixedBase.module.sass.d.ts": 3635,
	"./pages/ExtrasPage/screens/ProductCollection/components/molecules/FixedBase/FixedBase.tsx": 2038,
	"./pages/ExtrasPage/screens/ProductCollection/components/molecules/FixedBase/index": 1749,
	"./pages/ExtrasPage/screens/ProductCollection/components/molecules/FixedBase/index.ts": 1749,
	"./pages/ExtrasPage/screens/ProductCollection/components/molecules/ProductPrice": 1710,
	"./pages/ExtrasPage/screens/ProductCollection/components/molecules/ProductPrice/": 1710,
	"./pages/ExtrasPage/screens/ProductCollection/components/molecules/ProductPrice/ProductPrice": 1051,
	"./pages/ExtrasPage/screens/ProductCollection/components/molecules/ProductPrice/ProductPrice.module": 2470,
	"./pages/ExtrasPage/screens/ProductCollection/components/molecules/ProductPrice/ProductPrice.module.sass": 2470,
	"./pages/ExtrasPage/screens/ProductCollection/components/molecules/ProductPrice/ProductPrice.module.sass.d": 3636,
	"./pages/ExtrasPage/screens/ProductCollection/components/molecules/ProductPrice/ProductPrice.module.sass.d.ts": 3636,
	"./pages/ExtrasPage/screens/ProductCollection/components/molecules/ProductPrice/ProductPrice.tsx": 1051,
	"./pages/ExtrasPage/screens/ProductCollection/components/molecules/ProductPrice/__generated__/PriceFragment": 3637,
	"./pages/ExtrasPage/screens/ProductCollection/components/molecules/ProductPrice/__generated__/PriceFragment.ts": 3637,
	"./pages/ExtrasPage/screens/ProductCollection/components/molecules/ProductPrice/fragments": 1328,
	"./pages/ExtrasPage/screens/ProductCollection/components/molecules/ProductPrice/fragments.ts": 1328,
	"./pages/ExtrasPage/screens/ProductCollection/components/molecules/ProductPrice/index": 1710,
	"./pages/ExtrasPage/screens/ProductCollection/components/molecules/ProductPrice/index.ts": 1710,
	"./pages/ExtrasPage/screens/ProductCollection/components/molecules/ProductVariant": 1760,
	"./pages/ExtrasPage/screens/ProductCollection/components/molecules/ProductVariant/": 1760,
	"./pages/ExtrasPage/screens/ProductCollection/components/molecules/ProductVariant/ProductVariant": 2053,
	"./pages/ExtrasPage/screens/ProductCollection/components/molecules/ProductVariant/ProductVariant.module": 1166,
	"./pages/ExtrasPage/screens/ProductCollection/components/molecules/ProductVariant/ProductVariant.module.sass": 1166,
	"./pages/ExtrasPage/screens/ProductCollection/components/molecules/ProductVariant/ProductVariant.module.sass.d": 3638,
	"./pages/ExtrasPage/screens/ProductCollection/components/molecules/ProductVariant/ProductVariant.module.sass.d.ts": 3638,
	"./pages/ExtrasPage/screens/ProductCollection/components/molecules/ProductVariant/ProductVariant.tsx": 2053,
	"./pages/ExtrasPage/screens/ProductCollection/components/molecules/ProductVariant/index": 1760,
	"./pages/ExtrasPage/screens/ProductCollection/components/molecules/ProductVariant/index.ts": 1760,
	"./pages/ExtrasPage/screens/ProductCollection/components/molecules/ProductVariantFrequency": 1597,
	"./pages/ExtrasPage/screens/ProductCollection/components/molecules/ProductVariantFrequency/": 1597,
	"./pages/ExtrasPage/screens/ProductCollection/components/molecules/ProductVariantFrequency/ProductVariantFrequency": 2049,
	"./pages/ExtrasPage/screens/ProductCollection/components/molecules/ProductVariantFrequency/ProductVariantFrequency.module": 822,
	"./pages/ExtrasPage/screens/ProductCollection/components/molecules/ProductVariantFrequency/ProductVariantFrequency.module.sass": 822,
	"./pages/ExtrasPage/screens/ProductCollection/components/molecules/ProductVariantFrequency/ProductVariantFrequency.module.sass.d": 3639,
	"./pages/ExtrasPage/screens/ProductCollection/components/molecules/ProductVariantFrequency/ProductVariantFrequency.module.sass.d.ts": 3639,
	"./pages/ExtrasPage/screens/ProductCollection/components/molecules/ProductVariantFrequency/ProductVariantFrequency.tsx": 2049,
	"./pages/ExtrasPage/screens/ProductCollection/components/molecules/ProductVariantFrequency/index": 1597,
	"./pages/ExtrasPage/screens/ProductCollection/components/molecules/ProductVariantFrequency/index.ts": 1597,
	"./pages/ExtrasPage/screens/ProductCollection/components/molecules/ProductVariantFrequencyDropDown": 1758,
	"./pages/ExtrasPage/screens/ProductCollection/components/molecules/ProductVariantFrequencyDropDown/": 1758,
	"./pages/ExtrasPage/screens/ProductCollection/components/molecules/ProductVariantFrequencyDropDown/ProductVariantFrequencyDropDown": 2051,
	"./pages/ExtrasPage/screens/ProductCollection/components/molecules/ProductVariantFrequencyDropDown/ProductVariantFrequencyDropDown.module": 625,
	"./pages/ExtrasPage/screens/ProductCollection/components/molecules/ProductVariantFrequencyDropDown/ProductVariantFrequencyDropDown.module.sass": 625,
	"./pages/ExtrasPage/screens/ProductCollection/components/molecules/ProductVariantFrequencyDropDown/ProductVariantFrequencyDropDown.module.sass.d": 3640,
	"./pages/ExtrasPage/screens/ProductCollection/components/molecules/ProductVariantFrequencyDropDown/ProductVariantFrequencyDropDown.module.sass.d.ts": 3640,
	"./pages/ExtrasPage/screens/ProductCollection/components/molecules/ProductVariantFrequencyDropDown/ProductVariantFrequencyDropDown.tsx": 2051,
	"./pages/ExtrasPage/screens/ProductCollection/components/molecules/ProductVariantFrequencyDropDown/index": 1758,
	"./pages/ExtrasPage/screens/ProductCollection/components/molecules/ProductVariantFrequencyDropDown/index.ts": 1758,
	"./pages/ExtrasPage/screens/ProductCollection/components/molecules/ReviewCard": 1752,
	"./pages/ExtrasPage/screens/ProductCollection/components/molecules/ReviewCard/": 1752,
	"./pages/ExtrasPage/screens/ProductCollection/components/molecules/ReviewCard/ReviewCard": 2043,
	"./pages/ExtrasPage/screens/ProductCollection/components/molecules/ReviewCard/ReviewCard.module": 1659,
	"./pages/ExtrasPage/screens/ProductCollection/components/molecules/ReviewCard/ReviewCard.module.sass": 1659,
	"./pages/ExtrasPage/screens/ProductCollection/components/molecules/ReviewCard/ReviewCard.module.sass.d": 3641,
	"./pages/ExtrasPage/screens/ProductCollection/components/molecules/ReviewCard/ReviewCard.module.sass.d.ts": 3641,
	"./pages/ExtrasPage/screens/ProductCollection/components/molecules/ReviewCard/ReviewCard.tsx": 2043,
	"./pages/ExtrasPage/screens/ProductCollection/components/molecules/ReviewCard/index": 1752,
	"./pages/ExtrasPage/screens/ProductCollection/components/molecules/ReviewCard/index.ts": 1752,
	"./pages/ExtrasPage/screens/ProductCollection/components/organisms/About": 1750,
	"./pages/ExtrasPage/screens/ProductCollection/components/organisms/About/": 1750,
	"./pages/ExtrasPage/screens/ProductCollection/components/organisms/About/About": 2040,
	"./pages/ExtrasPage/screens/ProductCollection/components/organisms/About/About.module": 2559,
	"./pages/ExtrasPage/screens/ProductCollection/components/organisms/About/About.module.sass": 2559,
	"./pages/ExtrasPage/screens/ProductCollection/components/organisms/About/About.module.sass.d": 3642,
	"./pages/ExtrasPage/screens/ProductCollection/components/organisms/About/About.module.sass.d.ts": 3642,
	"./pages/ExtrasPage/screens/ProductCollection/components/organisms/About/About.tsx": 2040,
	"./pages/ExtrasPage/screens/ProductCollection/components/organisms/About/index": 1750,
	"./pages/ExtrasPage/screens/ProductCollection/components/organisms/About/index.ts": 1750,
	"./pages/ExtrasPage/screens/ProductCollection/components/organisms/CustomerReviews": 1751,
	"./pages/ExtrasPage/screens/ProductCollection/components/organisms/CustomerReviews/": 1751,
	"./pages/ExtrasPage/screens/ProductCollection/components/organisms/CustomerReviews/CustomerReviews": 2042,
	"./pages/ExtrasPage/screens/ProductCollection/components/organisms/CustomerReviews/CustomerReviews.module": 1660,
	"./pages/ExtrasPage/screens/ProductCollection/components/organisms/CustomerReviews/CustomerReviews.module.sass": 1660,
	"./pages/ExtrasPage/screens/ProductCollection/components/organisms/CustomerReviews/CustomerReviews.module.sass.d": 3643,
	"./pages/ExtrasPage/screens/ProductCollection/components/organisms/CustomerReviews/CustomerReviews.module.sass.d.ts": 3643,
	"./pages/ExtrasPage/screens/ProductCollection/components/organisms/CustomerReviews/CustomerReviews.tsx": 2042,
	"./pages/ExtrasPage/screens/ProductCollection/components/organisms/CustomerReviews/index": 1751,
	"./pages/ExtrasPage/screens/ProductCollection/components/organisms/CustomerReviews/index.ts": 1751,
	"./pages/ExtrasPage/screens/ProductCollection/components/organisms/Description": 1753,
	"./pages/ExtrasPage/screens/ProductCollection/components/organisms/Description/": 1753,
	"./pages/ExtrasPage/screens/ProductCollection/components/organisms/Description/Description": 2044,
	"./pages/ExtrasPage/screens/ProductCollection/components/organisms/Description/Description.module": 1918,
	"./pages/ExtrasPage/screens/ProductCollection/components/organisms/Description/Description.module.sass": 1918,
	"./pages/ExtrasPage/screens/ProductCollection/components/organisms/Description/Description.module.sass.d": 3644,
	"./pages/ExtrasPage/screens/ProductCollection/components/organisms/Description/Description.module.sass.d.ts": 3644,
	"./pages/ExtrasPage/screens/ProductCollection/components/organisms/Description/Description.tsx": 2044,
	"./pages/ExtrasPage/screens/ProductCollection/components/organisms/Description/index": 1753,
	"./pages/ExtrasPage/screens/ProductCollection/components/organisms/Description/index.ts": 1753,
	"./pages/ExtrasPage/screens/ProductCollection/components/organisms/Gallery": 1754,
	"./pages/ExtrasPage/screens/ProductCollection/components/organisms/Gallery/": 1754,
	"./pages/ExtrasPage/screens/ProductCollection/components/organisms/Gallery/Gallery": 2045,
	"./pages/ExtrasPage/screens/ProductCollection/components/organisms/Gallery/Gallery.module": 1661,
	"./pages/ExtrasPage/screens/ProductCollection/components/organisms/Gallery/Gallery.module.sass": 1661,
	"./pages/ExtrasPage/screens/ProductCollection/components/organisms/Gallery/Gallery.module.sass.d": 3645,
	"./pages/ExtrasPage/screens/ProductCollection/components/organisms/Gallery/Gallery.module.sass.d.ts": 3645,
	"./pages/ExtrasPage/screens/ProductCollection/components/organisms/Gallery/Gallery.tsx": 2045,
	"./pages/ExtrasPage/screens/ProductCollection/components/organisms/Gallery/index": 1754,
	"./pages/ExtrasPage/screens/ProductCollection/components/organisms/Gallery/index.ts": 1754,
	"./pages/ExtrasPage/screens/ProductCollection/components/organisms/KeyBenefits": 1755,
	"./pages/ExtrasPage/screens/ProductCollection/components/organisms/KeyBenefits/": 1755,
	"./pages/ExtrasPage/screens/ProductCollection/components/organisms/KeyBenefits/KeyBenefits": 2046,
	"./pages/ExtrasPage/screens/ProductCollection/components/organisms/KeyBenefits/KeyBenefits.module": 2334,
	"./pages/ExtrasPage/screens/ProductCollection/components/organisms/KeyBenefits/KeyBenefits.module.sass": 2334,
	"./pages/ExtrasPage/screens/ProductCollection/components/organisms/KeyBenefits/KeyBenefits.module.sass.d": 3646,
	"./pages/ExtrasPage/screens/ProductCollection/components/organisms/KeyBenefits/KeyBenefits.module.sass.d.ts": 3646,
	"./pages/ExtrasPage/screens/ProductCollection/components/organisms/KeyBenefits/KeyBenefits.tsx": 2046,
	"./pages/ExtrasPage/screens/ProductCollection/components/organisms/KeyBenefits/index": 1755,
	"./pages/ExtrasPage/screens/ProductCollection/components/organisms/KeyBenefits/index.ts": 1755,
	"./pages/ExtrasPage/screens/ProductCollection/components/organisms/ProductCollectionTitle": 1756,
	"./pages/ExtrasPage/screens/ProductCollection/components/organisms/ProductCollectionTitle/": 1756,
	"./pages/ExtrasPage/screens/ProductCollection/components/organisms/ProductCollectionTitle/ProductCollectionTitle": 2047,
	"./pages/ExtrasPage/screens/ProductCollection/components/organisms/ProductCollectionTitle/ProductCollectionTitle.module": 1919,
	"./pages/ExtrasPage/screens/ProductCollection/components/organisms/ProductCollectionTitle/ProductCollectionTitle.module.sass": 1919,
	"./pages/ExtrasPage/screens/ProductCollection/components/organisms/ProductCollectionTitle/ProductCollectionTitle.module.sass.d": 3647,
	"./pages/ExtrasPage/screens/ProductCollection/components/organisms/ProductCollectionTitle/ProductCollectionTitle.module.sass.d.ts": 3647,
	"./pages/ExtrasPage/screens/ProductCollection/components/organisms/ProductCollectionTitle/ProductCollectionTitle.tsx": 2047,
	"./pages/ExtrasPage/screens/ProductCollection/components/organisms/ProductCollectionTitle/index": 1756,
	"./pages/ExtrasPage/screens/ProductCollection/components/organisms/ProductCollectionTitle/index.ts": 1756,
	"./pages/ExtrasPage/screens/ProductCollection/components/organisms/ProductUnavailable": 1310,
	"./pages/ExtrasPage/screens/ProductCollection/components/organisms/ProductUnavailable/": 1310,
	"./pages/ExtrasPage/screens/ProductCollection/components/organisms/ProductUnavailable/ProductUnavailable": 2039,
	"./pages/ExtrasPage/screens/ProductCollection/components/organisms/ProductUnavailable/ProductUnavailable.module": 2558,
	"./pages/ExtrasPage/screens/ProductCollection/components/organisms/ProductUnavailable/ProductUnavailable.module.sass": 2558,
	"./pages/ExtrasPage/screens/ProductCollection/components/organisms/ProductUnavailable/ProductUnavailable.module.sass.d": 3648,
	"./pages/ExtrasPage/screens/ProductCollection/components/organisms/ProductUnavailable/ProductUnavailable.module.sass.d.ts": 3648,
	"./pages/ExtrasPage/screens/ProductCollection/components/organisms/ProductUnavailable/ProductUnavailable.tsx": 2039,
	"./pages/ExtrasPage/screens/ProductCollection/components/organisms/ProductUnavailable/index": 1310,
	"./pages/ExtrasPage/screens/ProductCollection/components/organisms/ProductUnavailable/index.ts": 1310,
	"./pages/ExtrasPage/screens/ProductCollection/components/organisms/ProductVariantFrequencies": 1757,
	"./pages/ExtrasPage/screens/ProductCollection/components/organisms/ProductVariantFrequencies/": 1757,
	"./pages/ExtrasPage/screens/ProductCollection/components/organisms/ProductVariantFrequencies/ProductVariantFrequencies": 2048,
	"./pages/ExtrasPage/screens/ProductCollection/components/organisms/ProductVariantFrequencies/ProductVariantFrequencies.module": 2560,
	"./pages/ExtrasPage/screens/ProductCollection/components/organisms/ProductVariantFrequencies/ProductVariantFrequencies.module.sass": 2560,
	"./pages/ExtrasPage/screens/ProductCollection/components/organisms/ProductVariantFrequencies/ProductVariantFrequencies.module.sass.d": 3649,
	"./pages/ExtrasPage/screens/ProductCollection/components/organisms/ProductVariantFrequencies/ProductVariantFrequencies.module.sass.d.ts": 3649,
	"./pages/ExtrasPage/screens/ProductCollection/components/organisms/ProductVariantFrequencies/ProductVariantFrequencies.tsx": 2048,
	"./pages/ExtrasPage/screens/ProductCollection/components/organisms/ProductVariantFrequencies/index": 1757,
	"./pages/ExtrasPage/screens/ProductCollection/components/organisms/ProductVariantFrequencies/index.ts": 1757,
	"./pages/ExtrasPage/screens/ProductCollection/components/organisms/ProductVariants": 1759,
	"./pages/ExtrasPage/screens/ProductCollection/components/organisms/ProductVariants/": 1759,
	"./pages/ExtrasPage/screens/ProductCollection/components/organisms/ProductVariants/ProductVariants": 2052,
	"./pages/ExtrasPage/screens/ProductCollection/components/organisms/ProductVariants/ProductVariants.module": 2335,
	"./pages/ExtrasPage/screens/ProductCollection/components/organisms/ProductVariants/ProductVariants.module.sass": 2335,
	"./pages/ExtrasPage/screens/ProductCollection/components/organisms/ProductVariants/ProductVariants.module.sass.d": 3650,
	"./pages/ExtrasPage/screens/ProductCollection/components/organisms/ProductVariants/ProductVariants.module.sass.d.ts": 3650,
	"./pages/ExtrasPage/screens/ProductCollection/components/organisms/ProductVariants/ProductVariants.tsx": 2052,
	"./pages/ExtrasPage/screens/ProductCollection/components/organisms/ProductVariants/index": 1759,
	"./pages/ExtrasPage/screens/ProductCollection/components/organisms/ProductVariants/index.ts": 1759,
	"./pages/ExtrasPage/screens/ProductCollection/components/organisms/QuantitySelection": 1761,
	"./pages/ExtrasPage/screens/ProductCollection/components/organisms/QuantitySelection/": 1761,
	"./pages/ExtrasPage/screens/ProductCollection/components/organisms/QuantitySelection/QuantitySelection": 2083,
	"./pages/ExtrasPage/screens/ProductCollection/components/organisms/QuantitySelection/QuantitySelection.module": 2561,
	"./pages/ExtrasPage/screens/ProductCollection/components/organisms/QuantitySelection/QuantitySelection.module.sass": 2561,
	"./pages/ExtrasPage/screens/ProductCollection/components/organisms/QuantitySelection/QuantitySelection.module.sass.d": 3651,
	"./pages/ExtrasPage/screens/ProductCollection/components/organisms/QuantitySelection/QuantitySelection.module.sass.d.ts": 3651,
	"./pages/ExtrasPage/screens/ProductCollection/components/organisms/QuantitySelection/QuantitySelection.tsx": 2083,
	"./pages/ExtrasPage/screens/ProductCollection/components/organisms/QuantitySelection/index": 1761,
	"./pages/ExtrasPage/screens/ProductCollection/components/organisms/QuantitySelection/index.ts": 1761,
	"./pages/ExtrasPage/screens/ProductCollection/helpers/basketItemsCount": 3652,
	"./pages/ExtrasPage/screens/ProductCollection/helpers/basketItemsCount.ts": 3652,
	"./pages/ExtrasPage/screens/ProductCollection/helpers/copies": 1327,
	"./pages/ExtrasPage/screens/ProductCollection/helpers/copies.ts": 1327,
	"./pages/ExtrasPage/screens/ProductCollection/hooks/useSelectedProduct": 2456,
	"./pages/ExtrasPage/screens/ProductCollection/hooks/useSelectedProduct/": 2456,
	"./pages/ExtrasPage/screens/ProductCollection/hooks/useSelectedProduct/index": 2456,
	"./pages/ExtrasPage/screens/ProductCollection/hooks/useSelectedProduct/index.ts": 2456,
	"./pages/ExtrasPage/screens/ProductCollection/hooks/useSelectedProduct/useSelectedProduct": 1762,
	"./pages/ExtrasPage/screens/ProductCollection/hooks/useSelectedProduct/useSelectedProduct.ts": 1762,
	"./pages/ExtrasPage/screens/ProductCollection/index": 1798,
	"./pages/ExtrasPage/screens/ProductCollection/index.ts": 1798,
	"./pages/ExtrasPage/screens/ProductCollection/mutations/__generated__/orderProductsCreate": 3653,
	"./pages/ExtrasPage/screens/ProductCollection/mutations/__generated__/orderProductsCreate.ts": 3653,
	"./pages/ExtrasPage/screens/ProductCollection/mutations/ordersProductCreate": 1337,
	"./pages/ExtrasPage/screens/ProductCollection/mutations/ordersProductCreate.ts": 1337,
	"./pages/ExtrasPage/screens/ProductCollection/queries/__generated__/ProductCollectionQuery": 3654,
	"./pages/ExtrasPage/screens/ProductCollection/queries/__generated__/ProductCollectionQuery.ts": 3654,
	"./pages/ExtrasPage/screens/ProductCollection/queries/productCollectionQuery": 2562,
	"./pages/ExtrasPage/screens/ProductCollection/queries/productCollectionQuery.ts": 2562,
	"./pages/ExtrasPage/screens/ProductCollection/utils/customerReviewsRating": 1826,
	"./pages/ExtrasPage/screens/ProductCollection/utils/customerReviewsRating.ts": 1826,
	"./pages/Influencers/Influencers": 2901,
	"./pages/Influencers/Influencers.module": 2369,
	"./pages/Influencers/Influencers.module.sass": 2369,
	"./pages/Influencers/Influencers.module.sass.d": 3655,
	"./pages/Influencers/Influencers.module.sass.d.ts": 3655,
	"./pages/Influencers/Influencers.tsx": 2901,
	"./pages/Influencers/components/SignupScreen": 2784,
	"./pages/Influencers/components/SignupScreen.tsx": 2784,
	"./pages/Influencers/mutations/__generated__/SignUpInfluencerMutation": 3656,
	"./pages/Influencers/mutations/__generated__/SignUpInfluencerMutation.ts": 3656,
	"./pages/Influencers/mutations/signupInfluencer": 2785,
	"./pages/Influencers/mutations/signupInfluencer.ts": 2785,
	"./pages/KeptSubscription/KeptSubscription": 2902,
	"./pages/KeptSubscription/KeptSubscription.module": 2370,
	"./pages/KeptSubscription/KeptSubscription.module.sass": 2370,
	"./pages/KeptSubscription/KeptSubscription.module.sass.d": 3657,
	"./pages/KeptSubscription/KeptSubscription.module.sass.d.ts": 3657,
	"./pages/KeptSubscription/KeptSubscription.tsx": 2902,
	"./pages/LoadingPaused/LoadingPaused": 3658,
	"./pages/LoadingPaused/LoadingPaused.stories": 3659,
	"./pages/LoadingPaused/LoadingPaused.stories.tsx": 3659,
	"./pages/LoadingPaused/LoadingPaused.tsx": 3658,
	"./pages/MFITBPlanOffer/MFITBPlanOffer": 2138,
	"./pages/MFITBPlanOffer/MFITBPlanOffer.module": 1167,
	"./pages/MFITBPlanOffer/MFITBPlanOffer.module.sass": 1167,
	"./pages/MFITBPlanOffer/MFITBPlanOffer.module.sass.d": 3660,
	"./pages/MFITBPlanOffer/MFITBPlanOffer.module.sass.d.ts": 3660,
	"./pages/MFITBPlanOffer/MFITBPlanOffer.tsx": 2138,
	"./pages/MFITBPlanOffer/queries/MFITBPlanOfferQuery": 2563,
	"./pages/MFITBPlanOffer/queries/MFITBPlanOfferQuery.ts": 2563,
	"./pages/MFITBPlanOffer/queries/__generated__/MFITBPlanOfferQuery": 3661,
	"./pages/MFITBPlanOffer/queries/__generated__/MFITBPlanOfferQuery.ts": 3661,
	"./pages/MealtimeChecklist/MealtimeChecklist": 2139,
	"./pages/MealtimeChecklist/MealtimeChecklist.module": 1381,
	"./pages/MealtimeChecklist/MealtimeChecklist.module.sass": 1381,
	"./pages/MealtimeChecklist/MealtimeChecklist.module.sass.d": 3662,
	"./pages/MealtimeChecklist/MealtimeChecklist.module.sass.d.ts": 3662,
	"./pages/MealtimeChecklist/MealtimeChecklist.tsx": 2139,
	"./pages/MealtimeChecklist/components/PawTip/PawTip": 893,
	"./pages/MealtimeChecklist/components/PawTip/PawTip.module": 2336,
	"./pages/MealtimeChecklist/components/PawTip/PawTip.module.sass": 2336,
	"./pages/MealtimeChecklist/components/PawTip/PawTip.module.sass.d": 3663,
	"./pages/MealtimeChecklist/components/PawTip/PawTip.module.sass.d.ts": 3663,
	"./pages/MealtimeChecklist/components/PawTip/PawTip.tsx": 893,
	"./pages/MyAccountPage/MyAccountPage": 2140,
	"./pages/MyAccountPage/MyAccountPage.module": 1104,
	"./pages/MyAccountPage/MyAccountPage.module.sass": 1104,
	"./pages/MyAccountPage/MyAccountPage.module.sass.d": 3664,
	"./pages/MyAccountPage/MyAccountPage.module.sass.d.ts": 3664,
	"./pages/MyAccountPage/MyAccountPage.tsx": 2140,
	"./pages/MyDetailsPage/components/AccountDetailsCard/AccountDetailsCard": 1202,
	"./pages/MyDetailsPage/components/AccountDetailsCard/AccountDetailsCard.module": 2706,
	"./pages/MyDetailsPage/components/AccountDetailsCard/AccountDetailsCard.module.sass": 2706,
	"./pages/MyDetailsPage/components/AccountDetailsCard/AccountDetailsCard.module.sass.d": 3665,
	"./pages/MyDetailsPage/components/AccountDetailsCard/AccountDetailsCard.module.sass.d.ts": 3665,
	"./pages/MyDetailsPage/components/AccountDetailsCard/AccountDetailsCard.tsx": 1202,
	"./pages/MyDetailsPage/components/DetailsCardSkeleton/DetailsCardSkeleton": 1603,
	"./pages/MyDetailsPage/components/DetailsCardSkeleton/DetailsCardSkeleton.module": 1170,
	"./pages/MyDetailsPage/components/DetailsCardSkeleton/DetailsCardSkeleton.module.sass": 1170,
	"./pages/MyDetailsPage/components/DetailsCardSkeleton/DetailsCardSkeleton.module.sass.d": 3666,
	"./pages/MyDetailsPage/components/DetailsCardSkeleton/DetailsCardSkeleton.module.sass.d.ts": 3666,
	"./pages/MyDetailsPage/components/DetailsCardSkeleton/DetailsCardSkeleton.tsx": 1603,
	"./pages/MyDetailsPage/fragments/__generated__/paymentMethodsFragment": 3667,
	"./pages/MyDetailsPage/fragments/__generated__/paymentMethodsFragment.ts": 3667,
	"./pages/MyDetailsPage/fragments/__generated__/userFragment": 3668,
	"./pages/MyDetailsPage/fragments/__generated__/userFragment.ts": 3668,
	"./pages/MyDetailsPage/fragments/fragments": 2786,
	"./pages/MyDetailsPage/fragments/fragments.ts": 2786,
	"./pages/MyDetailsPage/hooks/useAddBancontact": 2698,
	"./pages/MyDetailsPage/hooks/useAddBancontact.ts": 2698,
	"./pages/MyDetailsPage/hooks/useAddIdeal": 2695,
	"./pages/MyDetailsPage/hooks/useAddIdeal.ts": 2695,
	"./pages/MyDetailsPage/hooks/useAddPaypal": 2696,
	"./pages/MyDetailsPage/hooks/useAddPaypal.ts": 2696,
	"./pages/MyDetailsPage/hooks/useUnsavedDataCheck": 3669,
	"./pages/MyDetailsPage/hooks/useUnsavedDataCheck.tsx": 3669,
	"./pages/MyDetailsPage/queries/__generated__/MyDetailsInitialDataQuery": 3670,
	"./pages/MyDetailsPage/queries/__generated__/MyDetailsInitialDataQuery.ts": 3670,
	"./pages/MyDetailsPage/queries/__generated__/MyDetailsPersonalDetailsQuery": 3671,
	"./pages/MyDetailsPage/queries/__generated__/MyDetailsPersonalDetailsQuery.ts": 3671,
	"./pages/MyDetailsPage/queries/queries": 3672,
	"./pages/MyDetailsPage/queries/queries.ts": 3672,
	"./pages/MyDetailsPage/screens/PaymentMethods/PaymentMethods": 2141,
	"./pages/MyDetailsPage/screens/PaymentMethods/PaymentMethods.module": 583,
	"./pages/MyDetailsPage/screens/PaymentMethods/PaymentMethods.module.sass": 583,
	"./pages/MyDetailsPage/screens/PaymentMethods/PaymentMethods.module.sass.d": 3673,
	"./pages/MyDetailsPage/screens/PaymentMethods/PaymentMethods.module.sass.d.ts": 3673,
	"./pages/MyDetailsPage/screens/PaymentMethods/PaymentMethods.tsx": 2141,
	"./pages/MyDetailsPage/screens/PaymentMethods/PaymentMethodsPage": 2564,
	"./pages/MyDetailsPage/screens/PaymentMethods/PaymentMethodsPage.tsx": 2564,
	"./pages/MyDetailsPage/screens/PaymentMethods/PaymentMethodsSkeleton": 1853,
	"./pages/MyDetailsPage/screens/PaymentMethods/PaymentMethodsSkeleton.tsx": 1853,
	"./pages/MyDetailsPage/screens/PaymentMethods/components/AddPaymentMethod/AddPaymentMethod": 2180,
	"./pages/MyDetailsPage/screens/PaymentMethods/components/AddPaymentMethod/AddPaymentMethod.module": 894,
	"./pages/MyDetailsPage/screens/PaymentMethods/components/AddPaymentMethod/AddPaymentMethod.module.sass": 894,
	"./pages/MyDetailsPage/screens/PaymentMethods/components/AddPaymentMethod/AddPaymentMethod.module.sass.d": 3674,
	"./pages/MyDetailsPage/screens/PaymentMethods/components/AddPaymentMethod/AddPaymentMethod.module.sass.d.ts": 3674,
	"./pages/MyDetailsPage/screens/PaymentMethods/components/AddPaymentMethod/AddPaymentMethod.tsx": 2180,
	"./pages/MyDetailsPage/screens/PaymentMethods/components/AddPaymentMethod/AddPaymentMethodPage": 2689,
	"./pages/MyDetailsPage/screens/PaymentMethods/components/AddPaymentMethod/AddPaymentMethodPage.tsx": 2689,
	"./pages/MyDetailsPage/screens/PaymentMethods/components/AddPaymentMethod/AddPaymentMethodSkeleton": 2700,
	"./pages/MyDetailsPage/screens/PaymentMethods/components/AddPaymentMethod/AddPaymentMethodSkeleton.tsx": 2700,
	"./pages/MyDetailsPage/screens/PaymentMethods/components/AddPaymentMethod/queries/AddPaymentMethodQuery": 2694,
	"./pages/MyDetailsPage/screens/PaymentMethods/components/AddPaymentMethod/queries/AddPaymentMethodQuery.ts": 2694,
	"./pages/MyDetailsPage/screens/PaymentMethods/components/ArchivePaymentMethodModal/ArchivePaymentMethodModal": 2565,
	"./pages/MyDetailsPage/screens/PaymentMethods/components/ArchivePaymentMethodModal/ArchivePaymentMethodModal.tsx": 2565,
	"./pages/MyDetailsPage/screens/PaymentMethods/components/NoPaymentMethod/NoPaymentMethod": 2566,
	"./pages/MyDetailsPage/screens/PaymentMethods/components/NoPaymentMethod/NoPaymentMethod.tsx": 2566,
	"./pages/MyDetailsPage/screens/PaymentMethods/components/PaymentMethodCard/PaymentMethodCard": 2240,
	"./pages/MyDetailsPage/screens/PaymentMethods/components/PaymentMethodCard/PaymentMethodCard.module": 900,
	"./pages/MyDetailsPage/screens/PaymentMethods/components/PaymentMethodCard/PaymentMethodCard.module.sass": 900,
	"./pages/MyDetailsPage/screens/PaymentMethods/components/PaymentMethodCard/PaymentMethodCard.module.sass.d": 3675,
	"./pages/MyDetailsPage/screens/PaymentMethods/components/PaymentMethodCard/PaymentMethodCard.module.sass.d.ts": 3675,
	"./pages/MyDetailsPage/screens/PaymentMethods/components/PaymentMethodCard/PaymentMethodCard.tsx": 2240,
	"./pages/MyDetailsPage/screens/PaymentMethods/components/PaymentMethodCard/PaymentMethodSkeleton": 1847,
	"./pages/MyDetailsPage/screens/PaymentMethods/components/PaymentMethodCard/PaymentMethodSkeleton.tsx": 1847,
	"./pages/MyDetailsPage/screens/PaymentMethods/components/PaymentMethodCards/PaypalCard": 2699,
	"./pages/MyDetailsPage/screens/PaymentMethods/components/PaymentMethodCards/PaypalCard.tsx": 2699,
	"./pages/MyDetailsPage/screens/PaymentMethods/components/UpdateDefaultPaymentMethodModal/UpdateDefaultPaymentMethodModal": 2646,
	"./pages/MyDetailsPage/screens/PaymentMethods/components/UpdateDefaultPaymentMethodModal/UpdateDefaultPaymentMethodModal.tsx": 2646,
	"./pages/MyDetailsPage/screens/PaymentMethods/fragments/__generated__/BillingAgreementFragment": 3676,
	"./pages/MyDetailsPage/screens/PaymentMethods/fragments/__generated__/BillingAgreementFragment.ts": 3676,
	"./pages/MyDetailsPage/screens/PaymentMethods/fragments/__generated__/CreditCardPaymentMethodFragment": 3677,
	"./pages/MyDetailsPage/screens/PaymentMethods/fragments/__generated__/CreditCardPaymentMethodFragment.ts": 3677,
	"./pages/MyDetailsPage/screens/PaymentMethods/fragments/__generated__/MerchantInitiatedPaymentFragment": 3678,
	"./pages/MyDetailsPage/screens/PaymentMethods/fragments/__generated__/MerchantInitiatedPaymentFragment.ts": 3678,
	"./pages/MyDetailsPage/screens/PaymentMethods/fragments/__generated__/PaymentMethodsFragment": 3679,
	"./pages/MyDetailsPage/screens/PaymentMethods/fragments/__generated__/PaymentMethodsFragment.ts": 3679,
	"./pages/MyDetailsPage/screens/PaymentMethods/fragments/__generated__/SepaDirectDebitFragment": 3680,
	"./pages/MyDetailsPage/screens/PaymentMethods/fragments/__generated__/SepaDirectDebitFragment.ts": 3680,
	"./pages/MyDetailsPage/screens/PaymentMethods/fragments/paymentMethodFragments": 1072,
	"./pages/MyDetailsPage/screens/PaymentMethods/fragments/paymentMethodFragments.ts": 1072,
	"./pages/MyDetailsPage/screens/PaymentMethods/helpers/addPaymentMethod": 1351,
	"./pages/MyDetailsPage/screens/PaymentMethods/helpers/addPaymentMethod.tsx": 1351,
	"./pages/MyDetailsPage/screens/PaymentMethods/helpers/getPaypalAuthorisation": 2697,
	"./pages/MyDetailsPage/screens/PaymentMethods/helpers/getPaypalAuthorisation.ts": 2697,
	"./pages/MyDetailsPage/screens/PaymentMethods/mutations/ArchivePaymentMethodMutation": 2686,
	"./pages/MyDetailsPage/screens/PaymentMethods/mutations/ArchivePaymentMethodMutation.ts": 2686,
	"./pages/MyDetailsPage/screens/PaymentMethods/mutations/AuthenticationSetupCreateMutation": 3681,
	"./pages/MyDetailsPage/screens/PaymentMethods/mutations/AuthenticationSetupCreateMutation.ts": 3681,
	"./pages/MyDetailsPage/screens/PaymentMethods/mutations/CreatePaymentMethod": 1854,
	"./pages/MyDetailsPage/screens/PaymentMethods/mutations/CreatePaymentMethod.ts": 1854,
	"./pages/MyDetailsPage/screens/PaymentMethods/mutations/InstantChargeSetupCreate": 1845,
	"./pages/MyDetailsPage/screens/PaymentMethods/mutations/InstantChargeSetupCreate.ts": 1845,
	"./pages/MyDetailsPage/screens/PaymentMethods/mutations/PayOverdueInvoicesAndUnsuspend": 1846,
	"./pages/MyDetailsPage/screens/PaymentMethods/mutations/PayOverdueInvoicesAndUnsuspend.ts": 1846,
	"./pages/MyDetailsPage/screens/PaymentMethods/mutations/PaymentMethodSetActive": 2687,
	"./pages/MyDetailsPage/screens/PaymentMethods/mutations/PaymentMethodSetActive.ts": 2687,
	"./pages/MyDetailsPage/screens/PaymentMethods/mutations/SubscriptionUnsuspensionAttemptMutation": 1809,
	"./pages/MyDetailsPage/screens/PaymentMethods/mutations/SubscriptionUnsuspensionAttemptMutation.ts": 1809,
	"./pages/MyDetailsPage/screens/PaymentMethods/mutations/__generated__/ArchivePaymentMethod": 3682,
	"./pages/MyDetailsPage/screens/PaymentMethods/mutations/__generated__/ArchivePaymentMethod.ts": 3682,
	"./pages/MyDetailsPage/screens/PaymentMethods/mutations/__generated__/AuthenticationSetupCreateMutation": 3683,
	"./pages/MyDetailsPage/screens/PaymentMethods/mutations/__generated__/AuthenticationSetupCreateMutation.ts": 3683,
	"./pages/MyDetailsPage/screens/PaymentMethods/mutations/__generated__/CreatePaymentMethodMutation": 3684,
	"./pages/MyDetailsPage/screens/PaymentMethods/mutations/__generated__/CreatePaymentMethodMutation.ts": 3684,
	"./pages/MyDetailsPage/screens/PaymentMethods/mutations/__generated__/PaymentMethodSetActive": 3685,
	"./pages/MyDetailsPage/screens/PaymentMethods/mutations/__generated__/PaymentMethodSetActive.ts": 3685,
	"./pages/MyDetailsPage/screens/PaymentMethods/mutations/__generated__/SubscriptionUnsuspensionAttemptMutation": 3686,
	"./pages/MyDetailsPage/screens/PaymentMethods/mutations/__generated__/SubscriptionUnsuspensionAttemptMutation.ts": 3686,
	"./pages/MyDetailsPage/screens/PaymentMethods/mutations/__generated__/instantChargeSetupCreate": 3687,
	"./pages/MyDetailsPage/screens/PaymentMethods/mutations/__generated__/instantChargeSetupCreate.ts": 3687,
	"./pages/MyDetailsPage/screens/PaymentMethods/mutations/__generated__/payOverdueInvoicesAndUnsuspend": 3688,
	"./pages/MyDetailsPage/screens/PaymentMethods/mutations/__generated__/payOverdueInvoicesAndUnsuspend.ts": 3688,
	"./pages/MyDetailsPage/screens/PaymentMethods/queries/PaymentMethodsQuery": 2688,
	"./pages/MyDetailsPage/screens/PaymentMethods/queries/PaymentMethodsQuery.ts": 2688,
	"./pages/MyDetailsPage/screens/PaymentMethods/queries/__generated__/PaymentMethodsQuery": 3689,
	"./pages/MyDetailsPage/screens/PaymentMethods/queries/__generated__/PaymentMethodsQuery.ts": 3689,
	"./pages/NoDogsPage": 1312,
	"./pages/NoDogsPage/": 1312,
	"./pages/NoDogsPage/components/AddDogSection/AddDogSection": 1604,
	"./pages/NoDogsPage/components/AddDogSection/AddDogSection.module": 2353,
	"./pages/NoDogsPage/components/AddDogSection/AddDogSection.module.sass": 2353,
	"./pages/NoDogsPage/components/AddDogSection/AddDogSection.module.sass.d": 3690,
	"./pages/NoDogsPage/components/AddDogSection/AddDogSection.module.sass.d.ts": 3690,
	"./pages/NoDogsPage/components/AddDogSection/AddDogSection.tsx": 1604,
	"./pages/NoDogsPage/components/NoDogsHero/NoDogsHero": 2181,
	"./pages/NoDogsPage/components/NoDogsHero/NoDogsHero.module": 1091,
	"./pages/NoDogsPage/components/NoDogsHero/NoDogsHero.module.sass": 1091,
	"./pages/NoDogsPage/components/NoDogsHero/NoDogsHero.module.sass.d": 3691,
	"./pages/NoDogsPage/components/NoDogsHero/NoDogsHero.module.sass.d.ts": 3691,
	"./pages/NoDogsPage/components/NoDogsHero/NoDogsHero.tsx": 2181,
	"./pages/NoDogsPage/components/NoDogsStateContent": 1768,
	"./pages/NoDogsPage/components/NoDogsStateContent/": 1768,
	"./pages/NoDogsPage/components/NoDogsStateContent/NoDogsStateContent": 1767,
	"./pages/NoDogsPage/components/NoDogsStateContent/NoDogsStateContent.stories": 3692,
	"./pages/NoDogsPage/components/NoDogsStateContent/NoDogsStateContent.stories.tsx": 3692,
	"./pages/NoDogsPage/components/NoDogsStateContent/NoDogsStateContent.tsx": 1767,
	"./pages/NoDogsPage/components/NoDogsStateContent/index": 1768,
	"./pages/NoDogsPage/components/NoDogsStateContent/index.ts": 1768,
	"./pages/NoDogsPage/components/NoDogsStateContent/queries/__generated__/NoDogsHeroQuery": 3693,
	"./pages/NoDogsPage/components/NoDogsStateContent/queries/__generated__/NoDogsHeroQuery.ts": 3693,
	"./pages/NoDogsPage/components/NoDogsStateContent/queries/__generated__/NoDogsPageData": 3694,
	"./pages/NoDogsPage/components/NoDogsStateContent/queries/__generated__/NoDogsPageData.ts": 3694,
	"./pages/NoDogsPage/components/NoDogsStateContent/queries/__generated__/ProductSectionQuery": 3695,
	"./pages/NoDogsPage/components/NoDogsStateContent/queries/__generated__/ProductSectionQuery.ts": 3695,
	"./pages/NoDogsPage/components/NoDogsStateContent/queries/__generated__/productCollectionFragment": 3696,
	"./pages/NoDogsPage/components/NoDogsStateContent/queries/__generated__/productCollectionFragment.ts": 3696,
	"./pages/NoDogsPage/components/NoDogsStateContent/queries/noDogsPageQuery": 1353,
	"./pages/NoDogsPage/components/NoDogsStateContent/queries/noDogsPageQuery.ts": 1353,
	"./pages/NoDogsPage/components/ProductSection/ProductSection": 2182,
	"./pages/NoDogsPage/components/ProductSection/ProductSection.module": 1666,
	"./pages/NoDogsPage/components/ProductSection/ProductSection.module.sass": 1666,
	"./pages/NoDogsPage/components/ProductSection/ProductSection.module.sass.d": 3697,
	"./pages/NoDogsPage/components/ProductSection/ProductSection.module.sass.d.ts": 3697,
	"./pages/NoDogsPage/components/ProductSection/ProductSection.tsx": 2182,
	"./pages/NoDogsPage/index": 1312,
	"./pages/NoDogsPage/index.tsx": 1312,
	"./pages/NoDogsPage/routes": 2457,
	"./pages/NoDogsPage/routes/": 2457,
	"./pages/NoDogsPage/routes/RouterWrapper": 1769,
	"./pages/NoDogsPage/routes/RouterWrapper.tsx": 1769,
	"./pages/NoDogsPage/routes/index": 2457,
	"./pages/NoDogsPage/routes/index.ts": 2457,
	"./pages/NoDogsPage/types/pauses": 1855,
	"./pages/NoDogsPage/types/pauses.ts": 1855,
	"./pages/NoPaymentMethodPage/NoPaymentMethodPage": 2903,
	"./pages/NoPaymentMethodPage/NoPaymentMethodPage.module": 1373,
	"./pages/NoPaymentMethodPage/NoPaymentMethodPage.module.sass": 1373,
	"./pages/NoPaymentMethodPage/NoPaymentMethodPage.module.sass.d": 3698,
	"./pages/NoPaymentMethodPage/NoPaymentMethodPage.module.sass.d.ts": 3698,
	"./pages/NoPaymentMethodPage/NoPaymentMethodPage.stories": 3699,
	"./pages/NoPaymentMethodPage/NoPaymentMethodPage.stories.tsx": 3699,
	"./pages/NoPaymentMethodPage/NoPaymentMethodPage.tsx": 2903,
	"./pages/NoPaymentMethodPage/analytics/NoPaymentMethodAnalytics": 1352,
	"./pages/NoPaymentMethodPage/analytics/NoPaymentMethodAnalytics.tsx": 1352,
	"./pages/NoPaymentMethodPage/components/CreditCardView": 2790,
	"./pages/NoPaymentMethodPage/components/CreditCardView.tsx": 2790,
	"./pages/NoPaymentMethodPage/components/PaymentDetailsSection": 2787,
	"./pages/NoPaymentMethodPage/components/PaymentDetailsSection.tsx": 2787,
	"./pages/NoPaymentMethodPage/helpers/buySubscription": 2788,
	"./pages/NoPaymentMethodPage/helpers/buySubscription.tsx": 2788,
	"./pages/NoPaymentMethodPage/mutations/addPaymentMethod": 2789,
	"./pages/NoPaymentMethodPage/mutations/addPaymentMethod.ts": 2789,
	"./pages/NoPaymentMethodPage/queries/__generated__/NoPaymentMethodPageData": 3700,
	"./pages/NoPaymentMethodPage/queries/__generated__/NoPaymentMethodPageData.ts": 3700,
	"./pages/NoPaymentMethodPage/queries/noPaymentMethodPageQuery": 2791,
	"./pages/NoPaymentMethodPage/queries/noPaymentMethodPageQuery.ts": 2791,
	"./pages/NotFoundErrorPage/NotFoundErrorPage": 2208,
	"./pages/NotFoundErrorPage/NotFoundErrorPage.module": 1172,
	"./pages/NotFoundErrorPage/NotFoundErrorPage.module.sass": 1172,
	"./pages/NotFoundErrorPage/NotFoundErrorPage.module.sass.d": 3701,
	"./pages/NotFoundErrorPage/NotFoundErrorPage.module.sass.d.ts": 3701,
	"./pages/NotFoundErrorPage/NotFoundErrorPage.tsx": 2208,
	"./pages/OneOffBoxPage/queries/__generated__/OneOffBoxesCreate": 3702,
	"./pages/OneOffBoxPage/queries/__generated__/OneOffBoxesCreate.ts": 3702,
	"./pages/OneOffBoxPage/queries/__generated__/calendarDatesQuery": 3703,
	"./pages/OneOffBoxPage/queries/__generated__/calendarDatesQuery.ts": 3703,
	"./pages/OneOffBoxPage/queries/__generated__/oneOffBoxQuery": 3704,
	"./pages/OneOffBoxPage/queries/__generated__/oneOffBoxQuery.ts": 3704,
	"./pages/OneOffBoxPage/queries/queries": 1931,
	"./pages/OneOffBoxPage/queries/queries.ts": 1931,
	"./pages/OneOffBoxPage/screens/ConfirmationPage/ConfirmationPage": 2184,
	"./pages/OneOffBoxPage/screens/ConfirmationPage/ConfirmationPage.module": 1930,
	"./pages/OneOffBoxPage/screens/ConfirmationPage/ConfirmationPage.module.sass": 1930,
	"./pages/OneOffBoxPage/screens/ConfirmationPage/ConfirmationPage.module.sass.d": 3705,
	"./pages/OneOffBoxPage/screens/ConfirmationPage/ConfirmationPage.module.sass.d.ts": 3705,
	"./pages/OneOffBoxPage/screens/ConfirmationPage/ConfirmationPage.tsx": 2184,
	"./pages/OneOffBoxPage/screens/OneOffBox/OneOffBox": 2185,
	"./pages/OneOffBoxPage/screens/OneOffBox/OneOffBox.module": 1107,
	"./pages/OneOffBoxPage/screens/OneOffBox/OneOffBox.module.sass": 1107,
	"./pages/OneOffBoxPage/screens/OneOffBox/OneOffBox.module.sass.d": 3706,
	"./pages/OneOffBoxPage/screens/OneOffBox/OneOffBox.module.sass.d.ts": 3706,
	"./pages/OneOffBoxPage/screens/OneOffBox/OneOffBox.stories": 3707,
	"./pages/OneOffBoxPage/screens/OneOffBox/OneOffBox.stories.tsx": 3707,
	"./pages/OneOffBoxPage/screens/OneOffBox/OneOffBox.tsx": 2185,
	"./pages/OrderConfirmed/OrderConfirmed": 3708,
	"./pages/OrderConfirmed/OrderConfirmed.tsx": 3708,
	"./pages/OrderPage/OrderPage": 1142,
	"./pages/OrderPage/OrderPage.module": 826,
	"./pages/OrderPage/OrderPage.module.sass": 826,
	"./pages/OrderPage/OrderPage.module.sass.d": 3709,
	"./pages/OrderPage/OrderPage.module.sass.d.ts": 3709,
	"./pages/OrderPage/OrderPage.tsx": 1142,
	"./pages/OrderPage/OrderPageSkeleton": 2704,
	"./pages/OrderPage/OrderPageSkeleton.tsx": 2704,
	"./pages/OrderPage/__generated__/BoxDeliveryAddressUpdate": 3710,
	"./pages/OrderPage/__generated__/BoxDeliveryAddressUpdate.ts": 3710,
	"./pages/OrderPage/__generated__/BoxDeliveryDateUpdate": 3711,
	"./pages/OrderPage/__generated__/BoxDeliveryDateUpdate.ts": 3711,
	"./pages/OrderPage/__generated__/boxQuery": 3712,
	"./pages/OrderPage/__generated__/boxQuery.ts": 3712,
	"./pages/OrderPage/__generated__/mealsQuery": 3713,
	"./pages/OrderPage/__generated__/mealsQuery.ts": 3713,
	"./pages/OrderPage/components/AddMore/AddMore": 1584,
	"./pages/OrderPage/components/AddMore/AddMore.module": 2492,
	"./pages/OrderPage/components/AddMore/AddMore.module.sass": 2492,
	"./pages/OrderPage/components/AddMore/AddMore.module.sass.d": 3714,
	"./pages/OrderPage/components/AddMore/AddMore.module.sass.d.ts": 3714,
	"./pages/OrderPage/components/AddMore/AddMore.tsx": 1584,
	"./pages/OrderPage/components/AdditionalProductUpsellable": 1770,
	"./pages/OrderPage/components/AdditionalProductUpsellable/": 1770,
	"./pages/OrderPage/components/AdditionalProductUpsellable/AdditionalProductUpsellable": 2058,
	"./pages/OrderPage/components/AdditionalProductUpsellable/AdditionalProductUpsellable.module": 1667,
	"./pages/OrderPage/components/AdditionalProductUpsellable/AdditionalProductUpsellable.module.sass": 1667,
	"./pages/OrderPage/components/AdditionalProductUpsellable/AdditionalProductUpsellable.module.sass.d": 3715,
	"./pages/OrderPage/components/AdditionalProductUpsellable/AdditionalProductUpsellable.module.sass.d.ts": 3715,
	"./pages/OrderPage/components/AdditionalProductUpsellable/AdditionalProductUpsellable.tsx": 2058,
	"./pages/OrderPage/components/AdditionalProductUpsellable/index": 1770,
	"./pages/OrderPage/components/AdditionalProductUpsellable/index.ts": 1770,
	"./pages/OrderPage/components/InvoiceCard/InvoiceCard": 2188,
	"./pages/OrderPage/components/InvoiceCard/InvoiceCard.module": 1386,
	"./pages/OrderPage/components/InvoiceCard/InvoiceCard.module.sass": 1386,
	"./pages/OrderPage/components/InvoiceCard/InvoiceCard.module.sass.d": 3716,
	"./pages/OrderPage/components/InvoiceCard/InvoiceCard.module.sass.d.ts": 3716,
	"./pages/OrderPage/components/InvoiceCard/InvoiceCard.tsx": 2188,
	"./pages/OrderPage/components/RecipeSelection": 1771,
	"./pages/OrderPage/components/RecipeSelection/": 1771,
	"./pages/OrderPage/components/RecipeSelection/RecipeSelection": 2434,
	"./pages/OrderPage/components/RecipeSelection/RecipeSelection.tsx": 2434,
	"./pages/OrderPage/components/RecipeSelection/index": 1771,
	"./pages/OrderPage/components/RecipeSelection/index.ts": 1771,
	"./pages/OrderPage/helpers": 3717,
	"./pages/OrderPage/helpers.ts": 3717,
	"./pages/OrderPage/queries": 1085,
	"./pages/OrderPage/queries.ts": 1085,
	"./pages/OrdersPage/OrdersPage": 2243,
	"./pages/OrdersPage/OrdersPage.module": 1669,
	"./pages/OrdersPage/OrdersPage.module.sass": 1669,
	"./pages/OrdersPage/OrdersPage.module.sass.d": 3718,
	"./pages/OrdersPage/OrdersPage.module.sass.d.ts": 3718,
	"./pages/OrdersPage/OrdersPage.tsx": 2243,
	"./pages/OrdersPage/__generated__/boxOrderFragment": 3719,
	"./pages/OrdersPage/__generated__/boxOrderFragment.ts": 3719,
	"./pages/OrdersPage/__generated__/nonCoreOrderFragment": 3720,
	"./pages/OrdersPage/__generated__/nonCoreOrderFragment.ts": 3720,
	"./pages/OrdersPage/__generated__/pastOrderQuery": 3721,
	"./pages/OrdersPage/__generated__/pastOrderQuery.ts": 3721,
	"./pages/OrdersPage/__generated__/upcomingOrderQuery": 3722,
	"./pages/OrdersPage/__generated__/upcomingOrderQuery.ts": 3722,
	"./pages/OrdersPage/queries": 1824,
	"./pages/OrdersPage/queries.ts": 1824,
	"./pages/PersonalDetailsPage/PersonalDetails": 2189,
	"./pages/PersonalDetailsPage/PersonalDetails.module": 809,
	"./pages/PersonalDetailsPage/PersonalDetails.module.sass": 809,
	"./pages/PersonalDetailsPage/PersonalDetails.module.sass.d": 3723,
	"./pages/PersonalDetailsPage/PersonalDetails.module.sass.d.ts": 3723,
	"./pages/PersonalDetailsPage/PersonalDetails.tsx": 2189,
	"./pages/PersonalDetailsPage/components/PauseModal": 1773,
	"./pages/PersonalDetailsPage/components/PauseModal/": 1773,
	"./pages/PersonalDetailsPage/components/PauseModal/Buttons": 1858,
	"./pages/PersonalDetailsPage/components/PauseModal/Buttons.tsx": 1858,
	"./pages/PersonalDetailsPage/components/PauseModal/Delay": 2708,
	"./pages/PersonalDetailsPage/components/PauseModal/Delay.tsx": 2708,
	"./pages/PersonalDetailsPage/components/PauseModal/Discount": 2709,
	"./pages/PersonalDetailsPage/components/PauseModal/Discount.tsx": 2709,
	"./pages/PersonalDetailsPage/components/PauseModal/Error": 2710,
	"./pages/PersonalDetailsPage/components/PauseModal/Error.tsx": 2710,
	"./pages/PersonalDetailsPage/components/PauseModal/PauseModal": 2190,
	"./pages/PersonalDetailsPage/components/PauseModal/PauseModal.module": 2190,
	"./pages/PersonalDetailsPage/components/PauseModal/PauseModal.module.sass": 2190,
	"./pages/PersonalDetailsPage/components/PauseModal/PauseModal.module.sass.d": 3724,
	"./pages/PersonalDetailsPage/components/PauseModal/PauseModal.module.sass.d.ts": 3724,
	"./pages/PersonalDetailsPage/components/PauseModal/index": 1773,
	"./pages/PersonalDetailsPage/components/PauseModal/index.tsx": 1773,
	"./pages/PersonalDetailsPage/components/PauseModal/mutations/__generated__/PauseFlowStartedEventCreate": 3725,
	"./pages/PersonalDetailsPage/components/PauseModal/mutations/__generated__/PauseFlowStartedEventCreate.ts": 3725,
	"./pages/PersonalDetailsPage/components/PauseModal/mutations/pauseFlowStartedEventCreate": 2707,
	"./pages/PersonalDetailsPage/components/PauseModal/mutations/pauseFlowStartedEventCreate.ts": 2707,
	"./pages/PersonalDetailsPage/components/YourDetails": 2711,
	"./pages/PersonalDetailsPage/components/YourDetails.tsx": 2711,
	"./pages/PersonalDetailsPage/components/YourPassword": 2712,
	"./pages/PersonalDetailsPage/components/YourPassword.tsx": 2712,
	"./pages/PersonalDetailsPage/fragments/__generated__/personalDetailsFragment": 3726,
	"./pages/PersonalDetailsPage/fragments/__generated__/personalDetailsFragment.ts": 3726,
	"./pages/PersonalDetailsPage/fragments/personalDetailsFragment": 1355,
	"./pages/PersonalDetailsPage/fragments/personalDetailsFragment.ts": 1355,
	"./pages/PersonalDetailsPage/mutations/__generated__/UpdatePersonalDetails": 3727,
	"./pages/PersonalDetailsPage/mutations/__generated__/UpdatePersonalDetails.ts": 3727,
	"./pages/PersonalDetailsPage/mutations/updatePersonalDetails": 2354,
	"./pages/PersonalDetailsPage/mutations/updatePersonalDetails.ts": 2354,
	"./pages/PersonalDetailsPage/queries/__generated__/PersonalDetailsQuery": 3728,
	"./pages/PersonalDetailsPage/queries/__generated__/PersonalDetailsQuery.ts": 3728,
	"./pages/PersonalDetailsPage/queries/personalDetailsQuery": 2715,
	"./pages/PersonalDetailsPage/queries/personalDetailsQuery.ts": 2715,
	"./pages/PlanManagementPage/PlanManagementPage": 2716,
	"./pages/PlanManagementPage/PlanManagementPage.tsx": 2716,
	"./pages/PlansPage/Plans": 2792,
	"./pages/PlansPage/Plans.stories": 3729,
	"./pages/PlansPage/Plans.stories.tsx": 3729,
	"./pages/PlansPage/Plans.tsx": 2792,
	"./pages/PlansPage/PlansPage": 231,
	"./pages/PlansPage/PlansPage.tsx": 231,
	"./pages/PlansPage/__generated__/CreatePendingSubscription": 3730,
	"./pages/PlansPage/__generated__/CreatePendingSubscription.ts": 3730,
	"./pages/PlansPage/__generated__/ExtrasFeatureFlagQuery": 3731,
	"./pages/PlansPage/__generated__/ExtrasFeatureFlagQuery.ts": 3731,
	"./pages/PlansPage/__generated__/GuestQuery": 3732,
	"./pages/PlansPage/__generated__/GuestQuery.ts": 3732,
	"./pages/PlansPage/__generated__/RecommendationQuery": 3733,
	"./pages/PlansPage/__generated__/RecommendationQuery.ts": 3733,
	"./pages/PlansPage/__generated__/ReviewQuery": 3734,
	"./pages/PlansPage/__generated__/ReviewQuery.ts": 3734,
	"./pages/PlansPage/__generated__/UpdatePlan": 3735,
	"./pages/PlansPage/__generated__/UpdatePlan.ts": 3735,
	"./pages/PlansPage/__generated__/flavourFields": 3736,
	"./pages/PlansPage/__generated__/flavourFields.ts": 3736,
	"./pages/PlansPage/__generated__/pendingSubscriptionProductVariantFields": 3737,
	"./pages/PlansPage/__generated__/pendingSubscriptionProductVariantFields.ts": 3737,
	"./pages/PlansPage/__generated__/planFields": 3738,
	"./pages/PlansPage/__generated__/planFields.ts": 3738,
	"./pages/PlansPage/__generated__/recommendedExtraProductVariantsFields": 3739,
	"./pages/PlansPage/__generated__/recommendedExtraProductVariantsFields.ts": 3739,
	"./pages/PlansPage/components/CancelPlanUpdateWarningModal/CancelPlanUpdateWarningModal": 1342,
	"./pages/PlansPage/components/CancelPlanUpdateWarningModal/CancelPlanUpdateWarningModal.tsx": 1342,
	"./pages/PlansPage/components/FAQSection/FAQSection": 1067,
	"./pages/PlansPage/components/FAQSection/FAQSection.module": 2372,
	"./pages/PlansPage/components/FAQSection/FAQSection.module.sass": 2372,
	"./pages/PlansPage/components/FAQSection/FAQSection.module.sass.d": 3740,
	"./pages/PlansPage/components/FAQSection/FAQSection.module.sass.d.ts": 3740,
	"./pages/PlansPage/components/FAQSection/FAQSection.tsx": 1067,
	"./pages/PlansPage/components/LoadingScreenContent/LoadingScreenContent": 2230,
	"./pages/PlansPage/components/LoadingScreenContent/LoadingScreenContent.module": 709,
	"./pages/PlansPage/components/LoadingScreenContent/LoadingScreenContent.module.sass": 709,
	"./pages/PlansPage/components/LoadingScreenContent/LoadingScreenContent.module.sass.d": 3741,
	"./pages/PlansPage/components/LoadingScreenContent/LoadingScreenContent.module.sass.d.ts": 3741,
	"./pages/PlansPage/components/LoadingScreenContent/LoadingScreenContent.tsx": 2230,
	"./pages/PlansPage/components/RedeemDiscount/RedeemDiscount": 2232,
	"./pages/PlansPage/components/RedeemDiscount/RedeemDiscount.module": 2373,
	"./pages/PlansPage/components/RedeemDiscount/RedeemDiscount.module.sass": 2373,
	"./pages/PlansPage/components/RedeemDiscount/RedeemDiscount.module.sass.d": 3742,
	"./pages/PlansPage/components/RedeemDiscount/RedeemDiscount.module.sass.d.ts": 3742,
	"./pages/PlansPage/components/RedeemDiscount/RedeemDiscount.stories": 3743,
	"./pages/PlansPage/components/RedeemDiscount/RedeemDiscount.stories.tsx": 3743,
	"./pages/PlansPage/components/RedeemDiscount/RedeemDiscount.tsx": 2232,
	"./pages/PlansPage/components/RedeemDiscount/queries/__generated__/AddDiscountToGuest": 3744,
	"./pages/PlansPage/components/RedeemDiscount/queries/__generated__/AddDiscountToGuest.ts": 3744,
	"./pages/PlansPage/components/RedeemDiscount/queries/__generated__/CurrentDiscountCode": 3745,
	"./pages/PlansPage/components/RedeemDiscount/queries/__generated__/CurrentDiscountCode.ts": 3745,
	"./pages/PlansPage/components/RedeemDiscount/queries/currentDiscountCode": 2794,
	"./pages/PlansPage/components/RedeemDiscount/queries/currentDiscountCode.ts": 2794,
	"./pages/PlansPage/components/RedeemDiscount/queries/redeemDiscount": 1338,
	"./pages/PlansPage/components/RedeemDiscount/queries/redeemDiscount.ts": 1338,
	"./pages/PlansPage/components/TopNavigation/TopNavigation": 1359,
	"./pages/PlansPage/components/TopNavigation/TopNavigation.tsx": 1359,
	"./pages/PlansPage/helpers/analytics": 347,
	"./pages/PlansPage/helpers/analytics.ts": 347,
	"./pages/PlansPage/helpers/currentUserToLocaleData": 1075,
	"./pages/PlansPage/helpers/currentUserToLocaleData.ts": 1075,
	"./pages/PlansPage/helpers/handleErrors": 639,
	"./pages/PlansPage/helpers/handleErrors.tsx": 639,
	"./pages/PlansPage/helpers/isAllOrMix": 1232,
	"./pages/PlansPage/helpers/isAllOrMix.ts": 1232,
	"./pages/PlansPage/helpers/planRoutes": 3746,
	"./pages/PlansPage/helpers/planRoutes.ts": 3746,
	"./pages/PlansPage/planspage": 2904,
	"./pages/PlansPage/planspage.module": 2904,
	"./pages/PlansPage/planspage.module.sass": 2904,
	"./pages/PlansPage/planspage.module.sass.d": 3747,
	"./pages/PlansPage/planspage.module.sass.d.ts": 3747,
	"./pages/PlansPage/queries": 635,
	"./pages/PlansPage/queries.ts": 635,
	"./pages/PlansPage/screens/Extras/Extras": 2226,
	"./pages/PlansPage/screens/Extras/Extras.module": 589,
	"./pages/PlansPage/screens/Extras/Extras.module.sass": 589,
	"./pages/PlansPage/screens/Extras/Extras.module.sass.d": 3748,
	"./pages/PlansPage/screens/Extras/Extras.module.sass.d.ts": 3748,
	"./pages/PlansPage/screens/Extras/Extras.stories": 3749,
	"./pages/PlansPage/screens/Extras/Extras.stories.tsx": 3749,
	"./pages/PlansPage/screens/Extras/Extras.tsx": 2226,
	"./pages/PlansPage/screens/Plan/Plan": 1147,
	"./pages/PlansPage/screens/Plan/Plan.module": 644,
	"./pages/PlansPage/screens/Plan/Plan.module.sass": 644,
	"./pages/PlansPage/screens/Plan/Plan.module.sass.d": 3750,
	"./pages/PlansPage/screens/Plan/Plan.module.sass.d.ts": 3750,
	"./pages/PlansPage/screens/Plan/Plan.stories": 3751,
	"./pages/PlansPage/screens/Plan/Plan.stories.tsx": 3751,
	"./pages/PlansPage/screens/Plan/Plan.tsx": 1147,
	"./pages/PlansPage/screens/Plan/components/CadenceSection/CadenceSection": 2227,
	"./pages/PlansPage/screens/Plan/components/CadenceSection/CadenceSection.module": 827,
	"./pages/PlansPage/screens/Plan/components/CadenceSection/CadenceSection.module.sass": 827,
	"./pages/PlansPage/screens/Plan/components/CadenceSection/CadenceSection.module.sass.d": 3752,
	"./pages/PlansPage/screens/Plan/components/CadenceSection/CadenceSection.module.sass.d.ts": 3752,
	"./pages/PlansPage/screens/Plan/components/CadenceSection/CadenceSection.tsx": 2227,
	"./pages/PlansPage/screens/Plan/components/OngoingPlanCards/OngoingPlanCards": 2228,
	"./pages/PlansPage/screens/Plan/components/OngoingPlanCards/OngoingPlanCards.module": 2371,
	"./pages/PlansPage/screens/Plan/components/OngoingPlanCards/OngoingPlanCards.module.sass": 2371,
	"./pages/PlansPage/screens/Plan/components/OngoingPlanCards/OngoingPlanCards.module.sass.d": 3753,
	"./pages/PlansPage/screens/Plan/components/OngoingPlanCards/OngoingPlanCards.module.sass.d.ts": 3753,
	"./pages/PlansPage/screens/Plan/components/OngoingPlanCards/OngoingPlanCards.tsx": 2228,
	"./pages/PlansPage/screens/Recipes/Recipes": 2229,
	"./pages/PlansPage/screens/Recipes/Recipes.module": 560,
	"./pages/PlansPage/screens/Recipes/Recipes.module.sass": 560,
	"./pages/PlansPage/screens/Recipes/Recipes.module.sass.d": 3754,
	"./pages/PlansPage/screens/Recipes/Recipes.module.sass.d.ts": 3754,
	"./pages/PlansPage/screens/Recipes/Recipes.stories": 3755,
	"./pages/PlansPage/screens/Recipes/Recipes.stories.tsx": 3755,
	"./pages/PlansPage/screens/Recipes/Recipes.tsx": 2229,
	"./pages/PlansPage/screens/Review/Review": 2231,
	"./pages/PlansPage/screens/Review/Review.module": 544,
	"./pages/PlansPage/screens/Review/Review.module.sass": 544,
	"./pages/PlansPage/screens/Review/Review.module.sass.d": 3756,
	"./pages/PlansPage/screens/Review/Review.module.sass.d.ts": 3756,
	"./pages/PlansPage/screens/Review/Review.stories": 3757,
	"./pages/PlansPage/screens/Review/Review.stories.tsx": 3757,
	"./pages/PlansPage/screens/Review/Review.tsx": 2231,
	"./pages/PlansPage/screens/ReviewSharedPlan/ReviewSharedPlan": 2233,
	"./pages/PlansPage/screens/ReviewSharedPlan/ReviewSharedPlan.module": 904,
	"./pages/PlansPage/screens/ReviewSharedPlan/ReviewSharedPlan.module.sass": 904,
	"./pages/PlansPage/screens/ReviewSharedPlan/ReviewSharedPlan.module.sass.d": 3758,
	"./pages/PlansPage/screens/ReviewSharedPlan/ReviewSharedPlan.module.sass.d.ts": 3758,
	"./pages/PlansPage/screens/ReviewSharedPlan/ReviewSharedPlan.stories": 3759,
	"./pages/PlansPage/screens/ReviewSharedPlan/ReviewSharedPlan.stories.tsx": 3759,
	"./pages/PlansPage/screens/ReviewSharedPlan/ReviewSharedPlan.tsx": 2233,
	"./pages/PlansPage/types/routes": 375,
	"./pages/PlansPage/types/routes.ts": 375,
	"./pages/PlansPage/types/types": 3760,
	"./pages/PlansPage/types/types.ts": 3760,
	"./pages/PriceSensitivePausedPage/PriceSensitivePausedPage": 2192,
	"./pages/PriceSensitivePausedPage/PriceSensitivePausedPage.module": 386,
	"./pages/PriceSensitivePausedPage/PriceSensitivePausedPage.module.sass": 386,
	"./pages/PriceSensitivePausedPage/PriceSensitivePausedPage.module.sass.d": 3761,
	"./pages/PriceSensitivePausedPage/PriceSensitivePausedPage.module.sass.d.ts": 3761,
	"./pages/PriceSensitivePausedPage/PriceSensitivePausedPage.tsx": 2192,
	"./pages/PriceSensitivePausedPage/components": 1356,
	"./pages/PriceSensitivePausedPage/components/": 1356,
	"./pages/PriceSensitivePausedPage/components/DidYouKnowCard": 1697,
	"./pages/PriceSensitivePausedPage/components/DidYouKnowCard/": 1697,
	"./pages/PriceSensitivePausedPage/components/DidYouKnowCard/index": 1697,
	"./pages/PriceSensitivePausedPage/components/DidYouKnowCard/index.tsx": 1697,
	"./pages/PriceSensitivePausedPage/components/MFITBPlanCard": 1699,
	"./pages/PriceSensitivePausedPage/components/MFITBPlanCard/": 1699,
	"./pages/PriceSensitivePausedPage/components/MFITBPlanCard/index": 1699,
	"./pages/PriceSensitivePausedPage/components/MFITBPlanCard/index.tsx": 1699,
	"./pages/PriceSensitivePausedPage/components/ResumePlanCard": 1698,
	"./pages/PriceSensitivePausedPage/components/ResumePlanCard/": 1698,
	"./pages/PriceSensitivePausedPage/components/ResumePlanCard/index": 1698,
	"./pages/PriceSensitivePausedPage/components/ResumePlanCard/index.tsx": 1698,
	"./pages/PriceSensitivePausedPage/components/index": 1356,
	"./pages/PriceSensitivePausedPage/components/index.ts": 1356,
	"./pages/PriceSensitivePausedPage/queries/__generated__/PriceSensitivePausedPageQuery": 3762,
	"./pages/PriceSensitivePausedPage/queries/__generated__/PriceSensitivePausedPageQuery.ts": 3762,
	"./pages/PriceSensitivePausedPage/queries/queries": 2717,
	"./pages/PriceSensitivePausedPage/queries/queries.ts": 2717,
	"./pages/ReferAFriendPage/ReferAFriendPage": 1874,
	"./pages/ReferAFriendPage/ReferAFriendPage.module": 960,
	"./pages/ReferAFriendPage/ReferAFriendPage.module.sass": 960,
	"./pages/ReferAFriendPage/ReferAFriendPage.module.sass.d": 3763,
	"./pages/ReferAFriendPage/ReferAFriendPage.module.sass.d.ts": 3763,
	"./pages/ReferAFriendPage/ReferAFriendPage.stories": 3764,
	"./pages/ReferAFriendPage/ReferAFriendPage.stories.tsx": 3764,
	"./pages/ReferAFriendPage/ReferAFriendPage.tsx": 1874,
	"./pages/ReferAFriendPage/components/GiveAndGetTab/CardsCarousel/Cards/Donations/Donations": 2719,
	"./pages/ReferAFriendPage/components/GiveAndGetTab/CardsCarousel/Cards/Donations/Donations.tsx": 2719,
	"./pages/ReferAFriendPage/components/GiveAndGetTab/CardsCarousel/Cards/RafPass/RafPass": 2720,
	"./pages/ReferAFriendPage/components/GiveAndGetTab/CardsCarousel/Cards/RafPass/RafPass.tsx": 2720,
	"./pages/ReferAFriendPage/components/GiveAndGetTab/CardsCarousel/Cards/ReferralSavings/ReferralSavings": 2721,
	"./pages/ReferAFriendPage/components/GiveAndGetTab/CardsCarousel/Cards/ReferralSavings/ReferralSavings.tsx": 2721,
	"./pages/ReferAFriendPage/components/GiveAndGetTab/CardsCarousel/Cards/RescuePromise/RescuePromise": 2722,
	"./pages/ReferAFriendPage/components/GiveAndGetTab/CardsCarousel/Cards/RescuePromise/RescuePromise.tsx": 2722,
	"./pages/ReferAFriendPage/components/GiveAndGetTab/CardsCarousel/Cards/RuffGuide/RuffGuide": 2723,
	"./pages/ReferAFriendPage/components/GiveAndGetTab/CardsCarousel/Cards/RuffGuide/RuffGuide.tsx": 2723,
	"./pages/ReferAFriendPage/components/GiveAndGetTab/CardsCarousel/Cards/YourPack/YourPack": 2724,
	"./pages/ReferAFriendPage/components/GiveAndGetTab/CardsCarousel/Cards/YourPack/YourPack.tsx": 2724,
	"./pages/ReferAFriendPage/components/GiveAndGetTab/CardsCarousel/CardsCarousel": 2195,
	"./pages/ReferAFriendPage/components/GiveAndGetTab/CardsCarousel/CardsCarousel.module": 637,
	"./pages/ReferAFriendPage/components/GiveAndGetTab/CardsCarousel/CardsCarousel.module.sass": 637,
	"./pages/ReferAFriendPage/components/GiveAndGetTab/CardsCarousel/CardsCarousel.module.sass.d": 3765,
	"./pages/ReferAFriendPage/components/GiveAndGetTab/CardsCarousel/CardsCarousel.module.sass.d.ts": 3765,
	"./pages/ReferAFriendPage/components/GiveAndGetTab/CardsCarousel/CardsCarousel.tsx": 2195,
	"./pages/ReferAFriendPage/components/GiveAndGetTab/DiscountSection/DiscountSection": 2196,
	"./pages/ReferAFriendPage/components/GiveAndGetTab/DiscountSection/DiscountSection.module": 680,
	"./pages/ReferAFriendPage/components/GiveAndGetTab/DiscountSection/DiscountSection.module.sass": 680,
	"./pages/ReferAFriendPage/components/GiveAndGetTab/DiscountSection/DiscountSection.module.sass.d": 3766,
	"./pages/ReferAFriendPage/components/GiveAndGetTab/DiscountSection/DiscountSection.module.sass.d.ts": 3766,
	"./pages/ReferAFriendPage/components/GiveAndGetTab/DiscountSection/DiscountSection.tsx": 2196,
	"./pages/ReferAFriendPage/components/GiveAndGetTab/DonationsModal/DonationsModal": 1203,
	"./pages/ReferAFriendPage/components/GiveAndGetTab/DonationsModal/DonationsModal.module": 1933,
	"./pages/ReferAFriendPage/components/GiveAndGetTab/DonationsModal/DonationsModal.module.sass": 1933,
	"./pages/ReferAFriendPage/components/GiveAndGetTab/DonationsModal/DonationsModal.module.sass.d": 3767,
	"./pages/ReferAFriendPage/components/GiveAndGetTab/DonationsModal/DonationsModal.module.sass.d.ts": 3767,
	"./pages/ReferAFriendPage/components/GiveAndGetTab/DonationsModal/DonationsModal.tsx": 1203,
	"./pages/ReferAFriendPage/components/GiveAndGetTab/GiveAndGetCard/GiveAndGetCard": 2197,
	"./pages/ReferAFriendPage/components/GiveAndGetTab/GiveAndGetCard/GiveAndGetCard.module": 1934,
	"./pages/ReferAFriendPage/components/GiveAndGetTab/GiveAndGetCard/GiveAndGetCard.module.sass": 1934,
	"./pages/ReferAFriendPage/components/GiveAndGetTab/GiveAndGetCard/GiveAndGetCard.module.sass.d": 3768,
	"./pages/ReferAFriendPage/components/GiveAndGetTab/GiveAndGetCard/GiveAndGetCard.module.sass.d.ts": 3768,
	"./pages/ReferAFriendPage/components/GiveAndGetTab/GiveAndGetCard/GiveAndGetCard.tsx": 2197,
	"./pages/ReferAFriendPage/components/GiveAndGetTab/GiveAndGetTab": 2194,
	"./pages/ReferAFriendPage/components/GiveAndGetTab/GiveAndGetTab.module": 1935,
	"./pages/ReferAFriendPage/components/GiveAndGetTab/GiveAndGetTab.module.sass": 1935,
	"./pages/ReferAFriendPage/components/GiveAndGetTab/GiveAndGetTab.module.sass.d": 3769,
	"./pages/ReferAFriendPage/components/GiveAndGetTab/GiveAndGetTab.module.sass.d.ts": 3769,
	"./pages/ReferAFriendPage/components/GiveAndGetTab/GiveAndGetTab.tsx": 2194,
	"./pages/ReferAFriendPage/components/GiveAndGetTab/RAFPassModal/RAFPassModal": 877,
	"./pages/ReferAFriendPage/components/GiveAndGetTab/RAFPassModal/RAFPassModal.module": 1255,
	"./pages/ReferAFriendPage/components/GiveAndGetTab/RAFPassModal/RAFPassModal.module.sass": 1255,
	"./pages/ReferAFriendPage/components/GiveAndGetTab/RAFPassModal/RAFPassModal.module.sass.d": 3770,
	"./pages/ReferAFriendPage/components/GiveAndGetTab/RAFPassModal/RAFPassModal.module.sass.d.ts": 3770,
	"./pages/ReferAFriendPage/components/GiveAndGetTab/RAFPassModal/RAFPassModal.tsx": 877,
	"./pages/ReferAFriendPage/components/GiveAndGetTab/RafTabBar/RafTabBar": 2193,
	"./pages/ReferAFriendPage/components/GiveAndGetTab/RafTabBar/RafTabBar.module": 1387,
	"./pages/ReferAFriendPage/components/GiveAndGetTab/RafTabBar/RafTabBar.module.sass": 1387,
	"./pages/ReferAFriendPage/components/GiveAndGetTab/RafTabBar/RafTabBar.module.sass.d": 3771,
	"./pages/ReferAFriendPage/components/GiveAndGetTab/RafTabBar/RafTabBar.module.sass.d.ts": 3771,
	"./pages/ReferAFriendPage/components/GiveAndGetTab/RafTabBar/RafTabBar.tsx": 2193,
	"./pages/ReferAFriendPage/components/GiveAndGetTab/ReferralSavingsModal/ReferralSavingsModal": 1608,
	"./pages/ReferAFriendPage/components/GiveAndGetTab/ReferralSavingsModal/ReferralSavingsModal.module": 1932,
	"./pages/ReferAFriendPage/components/GiveAndGetTab/ReferralSavingsModal/ReferralSavingsModal.module.sass": 1932,
	"./pages/ReferAFriendPage/components/GiveAndGetTab/ReferralSavingsModal/ReferralSavingsModal.module.sass.d": 3772,
	"./pages/ReferAFriendPage/components/GiveAndGetTab/ReferralSavingsModal/ReferralSavingsModal.module.sass.d.ts": 3772,
	"./pages/ReferAFriendPage/components/GiveAndGetTab/ReferralSavingsModal/ReferralSavingsModal.tsx": 1608,
	"./pages/ReferAFriendPage/components/GiveAndGetTab/RuffGuideModal/RuffGuideModal": 1609,
	"./pages/ReferAFriendPage/components/GiveAndGetTab/RuffGuideModal/RuffGuideModal.module": 2355,
	"./pages/ReferAFriendPage/components/GiveAndGetTab/RuffGuideModal/RuffGuideModal.module.sass": 2355,
	"./pages/ReferAFriendPage/components/GiveAndGetTab/RuffGuideModal/RuffGuideModal.module.sass.d": 3773,
	"./pages/ReferAFriendPage/components/GiveAndGetTab/RuffGuideModal/RuffGuideModal.module.sass.d.ts": 3773,
	"./pages/ReferAFriendPage/components/GiveAndGetTab/RuffGuideModal/RuffGuideModal.tsx": 1609,
	"./pages/ReferAFriendPage/components/MyPackTab/MyPackTab": 2244,
	"./pages/ReferAFriendPage/components/MyPackTab/MyPackTab.module": 1171,
	"./pages/ReferAFriendPage/components/MyPackTab/MyPackTab.module.sass": 1171,
	"./pages/ReferAFriendPage/components/MyPackTab/MyPackTab.module.sass.d": 3774,
	"./pages/ReferAFriendPage/components/MyPackTab/MyPackTab.module.sass.d.ts": 3774,
	"./pages/ReferAFriendPage/components/MyPackTab/MyPackTab.tsx": 2244,
	"./pages/ReferAFriendPage/hooks/useDiscountCopy": 1144,
	"./pages/ReferAFriendPage/hooks/useDiscountCopy.ts": 1144,
	"./pages/ReferAFriendPage/queries/ReferAFriendPageQuery": 3775,
	"./pages/ReferAFriendPage/queries/ReferAFriendPageQuery.ts": 3775,
	"./pages/ReferAFriendPage/queries/__generated__/ReferAFriendPageQuery": 3776,
	"./pages/ReferAFriendPage/queries/__generated__/ReferAFriendPageQuery.ts": 3776,
	"./pages/ReferAFriendPage/utils/referralsToReferralLevel": 3777,
	"./pages/ReferAFriendPage/utils/referralsToReferralLevel.ts": 3777,
	"./pages/RestartPlanSuccess/RestartPlanSuccess": 2725,
	"./pages/RestartPlanSuccess/RestartPlanSuccess.tsx": 2725,
	"./pages/ReviewPlanChanges/ReviewPlanChanges": 1588,
	"./pages/ReviewPlanChanges/ReviewPlanChanges.module": 784,
	"./pages/ReviewPlanChanges/ReviewPlanChanges.module.sass": 784,
	"./pages/ReviewPlanChanges/ReviewPlanChanges.module.sass.d": 3778,
	"./pages/ReviewPlanChanges/ReviewPlanChanges.module.sass.d.ts": 3778,
	"./pages/ReviewPlanChanges/ReviewPlanChanges.tsx": 1588,
	"./pages/ReviewPlanChanges/fragments/__generated__/ReviewPlanChangesFragment": 3779,
	"./pages/ReviewPlanChanges/fragments/__generated__/ReviewPlanChangesFragment.ts": 3779,
	"./pages/ReviewPlanChanges/fragments/reviewPlanChangesFragment": 2528,
	"./pages/ReviewPlanChanges/fragments/reviewPlanChangesFragment.ts": 2528,
	"./pages/ReviewPlanChanges/mutations/reviewPlanChangesMutation": 2534,
	"./pages/ReviewPlanChanges/mutations/reviewPlanChangesMutation.ts": 2534,
	"./pages/SegmentedPausedPage/SegmentedPausedPage": 2200,
	"./pages/SegmentedPausedPage/SegmentedPausedPage.module": 586,
	"./pages/SegmentedPausedPage/SegmentedPausedPage.module.sass": 586,
	"./pages/SegmentedPausedPage/SegmentedPausedPage.module.sass.d": 3780,
	"./pages/SegmentedPausedPage/SegmentedPausedPage.module.sass.d.ts": 3780,
	"./pages/SegmentedPausedPage/SegmentedPausedPage.tsx": 2200,
	"./pages/SegmentedPausedPage/components": 1610,
	"./pages/SegmentedPausedPage/components/": 1610,
	"./pages/SegmentedPausedPage/components/EditPlan": 1701,
	"./pages/SegmentedPausedPage/components/EditPlan/": 1701,
	"./pages/SegmentedPausedPage/components/EditPlan/index": 1701,
	"./pages/SegmentedPausedPage/components/EditPlan/index.tsx": 1701,
	"./pages/SegmentedPausedPage/components/PlanSummary": 1700,
	"./pages/SegmentedPausedPage/components/PlanSummary/": 1700,
	"./pages/SegmentedPausedPage/components/PlanSummary/index": 1700,
	"./pages/SegmentedPausedPage/components/PlanSummary/index.tsx": 1700,
	"./pages/SegmentedPausedPage/components/index": 1610,
	"./pages/SegmentedPausedPage/components/index.ts": 1610,
	"./pages/SegmentedPausedPage/queries/queries": 1806,
	"./pages/SegmentedPausedPage/queries/queries.ts": 1806,
	"./pages/SelfResolutionPage/SelfResolution": 1526,
	"./pages/SelfResolutionPage/SelfResolution.tsx": 1526,
	"./pages/SelfResolutionPage/SelfResolutionPage": 127,
	"./pages/SelfResolutionPage/SelfResolutionPage.module": 581,
	"./pages/SelfResolutionPage/SelfResolutionPage.module.sass": 581,
	"./pages/SelfResolutionPage/SelfResolutionPage.module.sass.d": 3781,
	"./pages/SelfResolutionPage/SelfResolutionPage.module.sass.d.ts": 3781,
	"./pages/SelfResolutionPage/SelfResolutionPage.stories": 3782,
	"./pages/SelfResolutionPage/SelfResolutionPage.stories.tsx": 3782,
	"./pages/SelfResolutionPage/SelfResolutionPage.tsx": 127,
	"./pages/SelfResolutionPage/analytics": 187,
	"./pages/SelfResolutionPage/analytics/": 187,
	"./pages/SelfResolutionPage/analytics/index": 187,
	"./pages/SelfResolutionPage/analytics/index.ts": 187,
	"./pages/SelfResolutionPage/components/ContactCustomerLove/ContactCustomerLoveButton": 796,
	"./pages/SelfResolutionPage/components/ContactCustomerLove/ContactCustomerLoveButton.tsx": 796,
	"./pages/SelfResolutionPage/components/SelfResolutionHeader/SelfResolutionHeader": 1277,
	"./pages/SelfResolutionPage/components/SelfResolutionHeader/SelfResolutionHeader.module": 883,
	"./pages/SelfResolutionPage/components/SelfResolutionHeader/SelfResolutionHeader.module.sass": 883,
	"./pages/SelfResolutionPage/components/SelfResolutionHeader/SelfResolutionHeader.module.sass.d": 3783,
	"./pages/SelfResolutionPage/components/SelfResolutionHeader/SelfResolutionHeader.module.sass.d.ts": 3783,
	"./pages/SelfResolutionPage/components/SelfResolutionHeader/SelfResolutionHeader.tsx": 1277,
	"./pages/SelfResolutionPage/components/SelfResolutionLoading/SelfResolutionLoading": 1521,
	"./pages/SelfResolutionPage/components/SelfResolutionLoading/SelfResolutionLoading.tsx": 1521,
	"./pages/SelfResolutionPage/helpers/getRouteWithBoxId": 664,
	"./pages/SelfResolutionPage/helpers/getRouteWithBoxId.ts": 664,
	"./pages/SelfResolutionPage/helpers/useQueryParam": 1194,
	"./pages/SelfResolutionPage/helpers/useQueryParam.ts": 1194,
	"./pages/SelfResolutionPage/mutations/CustomerIssueCategorySubmission": 1522,
	"./pages/SelfResolutionPage/mutations/CustomerIssueCategorySubmission.ts": 1522,
	"./pages/SelfResolutionPage/mutations/ReportIssueSubmission": 1523,
	"./pages/SelfResolutionPage/mutations/ReportIssueSubmission.ts": 1523,
	"./pages/SelfResolutionPage/mutations/ResolutionAcceptanceApplyDiscountSubmission": 1524,
	"./pages/SelfResolutionPage/mutations/ResolutionAcceptanceApplyDiscountSubmission.ts": 1524,
	"./pages/SelfResolutionPage/mutations/ResolutionAcceptanceReplacementBoxSubmission": 1525,
	"./pages/SelfResolutionPage/mutations/ResolutionAcceptanceReplacementBoxSubmission.ts": 1525,
	"./pages/SelfResolutionPage/mutations/__generated__/CustomerIssueCategorySubmission": 3784,
	"./pages/SelfResolutionPage/mutations/__generated__/CustomerIssueCategorySubmission.ts": 3784,
	"./pages/SelfResolutionPage/mutations/__generated__/CustomerIssueReportEntriesSubmission": 3785,
	"./pages/SelfResolutionPage/mutations/__generated__/CustomerIssueReportEntriesSubmission.ts": 3785,
	"./pages/SelfResolutionPage/mutations/__generated__/CustomerIssueResolutionAcceptanceApplyDiscount": 3786,
	"./pages/SelfResolutionPage/mutations/__generated__/CustomerIssueResolutionAcceptanceApplyDiscount.ts": 3786,
	"./pages/SelfResolutionPage/mutations/__generated__/CustomerIssueResolutionAcceptanceReplacementBoxSubmission": 3787,
	"./pages/SelfResolutionPage/mutations/__generated__/CustomerIssueResolutionAcceptanceReplacementBoxSubmission.ts": 3787,
	"./pages/SelfResolutionPage/mutations/__generated__/orderTrackingNumberFields": 3788,
	"./pages/SelfResolutionPage/mutations/__generated__/orderTrackingNumberFields.ts": 3788,
	"./pages/SelfResolutionPage/queries/__generated__/SelfResolutionCategories": 3789,
	"./pages/SelfResolutionPage/queries/__generated__/SelfResolutionCategories.ts": 3789,
	"./pages/SelfResolutionPage/queries/categoriesQuery": 1056,
	"./pages/SelfResolutionPage/queries/categoriesQuery.ts": 1056,
	"./pages/SelfResolutionPage/screens/Categories/Categories": 1278,
	"./pages/SelfResolutionPage/screens/Categories/Categories.module": 807,
	"./pages/SelfResolutionPage/screens/Categories/Categories.module.sass": 807,
	"./pages/SelfResolutionPage/screens/Categories/Categories.module.sass.d": 3790,
	"./pages/SelfResolutionPage/screens/Categories/Categories.module.sass.d.ts": 3790,
	"./pages/SelfResolutionPage/screens/Categories/Categories.stories": 3791,
	"./pages/SelfResolutionPage/screens/Categories/Categories.stories.tsx": 3791,
	"./pages/SelfResolutionPage/screens/Categories/Categories.tsx": 1278,
	"./pages/SelfResolutionPage/screens/Categories/components/CategoryButton": 1527,
	"./pages/SelfResolutionPage/screens/Categories/components/CategoryButton.tsx": 1527,
	"./pages/SelfResolutionPage/screens/Categories/components/CategoryButtons": 1057,
	"./pages/SelfResolutionPage/screens/Categories/components/CategoryButtons.tsx": 1057,
	"./pages/SelfResolutionPage/screens/ContactCustomerLove/ContactCustomerLove": 1279,
	"./pages/SelfResolutionPage/screens/ContactCustomerLove/ContactCustomerLove.module": 318,
	"./pages/SelfResolutionPage/screens/ContactCustomerLove/ContactCustomerLove.module.sass": 318,
	"./pages/SelfResolutionPage/screens/ContactCustomerLove/ContactCustomerLove.module.sass.d": 3792,
	"./pages/SelfResolutionPage/screens/ContactCustomerLove/ContactCustomerLove.module.sass.d.ts": 3792,
	"./pages/SelfResolutionPage/screens/ContactCustomerLove/ContactCustomerLove.stories": 3793,
	"./pages/SelfResolutionPage/screens/ContactCustomerLove/ContactCustomerLove.stories.tsx": 3793,
	"./pages/SelfResolutionPage/screens/ContactCustomerLove/ContactCustomerLove.tsx": 1279,
	"./pages/SelfResolutionPage/screens/ContactCustomerLove/ContactCustomerLoveDetails": 538,
	"./pages/SelfResolutionPage/screens/ContactCustomerLove/ContactCustomerLoveDetails.tsx": 538,
	"./pages/SelfResolutionPage/screens/Error/Error": 1280,
	"./pages/SelfResolutionPage/screens/Error/Error.module": 1217,
	"./pages/SelfResolutionPage/screens/Error/Error.module.sass": 1217,
	"./pages/SelfResolutionPage/screens/Error/Error.module.sass.d": 3794,
	"./pages/SelfResolutionPage/screens/Error/Error.module.sass.d.ts": 3794,
	"./pages/SelfResolutionPage/screens/Error/Error.stories": 3795,
	"./pages/SelfResolutionPage/screens/Error/Error.stories.tsx": 3795,
	"./pages/SelfResolutionPage/screens/Error/Error.tsx": 1280,
	"./pages/SelfResolutionPage/screens/QuickHelpResolution/QuickHelpResolution": 1281,
	"./pages/SelfResolutionPage/screens/QuickHelpResolution/QuickHelpResolution.module": 884,
	"./pages/SelfResolutionPage/screens/QuickHelpResolution/QuickHelpResolution.module.sass": 884,
	"./pages/SelfResolutionPage/screens/QuickHelpResolution/QuickHelpResolution.module.sass.d": 3796,
	"./pages/SelfResolutionPage/screens/QuickHelpResolution/QuickHelpResolution.module.sass.d.ts": 3796,
	"./pages/SelfResolutionPage/screens/QuickHelpResolution/QuickHelpResolution.stories": 3797,
	"./pages/SelfResolutionPage/screens/QuickHelpResolution/QuickHelpResolution.stories.tsx": 3797,
	"./pages/SelfResolutionPage/screens/QuickHelpResolution/QuickHelpResolution.tsx": 1281,
	"./pages/SelfResolutionPage/screens/ReportIssue/ReportIssue": 1282,
	"./pages/SelfResolutionPage/screens/ReportIssue/ReportIssue.module": 317,
	"./pages/SelfResolutionPage/screens/ReportIssue/ReportIssue.module.sass": 317,
	"./pages/SelfResolutionPage/screens/ReportIssue/ReportIssue.module.sass.d": 3798,
	"./pages/SelfResolutionPage/screens/ReportIssue/ReportIssue.module.sass.d.ts": 3798,
	"./pages/SelfResolutionPage/screens/ReportIssue/ReportIssue.stories": 3799,
	"./pages/SelfResolutionPage/screens/ReportIssue/ReportIssue.stories.tsx": 3799,
	"./pages/SelfResolutionPage/screens/ReportIssue/ReportIssue.tsx": 1282,
	"./pages/SelfResolutionPage/screens/ReportIssue/components/CheckboxField": 1058,
	"./pages/SelfResolutionPage/screens/ReportIssue/components/CheckboxField.tsx": 1058,
	"./pages/SelfResolutionPage/screens/ReportIssue/components/DropdownField": 1059,
	"./pages/SelfResolutionPage/screens/ReportIssue/components/DropdownField.tsx": 1059,
	"./pages/SelfResolutionPage/screens/ReportIssue/components/IntegerField": 3800,
	"./pages/SelfResolutionPage/screens/ReportIssue/components/IntegerField.tsx": 3800,
	"./pages/SelfResolutionPage/screens/ReportIssue/components/IssueForm": 1528,
	"./pages/SelfResolutionPage/screens/ReportIssue/components/IssueForm.tsx": 1528,
	"./pages/SelfResolutionPage/screens/ReportIssue/components/ItemSelector": 1531,
	"./pages/SelfResolutionPage/screens/ReportIssue/components/ItemSelector.tsx": 1531,
	"./pages/SelfResolutionPage/screens/ReportIssue/components/ProductAmounts": 1532,
	"./pages/SelfResolutionPage/screens/ReportIssue/components/ProductAmounts.tsx": 1532,
	"./pages/SelfResolutionPage/screens/ReportIssue/components/ProductSelector": 1533,
	"./pages/SelfResolutionPage/screens/ReportIssue/components/ProductSelector.tsx": 1533,
	"./pages/SelfResolutionPage/screens/ReportIssue/components/ReasonField": 1529,
	"./pages/SelfResolutionPage/screens/ReportIssue/components/ReasonField.tsx": 1529,
	"./pages/SelfResolutionPage/screens/ReportIssue/components/TextAreaField": 1530,
	"./pages/SelfResolutionPage/screens/ReportIssue/components/TextAreaField.tsx": 1530,
	"./pages/SelfResolutionPage/screens/ResolutionConfirmation/ResolutionConfirmation": 1283,
	"./pages/SelfResolutionPage/screens/ResolutionConfirmation/ResolutionConfirmation.module": 519,
	"./pages/SelfResolutionPage/screens/ResolutionConfirmation/ResolutionConfirmation.module.sass": 519,
	"./pages/SelfResolutionPage/screens/ResolutionConfirmation/ResolutionConfirmation.module.sass.d": 3801,
	"./pages/SelfResolutionPage/screens/ResolutionConfirmation/ResolutionConfirmation.module.sass.d.ts": 3801,
	"./pages/SelfResolutionPage/screens/ResolutionConfirmation/ResolutionConfirmation.stories": 3802,
	"./pages/SelfResolutionPage/screens/ResolutionConfirmation/ResolutionConfirmation.stories.tsx": 3802,
	"./pages/SelfResolutionPage/screens/ResolutionConfirmation/ResolutionConfirmation.tsx": 1283,
	"./pages/SelfResolutionPage/screens/ResolutionConfirmation/ResolutionConfirmationComponents/DiscountConfirmation": 1534,
	"./pages/SelfResolutionPage/screens/ResolutionConfirmation/ResolutionConfirmationComponents/DiscountConfirmation.tsx": 1534,
	"./pages/SelfResolutionPage/screens/ResolutionConfirmation/ResolutionConfirmationComponents/ReplacementBoxConfirmation": 1535,
	"./pages/SelfResolutionPage/screens/ResolutionConfirmation/ResolutionConfirmationComponents/ReplacementBoxConfirmation.tsx": 1535,
	"./pages/SelfResolutionPage/screens/ResolutionConfirmation/ResolutionConfirmationComponents/ResolutionConfirmationBox": 1060,
	"./pages/SelfResolutionPage/screens/ResolutionConfirmation/ResolutionConfirmationComponents/ResolutionConfirmationBox.tsx": 1060,
	"./pages/SelfResolutionPage/screens/ResolutionOffering/ResolutionOffering": 1284,
	"./pages/SelfResolutionPage/screens/ResolutionOffering/ResolutionOffering.module": 448,
	"./pages/SelfResolutionPage/screens/ResolutionOffering/ResolutionOffering.module.sass": 448,
	"./pages/SelfResolutionPage/screens/ResolutionOffering/ResolutionOffering.module.sass.d": 3803,
	"./pages/SelfResolutionPage/screens/ResolutionOffering/ResolutionOffering.module.sass.d.ts": 3803,
	"./pages/SelfResolutionPage/screens/ResolutionOffering/ResolutionOffering.stories": 3804,
	"./pages/SelfResolutionPage/screens/ResolutionOffering/ResolutionOffering.stories.tsx": 3804,
	"./pages/SelfResolutionPage/screens/ResolutionOffering/ResolutionOffering.tsx": 1284,
	"./pages/SelfResolutionPage/screens/ResolutionOffering/ResolutionOfferingComponents/Discount": 1536,
	"./pages/SelfResolutionPage/screens/ResolutionOffering/ResolutionOfferingComponents/Discount.tsx": 1536,
	"./pages/SelfResolutionPage/screens/ResolutionOffering/ResolutionOfferingComponents/ReplacementBox": 1537,
	"./pages/SelfResolutionPage/screens/ResolutionOffering/ResolutionOfferingComponents/ReplacementBox.tsx": 1537,
	"./pages/SelfResolutionPage/types/routes": 213,
	"./pages/SelfResolutionPage/types/routes.ts": 213,
	"./pages/SelfResolutionPage/types/types": 3805,
	"./pages/SelfResolutionPage/types/types.ts": 3805,
	"./pages/ServingSizePage/ServingSizePage": 1331,
	"./pages/ServingSizePage/ServingSizePage.module": 753,
	"./pages/ServingSizePage/ServingSizePage.module.sass": 753,
	"./pages/ServingSizePage/ServingSizePage.module.sass.d": 3806,
	"./pages/ServingSizePage/ServingSizePage.module.sass.d.ts": 3806,
	"./pages/ServingSizePage/ServingSizePage.tsx": 1331,
	"./pages/SignupWizardPage/SignupWizard": 2600,
	"./pages/SignupWizardPage/SignupWizard.tsx": 2600,
	"./pages/SignupWizardPage/SignupWizardPage": 194,
	"./pages/SignupWizardPage/SignupWizardPage.stories": 3807,
	"./pages/SignupWizardPage/SignupWizardPage.stories.tsx": 3807,
	"./pages/SignupWizardPage/SignupWizardPage.tsx": 194,
	"./pages/SignupWizardPage/components/MarketingConsent": 2160,
	"./pages/SignupWizardPage/components/MarketingConsent.module": 704,
	"./pages/SignupWizardPage/components/MarketingConsent.module.sass": 704,
	"./pages/SignupWizardPage/components/MarketingConsent.module.sass.d": 3808,
	"./pages/SignupWizardPage/components/MarketingConsent.module.sass.d.ts": 3808,
	"./pages/SignupWizardPage/components/MarketingConsent.tsx": 2160,
	"./pages/SignupWizardPage/components/WizardQuestionTitle/WizardQuestionTitle": 374,
	"./pages/SignupWizardPage/components/WizardQuestionTitle/WizardQuestionTitle.module": 1923,
	"./pages/SignupWizardPage/components/WizardQuestionTitle/WizardQuestionTitle.module.sass": 1923,
	"./pages/SignupWizardPage/components/WizardQuestionTitle/WizardQuestionTitle.module.sass.d": 3809,
	"./pages/SignupWizardPage/components/WizardQuestionTitle/WizardQuestionTitle.module.sass.d.ts": 3809,
	"./pages/SignupWizardPage/components/WizardQuestionTitle/WizardQuestionTitle.tsx": 374,
	"./pages/SignupWizardPage/helpers/analytics": 879,
	"./pages/SignupWizardPage/helpers/analytics.ts": 879,
	"./pages/SignupWizardPage/helpers/dogAge": 1370,
	"./pages/SignupWizardPage/helpers/dogAge.ts": 1370,
	"./pages/SignupWizardPage/helpers/routeToFreshFactFooter": 2601,
	"./pages/SignupWizardPage/helpers/routeToFreshFactFooter.ts": 2601,
	"./pages/SignupWizardPage/helpers/stepHero": 2602,
	"./pages/SignupWizardPage/helpers/stepHero.ts": 2602,
	"./pages/SignupWizardPage/helpers/submitFormData": 945,
	"./pages/SignupWizardPage/helpers/submitFormData.ts": 945,
	"./pages/SignupWizardPage/helpers/testHelper": 3810,
	"./pages/SignupWizardPage/helpers/testHelper.ts": 3810,
	"./pages/SignupWizardPage/helpers/useImplicitFormSubmission": 385,
	"./pages/SignupWizardPage/helpers/useImplicitFormSubmission.ts": 385,
	"./pages/SignupWizardPage/helpers/wizardRoutes": 222,
	"./pages/SignupWizardPage/helpers/wizardRoutes.ts": 222,
	"./pages/SignupWizardPage/queries/__generated__/Allergens": 3811,
	"./pages/SignupWizardPage/queries/__generated__/Allergens.ts": 3811,
	"./pages/SignupWizardPage/queries/__generated__/CurrentUser": 3812,
	"./pages/SignupWizardPage/queries/__generated__/CurrentUser.ts": 3812,
	"./pages/SignupWizardPage/queries/__generated__/FoodCategories": 3813,
	"./pages/SignupWizardPage/queries/__generated__/FoodCategories.ts": 3813,
	"./pages/SignupWizardPage/queries/__generated__/ShippingCountries": 3814,
	"./pages/SignupWizardPage/queries/__generated__/ShippingCountries.ts": 3814,
	"./pages/SignupWizardPage/queries/__generated__/addDogs": 3815,
	"./pages/SignupWizardPage/queries/__generated__/addDogs.ts": 3815,
	"./pages/SignupWizardPage/queries/addDogsMutation": 2605,
	"./pages/SignupWizardPage/queries/addDogsMutation.ts": 2605,
	"./pages/SignupWizardPage/queries/allergiesQuery": 2147,
	"./pages/SignupWizardPage/queries/allergiesQuery.ts": 2147,
	"./pages/SignupWizardPage/queries/foodCategoriesQuery": 1840,
	"./pages/SignupWizardPage/queries/foodCategoriesQuery.ts": 1840,
	"./pages/SignupWizardPage/queries/shippingCountriesQuery": 2599,
	"./pages/SignupWizardPage/queries/shippingCountriesQuery.ts": 2599,
	"./pages/SignupWizardPage/queries/userQuery": 1343,
	"./pages/SignupWizardPage/queries/userQuery.ts": 1343,
	"./pages/SignupWizardPage/screens/Activity/Activity": 2145,
	"./pages/SignupWizardPage/screens/Activity/Activity.module": 184,
	"./pages/SignupWizardPage/screens/Activity/Activity.module.sass": 184,
	"./pages/SignupWizardPage/screens/Activity/Activity.module.sass.d": 3816,
	"./pages/SignupWizardPage/screens/Activity/Activity.module.sass.d.ts": 3816,
	"./pages/SignupWizardPage/screens/Activity/Activity.stories": 3817,
	"./pages/SignupWizardPage/screens/Activity/Activity.stories.tsx": 3817,
	"./pages/SignupWizardPage/screens/Activity/Activity.tsx": 2145,
	"./pages/SignupWizardPage/screens/Age/Age": 2146,
	"./pages/SignupWizardPage/screens/Age/Age.module": 755,
	"./pages/SignupWizardPage/screens/Age/Age.module.sass": 755,
	"./pages/SignupWizardPage/screens/Age/Age.module.sass.d": 3818,
	"./pages/SignupWizardPage/screens/Age/Age.module.sass.d.ts": 3818,
	"./pages/SignupWizardPage/screens/Age/Age.stories": 3819,
	"./pages/SignupWizardPage/screens/Age/Age.stories.tsx": 3819,
	"./pages/SignupWizardPage/screens/Age/Age.tsx": 2146,
	"./pages/SignupWizardPage/screens/Allergies/Allergies": 1598,
	"./pages/SignupWizardPage/screens/Allergies/Allergies.module": 824,
	"./pages/SignupWizardPage/screens/Allergies/Allergies.module.sass": 824,
	"./pages/SignupWizardPage/screens/Allergies/Allergies.module.sass.d": 3820,
	"./pages/SignupWizardPage/screens/Allergies/Allergies.module.sass.d.ts": 3820,
	"./pages/SignupWizardPage/screens/Allergies/Allergies.stories": 3821,
	"./pages/SignupWizardPage/screens/Allergies/Allergies.stories.tsx": 3821,
	"./pages/SignupWizardPage/screens/Allergies/Allergies.tsx": 1598,
	"./pages/SignupWizardPage/screens/BodyShape/BodyShape": 2148,
	"./pages/SignupWizardPage/screens/BodyShape/BodyShape.module": 272,
	"./pages/SignupWizardPage/screens/BodyShape/BodyShape.module.sass": 272,
	"./pages/SignupWizardPage/screens/BodyShape/BodyShape.module.sass.d": 3822,
	"./pages/SignupWizardPage/screens/BodyShape/BodyShape.module.sass.d.ts": 3822,
	"./pages/SignupWizardPage/screens/BodyShape/BodyShape.stories": 3823,
	"./pages/SignupWizardPage/screens/BodyShape/BodyShape.stories.tsx": 3823,
	"./pages/SignupWizardPage/screens/BodyShape/BodyShape.tsx": 2148,
	"./pages/SignupWizardPage/screens/Breed/Breed": 2149,
	"./pages/SignupWizardPage/screens/Breed/Breed.module": 825,
	"./pages/SignupWizardPage/screens/Breed/Breed.module.sass": 825,
	"./pages/SignupWizardPage/screens/Breed/Breed.module.sass.d": 3824,
	"./pages/SignupWizardPage/screens/Breed/Breed.module.sass.d.ts": 3824,
	"./pages/SignupWizardPage/screens/Breed/Breed.stories": 3825,
	"./pages/SignupWizardPage/screens/Breed/Breed.stories.tsx": 3825,
	"./pages/SignupWizardPage/screens/Breed/Breed.tsx": 2149,
	"./pages/SignupWizardPage/screens/Eater/Eater": 2152,
	"./pages/SignupWizardPage/screens/Eater/Eater.module": 1924,
	"./pages/SignupWizardPage/screens/Eater/Eater.module.sass": 1924,
	"./pages/SignupWizardPage/screens/Eater/Eater.module.sass.d": 3826,
	"./pages/SignupWizardPage/screens/Eater/Eater.module.sass.d.ts": 3826,
	"./pages/SignupWizardPage/screens/Eater/Eater.stories": 3827,
	"./pages/SignupWizardPage/screens/Eater/Eater.stories.tsx": 3827,
	"./pages/SignupWizardPage/screens/Eater/Eater.tsx": 2152,
	"./pages/SignupWizardPage/screens/Food/Food": 2153,
	"./pages/SignupWizardPage/screens/Food/Food.module": 1925,
	"./pages/SignupWizardPage/screens/Food/Food.module.sass": 1925,
	"./pages/SignupWizardPage/screens/Food/Food.module.sass.d": 3828,
	"./pages/SignupWizardPage/screens/Food/Food.module.sass.d.ts": 3828,
	"./pages/SignupWizardPage/screens/Food/Food.stories": 3829,
	"./pages/SignupWizardPage/screens/Food/Food.stories.tsx": 3829,
	"./pages/SignupWizardPage/screens/Food/Food.tsx": 2153,
	"./pages/SignupWizardPage/screens/FussinessHelp/FussinessHelp": 2154,
	"./pages/SignupWizardPage/screens/FussinessHelp/FussinessHelp.module": 1926,
	"./pages/SignupWizardPage/screens/FussinessHelp/FussinessHelp.module.sass": 1926,
	"./pages/SignupWizardPage/screens/FussinessHelp/FussinessHelp.module.sass.d": 3830,
	"./pages/SignupWizardPage/screens/FussinessHelp/FussinessHelp.module.sass.d.ts": 3830,
	"./pages/SignupWizardPage/screens/FussinessHelp/FussinessHelp.stories": 3831,
	"./pages/SignupWizardPage/screens/FussinessHelp/FussinessHelp.stories.tsx": 3831,
	"./pages/SignupWizardPage/screens/FussinessHelp/FussinessHelp.tsx": 2154,
	"./pages/SignupWizardPage/screens/Gender/Gender": 2155,
	"./pages/SignupWizardPage/screens/Gender/Gender.module": 1662,
	"./pages/SignupWizardPage/screens/Gender/Gender.module.sass": 1662,
	"./pages/SignupWizardPage/screens/Gender/Gender.module.sass.d": 3832,
	"./pages/SignupWizardPage/screens/Gender/Gender.module.sass.d.ts": 3832,
	"./pages/SignupWizardPage/screens/Gender/Gender.stories": 3833,
	"./pages/SignupWizardPage/screens/Gender/Gender.stories.tsx": 3833,
	"./pages/SignupWizardPage/screens/Gender/Gender.tsx": 2155,
	"./pages/SignupWizardPage/screens/Goals/Goals": 2156,
	"./pages/SignupWizardPage/screens/Goals/Goals.module": 1927,
	"./pages/SignupWizardPage/screens/Goals/Goals.module.sass": 1927,
	"./pages/SignupWizardPage/screens/Goals/Goals.module.sass.d": 3834,
	"./pages/SignupWizardPage/screens/Goals/Goals.module.sass.d.ts": 3834,
	"./pages/SignupWizardPage/screens/Goals/Goals.stories": 3835,
	"./pages/SignupWizardPage/screens/Goals/Goals.stories.tsx": 3835,
	"./pages/SignupWizardPage/screens/Goals/Goals.tsx": 2156,
	"./pages/SignupWizardPage/screens/Health/Health": 2157,
	"./pages/SignupWizardPage/screens/Health/Health.module": 1382,
	"./pages/SignupWizardPage/screens/Health/Health.module.sass": 1382,
	"./pages/SignupWizardPage/screens/Health/Health.module.sass.d": 3836,
	"./pages/SignupWizardPage/screens/Health/Health.module.sass.d.ts": 3836,
	"./pages/SignupWizardPage/screens/Health/Health.stories": 3837,
	"./pages/SignupWizardPage/screens/Health/Health.stories.tsx": 3837,
	"./pages/SignupWizardPage/screens/Health/Health.tsx": 2157,
	"./pages/SignupWizardPage/screens/Health/HealthIssueAlertCard": 2604,
	"./pages/SignupWizardPage/screens/Health/HealthIssueAlertCard.tsx": 2604,
	"./pages/SignupWizardPage/screens/Health/queries/__generated__/HealthIssues": 3838,
	"./pages/SignupWizardPage/screens/Health/queries/__generated__/HealthIssues.ts": 3838,
	"./pages/SignupWizardPage/screens/Health/queries/healthIssuesQuery": 1839,
	"./pages/SignupWizardPage/screens/Health/queries/healthIssuesQuery.ts": 1839,
	"./pages/SignupWizardPage/screens/Name/Name": 2158,
	"./pages/SignupWizardPage/screens/Name/Name.module": 786,
	"./pages/SignupWizardPage/screens/Name/Name.module.sass": 786,
	"./pages/SignupWizardPage/screens/Name/Name.module.sass.d": 3839,
	"./pages/SignupWizardPage/screens/Name/Name.module.sass.d.ts": 3839,
	"./pages/SignupWizardPage/screens/Name/Name.stories": 3840,
	"./pages/SignupWizardPage/screens/Name/Name.stories.tsx": 3840,
	"./pages/SignupWizardPage/screens/Name/Name.tsx": 2158,
	"./pages/SignupWizardPage/screens/PetParent/PetParent": 2159,
	"./pages/SignupWizardPage/screens/PetParent/PetParent.module": 1168,
	"./pages/SignupWizardPage/screens/PetParent/PetParent.module.sass": 1168,
	"./pages/SignupWizardPage/screens/PetParent/PetParent.module.sass.d": 3841,
	"./pages/SignupWizardPage/screens/PetParent/PetParent.module.sass.d.ts": 3841,
	"./pages/SignupWizardPage/screens/PetParent/PetParent.stories": 3842,
	"./pages/SignupWizardPage/screens/PetParent/PetParent.stories.tsx": 3842,
	"./pages/SignupWizardPage/screens/PetParent/PetParent.tsx": 2159,
	"./pages/SignupWizardPage/screens/Snacks/Snacks": 2161,
	"./pages/SignupWizardPage/screens/Snacks/Snacks.module": 508,
	"./pages/SignupWizardPage/screens/Snacks/Snacks.module.sass": 508,
	"./pages/SignupWizardPage/screens/Snacks/Snacks.module.sass.d": 3843,
	"./pages/SignupWizardPage/screens/Snacks/Snacks.module.sass.d.ts": 3843,
	"./pages/SignupWizardPage/screens/Snacks/Snacks.stories": 3844,
	"./pages/SignupWizardPage/screens/Snacks/Snacks.stories.tsx": 3844,
	"./pages/SignupWizardPage/screens/Snacks/Snacks.tsx": 2161,
	"./pages/SignupWizardPage/screens/Weight/Weight": 2162,
	"./pages/SignupWizardPage/screens/Weight/Weight.module": 599,
	"./pages/SignupWizardPage/screens/Weight/Weight.module.sass": 599,
	"./pages/SignupWizardPage/screens/Weight/Weight.module.sass.d": 3845,
	"./pages/SignupWizardPage/screens/Weight/Weight.module.sass.d.ts": 3845,
	"./pages/SignupWizardPage/screens/Weight/Weight.stories": 3846,
	"./pages/SignupWizardPage/screens/Weight/Weight.stories.tsx": 3846,
	"./pages/SignupWizardPage/screens/Weight/Weight.tsx": 2162,
	"./pages/SignupWizardPage/screens/Weight/staticData": 1663,
	"./pages/SignupWizardPage/screens/Weight/staticData.ts": 1663,
	"./pages/SignupWizardPage/types/globalTypes": 3847,
	"./pages/SignupWizardPage/types/globalTypes.ts": 3847,
	"./pages/SignupWizardPage/types/routes": 108,
	"./pages/SignupWizardPage/types/routes.ts": 108,
	"./pages/SignupWizardPage/types/types": 132,
	"./pages/SignupWizardPage/types/types.ts": 132,
	"./pages/SimplifiedPlansPage/SimplifiedPlansPage": 217,
	"./pages/SimplifiedPlansPage/SimplifiedPlansPage.tsx": 217,
	"./pages/SimplifiedPlansPage/SimplifiedPlansPageRouting": 2595,
	"./pages/SimplifiedPlansPage/SimplifiedPlansPageRouting.tsx": 2595,
	"./pages/SimplifiedPlansPage/components/LoadingScreenContent/LoadingScreenContent": 2167,
	"./pages/SimplifiedPlansPage/components/LoadingScreenContent/LoadingScreenContent.module": 705,
	"./pages/SimplifiedPlansPage/components/LoadingScreenContent/LoadingScreenContent.module.sass": 705,
	"./pages/SimplifiedPlansPage/components/LoadingScreenContent/LoadingScreenContent.module.sass.d": 3848,
	"./pages/SimplifiedPlansPage/components/LoadingScreenContent/LoadingScreenContent.module.sass.d.ts": 3848,
	"./pages/SimplifiedPlansPage/components/LoadingScreenContent/LoadingScreenContent.tsx": 2167,
	"./pages/SimplifiedPlansPage/helpers/analytics": 346,
	"./pages/SimplifiedPlansPage/helpers/analytics.ts": 346,
	"./pages/SimplifiedPlansPage/helpers/plansNavigation": 525,
	"./pages/SimplifiedPlansPage/helpers/plansNavigation.ts": 525,
	"./pages/SimplifiedPlansPage/hooks/UseUpdateDiscountCode/mutations/RedeemDiscountCode": 2616,
	"./pages/SimplifiedPlansPage/hooks/UseUpdateDiscountCode/mutations/RedeemDiscountCode.ts": 2616,
	"./pages/SimplifiedPlansPage/hooks/UseUpdateDiscountCode/useUpdateDiscountCode": 2615,
	"./pages/SimplifiedPlansPage/hooks/UseUpdateDiscountCode/useUpdateDiscountCode.ts": 2615,
	"./pages/SimplifiedPlansPage/hooks/useCreatePendingSubscription": 1344,
	"./pages/SimplifiedPlansPage/hooks/useCreatePendingSubscription.ts": 1344,
	"./pages/SimplifiedPlansPage/hooks/useIdealPlan": 1347,
	"./pages/SimplifiedPlansPage/hooks/useIdealPlan.ts": 1347,
	"./pages/SimplifiedPlansPage/mutations/CreatePendingSubscription": 2606,
	"./pages/SimplifiedPlansPage/mutations/CreatePendingSubscription.ts": 2606,
	"./pages/SimplifiedPlansPage/mutations/__generated__/SimplifiedCreatePendingSubscription": 3849,
	"./pages/SimplifiedPlansPage/mutations/__generated__/SimplifiedCreatePendingSubscription.ts": 3849,
	"./pages/SimplifiedPlansPage/queries/ExtrasScreenQuery": 2598,
	"./pages/SimplifiedPlansPage/queries/ExtrasScreenQuery.ts": 2598,
	"./pages/SimplifiedPlansPage/queries/FunnelGiftCampaignQuery": 1838,
	"./pages/SimplifiedPlansPage/queries/FunnelGiftCampaignQuery.ts": 1838,
	"./pages/SimplifiedPlansPage/queries/GuestQuery": 934,
	"./pages/SimplifiedPlansPage/queries/GuestQuery.ts": 934,
	"./pages/SimplifiedPlansPage/queries/IdealPlanQuery": 2610,
	"./pages/SimplifiedPlansPage/queries/IdealPlanQuery.ts": 2610,
	"./pages/SimplifiedPlansPage/queries/PendingSubscriptionOrderPricingQuery": 1346,
	"./pages/SimplifiedPlansPage/queries/PendingSubscriptionOrderPricingQuery.ts": 1346,
	"./pages/SimplifiedPlansPage/queries/RecipesScreenQuery": 2618,
	"./pages/SimplifiedPlansPage/queries/RecipesScreenQuery.ts": 2618,
	"./pages/SimplifiedPlansPage/queries/__generated__/ExtrasScreenQuery": 3850,
	"./pages/SimplifiedPlansPage/queries/__generated__/ExtrasScreenQuery.ts": 3850,
	"./pages/SimplifiedPlansPage/queries/__generated__/FunnelGiftCampaignQuery": 3851,
	"./pages/SimplifiedPlansPage/queries/__generated__/FunnelGiftCampaignQuery.ts": 3851,
	"./pages/SimplifiedPlansPage/queries/__generated__/IdealPlanQuery": 3852,
	"./pages/SimplifiedPlansPage/queries/__generated__/IdealPlanQuery.ts": 3852,
	"./pages/SimplifiedPlansPage/queries/__generated__/PendingSubscriptionOrderPricingQuery": 3853,
	"./pages/SimplifiedPlansPage/queries/__generated__/PendingSubscriptionOrderPricingQuery.ts": 3853,
	"./pages/SimplifiedPlansPage/queries/__generated__/RecipesScreenQuery": 3854,
	"./pages/SimplifiedPlansPage/queries/__generated__/RecipesScreenQuery.ts": 3854,
	"./pages/SimplifiedPlansPage/queries/__generated__/SimplifiedGuestQuery": 3855,
	"./pages/SimplifiedPlansPage/queries/__generated__/SimplifiedGuestQuery.ts": 3855,
	"./pages/SimplifiedPlansPage/queries/__generated__/idealPlanFragment": 3856,
	"./pages/SimplifiedPlansPage/queries/__generated__/idealPlanFragment.ts": 3856,
	"./pages/SimplifiedPlansPage/queries/fragment/RecommendedExtrasFragment": 1837,
	"./pages/SimplifiedPlansPage/queries/fragment/RecommendedExtrasFragment.ts": 1837,
	"./pages/SimplifiedPlansPage/queries/fragment/__generated__/recommendedExtrasFragment": 3857,
	"./pages/SimplifiedPlansPage/queries/fragment/__generated__/recommendedExtrasFragment.ts": 3857,
	"./pages/SimplifiedPlansPage/screens/Extras/Extras": 2596,
	"./pages/SimplifiedPlansPage/screens/Extras/Extras.tsx": 2596,
	"./pages/SimplifiedPlansPage/screens/Extras/extras": 950,
	"./pages/SimplifiedPlansPage/screens/Extras/extras.module": 950,
	"./pages/SimplifiedPlansPage/screens/Extras/extras.module.sass": 950,
	"./pages/SimplifiedPlansPage/screens/Extras/extras.module.sass.d": 3858,
	"./pages/SimplifiedPlansPage/screens/Extras/extras.module.sass.d.ts": 3858,
	"./pages/SimplifiedPlansPage/screens/MultivariatePlan/Plan": 2607,
	"./pages/SimplifiedPlansPage/screens/MultivariatePlan/Plan.tsx": 2607,
	"./pages/SimplifiedPlansPage/screens/MultivariatePlan/components/BoxPlanCard/BoxPlanCard": 2608,
	"./pages/SimplifiedPlansPage/screens/MultivariatePlan/components/BoxPlanCard/BoxPlanCard.tsx": 2608,
	"./pages/SimplifiedPlansPage/screens/MultivariatePlan/components/BoxPlanCard/boxplancard": 778,
	"./pages/SimplifiedPlansPage/screens/MultivariatePlan/components/BoxPlanCard/boxplancard.module": 778,
	"./pages/SimplifiedPlansPage/screens/MultivariatePlan/components/BoxPlanCard/boxplancard.module.sass": 778,
	"./pages/SimplifiedPlansPage/screens/MultivariatePlan/components/BoxPlanCard/boxplancard.module.sass.d": 3859,
	"./pages/SimplifiedPlansPage/screens/MultivariatePlan/components/BoxPlanCard/boxplancard.module.sass.d.ts": 3859,
	"./pages/SimplifiedPlansPage/screens/MultivariatePlan/components/StarterBoxCard/StarterBoxCard": 2609,
	"./pages/SimplifiedPlansPage/screens/MultivariatePlan/components/StarterBoxCard/StarterBoxCard.tsx": 2609,
	"./pages/SimplifiedPlansPage/screens/MultivariatePlan/components/StarterBoxCard/starterboxcard": 750,
	"./pages/SimplifiedPlansPage/screens/MultivariatePlan/components/StarterBoxCard/starterboxcard.module": 750,
	"./pages/SimplifiedPlansPage/screens/MultivariatePlan/components/StarterBoxCard/starterboxcard.module.sass": 750,
	"./pages/SimplifiedPlansPage/screens/MultivariatePlan/components/StarterBoxCard/starterboxcard.module.sass.d": 3860,
	"./pages/SimplifiedPlansPage/screens/MultivariatePlan/components/StarterBoxCard/starterboxcard.module.sass.d.ts": 3860,
	"./pages/SimplifiedPlansPage/screens/MultivariatePlan/plan": 1157,
	"./pages/SimplifiedPlansPage/screens/MultivariatePlan/plan.module": 1157,
	"./pages/SimplifiedPlansPage/screens/MultivariatePlan/plan.module.sass": 1157,
	"./pages/SimplifiedPlansPage/screens/MultivariatePlan/plan.module.sass.d": 3861,
	"./pages/SimplifiedPlansPage/screens/MultivariatePlan/plan.module.sass.d.ts": 3861,
	"./pages/SimplifiedPlansPage/screens/Plan/Plan": 2611,
	"./pages/SimplifiedPlansPage/screens/Plan/Plan.tsx": 2611,
	"./pages/SimplifiedPlansPage/screens/Plan/components/BoxPlanCard/BoxPlanCard": 2612,
	"./pages/SimplifiedPlansPage/screens/Plan/components/BoxPlanCard/BoxPlanCard.tsx": 2612,
	"./pages/SimplifiedPlansPage/screens/Plan/components/BoxPlanCard/boxplancard": 779,
	"./pages/SimplifiedPlansPage/screens/Plan/components/BoxPlanCard/boxplancard.module": 779,
	"./pages/SimplifiedPlansPage/screens/Plan/components/BoxPlanCard/boxplancard.module.sass": 779,
	"./pages/SimplifiedPlansPage/screens/Plan/components/BoxPlanCard/boxplancard.module.sass.d": 3862,
	"./pages/SimplifiedPlansPage/screens/Plan/components/BoxPlanCard/boxplancard.module.sass.d.ts": 3862,
	"./pages/SimplifiedPlansPage/screens/Plan/components/StarterBoxCard/StarterBoxCard": 2613,
	"./pages/SimplifiedPlansPage/screens/Plan/components/StarterBoxCard/StarterBoxCard.tsx": 2613,
	"./pages/SimplifiedPlansPage/screens/Plan/components/StarterBoxCard/starterboxcard": 751,
	"./pages/SimplifiedPlansPage/screens/Plan/components/StarterBoxCard/starterboxcard.module": 751,
	"./pages/SimplifiedPlansPage/screens/Plan/components/StarterBoxCard/starterboxcard.module.sass": 751,
	"./pages/SimplifiedPlansPage/screens/Plan/components/StarterBoxCard/starterboxcard.module.sass.d": 3863,
	"./pages/SimplifiedPlansPage/screens/Plan/components/StarterBoxCard/starterboxcard.module.sass.d.ts": 3863,
	"./pages/SimplifiedPlansPage/screens/Plan/plan": 1158,
	"./pages/SimplifiedPlansPage/screens/Plan/plan.module": 1158,
	"./pages/SimplifiedPlansPage/screens/Plan/plan.module.sass": 1158,
	"./pages/SimplifiedPlansPage/screens/Plan/plan.module.sass.d": 3864,
	"./pages/SimplifiedPlansPage/screens/Plan/plan.module.sass.d.ts": 3864,
	"./pages/SimplifiedPlansPage/screens/Recipes/Recipes": 2163,
	"./pages/SimplifiedPlansPage/screens/Recipes/Recipes.module": 854,
	"./pages/SimplifiedPlansPage/screens/Recipes/Recipes.module.sass": 854,
	"./pages/SimplifiedPlansPage/screens/Recipes/Recipes.module.sass.d": 3865,
	"./pages/SimplifiedPlansPage/screens/Recipes/Recipes.module.sass.d.ts": 3865,
	"./pages/SimplifiedPlansPage/screens/Recipes/Recipes.tsx": 2163,
	"./pages/SimplifiedPlansPage/screens/Recipes/components/PlansStickyNavigation/PlansStickyNavigation": 1345,
	"./pages/SimplifiedPlansPage/screens/Recipes/components/PlansStickyNavigation/PlansStickyNavigation.tsx": 1345,
	"./pages/SimplifiedPlansPage/screens/Recipes/components/PlansStickyNavigation/plansstickynavigation": 1371,
	"./pages/SimplifiedPlansPage/screens/Recipes/components/PlansStickyNavigation/plansstickynavigation.module": 1371,
	"./pages/SimplifiedPlansPage/screens/Recipes/components/PlansStickyNavigation/plansstickynavigation.module.sass": 1371,
	"./pages/SimplifiedPlansPage/screens/Recipes/components/PlansStickyNavigation/plansstickynavigation.module.sass.d": 3866,
	"./pages/SimplifiedPlansPage/screens/Recipes/components/PlansStickyNavigation/plansstickynavigation.module.sass.d.ts": 3866,
	"./pages/SimplifiedPlansPage/screens/Recipes/components/SecondaryRecipesSection/SecondaryRecipesSection": 2164,
	"./pages/SimplifiedPlansPage/screens/Recipes/components/SecondaryRecipesSection/SecondaryRecipesSection.module": 2343,
	"./pages/SimplifiedPlansPage/screens/Recipes/components/SecondaryRecipesSection/SecondaryRecipesSection.module.sass": 2343,
	"./pages/SimplifiedPlansPage/screens/Recipes/components/SecondaryRecipesSection/SecondaryRecipesSection.module.sass.d": 3867,
	"./pages/SimplifiedPlansPage/screens/Recipes/components/SecondaryRecipesSection/SecondaryRecipesSection.module.sass.d.ts": 3867,
	"./pages/SimplifiedPlansPage/screens/Recipes/components/SecondaryRecipesSection/SecondaryRecipesSection.tsx": 2164,
	"./pages/SimplifiedPlansPage/screens/Recipes/components/StarterBoxSection/StarterBoxSection": 2165,
	"./pages/SimplifiedPlansPage/screens/Recipes/components/StarterBoxSection/StarterBoxSection.module": 1264,
	"./pages/SimplifiedPlansPage/screens/Recipes/components/StarterBoxSection/StarterBoxSection.module.sass": 1264,
	"./pages/SimplifiedPlansPage/screens/Recipes/components/StarterBoxSection/StarterBoxSection.module.sass.d": 3868,
	"./pages/SimplifiedPlansPage/screens/Recipes/components/StarterBoxSection/StarterBoxSection.module.sass.d.ts": 3868,
	"./pages/SimplifiedPlansPage/screens/Recipes/components/StarterBoxSection/StarterBoxSection.tsx": 2165,
	"./pages/SimplifiedPlansPage/types/analyticsProperties": 419,
	"./pages/SimplifiedPlansPage/types/analyticsProperties.ts": 419,
	"./pages/SimplifiedPlansPage/types/routes": 196,
	"./pages/SimplifiedPlansPage/types/routes.ts": 196,
	"./pages/SurveyPage/SurveyPage": 2905,
	"./pages/SurveyPage/SurveyPage.module": 1942,
	"./pages/SurveyPage/SurveyPage.module.sass": 1942,
	"./pages/SurveyPage/SurveyPage.module.sass.d": 3869,
	"./pages/SurveyPage/SurveyPage.module.sass.d.ts": 3869,
	"./pages/SurveyPage/SurveyPage.stories": 3870,
	"./pages/SurveyPage/SurveyPage.stories.tsx": 3870,
	"./pages/SurveyPage/SurveyPage.tsx": 2905,
	"./pages/SurveyPage/screens/ChoiceQuestion/ChoiceQuestion": 1871,
	"./pages/SurveyPage/screens/ChoiceQuestion/ChoiceQuestion.module": 1175,
	"./pages/SurveyPage/screens/ChoiceQuestion/ChoiceQuestion.module.sass": 1175,
	"./pages/SurveyPage/screens/ChoiceQuestion/ChoiceQuestion.module.sass.d": 3871,
	"./pages/SurveyPage/screens/ChoiceQuestion/ChoiceQuestion.module.sass.d.ts": 3871,
	"./pages/SurveyPage/screens/ChoiceQuestion/ChoiceQuestion.tsx": 1871,
	"./pages/SurveyPage/screens/MultipleChoiceQuestion/MultipleChoiceQuestion": 2234,
	"./pages/SurveyPage/screens/MultipleChoiceQuestion/MultipleChoiceQuestion.module": 1680,
	"./pages/SurveyPage/screens/MultipleChoiceQuestion/MultipleChoiceQuestion.module.sass": 1680,
	"./pages/SurveyPage/screens/MultipleChoiceQuestion/MultipleChoiceQuestion.module.sass.d": 3872,
	"./pages/SurveyPage/screens/MultipleChoiceQuestion/MultipleChoiceQuestion.module.sass.d.ts": 3872,
	"./pages/SurveyPage/screens/MultipleChoiceQuestion/MultipleChoiceQuestion.tsx": 2234,
	"./pages/SurveyPage/screens/RatingQuestion/RatingQuestion": 1872,
	"./pages/SurveyPage/screens/RatingQuestion/RatingQuestion.module": 2374,
	"./pages/SurveyPage/screens/RatingQuestion/RatingQuestion.module.sass": 2374,
	"./pages/SurveyPage/screens/RatingQuestion/RatingQuestion.module.sass.d": 3873,
	"./pages/SurveyPage/screens/RatingQuestion/RatingQuestion.module.sass.d.ts": 3873,
	"./pages/SurveyPage/screens/RatingQuestion/RatingQuestion.tsx": 1872,
	"./pages/SurveyPage/utils": 2807,
	"./pages/SurveyPage/utils.ts": 2807,
	"./pages/SwapAndSavePage/SwapAndSavePage": 2201,
	"./pages/SwapAndSavePage/SwapAndSavePage.module": 901,
	"./pages/SwapAndSavePage/SwapAndSavePage.module.sass": 901,
	"./pages/SwapAndSavePage/SwapAndSavePage.module.sass.d": 3874,
	"./pages/SwapAndSavePage/SwapAndSavePage.module.sass.d.ts": 3874,
	"./pages/SwapAndSavePage/SwapAndSavePage.tsx": 2201,
	"./pages/SwapAndSavePage/queries/SubscriptionPlanUpdate": 1816,
	"./pages/SwapAndSavePage/queries/SubscriptionPlanUpdate.ts": 1816,
	"./pages/SwapAndSavePage/queries/SwapAndSavePageQuery": 1628,
	"./pages/SwapAndSavePage/queries/SwapAndSavePageQuery.ts": 1628,
	"./pages/SwapAndSavePage/queries/UpdatePlanAndResumeMutation": 1333,
	"./pages/SwapAndSavePage/queries/UpdatePlanAndResumeMutation.ts": 1333,
	"./pages/SwapAndSavePage/queries/__generated__/DogPlanPortionQuery": 3875,
	"./pages/SwapAndSavePage/queries/__generated__/DogPlanPortionQuery.ts": 3875,
	"./pages/SwapAndSavePage/queries/__generated__/SubscriptionPlanUpdate": 3876,
	"./pages/SwapAndSavePage/queries/__generated__/SubscriptionPlanUpdate.ts": 3876,
	"./pages/SwapAndSavePage/queries/__generated__/SwapAndSavePageQuery": 3877,
	"./pages/SwapAndSavePage/queries/__generated__/SwapAndSavePageQuery.ts": 3877,
	"./pages/SwapAndSavePage/queries/__generated__/UpdatePlanAndResume": 3878,
	"./pages/SwapAndSavePage/queries/__generated__/UpdatePlanAndResume.ts": 3878,
	"./pages/SwitchAndSavePage/SwitchAndSavePage": 2202,
	"./pages/SwitchAndSavePage/SwitchAndSavePage.module": 1670,
	"./pages/SwitchAndSavePage/SwitchAndSavePage.module.sass": 1670,
	"./pages/SwitchAndSavePage/SwitchAndSavePage.module.sass.d": 3879,
	"./pages/SwitchAndSavePage/SwitchAndSavePage.module.sass.d.ts": 3879,
	"./pages/SwitchAndSavePage/SwitchAndSavePage.tsx": 2202,
	"./pages/SwitchAndSavePage/queries/RemoveSurchargedRecipesMutation": 2726,
	"./pages/SwitchAndSavePage/queries/RemoveSurchargedRecipesMutation.ts": 2726,
	"./pages/SwitchAndSavePage/queries/SwitchAndSavePageQuery": 2727,
	"./pages/SwitchAndSavePage/queries/SwitchAndSavePageQuery.ts": 2727,
	"./pages/SwitchAndSavePage/queries/__generated__/RemoveSurchargedRecipes": 3880,
	"./pages/SwitchAndSavePage/queries/__generated__/RemoveSurchargedRecipes.ts": 3880,
	"./pages/SwitchAndSavePage/queries/__generated__/SwitchAndSavePageQuery": 3881,
	"./pages/SwitchAndSavePage/queries/__generated__/SwitchAndSavePageQuery.ts": 3881,
	"./pages/ThankYouPage/ThankYouPage": 2906,
	"./pages/ThankYouPage/ThankYouPage.module": 1943,
	"./pages/ThankYouPage/ThankYouPage.module.sass": 1943,
	"./pages/ThankYouPage/ThankYouPage.module.sass.d": 3882,
	"./pages/ThankYouPage/ThankYouPage.module.sass.d.ts": 3882,
	"./pages/ThankYouPage/ThankYouPage.tsx": 2906,
	"./pages/ThankYouPage/__generated__/thankYouQuery": 3883,
	"./pages/ThankYouPage/__generated__/thankYouQuery.ts": 3883,
	"./pages/ThankYouPage/components/DogProfileSection/DogProfileSection": 2235,
	"./pages/ThankYouPage/components/DogProfileSection/DogProfileSection.module": 1394,
	"./pages/ThankYouPage/components/DogProfileSection/DogProfileSection.module.sass": 1394,
	"./pages/ThankYouPage/components/DogProfileSection/DogProfileSection.module.sass.d": 3884,
	"./pages/ThankYouPage/components/DogProfileSection/DogProfileSection.module.sass.d.ts": 3884,
	"./pages/ThankYouPage/components/DogProfileSection/DogProfileSection.tsx": 2235,
	"./pages/ThankYouPage/components/RAFSection/RAFSection": 2236,
	"./pages/ThankYouPage/components/RAFSection/RAFSection.module": 2375,
	"./pages/ThankYouPage/components/RAFSection/RAFSection.module.sass": 2375,
	"./pages/ThankYouPage/components/RAFSection/RAFSection.module.sass.d": 3885,
	"./pages/ThankYouPage/components/RAFSection/RAFSection.module.sass.d.ts": 3885,
	"./pages/ThankYouPage/components/RAFSection/RAFSection.tsx": 2236,
	"./pages/ThankYouPage/queries": 2798,
	"./pages/ThankYouPage/queries.ts": 2798,
	"./pages/ThankYouPageV3": 2458,
	"./pages/ThankYouPageV3/": 2458,
	"./pages/ThankYouPageV3/ThankYouPageV3": 2080,
	"./pages/ThankYouPageV3/ThankYouPageV3.module": 1395,
	"./pages/ThankYouPageV3/ThankYouPageV3.module.sass": 1395,
	"./pages/ThankYouPageV3/ThankYouPageV3.module.sass.d": 3886,
	"./pages/ThankYouPageV3/ThankYouPageV3.module.sass.d.ts": 3886,
	"./pages/ThankYouPageV3/ThankYouPageV3.tsx": 2080,
	"./pages/ThankYouPageV3/__generated__/thankYouQueryV3": 3887,
	"./pages/ThankYouPageV3/__generated__/thankYouQueryV3.ts": 3887,
	"./pages/ThankYouPageV3/components": 1613,
	"./pages/ThankYouPageV3/components/": 1613,
	"./pages/ThankYouPageV3/components/AppOverlay/AppOverlay": 2237,
	"./pages/ThankYouPageV3/components/AppOverlay/AppOverlay.module": 2799,
	"./pages/ThankYouPageV3/components/AppOverlay/AppOverlay.module.sass": 2799,
	"./pages/ThankYouPageV3/components/AppOverlay/AppOverlay.module.sass.d": 3888,
	"./pages/ThankYouPageV3/components/AppOverlay/AppOverlay.module.sass.d.ts": 3888,
	"./pages/ThankYouPageV3/components/AppOverlay/AppOverlay.tsx": 2237,
	"./pages/ThankYouPageV3/components/Discounts": 1702,
	"./pages/ThankYouPageV3/components/Discounts/": 1702,
	"./pages/ThankYouPageV3/components/Discounts/Discounts": 1159,
	"./pages/ThankYouPageV3/components/Discounts/Discounts.module": 1159,
	"./pages/ThankYouPageV3/components/Discounts/Discounts.module.sass": 1159,
	"./pages/ThankYouPageV3/components/Discounts/Discounts.module.sass.d": 3889,
	"./pages/ThankYouPageV3/components/Discounts/Discounts.module.sass.d.ts": 3889,
	"./pages/ThankYouPageV3/components/Discounts/Referal": 2800,
	"./pages/ThankYouPageV3/components/Discounts/Referal.tsx": 2800,
	"./pages/ThankYouPageV3/components/Discounts/index": 1702,
	"./pages/ThankYouPageV3/components/Discounts/index.tsx": 1702,
	"./pages/ThankYouPageV3/components/DogProfile": 1703,
	"./pages/ThankYouPageV3/components/DogProfile/": 1703,
	"./pages/ThankYouPageV3/components/DogProfile/DogProfile": 1160,
	"./pages/ThankYouPageV3/components/DogProfile/DogProfile.module": 1160,
	"./pages/ThankYouPageV3/components/DogProfile/DogProfile.module.sass": 1160,
	"./pages/ThankYouPageV3/components/DogProfile/DogProfile.module.sass.d": 3890,
	"./pages/ThankYouPageV3/components/DogProfile/DogProfile.module.sass.d.ts": 3890,
	"./pages/ThankYouPageV3/components/DogProfile/index": 1703,
	"./pages/ThankYouPageV3/components/DogProfile/index.tsx": 1703,
	"./pages/ThankYouPageV3/components/SupscriptionConfirmation": 1799,
	"./pages/ThankYouPageV3/components/SupscriptionConfirmation/": 1799,
	"./pages/ThankYouPageV3/components/SupscriptionConfirmation/index": 1799,
	"./pages/ThankYouPageV3/components/SupscriptionConfirmation/index.tsx": 1799,
	"./pages/ThankYouPageV3/components/index": 1613,
	"./pages/ThankYouPageV3/components/index.ts": 1613,
	"./pages/ThankYouPageV3/index": 2458,
	"./pages/ThankYouPageV3/index.ts": 2458,
	"./pages/ThankYouPageV3/queries": 2801,
	"./pages/ThankYouPageV3/queries.ts": 2801,
	"./pages/TreatmentsPausedPage/TreatmentsPausedPage": 2728,
	"./pages/TreatmentsPausedPage/TreatmentsPausedPage.tsx": 2728,
	"./pages/TreatmentsPausedPage/components/CareModal/CareModal": 2203,
	"./pages/TreatmentsPausedPage/components/CareModal/CareModal.module": 1937,
	"./pages/TreatmentsPausedPage/components/CareModal/CareModal.module.sass": 1937,
	"./pages/TreatmentsPausedPage/components/CareModal/CareModal.module.sass.d": 3891,
	"./pages/TreatmentsPausedPage/components/CareModal/CareModal.module.sass.d.ts": 3891,
	"./pages/TreatmentsPausedPage/components/CareModal/CareModal.tsx": 2203,
	"./pages/TreatmentsPausedPage/components/DogsHero/DogsHero": 2204,
	"./pages/TreatmentsPausedPage/components/DogsHero/DogsHero.module": 707,
	"./pages/TreatmentsPausedPage/components/DogsHero/DogsHero.module.sass": 707,
	"./pages/TreatmentsPausedPage/components/DogsHero/DogsHero.module.sass.d": 3892,
	"./pages/TreatmentsPausedPage/components/DogsHero/DogsHero.module.sass.d.ts": 3892,
	"./pages/TreatmentsPausedPage/components/DogsHero/DogsHero.tsx": 2204,
	"./pages/TreatmentsPausedPage/components/PageTitle/PageTitle": 2907,
	"./pages/TreatmentsPausedPage/components/PageTitle/PageTitle.module": 1681,
	"./pages/TreatmentsPausedPage/components/PageTitle/PageTitle.module.sass": 1681,
	"./pages/TreatmentsPausedPage/components/PageTitle/PageTitle.module.sass.d": 3893,
	"./pages/TreatmentsPausedPage/components/PageTitle/PageTitle.module.sass.d.ts": 3893,
	"./pages/TreatmentsPausedPage/components/PageTitle/PageTitle.tsx": 2907,
	"./pages/TreatmentsPausedPage/components/PausedDatePicker/PausedDatePicker": 2205,
	"./pages/TreatmentsPausedPage/components/PausedDatePicker/PausedDatePicker.module": 2729,
	"./pages/TreatmentsPausedPage/components/PausedDatePicker/PausedDatePicker.module.sass": 2729,
	"./pages/TreatmentsPausedPage/components/PausedDatePicker/PausedDatePicker.module.sass.d": 3894,
	"./pages/TreatmentsPausedPage/components/PausedDatePicker/PausedDatePicker.module.sass.d.ts": 3894,
	"./pages/TreatmentsPausedPage/components/PausedDatePicker/PausedDatePicker.tsx": 2205,
	"./pages/TreatmentsPausedPage/components/PausedDatePicker/components/Calendar": 1819,
	"./pages/TreatmentsPausedPage/components/PausedDatePicker/components/Calendar.tsx": 1819,
	"./pages/TreatmentsPausedPage/components/PausedDatePicker/queries/__generated__/PausedCalendarDatesData": 3895,
	"./pages/TreatmentsPausedPage/components/PausedDatePicker/queries/__generated__/PausedCalendarDatesData.ts": 3895,
	"./pages/TreatmentsPausedPage/components/PausedDatePicker/queries/pausedCalendarDatesQuery": 2546,
	"./pages/TreatmentsPausedPage/components/PausedDatePicker/queries/pausedCalendarDatesQuery.ts": 2546,
	"./pages/TreatmentsPausedPage/components/TreatmentSection/TreatmentSection": 2206,
	"./pages/TreatmentsPausedPage/components/TreatmentSection/TreatmentSection.module": 1388,
	"./pages/TreatmentsPausedPage/components/TreatmentSection/TreatmentSection.module.sass": 1388,
	"./pages/TreatmentsPausedPage/components/TreatmentSection/TreatmentSection.module.sass.d": 3896,
	"./pages/TreatmentsPausedPage/components/TreatmentSection/TreatmentSection.module.sass.d.ts": 3896,
	"./pages/TreatmentsPausedPage/components/TreatmentSection/TreatmentSection.tsx": 2206,
	"./pages/TreatmentsPausedPage/helpers/helpers": 2356,
	"./pages/TreatmentsPausedPage/helpers/helpers.ts": 2356,
	"./pages/TreatmentsPausedPage/queries/__generated__/SubscriptionResume": 3897,
	"./pages/TreatmentsPausedPage/queries/__generated__/SubscriptionResume.ts": 3897,
	"./pages/TreatmentsPausedPage/queries/__generated__/TreatmentsPausedFutureBoxesQuery": 3898,
	"./pages/TreatmentsPausedPage/queries/__generated__/TreatmentsPausedFutureBoxesQuery.ts": 3898,
	"./pages/TreatmentsPausedPage/queries/__generated__/TreatmentsPausedPageQuery": 3899,
	"./pages/TreatmentsPausedPage/queries/__generated__/TreatmentsPausedPageQuery.ts": 3899,
	"./pages/TreatmentsPausedPage/queries/__generated__/reactivationCampaignFragment": 3900,
	"./pages/TreatmentsPausedPage/queries/__generated__/reactivationCampaignFragment.ts": 3900,
	"./pages/TreatmentsPausedPage/queries/__generated__/reactivationCampaignQuery": 3901,
	"./pages/TreatmentsPausedPage/queries/__generated__/reactivationCampaignQuery.ts": 3901,
	"./pages/TreatmentsPausedPage/queries/queries": 1230,
	"./pages/TreatmentsPausedPage/queries/queries.ts": 1230,
	"./pages/UpdateDogAboutInfo": 1774,
	"./pages/UpdateDogAboutInfo/": 1774,
	"./pages/UpdateDogAboutInfo/UpdateDogAboutInfo": 2060,
	"./pages/UpdateDogAboutInfo/UpdateDogAboutInfo.module": 856,
	"./pages/UpdateDogAboutInfo/UpdateDogAboutInfo.module.sass": 856,
	"./pages/UpdateDogAboutInfo/UpdateDogAboutInfo.module.sass.d": 3902,
	"./pages/UpdateDogAboutInfo/UpdateDogAboutInfo.module.sass.d.ts": 3902,
	"./pages/UpdateDogAboutInfo/UpdateDogAboutInfo.tsx": 2060,
	"./pages/UpdateDogAboutInfo/UpdateDogAboutInfoContent": 2730,
	"./pages/UpdateDogAboutInfo/UpdateDogAboutInfoContent.tsx": 2730,
	"./pages/UpdateDogAboutInfo/index": 1774,
	"./pages/UpdateDogAboutInfo/index.ts": 1774,
	"./pages/UpdateDogAboutInfo/mutations/__generated__/UpdateDogAboutInfoMutation": 3903,
	"./pages/UpdateDogAboutInfo/mutations/__generated__/UpdateDogAboutInfoMutation.ts": 3903,
	"./pages/UpdateDogAboutInfo/mutations/updateDogAboutInfoMutation": 2731,
	"./pages/UpdateDogAboutInfo/mutations/updateDogAboutInfoMutation.ts": 2731,
	"./pages/UpdateDogAboutInfo/queries/__generated__/DogAboutInfoQuery": 3904,
	"./pages/UpdateDogAboutInfo/queries/__generated__/DogAboutInfoQuery.ts": 3904,
	"./pages/UpdateDogAboutInfo/queries/dogAboutInfoQuery": 1861,
	"./pages/UpdateDogAboutInfo/queries/dogAboutInfoQuery.ts": 1861,
	"./pages/UpdateDogAboutInfo/v2": 1775,
	"./pages/UpdateDogAboutInfo/v2/": 1775,
	"./pages/UpdateDogAboutInfo/v2/UpdateDogAboutInfo": 2061,
	"./pages/UpdateDogAboutInfo/v2/UpdateDogAboutInfo.module": 681,
	"./pages/UpdateDogAboutInfo/v2/UpdateDogAboutInfo.module.sass": 681,
	"./pages/UpdateDogAboutInfo/v2/UpdateDogAboutInfo.module.sass.d": 3905,
	"./pages/UpdateDogAboutInfo/v2/UpdateDogAboutInfo.module.sass.d.ts": 3905,
	"./pages/UpdateDogAboutInfo/v2/UpdateDogAboutInfo.tsx": 2061,
	"./pages/UpdateDogAboutInfo/v2/UpdateDogAboutInfoContent": 2732,
	"./pages/UpdateDogAboutInfo/v2/UpdateDogAboutInfoContent.tsx": 2732,
	"./pages/UpdateDogAboutInfo/v2/index": 1775,
	"./pages/UpdateDogAboutInfo/v2/index.ts": 1775,
	"./pages/UpdateDogAboutInfo/v2/mutations/__generated__/UpdateDogBasicInformationMutation": 3906,
	"./pages/UpdateDogAboutInfo/v2/mutations/__generated__/UpdateDogBasicInformationMutation.ts": 3906,
	"./pages/UpdateDogAboutInfo/v2/mutations/updateDogBasicInformationMutation": 2733,
	"./pages/UpdateDogAboutInfo/v2/mutations/updateDogBasicInformationMutation.ts": 2733,
	"./pages/UpdateDogBasicInfo": 1776,
	"./pages/UpdateDogBasicInfo/": 1776,
	"./pages/UpdateDogBasicInfo/UpdateDogBasicInfo": 2063,
	"./pages/UpdateDogBasicInfo/UpdateDogBasicInfo.module": 853,
	"./pages/UpdateDogBasicInfo/UpdateDogBasicInfo.module.sass": 853,
	"./pages/UpdateDogBasicInfo/UpdateDogBasicInfo.module.sass.d": 3907,
	"./pages/UpdateDogBasicInfo/UpdateDogBasicInfo.module.sass.d.ts": 3907,
	"./pages/UpdateDogBasicInfo/UpdateDogBasicInfo.tsx": 2063,
	"./pages/UpdateDogBasicInfo/UpdateDogBasicInfoContent": 1240,
	"./pages/UpdateDogBasicInfo/UpdateDogBasicInfoContent.tsx": 1240,
	"./pages/UpdateDogBasicInfo/index": 1776,
	"./pages/UpdateDogBasicInfo/index.ts": 1776,
	"./pages/UpdateDogBasicInfo/mutations/__generated__/UpdateDogBasicInfoMutation": 3908,
	"./pages/UpdateDogBasicInfo/mutations/__generated__/UpdateDogBasicInfoMutation.ts": 3908,
	"./pages/UpdateDogBasicInfo/mutations/updateDogBasicInfoMutation": 2541,
	"./pages/UpdateDogBasicInfo/mutations/updateDogBasicInfoMutation.ts": 2541,
	"./pages/UpdateDogBasicInfo/queries/__generated__/DogBasicInfoQuery": 3909,
	"./pages/UpdateDogBasicInfo/queries/__generated__/DogBasicInfoQuery.ts": 3909,
	"./pages/UpdateDogBasicInfo/queries/dogBasicInfoQuery": 2734,
	"./pages/UpdateDogBasicInfo/queries/dogBasicInfoQuery.ts": 2734,
	"./pages/UpdateDogEatingHabits": 1777,
	"./pages/UpdateDogEatingHabits/": 1777,
	"./pages/UpdateDogEatingHabits/UpdateDogEatingHabits": 2064,
	"./pages/UpdateDogEatingHabits/UpdateDogEatingHabits.module": 1110,
	"./pages/UpdateDogEatingHabits/UpdateDogEatingHabits.module.sass": 1110,
	"./pages/UpdateDogEatingHabits/UpdateDogEatingHabits.module.sass.d": 3910,
	"./pages/UpdateDogEatingHabits/UpdateDogEatingHabits.module.sass.d.ts": 3910,
	"./pages/UpdateDogEatingHabits/UpdateDogEatingHabits.tsx": 2064,
	"./pages/UpdateDogEatingHabits/UpdateDogEatingHabitsContent": 2736,
	"./pages/UpdateDogEatingHabits/UpdateDogEatingHabitsContent.tsx": 2736,
	"./pages/UpdateDogEatingHabits/index": 1777,
	"./pages/UpdateDogEatingHabits/index.ts": 1777,
	"./pages/UpdateDogEatingHabits/mutations/__generated__/UpdateDogEatingHabitsMutation": 3911,
	"./pages/UpdateDogEatingHabits/mutations/__generated__/UpdateDogEatingHabitsMutation.ts": 3911,
	"./pages/UpdateDogEatingHabits/mutations/updateDogEatingHabitsMutation": 2737,
	"./pages/UpdateDogEatingHabits/mutations/updateDogEatingHabitsMutation.ts": 2737,
	"./pages/UpdateDogEatingHabits/queries/__generated__/DogEatingHabitsQuery": 3912,
	"./pages/UpdateDogEatingHabits/queries/__generated__/DogEatingHabitsQuery.ts": 3912,
	"./pages/UpdateDogEatingHabits/queries/dogEatingHabitsQuery": 2735,
	"./pages/UpdateDogEatingHabits/queries/dogEatingHabitsQuery.ts": 2735,
	"./pages/UpdateDogMedicalInfo": 1778,
	"./pages/UpdateDogMedicalInfo/": 1778,
	"./pages/UpdateDogMedicalInfo/UpdateDogMedicalInfo": 2065,
	"./pages/UpdateDogMedicalInfo/UpdateDogMedicalInfo.module": 1258,
	"./pages/UpdateDogMedicalInfo/UpdateDogMedicalInfo.module.sass": 1258,
	"./pages/UpdateDogMedicalInfo/UpdateDogMedicalInfo.module.sass.d": 3913,
	"./pages/UpdateDogMedicalInfo/UpdateDogMedicalInfo.module.sass.d.ts": 3913,
	"./pages/UpdateDogMedicalInfo/UpdateDogMedicalInfo.tsx": 2065,
	"./pages/UpdateDogMedicalInfo/UpdateDogMedicalInfoContent": 1630,
	"./pages/UpdateDogMedicalInfo/UpdateDogMedicalInfoContent.tsx": 1630,
	"./pages/UpdateDogMedicalInfo/index": 1778,
	"./pages/UpdateDogMedicalInfo/index.ts": 1778,
	"./pages/UpdateDogMedicalInfo/mutations/__generated__/UpdateMedicalInfoMutation": 3914,
	"./pages/UpdateDogMedicalInfo/mutations/__generated__/UpdateMedicalInfoMutation.ts": 3914,
	"./pages/UpdateDogMedicalInfo/mutations/updateMedicalInfoMutation": 1817,
	"./pages/UpdateDogMedicalInfo/mutations/updateMedicalInfoMutation.ts": 1817,
	"./pages/UpdateDogMedicalInfo/queries/__generated__/MedicalInfoQuery": 3915,
	"./pages/UpdateDogMedicalInfo/queries/__generated__/MedicalInfoQuery.ts": 3915,
	"./pages/UpdateDogMedicalInfo/queries/medicalInfoQuery": 1862,
	"./pages/UpdateDogMedicalInfo/queries/medicalInfoQuery.ts": 1862,
	"./pages/UpdateDogMedicalInfo/v2": 1779,
	"./pages/UpdateDogMedicalInfo/v2/": 1779,
	"./pages/UpdateDogMedicalInfo/v2/UpdateDogMedicalInfo": 2066,
	"./pages/UpdateDogMedicalInfo/v2/UpdateDogMedicalInfo.module": 757,
	"./pages/UpdateDogMedicalInfo/v2/UpdateDogMedicalInfo.module.sass": 757,
	"./pages/UpdateDogMedicalInfo/v2/UpdateDogMedicalInfo.module.sass.d": 3916,
	"./pages/UpdateDogMedicalInfo/v2/UpdateDogMedicalInfo.module.sass.d.ts": 3916,
	"./pages/UpdateDogMedicalInfo/v2/UpdateDogMedicalInfo.tsx": 2066,
	"./pages/UpdateDogMedicalInfo/v2/UpdateDogMedicalInfoContent": 2738,
	"./pages/UpdateDogMedicalInfo/v2/UpdateDogMedicalInfoContent.tsx": 2738,
	"./pages/UpdateDogMedicalInfo/v2/index": 1779,
	"./pages/UpdateDogMedicalInfo/v2/index.ts": 1779,
	"./pages/UpdateDogPersonality": 1780,
	"./pages/UpdateDogPersonality/": 1780,
	"./pages/UpdateDogPersonality/UpdateDogPersonality": 2067,
	"./pages/UpdateDogPersonality/UpdateDogPersonality.module": 1111,
	"./pages/UpdateDogPersonality/UpdateDogPersonality.module.sass": 1111,
	"./pages/UpdateDogPersonality/UpdateDogPersonality.module.sass.d": 3917,
	"./pages/UpdateDogPersonality/UpdateDogPersonality.module.sass.d.ts": 3917,
	"./pages/UpdateDogPersonality/UpdateDogPersonality.tsx": 2067,
	"./pages/UpdateDogPersonality/UpdateDogPersonalityContent": 2740,
	"./pages/UpdateDogPersonality/UpdateDogPersonalityContent.tsx": 2740,
	"./pages/UpdateDogPersonality/index": 1780,
	"./pages/UpdateDogPersonality/index.ts": 1780,
	"./pages/UpdateDogPersonality/mutations/__generated__/CreateDogProfilesMutation": 3918,
	"./pages/UpdateDogPersonality/mutations/__generated__/CreateDogProfilesMutation.ts": 3918,
	"./pages/UpdateDogPersonality/mutations/__generated__/UpdateDogPersonalityMutation": 3919,
	"./pages/UpdateDogPersonality/mutations/__generated__/UpdateDogPersonalityMutation.ts": 3919,
	"./pages/UpdateDogPersonality/mutations/updateDogPersonalityMutation": 2357,
	"./pages/UpdateDogPersonality/mutations/updateDogPersonalityMutation.ts": 2357,
	"./pages/UpdateDogPersonality/queries/__generated__/DogPersonalityQuery": 3920,
	"./pages/UpdateDogPersonality/queries/__generated__/DogPersonalityQuery.ts": 3920,
	"./pages/UpdateDogPersonality/queries/dogPersonalityQuery": 2739,
	"./pages/UpdateDogPersonality/queries/dogPersonalityQuery.ts": 2739,
	"./pages/UpdateDogWeightAndAppetite": 1781,
	"./pages/UpdateDogWeightAndAppetite/": 1781,
	"./pages/UpdateDogWeightAndAppetite/UpdateDogWeightAndAppetite": 2068,
	"./pages/UpdateDogWeightAndAppetite/UpdateDogWeightAndAppetite.module": 1938,
	"./pages/UpdateDogWeightAndAppetite/UpdateDogWeightAndAppetite.module.sass": 1938,
	"./pages/UpdateDogWeightAndAppetite/UpdateDogWeightAndAppetite.module.sass.d": 3921,
	"./pages/UpdateDogWeightAndAppetite/UpdateDogWeightAndAppetite.module.sass.d.ts": 3921,
	"./pages/UpdateDogWeightAndAppetite/UpdateDogWeightAndAppetite.tsx": 2068,
	"./pages/UpdateDogWeightAndAppetite/UpdateDogWeightAndAppetiteContent": 2742,
	"./pages/UpdateDogWeightAndAppetite/UpdateDogWeightAndAppetiteContent.tsx": 2742,
	"./pages/UpdateDogWeightAndAppetite/components/Activity": 1782,
	"./pages/UpdateDogWeightAndAppetite/components/Activity/": 1782,
	"./pages/UpdateDogWeightAndAppetite/components/Activity/Activity": 2436,
	"./pages/UpdateDogWeightAndAppetite/components/Activity/Activity.tsx": 2436,
	"./pages/UpdateDogWeightAndAppetite/components/Activity/index": 1782,
	"./pages/UpdateDogWeightAndAppetite/components/Activity/index.ts": 1782,
	"./pages/UpdateDogWeightAndAppetite/components/BodyCondition": 1783,
	"./pages/UpdateDogWeightAndAppetite/components/BodyCondition/": 1783,
	"./pages/UpdateDogWeightAndAppetite/components/BodyCondition/BodyCondition": 2437,
	"./pages/UpdateDogWeightAndAppetite/components/BodyCondition/BodyCondition.tsx": 2437,
	"./pages/UpdateDogWeightAndAppetite/components/BodyCondition/index": 1783,
	"./pages/UpdateDogWeightAndAppetite/components/BodyCondition/index.ts": 1783,
	"./pages/UpdateDogWeightAndAppetite/components/EatingHabits": 1784,
	"./pages/UpdateDogWeightAndAppetite/components/EatingHabits/": 1784,
	"./pages/UpdateDogWeightAndAppetite/components/EatingHabits/EatingHabits": 2438,
	"./pages/UpdateDogWeightAndAppetite/components/EatingHabits/EatingHabits.tsx": 2438,
	"./pages/UpdateDogWeightAndAppetite/components/EatingHabits/index": 1784,
	"./pages/UpdateDogWeightAndAppetite/components/EatingHabits/index.ts": 1784,
	"./pages/UpdateDogWeightAndAppetite/components/SnackingHabits": 1785,
	"./pages/UpdateDogWeightAndAppetite/components/SnackingHabits/": 1785,
	"./pages/UpdateDogWeightAndAppetite/components/SnackingHabits/SnackingHabits": 2439,
	"./pages/UpdateDogWeightAndAppetite/components/SnackingHabits/SnackingHabits.tsx": 2439,
	"./pages/UpdateDogWeightAndAppetite/components/SnackingHabits/index": 1785,
	"./pages/UpdateDogWeightAndAppetite/components/SnackingHabits/index.ts": 1785,
	"./pages/UpdateDogWeightAndAppetite/components/Weight": 1786,
	"./pages/UpdateDogWeightAndAppetite/components/Weight/": 1786,
	"./pages/UpdateDogWeightAndAppetite/components/Weight/Weight": 2440,
	"./pages/UpdateDogWeightAndAppetite/components/Weight/Weight.tsx": 2440,
	"./pages/UpdateDogWeightAndAppetite/components/Weight/index": 1786,
	"./pages/UpdateDogWeightAndAppetite/components/Weight/index.ts": 1786,
	"./pages/UpdateDogWeightAndAppetite/index": 1781,
	"./pages/UpdateDogWeightAndAppetite/index.ts": 1781,
	"./pages/UpdateDogWeightAndAppetite/mutations/__generated__/UpdateDogWeightAndAppetiteMutation": 3922,
	"./pages/UpdateDogWeightAndAppetite/mutations/__generated__/UpdateDogWeightAndAppetiteMutation.ts": 3922,
	"./pages/UpdateDogWeightAndAppetite/mutations/updateDogWeightAndAppetiteMutation": 2743,
	"./pages/UpdateDogWeightAndAppetite/mutations/updateDogWeightAndAppetiteMutation.ts": 2743,
	"./pages/UpdateDogWeightAndAppetite/queries/__generated__/DogWeightAndAppetiteQuery": 3923,
	"./pages/UpdateDogWeightAndAppetite/queries/__generated__/DogWeightAndAppetiteQuery.ts": 3923,
	"./pages/UpdateDogWeightAndAppetite/queries/dogWeightAndAppetiteQuery": 2741,
	"./pages/UpdateDogWeightAndAppetite/queries/dogWeightAndAppetiteQuery.ts": 2741,
	"./pages/UpdatePlanPage/UpdatePlanPage": 2207,
	"./pages/UpdatePlanPage/UpdatePlanPage.module": 627,
	"./pages/UpdatePlanPage/UpdatePlanPage.module.sass": 627,
	"./pages/UpdatePlanPage/UpdatePlanPage.module.sass.d": 3924,
	"./pages/UpdatePlanPage/UpdatePlanPage.module.sass.d.ts": 3924,
	"./pages/UpdatePlanPage/UpdatePlanPage.tsx": 2207,
	"./pages/Welcome/queries/__generated__/WelcomeQuery": 3925,
	"./pages/Welcome/queries/__generated__/WelcomeQuery.ts": 3925,
	"./paw": 1434,
	"./paw/": 1434,
	"./paw/components/FunnelCTA": 1558,
	"./paw/components/FunnelCTA.tsx": 1558,
	"./paw/components/FunnelTab": 1557,
	"./paw/components/FunnelTab.tsx": 1557,
	"./paw/components/IdeasTab": 1560,
	"./paw/components/IdeasTab.tsx": 1560,
	"./paw/components/ListItem": 798,
	"./paw/components/ListItem.tsx": 798,
	"./paw/components/LocalisationTab": 1561,
	"./paw/components/LocalisationTab.tsx": 1561,
	"./paw/components/Paw": 1554,
	"./paw/components/Paw.tsx": 1554,
	"./paw/components/PresetList": 1559,
	"./paw/components/PresetList.tsx": 1559,
	"./paw/components/TabBar": 1555,
	"./paw/components/TabBar.tsx": 1555,
	"./paw/components/TabContent": 1556,
	"./paw/components/TabContent.tsx": 1556,
	"./paw/index": 1434,
	"./paw/index.tsx": 1434,
	"./paw/models/dog": 616,
	"./paw/models/dog.ts": 616,
	"./paw/models/tab": 1222,
	"./paw/models/tab.ts": 1222,
	"./paw/models/user": 886,
	"./paw/models/user.ts": 886,
	"./paw/reducer": 1562,
	"./paw/reducer.ts": 1562,
	"./paw/slices/funnelSlice": 615,
	"./paw/slices/funnelSlice.ts": 615,
	"./paw/slices/navigationSlice": 736,
	"./paw/slices/navigationSlice.ts": 736,
	"./post_sign_up_wizard": 1441,
	"./post_sign_up_wizard/": 1441,
	"./post_sign_up_wizard/actions": 141,
	"./post_sign_up_wizard/actions/": 141,
	"./post_sign_up_wizard/actions/index": 141,
	"./post_sign_up_wizard/actions/index.js": 141,
	"./post_sign_up_wizard/actions/messages": 111,
	"./post_sign_up_wizard/actions/messages.js": 111,
	"./post_sign_up_wizard/actions/types": 1423,
	"./post_sign_up_wizard/actions/types.js": 1423,
	"./post_sign_up_wizard/analytics": 1064,
	"./post_sign_up_wizard/analytics/": 1064,
	"./post_sign_up_wizard/analytics/index": 1064,
	"./post_sign_up_wizard/analytics/index.js": 1064,
	"./post_sign_up_wizard/assets": 331,
	"./post_sign_up_wizard/assets/": 331,
	"./post_sign_up_wizard/assets/index": 331,
	"./post_sign_up_wizard/assets/index.js": 331,
	"./post_sign_up_wizard/components/DogDescription": 1571,
	"./post_sign_up_wizard/components/DogDescription.js": 1571,
	"./post_sign_up_wizard/components/FavouriteActivities": 1568,
	"./post_sign_up_wizard/components/FavouriteActivities.js": 1568,
	"./post_sign_up_wizard/components/FavouriteGames": 1616,
	"./post_sign_up_wizard/components/FavouriteGames.js": 1616,
	"./post_sign_up_wizard/components/FinishingUp": 1573,
	"./post_sign_up_wizard/components/FinishingUp.js": 1573,
	"./post_sign_up_wizard/components/PostWizard": 1572,
	"./post_sign_up_wizard/components/PostWizard.js": 1572,
	"./post_sign_up_wizard/components/QuirksAndTraits": 1569,
	"./post_sign_up_wizard/components/QuirksAndTraits.js": 1569,
	"./post_sign_up_wizard/components/UploadPhoto": 1570,
	"./post_sign_up_wizard/components/UploadPhoto.js": 1570,
	"./post_sign_up_wizard/components/WizardSteps": 1563,
	"./post_sign_up_wizard/components/WizardSteps.js": 1563,
	"./post_sign_up_wizard/components/base_components/DogNameDivider": 799,
	"./post_sign_up_wizard/components/base_components/DogNameDivider.js": 799,
	"./post_sign_up_wizard/components/base_components/NavigationBar": 1564,
	"./post_sign_up_wizard/components/base_components/NavigationBar.js": 1564,
	"./post_sign_up_wizard/components/base_components/PostWizardReferral": 1574,
	"./post_sign_up_wizard/components/base_components/PostWizardReferral.js.flow": 4317,
	"./post_sign_up_wizard/components/base_components/PostWizardReferral.tsx": 1574,
	"./post_sign_up_wizard/components/base_components/ProgressBar": 1565,
	"./post_sign_up_wizard/components/base_components/ProgressBar.js": 1565,
	"./post_sign_up_wizard/index": 1441,
	"./post_sign_up_wizard/index.js": 1441,
	"./post_sign_up_wizard/message_types": 2459,
	"./post_sign_up_wizard/message_types/": 2459,
	"./post_sign_up_wizard/message_types/index": 2459,
	"./post_sign_up_wizard/message_types/index.d": 3926,
	"./post_sign_up_wizard/message_types/index.d.ts": 3926,
	"./post_sign_up_wizard/message_types/index.js": 2459,
	"./post_sign_up_wizard/postSignUpRoutes": 304,
	"./post_sign_up_wizard/postSignUpRoutes.js": 304,
	"./post_sign_up_wizard/reducers": 2460,
	"./post_sign_up_wizard/reducers/": 2460,
	"./post_sign_up_wizard/reducers/dogProfilesReducer": 617,
	"./post_sign_up_wizard/reducers/dogProfilesReducer.js": 617,
	"./post_sign_up_wizard/reducers/globalAttributesReducer": 800,
	"./post_sign_up_wizard/reducers/globalAttributesReducer.js": 800,
	"./post_sign_up_wizard/reducers/index": 2460,
	"./post_sign_up_wizard/reducers/index.js": 2460,
	"./post_sign_up_wizard/reducers/requestsReducer": 1577,
	"./post_sign_up_wizard/reducers/requestsReducer.js": 1577,
	"./post_sign_up_wizard/reducers/wizardStepReducer": 1576,
	"./post_sign_up_wizard/reducers/wizardStepReducer.js": 1576,
	"./post_sign_up_wizard/thunks": 535,
	"./post_sign_up_wizard/thunks/": 535,
	"./post_sign_up_wizard/thunks/activitiesUpdate": 1426,
	"./post_sign_up_wizard/thunks/activitiesUpdate.js": 1426,
	"./post_sign_up_wizard/thunks/descriptionsUpdate": 1428,
	"./post_sign_up_wizard/thunks/descriptionsUpdate.js": 1428,
	"./post_sign_up_wizard/thunks/favouriteGamesUpdate": 1425,
	"./post_sign_up_wizard/thunks/favouriteGamesUpdate.js": 1425,
	"./post_sign_up_wizard/thunks/imageUpload": 1429,
	"./post_sign_up_wizard/thunks/imageUpload.js": 1429,
	"./post_sign_up_wizard/thunks/index": 535,
	"./post_sign_up_wizard/thunks/index.js": 535,
	"./post_sign_up_wizard/thunks/traitsUpdate": 1427,
	"./post_sign_up_wizard/thunks/traitsUpdate.js": 1427,
	"./shared/AffiliatesSummaryGridItemComponent": 598,
	"./shared/AffiliatesSummaryGridItemComponent.jsx": 598,
	"./shared/BaseModalComponent": 1485,
	"./shared/BaseModalComponent.js": 1485,
	"./shared/Calendar": 4006,
	"./shared/Calendar.js": 4006,
	"./shared/CookieConsent/CookieConsent": 64,
	"./shared/CookieConsent/CookieConsent.tsx": 64,
	"./shared/CookieConsent/CookieConsentBanner": 296,
	"./shared/CookieConsent/CookieConsentBanner.tsx": 296,
	"./shared/CookieConsent/Modals/CookieConsentModal": 90,
	"./shared/CookieConsent/Modals/CookieConsentModal.tsx": 90,
	"./shared/CookieConsent/Modals/ManageModal": 297,
	"./shared/CookieConsent/Modals/ManageModal.tsx": 297,
	"./shared/CookieConsent/Modals/StrictModal": 298,
	"./shared/CookieConsent/Modals/StrictModal.tsx": 298,
	"./shared/CookieConsent/helpers": 35,
	"./shared/CookieConsent/helpers.ts": 35,
	"./shared/CookieConsent/types": 63,
	"./shared/CookieConsent/types.ts": 63,
	"./shared/DashboardAlert": 384,
	"./shared/DashboardAlert.jsx": 384,
	"./shared/DatePicker": 1474,
	"./shared/DatePicker.js.flow": 4318,
	"./shared/DatePicker.tsx": 1474,
	"./shared/Expert": 3927,
	"./shared/Expert.d": 3928,
	"./shared/Expert.d.ts": 3928,
	"./shared/Expert.js": 3927,
	"./shared/LearnMoreAboutButternut": 630,
	"./shared/LearnMoreAboutButternut.tsx": 630,
	"./shared/ProductCard": 1552,
	"./shared/ProductCard.tsx": 1552,
	"./shared/ProductCardAndModal": 2096,
	"./shared/ProductCardAndModal.tsx": 2096,
	"./shared/ProductModal": 1553,
	"./shared/ProductModal.tsx": 1553,
	"./shared/SelectBarComponent": 926,
	"./shared/SelectBarComponent.jsx": 926,
	"./shared/TabbedComponent": 2093,
	"./shared/TabbedComponent.tsx": 2093,
	"./shared/TabbedPanel": 1543,
	"./shared/TabbedPanel.d": 3929,
	"./shared/TabbedPanel.d.ts": 3929,
	"./shared/TabbedPanel.js": 1543,
	"./shared/Tooltip": 2593,
	"./shared/Tooltip.d": 3930,
	"./shared/Tooltip.d.ts": 3930,
	"./shared/Tooltip.jsx": 2593,
	"./shared/TransitionalModal": 280,
	"./shared/TransitionalModal.d": 3931,
	"./shared/TransitionalModal.d.ts": 3931,
	"./shared/TransitionalModal.js": 280,
	"./shared/VideoElement": 3932,
	"./shared/VideoElement.d": 3933,
	"./shared/VideoElement.d.ts": 3933,
	"./shared/VideoElement.js": 3932,
	"./shared/blocks/DashboardWizardNav": 1190,
	"./shared/blocks/DashboardWizardNav/": 1190,
	"./shared/blocks/DashboardWizardNav/DashboardWizardNav": 1424,
	"./shared/blocks/DashboardWizardNav/DashboardWizardNav.d": 3934,
	"./shared/blocks/DashboardWizardNav/DashboardWizardNav.d.ts": 3934,
	"./shared/blocks/DashboardWizardNav/DashboardWizardNav.js": 1424,
	"./shared/blocks/DashboardWizardNav/index": 1190,
	"./shared/blocks/DashboardWizardNav/index.js": 1190,
	"./shared/blocks/DogAvatar": 1800,
	"./shared/blocks/DogAvatar/": 1800,
	"./shared/blocks/DogAvatar/DogAvatar": 2461,
	"./shared/blocks/DogAvatar/DogAvatar.js.flow": 4319,
	"./shared/blocks/DogAvatar/DogAvatar.tsx": 2461,
	"./shared/blocks/DogAvatar/index": 1800,
	"./shared/blocks/DogAvatar/index.ts": 1800,
	"./shared/blocks/DogAvatarCard": 2462,
	"./shared/blocks/DogAvatarCard/": 2462,
	"./shared/blocks/DogAvatarCard/DogAvatarCard": 2463,
	"./shared/blocks/DogAvatarCard/DogAvatarCard.tsx": 2463,
	"./shared/blocks/DogAvatarCard/index": 2462,
	"./shared/blocks/DogAvatarCard/index.ts": 2462,
	"./shared/blocks/ReactivationCampaignError": 1433,
	"./shared/blocks/ReactivationCampaignError/": 1433,
	"./shared/blocks/ReactivationCampaignError/ReactivationCampaignError": 1421,
	"./shared/blocks/ReactivationCampaignError/ReactivationCampaignError.tsx": 1421,
	"./shared/blocks/ReactivationCampaignError/index": 1433,
	"./shared/blocks/ReactivationCampaignError/index.ts": 1433,
	"./shared/elements/BlogExitDiscountModal": 2464,
	"./shared/elements/BlogExitDiscountModal/": 2464,
	"./shared/elements/BlogExitDiscountModal/BlogExitDiscountModal": 1614,
	"./shared/elements/BlogExitDiscountModal/BlogExitDiscountModal.tsx": 1614,
	"./shared/elements/BlogExitDiscountModal/components/CopyInputButton": 1503,
	"./shared/elements/BlogExitDiscountModal/components/CopyInputButton.tsx": 1503,
	"./shared/elements/BlogExitDiscountModal/components/DiscountModalForm": 1501,
	"./shared/elements/BlogExitDiscountModal/components/DiscountModalForm.tsx": 1501,
	"./shared/elements/BlogExitDiscountModal/components/mutations/PreWizardGuestIterableUpsertMutation": 1502,
	"./shared/elements/BlogExitDiscountModal/components/mutations/PreWizardGuestIterableUpsertMutation.ts": 1502,
	"./shared/elements/BlogExitDiscountModal/components/mutations/__generated__/PreWizardGuestIterableUpsertMutation": 3935,
	"./shared/elements/BlogExitDiscountModal/components/mutations/__generated__/PreWizardGuestIterableUpsertMutation.ts": 3935,
	"./shared/elements/BlogExitDiscountModal/index": 2464,
	"./shared/elements/BlogExitDiscountModal/index.ts": 2464,
	"./shared/elements/BreedQuestionaireCard/BreedQuestionaireCard": 1187,
	"./shared/elements/BreedQuestionaireCard/BreedQuestionaireCard.module": 671,
	"./shared/elements/BreedQuestionaireCard/BreedQuestionaireCard.module.sass": 671,
	"./shared/elements/BreedQuestionaireCard/BreedQuestionaireCard.module.sass.d": 3936,
	"./shared/elements/BreedQuestionaireCard/BreedQuestionaireCard.module.sass.d.ts": 3936,
	"./shared/elements/BreedQuestionaireCard/BreedQuestionaireCard.tsx": 1187,
	"./shared/elements/BreedSelector": 1440,
	"./shared/elements/BreedSelector/": 1440,
	"./shared/elements/BreedSelector/BreedSelector": 142,
	"./shared/elements/BreedSelector/BreedSelector.tsx": 142,
	"./shared/elements/BreedSelector/components/BreedAutocomplete/BreedAutocomplete": 321,
	"./shared/elements/BreedSelector/components/BreedAutocomplete/BreedAutocomplete.tsx": 321,
	"./shared/elements/BreedSelector/components/BreedCard": 2465,
	"./shared/elements/BreedSelector/components/BreedCard/": 2465,
	"./shared/elements/BreedSelector/components/BreedCard/BreedCard": 367,
	"./shared/elements/BreedSelector/components/BreedCard/BreedCard.tsx": 367,
	"./shared/elements/BreedSelector/components/BreedCard/index": 2465,
	"./shared/elements/BreedSelector/components/BreedCard/index.ts": 2465,
	"./shared/elements/BreedSelector/components/BreedQuestionaire": 687,
	"./shared/elements/BreedSelector/components/BreedQuestionaire/": 687,
	"./shared/elements/BreedSelector/components/BreedQuestionaire/BreedQuestionnaire": 763,
	"./shared/elements/BreedSelector/components/BreedQuestionaire/BreedQuestionnaire.tsx": 763,
	"./shared/elements/BreedSelector/components/BreedQuestionaire/index": 687,
	"./shared/elements/BreedSelector/components/BreedQuestionaire/index.tsx": 687,
	"./shared/elements/BreedSelector/components/ExpandableIconButton/ExpandableIconButton": 764,
	"./shared/elements/BreedSelector/components/ExpandableIconButton/ExpandableIconButton.tsx": 764,
	"./shared/elements/BreedSelector/index": 1440,
	"./shared/elements/BreedSelector/index.ts": 1440,
	"./shared/elements/BreedSelector/queries/__generated__/HomeBreedSelectorQuery": 3937,
	"./shared/elements/BreedSelector/queries/__generated__/HomeBreedSelectorQuery.ts": 3937,
	"./shared/elements/BreedSelector/queries/homeBreedSelectorQuery": 762,
	"./shared/elements/BreedSelector/queries/homeBreedSelectorQuery.ts": 762,
	"./shared/elements/Button/Button": 197,
	"./shared/elements/Button/Button.module": 95,
	"./shared/elements/Button/Button.module.sass": 95,
	"./shared/elements/Button/Button.module.sass.d": 3938,
	"./shared/elements/Button/Button.module.sass.d.ts": 3938,
	"./shared/elements/Button/Button.tsx": 197,
	"./shared/elements/Button/ButtonSkeleton": 365,
	"./shared/elements/Button/ButtonSkeleton.tsx": 365,
	"./shared/elements/CloudinaryImage": 2466,
	"./shared/elements/CloudinaryImage/": 2466,
	"./shared/elements/CloudinaryImage/CloudinaryImage": 234,
	"./shared/elements/CloudinaryImage/CloudinaryImage.d": 3939,
	"./shared/elements/CloudinaryImage/CloudinaryImage.d.ts": 3939,
	"./shared/elements/CloudinaryImage/CloudinaryImage.js": 234,
	"./shared/elements/CloudinaryImage/index": 2466,
	"./shared/elements/CloudinaryImage/index.js": 2466,
	"./shared/elements/ComparisonTable/ComparisonTable": 1705,
	"./shared/elements/ComparisonTable/ComparisonTable.module": 353,
	"./shared/elements/ComparisonTable/ComparisonTable.module.sass": 353,
	"./shared/elements/ComparisonTable/ComparisonTable.module.sass.d": 3940,
	"./shared/elements/ComparisonTable/ComparisonTable.module.sass.d.ts": 3940,
	"./shared/elements/ComparisonTable/ComparisonTable.tsx": 1705,
	"./shared/elements/ComparisonTable/helpers": 748,
	"./shared/elements/ComparisonTable/helpers.tsx": 748,
	"./shared/elements/FlavourImage": 1050,
	"./shared/elements/FlavourImage/": 1050,
	"./shared/elements/FlavourImage/FlavourImage": 1420,
	"./shared/elements/FlavourImage/FlavourImage.tsx": 1420,
	"./shared/elements/FlavourImage/flavourimage": 938,
	"./shared/elements/FlavourImage/flavourimage.module": 938,
	"./shared/elements/FlavourImage/flavourimage.module.sass": 938,
	"./shared/elements/FlavourImage/flavourimage.module.sass.d": 3941,
	"./shared/elements/FlavourImage/flavourimage.module.sass.d.ts": 3941,
	"./shared/elements/FlavourImage/index": 1050,
	"./shared/elements/FlavourImage/index.ts": 1050,
	"./shared/elements/FooterLeadCapture/FooterLeadCapture": 436,
	"./shared/elements/FooterLeadCapture/FooterLeadCapture.tsx": 436,
	"./shared/elements/FooterLeadCapture/mutations/PreWizardGuestIterableUpsertWithRecaptchaMutation": 410,
	"./shared/elements/FooterLeadCapture/mutations/PreWizardGuestIterableUpsertWithRecaptchaMutation.ts": 410,
	"./shared/elements/Image": 1184,
	"./shared/elements/Image/": 1184,
	"./shared/elements/Image/Image": 116,
	"./shared/elements/Image/Image.tsx": 116,
	"./shared/elements/Image/index": 1184,
	"./shared/elements/Image/index.ts": 1184,
	"./shared/elements/InjectedMarkupText": 2467,
	"./shared/elements/InjectedMarkupText/": 2467,
	"./shared/elements/InjectedMarkupText/InjectedMarkupText": 2802,
	"./shared/elements/InjectedMarkupText/InjectedMarkupText.tsx": 2802,
	"./shared/elements/InjectedMarkupText/index": 2467,
	"./shared/elements/InjectedMarkupText/index.ts": 2467,
	"./shared/elements/Input": 300,
	"./shared/elements/Input.d": 3942,
	"./shared/elements/Input.d.ts": 3942,
	"./shared/elements/Input.js": 300,
	"./shared/elements/InstagramCarousel/InstagramCarousel": 1286,
	"./shared/elements/InstagramCarousel/InstagramCarousel.module": 813,
	"./shared/elements/InstagramCarousel/InstagramCarousel.module.sass": 813,
	"./shared/elements/InstagramCarousel/InstagramCarousel.module.sass.d": 3943,
	"./shared/elements/InstagramCarousel/InstagramCarousel.module.sass.d.ts": 3943,
	"./shared/elements/InstagramCarousel/InstagramCarousel.stories": 3944,
	"./shared/elements/InstagramCarousel/InstagramCarousel.stories.tsx": 3944,
	"./shared/elements/InstagramCarousel/InstagramCarousel.tsx": 1286,
	"./shared/elements/InstagramCarousel/staticData/gbData": 1545,
	"./shared/elements/InstagramCarousel/staticData/gbData.ts": 1545,
	"./shared/elements/InstagramCarousel/staticData/ieData": 1546,
	"./shared/elements/InstagramCarousel/staticData/ieData.ts": 1546,
	"./shared/elements/InstagramCarousel/staticData/nlData": 1547,
	"./shared/elements/InstagramCarousel/staticData/nlData.ts": 1547,
	"./shared/elements/InstagramCarousel/staticData/plData": 1548,
	"./shared/elements/InstagramCarousel/staticData/plData.ts": 1548,
	"./shared/elements/Message": 1516,
	"./shared/elements/Message.d": 3945,
	"./shared/elements/Message.d.ts": 3945,
	"./shared/elements/Message.js": 1516,
	"./shared/elements/PillButton/PillButton": 1567,
	"./shared/elements/PillButton/PillButton.jsx": 1567,
	"./shared/elements/PillButton/SelectableItemList": 1566,
	"./shared/elements/PillButton/SelectableItemList.jsx": 1566,
	"./shared/elements/PillButton/SelectablePillButton": 1063,
	"./shared/elements/PillButton/SelectablePillButton.jsx": 1063,
	"./shared/elements/ProductLabel": 1189,
	"./shared/elements/ProductLabel/": 1189,
	"./shared/elements/ProductLabel/ProductLabel": 1422,
	"./shared/elements/ProductLabel/ProductLabel.tsx": 1422,
	"./shared/elements/ProductLabel/index": 1189,
	"./shared/elements/ProductLabel/index.ts": 1189,
	"./shared/elements/ProductLabel/productlabel": 1135,
	"./shared/elements/ProductLabel/productlabel.module": 1135,
	"./shared/elements/ProductLabel/productlabel.module.sass": 1135,
	"./shared/elements/ProductLabel/productlabel.module.sass.d": 3946,
	"./shared/elements/ProductLabel/productlabel.module.sass.d.ts": 3946,
	"./shared/elements/RealStoriesVideoCarousel/RealStoriesVideoCarousel": 1706,
	"./shared/elements/RealStoriesVideoCarousel/RealStoriesVideoCarousel.module": 749,
	"./shared/elements/RealStoriesVideoCarousel/RealStoriesVideoCarousel.module.sass": 749,
	"./shared/elements/RealStoriesVideoCarousel/RealStoriesVideoCarousel.module.sass.d": 3947,
	"./shared/elements/RealStoriesVideoCarousel/RealStoriesVideoCarousel.module.sass.d.ts": 3947,
	"./shared/elements/RealStoriesVideoCarousel/RealStoriesVideoCarousel.tsx": 1706,
	"./shared/elements/RoughCostCalculator/FullSectionRoughCostCalculator": 1285,
	"./shared/elements/RoughCostCalculator/FullSectionRoughCostCalculator.tsx": 1285,
	"./shared/elements/RoughCostCalculator/components/AgeSelect": 738,
	"./shared/elements/RoughCostCalculator/components/AgeSelect.tsx": 738,
	"./shared/elements/RoughCostCalculator/components/BreedSelect": 868,
	"./shared/elements/RoughCostCalculator/components/BreedSelect.tsx": 868,
	"./shared/elements/RoughCostCalculator/components/CTA": 768,
	"./shared/elements/RoughCostCalculator/components/CTA.tsx": 768,
	"./shared/elements/RoughCostCalculator/components/DogDetailsForm": 251,
	"./shared/elements/RoughCostCalculator/components/DogDetailsForm.tsx": 251,
	"./shared/elements/RoughCostCalculator/components/Plan": 661,
	"./shared/elements/RoughCostCalculator/components/Plan.tsx": 661,
	"./shared/elements/RoughCostCalculator/components/WeightSelect": 739,
	"./shared/elements/RoughCostCalculator/components/WeightSelect.tsx": 739,
	"./shared/elements/RoughCostCalculator/helpers/roughCostCalculatorHelpers": 869,
	"./shared/elements/RoughCostCalculator/helpers/roughCostCalculatorHelpers.ts": 869,
	"./shared/elements/Select": 1518,
	"./shared/elements/Select.d": 3948,
	"./shared/elements/Select.d.ts": 3948,
	"./shared/elements/Select.js": 1518,
	"./shared/elements/Select/Select": 613,
	"./shared/elements/Select/Select.tsx": 613,
	"./shared/elements/SocialReviewsSection/SocialReviewsSection": 1707,
	"./shared/elements/SocialReviewsSection/SocialReviewsSection.module": 1221,
	"./shared/elements/SocialReviewsSection/SocialReviewsSection.module.sass": 1221,
	"./shared/elements/SocialReviewsSection/SocialReviewsSection.module.sass.d": 3949,
	"./shared/elements/SocialReviewsSection/SocialReviewsSection.module.sass.d.ts": 3949,
	"./shared/elements/SocialReviewsSection/SocialReviewsSection.tsx": 1707,
	"./shared/elements/SwiperSlider/SwiperSlider": 1287,
	"./shared/elements/SwiperSlider/SwiperSlider.module": 377,
	"./shared/elements/SwiperSlider/SwiperSlider.module.sass": 377,
	"./shared/elements/SwiperSlider/SwiperSlider.module.sass.d": 3950,
	"./shared/elements/SwiperSlider/SwiperSlider.module.sass.d.ts": 3950,
	"./shared/elements/SwiperSlider/SwiperSlider.tsx": 1287,
	"./shared/elements/TestimonialsCarousel/TestimonialsCarousel": 2092,
	"./shared/elements/TestimonialsCarousel/TestimonialsCarousel.tsx": 2092,
	"./shared/elements/TestimonialsTrustpilot/TestimonialsTrustpilot": 1708,
	"./shared/elements/TestimonialsTrustpilot/TestimonialsTrustpilot.module": 520,
	"./shared/elements/TestimonialsTrustpilot/TestimonialsTrustpilot.module.sass": 520,
	"./shared/elements/TestimonialsTrustpilot/TestimonialsTrustpilot.module.sass.d": 3951,
	"./shared/elements/TestimonialsTrustpilot/TestimonialsTrustpilot.module.sass.d.ts": 3951,
	"./shared/elements/TestimonialsTrustpilot/TestimonialsTrustpilot.tsx": 1708,
	"./shared/elements/TestimonialsTrustpilot/helpers": 808,
	"./shared/elements/TestimonialsTrustpilot/helpers.tsx": 808,
	"./shared/elements/Text/Text": 119,
	"./shared/elements/Text/Text.module": 80,
	"./shared/elements/Text/Text.module.sass": 80,
	"./shared/elements/Text/Text.module.sass.d": 3952,
	"./shared/elements/Text/Text.module.sass.d.ts": 3952,
	"./shared/elements/Text/Text.tsx": 119,
	"./shared/elements/TextArea": 1509,
	"./shared/elements/TextArea.d": 3953,
	"./shared/elements/TextArea.d.ts": 3953,
	"./shared/elements/TextArea.js": 1509,
	"./shared/elements/TrustpilotWidget/TrustpilotWidget": 1622,
	"./shared/elements/TrustpilotWidget/TrustpilotWidget.tsx": 1622,
	"./shared/elements/Video/Video": 1062,
	"./shared/elements/Video/Video.module": 1544,
	"./shared/elements/Video/Video.module.sass": 1544,
	"./shared/elements/Video/Video.module.sass.d": 3954,
	"./shared/elements/Video/Video.module.sass.d.ts": 3954,
	"./shared/elements/Video/Video.tsx": 1062,
	"./shared/elements/WonkyTitleText/WonkyTitleText": 2238,
	"./shared/elements/WonkyTitleText/WonkyTitleText.tsx": 2238,
	"./shared/elements/typography/Title": 3955,
	"./shared/elements/typography/Title.d": 3956,
	"./shared/elements/typography/Title.d.ts": 3956,
	"./shared/elements/typography/Title.js": 3955,
	"./shared/geo_ip_widget/GeoIpWidget": 2594,
	"./shared/geo_ip_widget/GeoIpWidget.js.flow": 4320,
	"./shared/geo_ip_widget/GeoIpWidget.tsx": 2594,
	"./shared/geo_ip_widget/LanguageWidget": 500,
	"./shared/geo_ip_widget/LanguageWidget.tsx": 500,
	"./shared/geo_ip_widget/LocalisationModal/localisationModal": 499,
	"./shared/geo_ip_widget/LocalisationModal/localisationModal.tsx": 499,
	"./shared/geo_ip_widget/LocalisationModal/queries/__generated__/SaveLanguageUpdate": 3957,
	"./shared/geo_ip_widget/LocalisationModal/queries/__generated__/SaveLanguageUpdate.ts": 3957,
	"./shared/geo_ip_widget/LocalisationModal/queries/__generated__/UserQuery": 3958,
	"./shared/geo_ip_widget/LocalisationModal/queries/__generated__/UserQuery.ts": 3958,
	"./shared/geo_ip_widget/LocalisationModal/queries/saveLanguage": 502,
	"./shared/geo_ip_widget/LocalisationModal/queries/saveLanguage.ts": 502,
	"./shared/geo_ip_widget/LocalisationModal/queries/userQuery": 503,
	"./shared/geo_ip_widget/LocalisationModal/queries/userQuery.ts": 503,
	"./shared/geo_ip_widget/RegionWidget": 501,
	"./shared/geo_ip_widget/RegionWidget.tsx": 501,
	"./shared/geo_ip_widget/initGeoIpWidget": 504,
	"./shared/geo_ip_widget/initGeoIpWidget.js.flow": 4321,
	"./shared/geo_ip_widget/initGeoIpWidget.tsx": 504,
	"./shared/geo_ip_widget/localisationDisplay": 351,
	"./shared/geo_ip_widget/localisationDisplay.tsx": 351,
	"./shared/geo_ip_widget/localisationHelpers": 67,
	"./shared/geo_ip_widget/localisationHelpers.js.flow": 4322,
	"./shared/geo_ip_widget/localisationHelpers.ts": 67,
	"./shared/images/Chevron": 416,
	"./shared/images/Chevron.d": 3959,
	"./shared/images/Chevron.d.ts": 3959,
	"./shared/images/Chevron.jsx": 416,
	"./shared/images/Star": 3960,
	"./shared/images/Star.d": 3961,
	"./shared/images/Star.d.ts": 3961,
	"./shared/images/Star.jsx": 3960,
	"./shared/vanillaTooltip": 1288,
	"./shared/vanillaTooltip.ts": 1288,
	"./shared/wizards/Header": 575,
	"./shared/wizards/Header.d": 3962,
	"./shared/wizards/Header.d.ts": 3962,
	"./shared/wizards/Header.js": 575,
	"./templates/Base": 135,
	"./templates/Base.module": 1124,
	"./templates/Base.module.sass": 1124,
	"./templates/Base.module.sass.d": 3963,
	"./templates/Base.module.sass.d.ts": 3963,
	"./templates/Base.stories": 3964,
	"./templates/Base.stories.tsx": 3964,
	"./templates/Base.tsx": 135,
	"./templates/NoNavigationFullWidth/NoNavigationFullWidth": 2225,
	"./templates/NoNavigationFullWidth/NoNavigationFullWidth.module": 2793,
	"./templates/NoNavigationFullWidth/NoNavigationFullWidth.module.sass": 2793,
	"./templates/NoNavigationFullWidth/NoNavigationFullWidth.module.sass.d": 3965,
	"./templates/NoNavigationFullWidth/NoNavigationFullWidth.module.sass.d.ts": 3965,
	"./templates/NoNavigationFullWidth/NoNavigationFullWidth.stories": 3966,
	"./templates/NoNavigationFullWidth/NoNavigationFullWidth.stories.tsx": 3966,
	"./templates/NoNavigationFullWidth/NoNavigationFullWidth.tsx": 2225,
	"./templates/RafCampaign/RafCampaign": 2198,
	"./templates/RafCampaign/RafCampaign.module": 626,
	"./templates/RafCampaign/RafCampaign.module.sass": 626,
	"./templates/RafCampaign/RafCampaign.module.sass.d": 3967,
	"./templates/RafCampaign/RafCampaign.module.sass.d.ts": 3967,
	"./templates/RafCampaign/RafCampaign.stories": 3968,
	"./templates/RafCampaign/RafCampaign.stories.tsx": 3968,
	"./templates/RafCampaign/RafCampaign.tsx": 2198,
	"./templates/RouteTransition/RouteTransition": 2239,
	"./templates/RouteTransition/RouteTransition.module": 2693,
	"./templates/RouteTransition/RouteTransition.module.sass": 2693,
	"./templates/RouteTransition/RouteTransition.module.sass.d": 3969,
	"./templates/RouteTransition/RouteTransition.module.sass.d.ts": 3969,
	"./templates/RouteTransition/RouteTransition.tsx": 2239,
	"./templates/Screen": 1311,
	"./templates/Screen/": 1311,
	"./templates/Screen/Screen": 1276,
	"./templates/Screen/Screen.module": 527,
	"./templates/Screen/Screen.module.sass": 527,
	"./templates/Screen/Screen.module.sass.d": 3970,
	"./templates/Screen/Screen.module.sass.d.ts": 3970,
	"./templates/Screen/Screen.stories": 3971,
	"./templates/Screen/Screen.stories.tsx": 3971,
	"./templates/Screen/Screen.tsx": 1276,
	"./templates/Screen/index": 1311,
	"./templates/Screen/index.ts": 1311,
	"./templates/WizardNavigationLayout/WizardNavigationLayout": 1201,
	"./templates/WizardNavigationLayout/WizardNavigationLayout.module": 1922,
	"./templates/WizardNavigationLayout/WizardNavigationLayout.module.sass": 1922,
	"./templates/WizardNavigationLayout/WizardNavigationLayout.module.sass.d": 3972,
	"./templates/WizardNavigationLayout/WizardNavigationLayout.module.sass.d.ts": 3972,
	"./templates/WizardNavigationLayout/WizardNavigationLayout.stories": 3973,
	"./templates/WizardNavigationLayout/WizardNavigationLayout.stories.tsx": 3973,
	"./templates/WizardNavigationLayout/WizardNavigationLayout.tsx": 1201,
	"./thank_you/components/ThankYouRaf": 2795,
	"./thank_you/components/ThankYouRaf.tsx": 2795,
	"./thank_you/components/blocks/GoToAccount/GoToAccount": 2796,
	"./thank_you/components/blocks/GoToAccount/GoToAccount.tsx": 2796,
	"./thank_you/components/blocks/NextSteps/NextSteps": 2797,
	"./thank_you/components/blocks/NextSteps/NextSteps.tsx": 2797,
	"./theme/border-radius": 3974,
	"./theme/border-radius.sass": 3974,
	"./theme/breakpoints": 295,
	"./theme/breakpoints.sass": 295,
	"./theme/breakpoints.sass.d": 3975,
	"./theme/breakpoints.sass.d.ts": 3975,
	"./theme/colours": 3976,
	"./theme/colours.sass": 3976,
	"./theme/fonts": 3977,
	"./theme/fonts.sass": 3977,
	"./theme/fonts/CooperHewitt-Bold.eot": 4323,
	"./theme/fonts/CooperHewitt-Bold.ttf": 4324,
	"./theme/fonts/CooperHewitt-Bold.woff": 4325,
	"./theme/fonts/CooperHewitt-Bold.woff2": 4326,
	"./theme/fonts/GT-Pressura-Bold.eot": 4327,
	"./theme/fonts/GT-Pressura-Bold.otf": 4328,
	"./theme/fonts/GT-Pressura-Bold.ttf": 4329,
	"./theme/fonts/GT-Pressura-Bold.woff": 4330,
	"./theme/fonts/GT-Pressura-Bold.woff2": 4331,
	"./theme/fonts/GT-Pressura-Mono-Bold.eot": 4332,
	"./theme/fonts/GT-Pressura-Mono-Bold.otf": 4333,
	"./theme/fonts/GT-Pressura-Mono-Bold.ttf": 4334,
	"./theme/fonts/GT-Pressura-Mono-Bold.woff": 4335,
	"./theme/fonts/GT-Pressura-Mono-Bold.woff2": 4336,
	"./theme/fonts/GT-Pressura-Regular.eot": 4337,
	"./theme/fonts/GT-Pressura-Regular.otf": 4338,
	"./theme/fonts/GT-Pressura-Regular.ttf": 4339,
	"./theme/fonts/GT-Pressura-Regular.woff": 4340,
	"./theme/fonts/GT-Pressura-Regular.woff2": 4341,
	"./theme/fonts/GTPressuraMono.eot": 4342,
	"./theme/fonts/GTPressuraMono.ttf": 4343,
	"./theme/fonts/GTPressuraMono.woff": 4344,
	"./theme/fonts/GTPressuraMono.woff2": 4345,
	"./theme/fonts/demo.html": 4346,
	"./theme/fonts/icomoon": 3978,
	"./theme/fonts/icomoon.eot": 4347,
	"./theme/fonts/icomoon.svg": 3978,
	"./theme/fonts/icomoon.ttf": 4348,
	"./theme/fonts/icomoon.woff": 4349,
	"./theme/indents": 3979,
	"./theme/indents.sass": 3979,
	"./theme/lazy-loading": 3980,
	"./theme/lazy-loading.sass": 3980,
	"./theme/overrides/nl": 3981,
	"./theme/overrides/nl.sass": 3981,
	"./theme/paths": 3982,
	"./theme/paths.sass": 3982,
	"./theme/squiggly-underline": 3983,
	"./theme/squiggly-underline.sass": 3983,
	"./theme/tape": 3984,
	"./theme/tape.sass": 3984,
	"./theme/theme": 3985,
	"./theme/theme.sass": 3985,
	"./theme/z-index": 3986,
	"./theme/z-index.sass": 3986,
	"./types": 2468,
	"./types/": 2468,
	"./types/Allergen": 3987,
	"./types/Allergen.ts": 3987,
	"./types/Box": 3988,
	"./types/Box.ts": 3988,
	"./types/DeliveryStatus": 3989,
	"./types/DeliveryStatus.ts": 3989,
	"./types/Dog": 3990,
	"./types/Dog.ts": 3990,
	"./types/DogProfile": 3991,
	"./types/DogProfile.ts": 3991,
	"./types/Flavour": 3992,
	"./types/Flavour.ts": 3992,
	"./types/Frequency": 3993,
	"./types/Frequency.ts": 3993,
	"./types/HealthIssue": 3994,
	"./types/HealthIssue.ts": 3994,
	"./types/Image": 3995,
	"./types/Image.ts": 3995,
	"./types/Notification": 3996,
	"./types/Notification.ts": 3996,
	"./types/PendingSubscription": 3997,
	"./types/PendingSubscription.ts": 3997,
	"./types/PlanRecommendation": 3998,
	"./types/PlanRecommendation.ts": 3998,
	"./types/PlanType": 1941,
	"./types/PlanType.ts": 1941,
	"./types/ProductCollection": 3999,
	"./types/ProductCollection.ts": 3999,
	"./types/Recommendation": 4000,
	"./types/Recommendation.ts": 4000,
	"./types/RecommendationReason": 4001,
	"./types/RecommendationReason.ts": 4001,
	"./types/Subscription": 4002,
	"./types/Subscription.ts": 4002,
	"./types/Survey": 4003,
	"./types/Survey.ts": 4003,
	"./types/User": 4004,
	"./types/User.ts": 4004,
	"./types/index": 2468,
	"./types/index.ts": 2468
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4225;